{
	"_reusableBaseText": {
		"cancel": "Cancel",
		"codeNodeEditor": {
			"linter": {
				"useJson": "Access the properties of an item under `.json`, e.g. `item.json`"
			},
			"completer": {
				"all": "Returns an array of the node's output items",
				"first": "Returns the first item output by the node",
				"last": "Returns the last item output by the node",
				"itemMatching": "Returns the matching item, i.e. the one used to produce the item in the current node at the specified index."
			}
		},
		"name": "Name",
		"save": "Save",
		"dismiss": "Dismiss",
		"unlimited": "Unlimited",
		"activate": "Activate",
		"user": "User",
		"enabled": "Enabled",
		"disabled": "Disabled",
		"type": "Type",
		"role": "Role",
		"roles": {
			"admin": "Admin",
			"editor": "Editor",
			"viewer": "Viewer"
		}
	},
	"_reusableDynamicText": {
		"readMore": "Read more",
		"learnMore": "Learn more",
		"moreInfo": "More info",
		"oauth2": {
			"clientId": "Client ID",
			"clientSecret": "Client Secret"
		}
	},
	"generic.activate": "Activate",
	"generic.annotations": "Annotations",
	"generic.annotationData": "Highlighted data",
	"generic.any": "Any",
	"generic.allow": "Allow",
	"generic.deny": "Deny",
	"generic.docs": "Docs",
	"generic.documentation": "Documentation",
	"generic.back": "Back",
	"generic.cancel": "Cancel",
	"generic.connect": "Connect",
	"generic.save": "Save",
	"generic.open": "Open",
	"generic.openResource": "Open {resource}",
	"generic.add": "Add",
	"generic.close": "Close",
	"generic.clear": "Clear",
	"generic.confirm": "Confirm",
	"generic.create": "Create",
	"generic.start": "Start",
	"generic.create.workflow": "Create workflow",
	"generic.deleteWorkflowError": "Problem deleting workflow",
	"generic.archiveWorkflowError": "Problem archiving workflow",
	"generic.unarchiveWorkflowError": "Problem unarchiving workflow",
	"generic.filtersApplied": "Filters are currently applied.",
	"generic.field": "field",
	"generic.fields": "fields",
	"generic.folderCount": "Folder | {count} Folder | {count} Folders",
	"generic.folder": "Folder",
	"generic.keepBuilding": "Keep building",
	"generic.learnMore": "Learn more",
	"generic.recommended": "Recommended",
	"generic.reset": "Reset",
	"generic.resetAllFilters": "Reset all filters",
	"generic.communityNode": "Community Node",
	"generic.communityNode.tooltip": "This is a node from our community. It's part of the {packageName} package. <a href=\"{docURL}\" target=\"_blank\" title=\"Read the n8n docs\">Learn more</a>",
	"generic.officialNode.tooltip": "This is an official node maintained by {author}",
	"generic.complete": "Complete",
	"generic.copy": "Copy",
	"generic.copied": "Copied",
	"generic.delete": "Delete",
	"generic.edit": "Edit",
	"generic.keepEditing": "Keep editing",
	"generic.dontShowAgain": "Don't show again",
	"generic.enterprise": "Enterprise",
	"generic.executions": "Executions",
	"generic.tag_plural": "Tags",
	"generic.tag": "Tag | {count} Tags",
	"generic.tests": "Evaluations",
	"generic.templates": "Templates",
	"generic.optional": "optional",
	"generic.or": "or",
	"generic.clickToCopy": "Click to copy",
	"generic.copiedToClipboard": "Copied to clipboard",
	"generic.beta": "beta",
	"generic.betaProper": "Beta",
	"generic.freeCredits": "Free credits",
	"generic.yes": "Yes",
	"generic.no": "No",
	"generic.rating": "Rating",
	"generic.refresh": "Refresh",
	"generic.retry": "Retry",
	"generic.error": "Something went wrong",
	"generic.error.subworkflowCreationFailed": "Error creating sub-workflow",
	"generic.settings": "Settings",
	"generic.service": "the service",
	"generic.star": "Star",
	"generic.tryNow": "Try now",
	"generic.startNow": "Start now",
	"generic.dismiss": "Dismiss",
	"generic.saving": "Saving",
	"generic.name": "Name",
	"generic.nameVersion": "Name version",
	"generic.description": "Description",
	"generic.unsavedWork.confirmMessage.headline": "Save changes before leaving?",
	"generic.unsavedWork.confirmMessage.message": "If you don't save, you might lose your changes.",
	"generic.unsavedWork.confirmMessage.confirmButtonText": "Save",
	"generic.unsavedWork.confirmMessage.cancelButtonText": "Leave without saving",
	"generic.trial.message.days": "1 day left | {count} days left",
	"generic.trial.message.hours": "1 hour left | {count} hours left",
	"generic.trial.message.minutes": "1 minute left | {count} minutes left",
	"generic.trial.tooltip.days": "1 day left in your trial. Upgrade to keep using n8n. | {count} days left in your trial. Upgrade to keep using n8n.",
	"generic.trial.tooltip.hours": "1 hour left in your trial. Upgrade to keep using n8n. | {count} hours left in your trial. Upgrade to keep using n8n.",
	"generic.trial.tooltip.minutes": "1 minute left in your trial. Upgrade to keep using n8n. | {count} minutes left in your trial. Upgrade to keep using n8n.",
	"generic.upgrade": "Upgrade",
	"generic.upgradeNow": "Upgrade now",
	"generic.update": "Update",
	"generic.credential": "Credential | {count} Credential | {count} Credentials",
	"generic.credentials": "Credentials",
	"generic.datatable": "Data table | {count} Data table | {count} Data tables",
	"generic.workflow": "Workflow | {count} Workflow | {count} Workflows",
	"generic.workflowSaved": "Workflow changes saved",
	"generic.autosave.retrying": "Autosave failed: {error}\nRetrying in {retryIn}...",
	"generic.editor": "Editor",
	"generic.seePlans": "See plans",
	"generic.loading": "Loading",
	"generic.loadingEllipsis": "Loading...",
	"generic.and": "and",
	"generic.ownedByMe": "(You)",
	"generic.moreInfo": "More info",
	"generic.next": "Next",
	"generic.pro": "Pro",
	"generic.variable_plural": "Variables",
	"generic.folders_plural": "Folders",
	"generic.variable": "Variable | {count} Variables",
	"generic.viewDocs": "View docs",
	"generic.workflows": "Workflows",
	"generic.rename": "Rename",
	"generic.missing.permissions": "Missing permissions to perform this action",
	"generic.shortcutHint": "Or press",
	"generic.unknownError": "An unknown error occurred",
	"generic.upgradeToEnterprise": "Upgrade to Enterprise",
	"generic.never": "Never",
	"generic.list.clearSelection": "Clear selection",
	"generic.list.selected": "{count} row selected | {count} rows selected",
	"generic.project": "Project",
	"generic.projects": "Projects",
	"generic.your": "Your",
	"generic.you": "you",
	"generic.apiKey": "API Key",
	"generic.search": "Search",
	"generic.showMore": "Show more",
	"generic.showLess": "Show less",
	"generic.stopAll": "Stop all",
	"generic.published": "Published",
	"generic.notPublished": "Not published",
	"generic.tip": "Tip",
	"about.aboutN8n": "About n8n",
	"about.close": "Close",
	"about.license": "License",
	"about.n8nLicense": "Sustainable Use License + n8n Enterprise License",
	"about.n8nVersion": "n8n Version",
	"about.sourceCode": "Source Code",
	"about.instanceID": "Instance ID",
	"about.debug.title": "Debug",
	"about.debug.message": "Copy debug information",
	"about.debug.toast.title": "Debug info",
	"about.debug.toast.message": "Copied debug info to clipboard",
	"about.thirdPartyLicenses": "Third-Party Licenses",
	"about.thirdPartyLicensesLink": "View all third-party licenses",
	"about.thirdPartyLicenses.downloadError": "Failed to download third-party licenses file",
	"appSelection.heading": "Welcome, {name}!",
	"appSelection.heading.noName": "Welcome!",
	"appSelection.subheading": "Connect your favorite apps to get started",
	"appSelection.searchPlaceholder": "Search apps...",
	"appSelection.continue": "Continue",
	"appSelection.continueWithCount": "Continue ({count})",
	"appSelection.noResults": "No apps found matching your search",
	"appSelection.error.oauthFailed": "Failed to connect app",
	"appSelection.toast.success": "You're ready to build!",
	"appSelection.instantConnect": "Instant connect",
	"appSelection.connectLater": "I'll connect apps later",
	"askAi.dialog.title": "'Ask AI' is almost ready",
	"askAi.dialog.body": "We’re still applying the finishing touches. Soon, you will be able to <strong>automatically generate code from simple text prompts</strong>. Join the waitlist to get early access to this feature.",
	"askAi.dialog.signup": "Join Waitlist",
	"activationModal.butYouCanSeeThem": "but you can see them in the",
	"activationModal.executionList": "execution list",
	"activationModal.gotIt": "Got it",
	"activationModal.ifYouChooseTo": "if you choose to",
	"activationModal.saveExecutions": "save executions.",
	"activationModal.theseExecutionsWillNotShowUp": "These executions will not show up immediately in the editor,",
	"activationModal.workflowPublished": "Workflow published",
	"activationModal.yourTriggerWillNowFire": "Your trigger will now fire production executions automatically.",
	"activationModal.yourTriggersWillNowFire": "Your triggers will now fire production executions automatically.",
	"activationModal.yourWorkflowWillNowListenForEvents": "Your workflow will now listen for events from {serviceName} and trigger executions.",
	"activationModal.yourWorkflowWillNowRegularlyCheck": "Your workflow will now regularly check {serviceName} for events and trigger executions for them.",
	"annotationTagsManager.manageTags": "Manage execution tags",
	"annotationTagsView.usage": "Usage (all workflows)",
	"annotationTagsView.inUse": "{count} execution | {count} executions",
	"auth.changePassword": "Change password",
	"auth.changePassword.currentPassword": "Current password",
	"auth.changePassword.mfaCode": "Two-factor code",
	"auth.changePassword.error": "Problem changing the password",
	"auth.changePassword.missingTokenError": "Missing token",
	"auth.changePassword.missingUserIdError": "Missing user ID",
	"auth.changePassword.passwordUpdated": "Password updated",
	"auth.changePassword.passwordUpdatedMessage": "You can now sign in with your new password",
	"auth.changePassword.passwordsMustMatchError": "Passwords must match",
	"auth.changePassword.reenterNewPassword": "Re-enter new password",
	"auth.changePassword.tokenValidationError": "Invalid password-reset token",
	"auth.confirmPassword": "Confirm password",
	"auth.confirmPassword.currentPassword": "Current password",
	"auth.confirmPassword.confirmPasswordToChangeEmail": "Please confirm your password in order to change your email address.",
	"auth.defaultPasswordRequirements": "{minimum}+ characters, at least 1 number and 1 capital letter",
	"auth.validation.missingParameters": "Missing token or user id",
	"auth.email": "Email",
	"auth.firstName": "First Name",
	"auth.lastName": "Last Name",
	"auth.newPassword": "New password",
	"auth.password": "Password",
	"auth.role": "Role",
	"auth.roles.default": "Default",
	"auth.roles.member": "Member",
	"auth.roles.admin": "@:_reusableBaseText.roles.admin",
	"auth.roles.owner": "Owner",
	"auth.roles.chatUser": "Chat user",
	"auth.agreement.label": "I want to receive security and product updates",
	"auth.setup.next": "Next",
	"auth.setup.settingUpOwnerError": "Problem setting up owner",
	"auth.setup.setupOwner": "Set up owner account",
	"auth.signin": "Sign in",
	"auth.signin.error": "Problem logging in",
	"auth.signout": "Sign out",
	"auth.signout.error": "Could not sign out",
	"auth.signup.finishAccountSetup": "Finish account setup",
	"auth.signup.missingTokenError": "Missing token",
	"auth.signup.setupYourAccount": "Set up your account",
	"auth.signup.setupYourAccountError": "Problem setting up your account",
	"auth.signup.tokenValidationError": "Issue validating invite token",
	"aiAssistant.name": "n8n AI",
	"aiAssistant.assistant": "Assistant",
	"aiAssistant.tabs.ask": "Ask",
	"aiAssistant.tabs.build": "Build",
	"aiAssistant.reducedHelp.chat.notice": "Your admin turned off sending actual data values to the AI. Responses may be less accurate.",
	"aiAssistant.tabs.builder.disabled.tooltip": "AI Builder is disabled because sending data values to AI is turned off. Enable it in AI Usage settings to use AI Builder.",
	"aiAssistant.builder.mode": "AI Builder",
	"aiAssistant.builder.placeholder": "Ask n8n to build...",
	"aiAssistant.builder.assistantPlaceholder": "What would you like to modify or add?",
	"aiAssistant.builder.existingWorkflow.emptyState.title": "Modify your workflow",
	"aiAssistant.builder.existingWorkflow.emptyState.body": "Ask n8n AI to modify existing nodes, add new steps, update parameters, or help debug issues in your workflow.",
	"aiAssistant.builder.planMode.selector.build": "Build",
	"aiAssistant.builder.planMode.selector.build.description": "Build right away · 1 credit",
	"aiAssistant.builder.planMode.selector.plan": "Plan",
	"aiAssistant.builder.planMode.selector.plan.description": "Refine requirements first · free",
	"aiAssistant.builder.planMode.questions.title": "A few quick questions",
	"aiAssistant.builder.planMode.questions.customPlaceholder": "Add details (optional)",
	"aiAssistant.builder.planMode.questions.submitButton": "Submit",
	"aiAssistant.builder.planMode.questions.back": "Back",
	"aiAssistant.builder.planMode.questions.next": "Next",
	"aiAssistant.builder.planMode.questions.skip": "Skip",
	"aiAssistant.builder.planMode.questions.skipAndSubmit": "Skip & submit",
	"aiAssistant.builder.planMode.questions.other": "Other",
	"aiAssistant.builder.planMode.questions.somethingElse": "Something else",
	"aiAssistant.builder.planMode.questions.clarifyPlaceholder": "Clarify here...",
	"aiAssistant.builder.planMode.questions.paginationOf": "of",
	"aiAssistant.builder.planMode.answers.skipped": "Skipped",
	"aiAssistant.builder.planMode.plan.title": "Proposed plan",
	"aiAssistant.builder.planMode.plan.triggerLabel": "Trigger",
	"aiAssistant.builder.planMode.plan.stepsLabel": "Steps",
	"aiAssistant.builder.planMode.plan.notesLabel": "Notes",
	"aiAssistant.builder.planMode.plan.feedbackLabel": "Feedback (optional)",
	"aiAssistant.builder.planMode.plan.feedbackPlaceholder": "Describe what you'd like to change",
	"aiAssistant.builder.planMode.actions.submitAnswers": "Submit answers",
	"aiAssistant.builder.planMode.actions.implement": "Implement the plan",
	"aiAssistant.builder.planMode.actions.modify": "Request changes",
	"aiAssistant.builder.planMode.actions.modifyWithFeedback": "Request changes: {feedback}",
	"aiAssistant.builder.planMode.answers.noAnswer": "No answer provided",
	"aiAssistant.builder.planMode.actions.reject": "Reject the plan",
	"aiAssistant.builder.planMode.actions.rejectWithFeedback": "Reject the plan: {feedback}",
	"aiAssistant.builder.webFetch.prompt": "n8n AI wants to fetch content",
	"aiAssistant.builder.webFetch.allowOnce": "Allow once",
	"aiAssistant.builder.webFetch.alwaysAllow": "Always allow",
	"aiAssistant.builder.webFetch.allowDomain": "Always allow {domain}",
	"aiAssistant.builder.webFetch.allowAll": "Always allow for all domains",
	"aiAssistant.builder.webFetch.deny": "Deny",
	"aiAssistant.builder.webFetch.unsupported": "This content type is not supported",
	"aiAssistant.builder.collapsedMessages.count": "{count} versions hidden",
	"aiAssistant.builder.collapsedMessages.notVisibleToAI": "These messages are not visible to the AI",
	"aiAssistant.builder.collapsedMessages.expand": "Show hidden messages",
	"aiAssistant.builder.collapsedMessages.collapse": "Hide messages",
	"aiAssistant.builder.collapsedMessages.thinking": "Thinking",
	"aiAssistant.builder.characterLimit": "You've reached the { limit } character limit",
	"aiAssistant.builder.generateNew": "Generate new workflow",
	"aiAssistant.builder.newWorkflowNotice": "The created workflow will be added to the editor",
	"aiAssistant.builder.feedbackPrompt": "Is this workflow helpful?",
	"aiAssistant.builder.invalidPrompt": "Prompt validation failed. Please try again with a clearer description of your workflow requirements and supported integrations.",
	"aiAssistant.builder.workflowParsingError.title": "Unable to insert workflow",
	"aiAssistant.builder.workflowParsingError.content": "The workflow returned by AI could not be parsed. Please try again.",
	"aiAssistant.builder.error.title": "Workflow update failed",
	"aiAssistant.builder.reviewChanges.editsCount": "Edits · {count} nodes",
	"aiAssistant.builder.reviewChanges.openDiff": "Open diff",
	"aiAssistant.builder.reviewChanges.previousVersion": "Previous version",
	"aiAssistant.builder.reviewChanges.currentVersion": "Current version",
	"aiAssistant.builder.reviewChanges.error": "Could not load the previous version of the workflow. The version history may no longer be available.",
	"aiAssistant.versionCard.version": "Version",
	"aiAssistant.versionCard.versionNumber": "Version #{number}",
	"aiAssistant.versionCard.menu.openDiff": "Open diff",
	"aiAssistant.versionCard.menu.restore": "Restore",
	"aiAssistant.versionCard.menu.showInHistory": "Show in history",
	"aiAssistant.builder.canvasPrompt.title": "What would you like to automate?",
	"aiAssistant.builder.canvasPrompt.confirmTitle": "Replace current prompt?",
	"aiAssistant.builder.canvasPrompt.confirmMessage": "This will replace your current prompt. Are you sure?",
	"aiAssistant.builder.canvasPrompt.confirmButton": "Replace",
	"aiAssistant.builder.canvasPrompt.cancelButton": "Cancel",
	"aiAssistant.builder.canvasPrompt.startManually.title": "Start manually",
	"aiAssistant.builder.canvasPrompt.startManually.subTitle": "Add the first node",
	"aiAssistant.builder.canvasPrompt.buildWithAI": "Build with AI",
	"aiAssistant.builder.credentialHelpMessage": "How do I set up the credentials for {credentialName}?",
	"aiAssistant.builder.errorHelpMessage": "I'm getting an error on the \"{nodeName}\" node: {errorMessage}",
	"aiAssistant.builder.streamAbortedMessage": "Task aborted",
	"aiAssistant.builder.executeMessage.description": "Complete these steps to finalize your workflow",
	"aiAssistant.builder.executeMessage.noIssues": "Your workflow is ready to be executed",
	"aiAssistant.builder.executeMessage.noIssuesWithPinData": "Your workflow is set up with test data (pinned data) for you to execute. Unpin nodes to execute with your own data.",
	"aiAssistant.builder.executeMessage.validationTooltip": "Complete the steps above before executing",
	"aiAssistant.builder.executeMessage.execute": "Execute and refine",
	"aiAssistant.builder.executeMessage.chooseModel": "Choose model",
	"aiAssistant.builder.executeMessage.chooseCredentials": "Choose credentials",
	"aiAssistant.builder.executeMessage.noExecutionData": "Workflow execution could not be started. Please try again.",
	"aiAssistant.builder.executeMessage.executionSuccess": "Workflow executed successfully.",
	"aiAssistant.builder.executeMessage.executionFailedOnNode": "Workflow execution failed on node \"{nodeName}\": {errorMessage}",
	"aiAssistant.builder.executeMessage.executionFailed": "Workflow execution failed: {errorMessage}",
	"aiAssistant.builder.executeMessage.fillParameter": "Update \"{label}\" parameter",
	"aiAssistant.builder.executeMessage.addMissingCredentials": "Add missing credentials:",
	"aiAssistant.builder.executeMessage.nodeListTwo": "{first} and {second}",
	"aiAssistant.builder.executeMessage.nodeListLast": "{list}, and {last}",
	"aiAssistant.builder.executeMessage.nodeListMore": "{list}, and {count} more | {list}, and {count} more",
	"aiAssistant.builder.executeMessage.unpinAll": "Unpin all nodes",
	"aiAssistant.builder.executeMessage.unpinIndividually": "or unpin individually",
	"aiAssistant.builder.executeMessage.unpinTooltip": "Right-click on a node and select \"Unpin\" to unpin it",
	"aiAssistant.builder.followUps.title": "Follow-ups",
	"aiAssistant.builder.followUps.executeWithMockData": "Execute with mock data",
	"aiAssistant.builder.followUps.unpinTestData": "Unpin test data",
	"aiAssistant.builder.followUps.repinTestData": "Re-pin test data",
	"aiAssistant.builder.followUps.executeAndRefine": "Execute and refine",
	"aiAssistant.builder.followUps.executeWithConfiguredData": "Execute with my configured data",
	"aiAssistant.builder.executeMessage.wizardSetupSuccess": "Workflow set up successfully",
	"aiAssistant.builder.setupWizard.continue": "Continue",
	"aiAssistant.builder.setupWizard.complete": "Complete",
	"aiAssistant.builder.setupWizard.checkingCredentials": "Checking credentials",
	"aiAssistant.builder.setupWizard.configureParameters": "Configure {count} parameter | Configure {count} parameters",
	"aiAssistant.builder.toast.title": "Send chat message to start the execution",
	"aiAssistant.builder.toast.description": "Please send a message in the chat panel to start the execution of your workflow",
	"aiAssistant.builder.restoreError.title": "Failed to restore version",
	"aiAssistant.builder.disabledTooltip.autosaving": "Saving workflow...",
	"aiAssistant.builder.disabledTooltip.readOnly": "Another user is currently editing this workflow",
	"aiAssistant.builder.thinkingCompletionMessage.codeBuilder": "Crafting workflow",
	"aiAssistant.builder.notification.title": "Workflow ready - n8n",
	"aiAssistant.builder.notification.body": "Done building {workflowName}",
	"aiAssistant.builder.notification.inputNeeded.title": "Input needed - n8n",
	"aiAssistant.builder.notification.inputNeeded.body": "Waiting for your response on {workflowName}",
	"aiAssistant.builder.notificationBanner.text": "Want to be notified when the agent finishes building?",
	"aiAssistant.builder.notificationBanner.notify": "Notify",
	"aiAssistant.builder.settings.credits": "Credits",
	"aiAssistant.builder.settings.creditsLeft": "{count} left",
	"aiAssistant.builder.settings.threadCreditsUsed": "This thread has used {count} credits so far",
	"aiAssistant.builder.settings.getMoreCredits": "Get more credits",
	"aiAssistant.builder.settings.creditsTooltip": "Credits are based on token usage. Credits renew on {renewalDate}. Unused credits expire on {expiryDate}.",
	"aiAssistant.builder.creditBanner.text": "{remaining}/{total} monthly credits left",
	"aiAssistant.builder.creditBanner.trialText": "{remaining}/{total} credits left in your free trial",
	"aiAssistant.builder.creditBanner.getMore": "Get more",
	"aiAssistant.builder.upgradeWhileStreaming.title": "AI Builder is still working",
	"aiAssistant.builder.upgradeWhileStreaming.message": "The AI Builder is currently generating your workflow. Leaving this page will stop the generation.",
	"aiAssistant.builder.upgradeWhileStreaming.confirmButtonText": "Leave and upgrade",
	"aiAssistant.builder.upgradeWhileStreaming.cancelButtonText": "Stay",
	"aiAssistant.newSessionModal.title.part1": "Start new",
	"aiAssistant.newSessionModal.title.part2": "session",
	"aiAssistant.newSessionModal.message": "You already have an active n8n AI session. Starting a new session will clear your current conversation history.",
	"aiAssistant.newSessionModal.question": "Are you sure you want to start a new session?",
	"aiAssistant.newSessionModal.confirm": "Start new session",
	"aiAssistant.serviceError.message": "Unable to connect to n8n's AI service ({message})",
	"aiAssistant.payloadTooBig.message": "Payload size is too large",
	"aiAssistant.codeUpdated.message.title": "n8n AI modified workflow",
	"aiAssistant.codeUpdated.message.body1": "Open the",
	"aiAssistant.codeUpdated.message.body2": "node to see the changes",
	"aiAssistant.thinkingSteps.analyzingError": "Analyzing the error...",
	"aiAssistant.thinkingSteps.compacting": "Compacting",
	"aiAssistant.thinkingSteps.thinking": "Thinking",
	"aiAssistant.prompts.currentView.workflowList": "The user is currently looking at the list of workflows.",
	"aiAssistant.prompts.currentView.credentialsList": "The user is currently looking at the list of credentials.",
	"aiAssistant.prompts.currentView.executionsView": "The user is currently looking at the list of executions for the currently open workflow.",
	"aiAssistant.prompts.currentView.workflowEditor": "The user is currently looking at the current workflow in n8n editor, without any specific node selected.",
	"aiAssistant.tooltip": "n8n AI",
	"aiAssistant.coachmark.title": "Ask mode enabled",
	"aiAssistant.coachmark.body": "Ask questions about n8n, get help with errors, or learn about automation. Switch to Build anytime to create workflows.",
	"aiAssistant.coachmark.gotIt": "Got it",
	"nodeCreator.shortcutCoachmark.title": "Press N to browse nodes",
	"nodeCreator.shortcutCoachmark.body": "We changed the shortcut to improve keyboard navigation",
	"nodeCreator.shortcutCoachmark.gotIt": "Got it",
	"aiAssistant.askMode.emptyState.title": "Ask n8n AI",
	"aiAssistant.askMode.emptyState.body1": "Ask anything about n8n, your workflow, or how to accomplish a task. This won't use any of your AI credits.",
	"aiAssistant.askMode.emptyState.body2": "Look for the",
	"aiAssistant.askMode.emptyState.body3": "button throughout the UI to get contextual help.",
	"aiAssistant.askMode.inputPlaceholder": "What do you need help with?",
	"banners.confirmEmail.message.1": "To secure your account and prevent future access issues, please confirm your",
	"banners.confirmEmail.message.2": "email address.",
	"banners.confirmEmail.button": "Confirm email",
	"banners.confirmEmail.toast.success.heading": "Confirmation email sent",
	"banners.confirmEmail.toast.success.message": "Please check your inbox and click the confirmation link.",
	"banners.confirmEmail.toast.error.heading": "Problem sending confirmation email",
	"banners.confirmEmail.toast.error.message": "Please try again later.",
	"banners.nonProductionLicense.message": "This n8n instance is not licensed for production purposes.",
	"banners.trial.message.days": "1 day left in your n8n trial | {count} days left in your n8n trial",
	"banners.trial.message.hours": "1 hour left in your n8n trial | {count} hours left in your n8n trial",
	"banners.trial.message.minutes": "1 minute left in your n8n trial | {count} minutes left in your n8n trial",
	"banners.trialOver.message": "Your trial is over. Upgrade now to keep automating.",
	"banners.v1.message": "n8n has been updated to version 1, introducing some breaking changes. Please consult the <a target=\"_blank\" href=\"https://docs.n8n.io/1-0-migration-checklist\">migration guide</a> for more information.",
	"banners.workflowAutoDeactivated.message": "This workflow was automatically deactivated due to multiple crashed executions. Please review and reactivate it when ready.",
	"binaryDataDisplay.backToList": "Back to list",
	"binaryDataDisplay.backToOverviewPage": "Back to overview page",
	"binaryDataDisplay.noDataFoundToDisplay": "No data found to display",
	"binaryDataDisplay.yourBrowserDoesNotSupport": "Your browser does not support the video element. Kindly update it to latest version.",
	"chat.hide": "Hide chat",
	"chat.open": "Open chat",
	"chat.window.title": "Chat",
	"chat.window.logs": "Latest Logs",
	"chat.window.logsFromNode": "from {nodeName} node",
	"chat.window.noChatNode": "No Chat Node",
	"chat.window.noExecution": "Nothing got executed yet",
	"chat.window.chat.placeholder": "Type message, or press ‘up’ for previous one",
	"chat.window.chat.placeholderPristine": "Type a message",
	"chat.window.chat.sendButtonText": "Send",
	"chat.window.chat.provideMessage": "Please provide a message",
	"chat.window.chat.emptyChatMessage": "Empty chat message",
	"chat.window.chat.emptyChatMessage.v2": "Send a message below to trigger the chat workflow",
	"chat.window.chat.chatMessageOptions.reuseMessage": "Reuse Message",
	"chat.window.chat.chatMessageOptions.repostMessage": "Repost Message",
	"chat.window.chat.chatMessageOptions.executionId": "Execution ID",
	"chat.window.chat.unpinAndExecute.description": "Sending the message overwrites the pinned chat node data.",
	"chat.window.chat.unpinAndExecute.title": "Unpin chat output data?",
	"chat.window.chat.unpinAndExecute.confirm": "Unpin and send",
	"chat.window.chat.unpinAndExecute.cancel": "Cancel",
	"chat.window.chat.response.empty": "[No response. Make sure the last executed node outputs the content to display here]",
	"chat.window.chat.response.redacted": "[Response data has been redacted]",
	"chat.window.session.title": "Session",
	"chat.window.session.id": "Session: {id}",
	"chat.window.session.id.copy": "(click to copy)",
	"chat.window.session.reset": "Reset",
	"chat.window.session.resetSession": "Reset chat session",
	"chatHub.agent.personalAgents": "Personal agents",
	"chatHub.agent.workflowAgents": "Workflow agents",
	"chatHub.agent.newAgent": "New Agent",
	"chatHub.agent.unavailableAgent": "Unavailable agent",
	"chatHub.agent.configureCredentials": "Configure credentials",
	"chatHub.agent.addModel": "Choose model by ID",
	"chatHub.agent.credentialsMissing": "Credentials missing",
	"chatHub.agent.card.menu.edit": "Edit",
	"chatHub.agent.card.menu.delete": "Delete",
	"chatHub.agent.card.noDescription": "No description",
	"chatHub.agent.card.button.edit": "Edit",
	"chatHub.agent.card.button.moreOptions": "More options",
	"chatHub.agent.editor.title.new": "New Agent",
	"chatHub.agent.editor.title.edit": "Edit Agent",
	"chatHub.agent.editor.name.label": "Icon and name",
	"chatHub.agent.editor.name.placeholder": "Enter agent name",
	"chatHub.agent.editor.iconPicker.button.tooltip": "Change icon",
	"chatHub.agent.editor.description.label": "Description",
	"chatHub.agent.editor.description.placeholder": "Enter agent description (optional)",
	"chatHub.agent.editor.systemPrompt.label": "Instructions",
	"chatHub.agent.editor.systemPrompt.placeholder": "Enter instructions (optional)",
	"chatHub.agent.editor.model.label": "Model",
	"chatHub.agent.editor.tools.label": "Tools",
	"chatHub.agent.editor.loading": "Loading agent...",
	"chatHub.agent.editor.saving": "Saving...",
	"chatHub.agent.editor.save": "Save",
	"chatHub.agent.editor.cancel": "Cancel",
	"chatHub.agent.editor.delete": "Delete",
	"chatHub.agent.editor.deleting": "Deleting...",
	"chatHub.agent.editor.delete.confirm.title": "Delete Agent",
	"chatHub.agent.editor.delete.confirm.message": "Are you sure you want to delete this agent? This action cannot be undone.",
	"chatHub.agent.editor.delete.confirm.button": "Delete",
	"chatHub.agent.editor.delete.cancel.button": "Cancel",
	"chatHub.agent.editor.error.load": "Failed to load agent",
	"chatHub.agent.editor.files.label": "Files",
	"chatHub.agent.editor.files.tooLarge": "File \"{fileName}\" is too large. Maximum file size is {maxSizeMb} MB.",
	"chatHub.agent.editor.files.createdAt": "Added on {date}",
	"chatHub.agent.editor.files.indexing": "Preparing...",
	"chatHub.agent.editor.files.failed": "Failed",
	"chatHub.agent.editor.files.unavailable": "Unavailable",
	"chatHub.agent.editor.files.indexingError.tooltip": "Indexing failed. Please remove this file and upload it again. Error: {error}",
	"chatHub.agent.editor.files.embeddingMismatch.tooltip": "This file was indexed with {fileProvider} embedding model. It may not be searchable because the current embedding model is {currentProvider}.",
	"chatHub.agent.editor.files.semanticSearchNotReady.tooltip": "Semantic search is not configured. This file may not be searchable.",
	"chatHub.agent.editor.error.save": "Failed to save agent",
	"chatHub.agent.editor.error.delete": "Failed to delete agent",
	"chatHub.agent.editor.success.create": "Agent created successfully",
	"chatHub.agent.editor.success.update": "Agent updated successfully",
	"chatHub.agent.editor.success.withFiles": "It takes up to a few minutes for uploaded files to be reflected in agent's response.",
	"chatHub.agent.editor.success.delete": "Agent deleted successfully",
	"chatHub.agent.editor.dropOverlay.addFile": "Add file to agent",
	"chatHub.agent.editor.dropOverlay.unsupportedFileType": "File type not supported. Only PDF files are accepted.",
	"chatHub.agent.editor.semanticSearch.notReady": "To upload PDF documents, contact your instance owner to configure semantic search in {settingsLink}.",
	"chatHub.agent.editor.semanticSearch.notReady.canConfigure": "To upload PDF documents, configure semantic search in {settingsLink}.",
	"chatHub.agent.editor.semanticSearch.settingsLink": "chat settings",
	"chatHub.agent.editor.suggestedPrompts.label": "Suggestions",
	"chatHub.agent.editor.suggestedPrompts.tooltip": "These are shown as clickable prompts when starting a new chat with this agent.",
	"chatHub.agent.editor.suggestedPrompts.placeholder": "Enter a suggested prompt",
	"chatHub.agent.editor.suggestedPrompts.addButton": "Add Prompt",
	"chatHub.agents.loadError": "Failed to load agent",
	"chatHub.agents.delete.confirm.message": "Are you sure you want to delete this agent?",
	"chatHub.agents.delete.confirm.title": "Delete agent",
	"chatHub.agents.delete.confirm.button": "Delete",
	"chatHub.agents.delete.cancel.button": "Cancel",
	"chatHub.agents.delete.success": "Agent deleted successfully",
	"chatHub.agents.delete.error": "Could not delete the agent",
	"chatHub.agents.button.newAgent": "New Agent",
	"chatHub.agents.search.placeholder": "Search",
	"chatHub.agents.sort.updatedAt": "Sort by last updated",
	"chatHub.agents.sort.createdAt": "Sort by created",
	"chatHub.agents.empty.noMatch": "No agents match your search criteria.",
	"chatHub.workflowAgents.title": "Workflow Agents",
	"chatHub.workflowAgents.description": "Browse and use AI agents built with n8n workflows",
	"chatHub.workflowAgents.empty.noAgents": "No workflow agents available.",
	"chatHub.workflowAgents.empty.noMatch": "No workflow agents match your search criteria.",
	"chatHub.personalAgents.title": "Personal Agents",
	"chatHub.personalAgents.description": "Create and manage custom AI agents with specific instructions and behaviors",
	"chatHub.personalAgents.empty.noAgents": "No personal agents available. Create your first custom agent to get started.",
	"chatHub.personalAgents.empty.noMatch": "No personal agents match your search criteria.",
	"chatHub.chat.greeting": "Start a chat with",
	"chatHub.chat.greeting.fallback": "Select a model to start chatting",
	"chatHub.welcome.header": "Your agents, any model",
	"chatHub.welcome.subtitle": "One place to talk to everything you've built or connected",
	"chatHub.welcome.card.workflowAgents.title": "Workflow agents",
	"chatHub.welcome.card.workflowAgents.description": "Agents built with n8n workflows, made available by builders in your instance.",
	"chatHub.welcome.card.personalAgents.title": "Personal agents",
	"chatHub.welcome.card.personalAgents.description": "Simple agents with custom instructions and tool sets you define.",
	"chatHub.welcome.card.baseModels.title": "Base models",
	"chatHub.welcome.card.baseModels.description": "Chat models from any provider you have access to a credential for.",
	"chatHub.welcome.button.startNewChat": "Start new chat",
	"chatHub.welcome.button.inviteChatUsers": "Invite chat users",
	"chatHub.welcome.inviteUpgrade.tooltip": "{link} to invite chat users. Read more {docsLink}",
	"chatHub.welcome.inviteUpgrade.here": "here.",
	"chatHub.chat.dropOverlay": "Drop files here to attach",
	"chatHub.chat.scrollToBottom": "Scroll to bottom",
	"chatHub.chat.header.button.editAgent": "Edit Agent",
	"chatHub.chat.header.button.newChat": "New Chat",
	"chatHub.chat.header.button.openWorkflow": "Open Workflow",
	"chatHub.chat.header.button.manageConnections": "Manage connections",
	"chatHub.chat.prompt.microphone.accessDenied": "Microphone access denied",
	"chatHub.chat.prompt.microphone.allowAccess": "Please allow microphone access to use voice input",
	"chatHub.chat.prompt.microphone.noSpeech": "No speech detected. Please try again",
	"chatHub.chat.prompt.callout.selectModel.new": "Please {link} to start a conversation",
	"chatHub.chat.prompt.callout.selectModel.new.link": "select a model",
	"chatHub.chat.prompt.callout.selectModel.existing": "Please {link} to continue the conversation",
	"chatHub.chat.prompt.callout.selectModel.existing.link": "reselect a model",
	"chatHub.chat.prompt.callout.setCredentials.new": "Please {link} for {provider} to start a conversation",
	"chatHub.chat.prompt.callout.setCredentials.new.link": "set credentials",
	"chatHub.chat.prompt.callout.setCredentials.existing": "Please {link} for {provider} to continue the conversation",
	"chatHub.chat.prompt.callout.setCredentials.existing.link": "set credentials",
	"chatHub.chat.prompt.callout.dynamicCredentials.missing": "To run this workflow, connect the required accounts.",
	"chatHub.chat.prompt.callout.dynamicCredentials.missing.button": "Connect",
	"chatHub.chat.prompt.callout.dynamicCredentials.expired": "Connection expired. Reconnect missing accounts to continue.",
	"chatHub.chat.prompt.callout.dynamicCredentials.expired.button": "Connect",
	"chatHub.dynamicCredentials.drawer.title": "Credentials",
	"chatHub.dynamicCredentials.drawer.subtitle": "Required connections",
	"chatHub.dynamicCredentials.drawer.description": "This workflow will access the accounts below to complete your request. Manage or disconnect them anytime.",
	"chatHub.dynamicCredentials.drawer.connect": "Connect",
	"chatHub.dynamicCredentials.drawer.disconnect": "Disconnect",
	"chatHub.dynamicCredentials.drawer.status.notConnected": "not connected",
	"chatHub.dynamicCredentials.drawer.status.connected": "Connected",
	"chatHub.dynamicCredentials.drawer.footer": "{connected}/{total} connections",
	"chatHub.chat.prompt.button.attach": "Attach",
	"chatHub.chat.prompt.button.attach.disabled": "File attachments are not supported by the selected model",
	"chatHub.chat.attachments.unsupported.title": "Some files couldn't be uploaded",
	"chatHub.chat.attachments.unsupported.toast": "{fileName} isn't a supported file type and was not attached.",
	"chatHub.chat.prompt.button.stopRecording": "Stop recording",
	"chatHub.chat.prompt.button.voiceInput": "Voice input",
	"chatHub.chat.prompt.button.send": "Send",
	"chatHub.chat.prompt.button.stopGenerating": "Stop generating",
	"chatHub.chat.prompt.placeholder.withModel": "Message {model}...",
	"chatHub.chat.prompt.placeholder.selectModel": "Select a model",
	"chatHub.chat.prompt.placeholder.sendPreview": "Send preview message...",
	"chatHub.canvas.previewBadge": "Preview",
	"chatHub.canvas.floatingTitle": "Chat preview",
	"chatHub.canvas.session.newChat": "New Chat",
	"chatHub.canvas.session.noSessions": "No previous sessions for this workflow",
	"chatHub.canvas.session.tooltip.sessionId": "Session: {sessionId}",
	"chatHub.canvas.menu.sessions": "Sessions",
	"chatHub.canvas.menu.copySessionId": "Copy session ID",
	"chatHub.canvas.menu.newSession": "New session",
	"chatHub.canvas.menu.popOut": "Pop out",
	"chatHub.tools.editor.title": "Add Tools",
	"chatHub.tools.editor.credential": "Credential",
	"chatHub.tools.editor.credential.placeholder": "Select credential…",
	"chatHub.tools.editor.credential.createNew": "Create New",
	"chatHub.tools.editor.credential.createNew.permissionDenied": "Your current role does not allow you to create credentials",
	"chatHub.tools.editor.selectedCount": "{count} tool selected | {count} tools selected",
	"chatHub.tools.editor.confirm": "Confirm",
	"chatHub.tools.editor.cancel": "Cancel",
	"chatHub.tools.selector.label.count": "{count} Tool | {count} Tools",
	"chatHub.tools.selector.label.default": "Tools",
	"chatHub.tools.selector.createNew": "Create new tool",
	"chatHub.tools.selector.disabled.tooltip": "Tools are not supported by the selected model",
	"chatHub.tools.selector.disabled.noModel.tooltip": "Select a model to use tools",
	"chatHub.toolSettings.title": "Configure Tool",
	"chatHub.toolSettings.confirm": "Save",
	"chatHub.toolSettings.cancel": "Cancel",
	"chatHub.toolsManager.title": "Tools",
	"chatHub.toolsManager.searchPlaceholder": "Search tools...",
	"chatHub.toolsManager.configuredTools": "Configured tools ({count})",
	"chatHub.toolsManager.availableTools": "Available tools ({count})",
	"chatHub.toolsManager.noResults": "No tools found",
	"chatHub.toolsManager.add": "Add",
	"chatHub.toolsManager.addTool": "Add tool",
	"chatHub.toolsManager.remove": "Remove",
	"chatHub.toolsManager.configure": "Configure",
	"chatHub.toolsManager.manageTools": "Manage tools",
	"chatHub.toolsManager.enableTool": "Enable tool",
	"chatHub.toolsManager.confirmRemove.message": "Are you sure you want to remove this tool? It will also be removed from all your conversations and personal agents that use it.",
	"chatHub.toolsManager.confirmRemove.title": "Remove tool",
	"chatHub.toolsManager.disableTool": "Disable tool",
	"chatHub.credentials.selector.title": "Select {provider} credential",
	"chatHub.credentials.selector.chooseOrCreate": "Choose or create a credential for {provider}",
	"chatHub.credentials.selector.createNew": "Create new",
	"chatHub.credentials.selector.createNew.permissionDenied": "Your current role does not allow you to create credentials",
	"chatHub.credentials.selector.confirm": "Select",
	"chatHub.credentials.selector.cancel": "Cancel",
	"chatHub.message.actions.readAloud": "Read aloud",
	"chatHub.message.actions.stopReading": "Stop reading",
	"agents.builder.preview.sendToAssistant": "Send to assistant",
	"chatHub.message.actions.edit": "Edit",
	"chatHub.message.actions.regenerate": "Regenerate",
	"chatHub.message.actions.executionId": "Execution ID",
	"chatHub.message.edit.cancel": "Cancel",
	"chatHub.message.edit.send": "Send",
	"chatHub.message.error.unknown": "Something went wrong. Please try again.",
	"chatHub.error.payloadTooLarge": "Message too large",
	"chatHub.error.badRequest": "Invalid request",
	"chatHub.error.forbidden": "Permission denied",
	"chatHub.error.serverError": "Server error",
	"chatHub.error.serverErrorWithReason": "Server error: {error}",
	"chatHub.error.unknown": "Unknown error",
	"chatHub.error.noConnection": "Connection failed",
	"chatHub.error.fetchConversationFailed": "Failed to load conversation",
	"chatHub.error.sendMessageFailed": "Failed to send message",
	"chatHub.error.updateModelFailed": "Failed to update model",
	"chatHub.error.updateToolsFailed": "Failed to update tools",
	"chatHub.models.selector.defaultLabel": "Select model",
	"chatHub.models.selector.personalProject": "Personal",
	"chatHub.models.selector.noMatch": "No agents match your search criteria.",
	"chatHub.models.selector.moreModels": "More {providerName} models...",
	"chatHub.models.byIdSelector.title": "Choose {provider} model by ID",
	"chatHub.models.byIdSelector.choose": "Enter model identifier (e.g. \"gpt-4\")",
	"chatHub.models.byIdSelector.confirm": "Select",
	"chatHub.models.byIdSelector.cancel": "Cancel",
	"chatHub.session.actions.rename": "Rename",
	"chatHub.session.actions.delete": "Delete",
	"chatHub.session.updateTitle.error": "Could not update the conversation title.",
	"chatHub.session.delete.confirm.message": "Are you sure you want to delete this conversation?",
	"chatHub.session.delete.confirm.title": "Delete conversation",
	"chatHub.session.delete.confirm.button": "Delete",
	"chatHub.session.delete.cancel.button": "Cancel",
	"chatHub.session.delete.success": "Conversation is deleted",
	"chatHub.session.delete.error": "Could not delete the conversation",
	"chatHub.sidebar.title": "Chat",
	"chatHub.sidebar.button.toggle": "Toggle sidebar",
	"chatHub.sidebar.link.newChat": "New chat",
	"chatHub.sidebar.link.workflowAgents": "Workflow agents",
	"chatHub.sidebar.link.personalAgents": "Personal agents",
	"chatHub.sidebar.loadMoreSessions": "Load more",
	"chatEmbed.infoTip.description": "Add chat to external applications using the n8n chat package.",
	"chatEmbed.infoTip.link": "More info",
	"chatEmbed.title": "Embed Chat in your website",
	"chatEmbed.close": "Close",
	"chatEmbed.install": "First, install the n8n chat package:",
	"chatEmbed.paste.cdn": "Paste the following code anywhere in the {code} tag of your HTML file.",
	"chatEmbed.paste.cdn.file": "<body>",
	"chatEmbed.paste.vue": "Next, paste the following code in your {code} file.",
	"chatEmbed.paste.vue.file": "App.vue",
	"chatEmbed.paste.react": "Next, paste the following code in your {code} file.",
	"chatEmbed.paste.react.file": "App.ts",
	"chatEmbed.paste.other": "Next, paste the following code in your {code} file.",
	"chatEmbed.paste.other.file": "main.ts",
	"chatEmbed.packageInfo.description": "The n8n Chat widget can be easily customized to fit your needs.",
	"chatEmbed.packageInfo.link": "Read the full documentation",
	"chatEmbed.chatTriggerNode": "You can use a Chat Trigger Node to embed the chat widget directly into n8n.",
	"chatEmbed.url": "https://www.npmjs.com/package/{'@'}n8n/chat",
	"codeEdit.edit": "Edit",
	"codeNodeEditor.askAi": "✨ Ask AI",
	"codeNodeEditor.completer.$()": "Output data of the {nodeName} node",
	"codeNodeEditor.completer.$execution": "Retrieve or set metadata for the current execution",
	"codeNodeEditor.completer.$execution.id": "The ID of the current workflow execution",
	"codeNodeEditor.completer.$execution.mode": "Returns either <code>test</code> (meaning the execution was triggered by clicking a button in n8n) or <code>production</code> (meaning the execution was triggered automatically)",
	"codeNodeEditor.completer.$execution.resumeUrl": "The webhook URL to call to resume a workflow waiting at a 'Wait' node.",
	"codeNodeEditor.completer.$execution.resumeFormUrl": "The URL to access a form generated by the 'Wait' node.",
	"codeNodeEditor.completer.$execution.customData": "Set and get custom execution data (e.g. to filter executions by). You can also do this with the 'Execution Data' node.",
	"codeNodeEditor.completer.$execution.customData.set": "Stores custom execution data under the key specified. Use this to easily filter executions by this data.",
	"codeNodeEditor.completer.$execution.customData.set.args.key": "The key (identifier) under which the data is stored",
	"codeNodeEditor.completer.$execution.customData.set.args.value": "The data to store",
	"codeNodeEditor.completer.$execution.customData.set.examples.1": "Store the user's email, to easily retrieve all execs related to that user later",
	"codeNodeEditor.completer.$execution.customData.get": "Returns the custom execution data stored under the given key.",
	"codeNodeEditor.completer.$execution.customData.get.args.key": "The key (identifier) under which the data is stored",
	"codeNodeEditor.completer.$execution.customData.get.examples.1": "Get the user's email (which was previously stored)",
	"codeNodeEditor.completer.$execution.customData.setAll": "Sets multiple key-value pairs of  custom data for the execution. Use this to easily filter executions by this data.",
	"codeNodeEditor.completer.$execution.customData.setAll.args.obj": "A JavaScript object containing key-value pairs of the data to set",
	"codeNodeEditor.completer.$execution.customData.getAll": "Returns all the key-value pairs of custom data that have been set in the current execution.",
	"codeNodeEditor.completer.$ifEmpty": "Returns the first parameter if it isn't empty, otherwise returns the second parameter. The following count as empty: <code>\"</code>, <code>[]</code>, <code>{'{}'}</code>, <code>null</code>, <code>undefined</code>",
	"codeNodeEditor.completer.$ifEmpty.args.value": "The value to return, provided it isn't empty",
	"codeNodeEditor.completer.$ifEmpty.args.valueIfEmpty": "What to return if <code>value</code> is empty",
	"codeNodeEditor.completer.$input": "The input data of the current node",
	"codeNodeEditor.completer.$input.all": "@:_reusableBaseText.codeNodeEditor.completer.all",
	"codeNodeEditor.completer.$input.first": "@:_reusableBaseText.codeNodeEditor.completer.first",
	"codeNodeEditor.completer.$input.item": "The item that generated the current one",
	"codeNodeEditor.completer.$input.itemMatching": "@:_reusableBaseText.codeNodeEditor.completer.itemMatching",
	"codeNodeEditor.completer.$input.last": "@:_reusableBaseText.codeNodeEditor.completer.last",
	"codeNodeEditor.completer.$itemIndex": "The position of the item currently being processed in the list of input items",
	"codeNodeEditor.completer.$jmespath": "Extracts data from an object (or array of objects) using a <a target=\"_blank\" href=\"https://docs.n8n.io/code/cookbook/jmespath/\">JMESPath</a> expression. Useful for querying complex, nested objects. Returns <code>undefined</code> if the expression is invalid.",
	"codeNodeEditor.completer.$jmespath.args.obj": "The Object or array of Objects to retrieve data from",
	"codeNodeEditor.completer.$jmespath.args.expression": "A <a target=\"_blank\" href=\"https://jmespath.org/examples.html\">JMESPath expression</a> defining the data to retrieve from the object",
	"codeNodeEditor.completer.$jmespath.examples.1": "Get all names, in an array",
	"codeNodeEditor.completer.$jmespath.examples.2": "Get the names and ages of everyone under 20",
	"codeNodeEditor.completer.$jmespath.examples.3": "Get the name of the first person under 20",
	"codeNodeEditor.completer.$jmespath.examples.4": "Get the names of all the guests in each reservation that require a double room",
	"codeNodeEditor.completer.$if": "Returns one of two values depending on the <code>condition</code>. Similar to the <code>?</code> operator in JavaScript.",
	"codeNodeEditor.completer.$if.args.condition": "The check to make. Should evaluate to either <code>true</code> or <code>false</code>",
	"codeNodeEditor.completer.$if.args.valueIfTrue": "The value to return if the condition is true",
	"codeNodeEditor.completer.$if.args.valueIfFalse": "The value to return if the condition is false",
	"codeNodeEditor.completer.$if.examples.1": "Return \"Good day\" if time is before 5pm, otherwise \"Good evening\"",
	"codeNodeEditor.completer.$if.examples.2": "$if() calls can be combined\nReturn \"Good morning\" if time is before 10am, \"Good day\" it's before 5pm, otherwise \"Good evening\"",
	"codeNodeEditor.completer.$max": "Returns the highest of the given numbers, or -Infinity if there are no parameters.",
	"codeNodeEditor.completer.$max.args.numbers": "The numbers to compare",
	"codeNodeEditor.completer.$min": "Returns the lowest of the given numbers, or Infinity if there are no parameters.",
	"codeNodeEditor.completer.$now": "A DateTime representing the current moment. \n\nUses the workflow's time zone (which can be changed in the workflow settings).",
	"codeNodeEditor.completer.$parameter": "The configuration settings of the current node. These are the parameters you fill out within the node's UI (e.g. its operation).",
	"codeNodeEditor.completer.$prevNode": "Information about the node that the current input came from. \n\nWhen in a 'Merge' node, always uses the first input connector.",
	"codeNodeEditor.completer.$prevNode.name": "The name of the node that the current input came from. \n\nAlways uses the current node's first input connector if there is more than one (e.g. in the 'Merge' node).",
	"codeNodeEditor.completer.$prevNode.outputIndex": "The index of the output connector that the current input came from. Use this when the previous node had multiple outputs (such as an 'If' or 'Switch' node). \n\nAlways uses the current node's first input connector if there is more than one (e.g. in the 'Merge' node).",
	"codeNodeEditor.completer.$prevNode.runIndex": "The run of the previous node that generated the current input. \n\nAlways uses the current node's first input connector if there is more than one (e.g. in the 'Merge' node). ",
	"codeNodeEditor.completer.$runIndex": "The index of the current run of the current node execution. Starts at 0.",
	"codeNodeEditor.completer.$nodeVersion": "The version of the current node (as displayed at the bottom of the nodes's settings pane)",
	"codeNodeEditor.completer.$tool": "The name and parameters of the tool that is currently being executed. Only available in HITL nodes",
	"codeNodeEditor.completer.$today": "A DateTime representing midnight at the start of the current day. \n\nUses the instance's time zone (unless overridden in the workflow's settings).",
	"codeNodeEditor.completer.$vars": "The <a target=\"_blank\"  href=\"https://docs.n8n.io/code/variables/\">variables</a> available to the workflow",
	"codeNodeEditor.completer.$vars.varName.global": "Global variable defined for this n8n instance. All variables evaluate to strings.",
	"codeNodeEditor.completer.$vars.varName.global.overridden": "Global variable overridden by project {projectName} variable. All variables evaluate to strings. ",
	"codeNodeEditor.completer.$vars.varName.project": "Project variable defined in the {projectName} project. All variables evaluate to strings.",
	"codeNodeEditor.completer.$secrets": "The secrets from an <a target=\"_blank\" href=\"https://docs.n8n.io/external-secrets/\">external secrets vault</a>, if configured. Secret values are never displayed to the user. Only available in credential fields.",
	"codeNodeEditor.completer.$secrets.provider": "External secrets providers connected to this n8n instance.",
	"codeNodeEditor.completer.$secrets.provider.varName": "External secrets connected to this n8n instance. All secrets evaluate to strings.",
	"codeNodeEditor.completer.$secrets.group.project": "Project vaults",
	"codeNodeEditor.completer.$secrets.group.project.description": "External secret vault connected to this project.",
	"codeNodeEditor.completer.$secrets.group.global": "Global vaults",
	"codeNodeEditor.completer.$secrets.group.global.description": "External secret vault connected to this n8n instance.",
	"codeNodeEditor.completer.$workflow": "Information about the current workflow",
	"codeNodeEditor.completer.$workflow.active": "Whether the workflow is active",
	"codeNodeEditor.completer.$workflow.id": "The workflow ID. Can also be found in the workflow's URL.",
	"codeNodeEditor.completer.$workflow.name": "The name of the workflow, as shown at the top of the editor",
	"codeNodeEditor.completer.$response": "The response returned by the last HTTP call. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.$response.headers": "The headers returned by the last HTTP call. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.$response.statusCode": "The HTTP status code returned by the last HTTP call. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.$response.statusMessage": "An optional message regarding the request status. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.$response.body": "The body of the response object from the last HTTP call. Only available in the 'HTTP Request' node",
	"codeNodeEditor.completer.$request": "The request object sent during the last run of the node. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.$pageCount": "The number of results pages the node has fetched. Only available in the 'HTTP Request' node.",
	"codeNodeEditor.completer.dateTime": "Luxon DateTime. Use this object to parse, format and manipulate dates and times.",
	"codeNodeEditor.completer.binary": "Returns any binary input data to the current node, for the current item. Shorthand for <code>$input.item.binary</code>.",
	"codeNodeEditor.completer.binary.mimeType": "A string representing the format of the file's contents, e.g. <code>image/jpeg</code>",
	"codeNodeEditor.completer.binary.fileSize": "A string representing the size of the file (e.g. <code>1 kB</code>)",
	"codeNodeEditor.completer.binary.fileName": "The name of the file, including extension",
	"codeNodeEditor.completer.binary.fileExtension": "The suffix attached to the filename (e.g. <code>txt</code>)",
	"codeNodeEditor.completer.binary.fileType": "A string representing the type of the file, e.g. <code>image</code>. Corresponds to the first part of the MIME type.",
	"codeNodeEditor.completer.binary.id": "The unique ID of the file. Used to identify the file when it is stored on disk or in a storage service such as S3.",
	"codeNodeEditor.completer.binary.directory": "The path to the directory that the file is stored in. Useful for distinguishing between files with the same name in different directories. Not set if n8n is  configured to store files in its database.",
	"codeNodeEditor.completer.item.binary": "Returns any binary data the item contains.",
	"codeNodeEditor.completer.item.json": "Returns the JSON data the item contains.",
	"codeNodeEditor.completer.math": "Mathematical utility methods",
	"codeNodeEditor.completer.globalObject": "Methods to manipulate JavaScript Objects",
	"codeNodeEditor.completer.globalObject.assign": "Merge all enumerable object properties into a target object. Returns the modified target object.",
	"codeNodeEditor.completer.globalObject.entries": "The object's keys and values",
	"codeNodeEditor.completer.globalObject.keys": "The object's keys",
	"codeNodeEditor.completer.globalObject.values": "The object's values",
	"codeNodeEditor.completer.json": "Returns the JSON input data to the current node, for the current item. Shorthand for <code>$input.item.json</code>.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.expandFormat": "Produce the the fully expanded format token for the locale Does NOT quote characters, so quoted tokens will not round trip correctly.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromFormat": "Create a DateTime from an input string and format string.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromFormatExplain": "Explain how a string would be parsed by fromFormat().",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromHTTP": "Create a DateTime from an HTTP header date",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromISO": "Create a DateTime from an ISO 8601 string",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromISO.args.isoString": "ISO 8601 string to convert to a DateTime",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromISO.args.opts": "Configuration options. See  See <a target=\"blank\" href=\"https://moment.github.io/luxon/api-docs/index.html#datetimefromiso\">Luxon docs</a> for more info.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromJSDate": "Create a DateTime from a JavaScript Date object. Uses the default zone",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromMillis": "Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromMillis.args.milliseconds": "Number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC)",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromMillis.args.opts": "Configuration options. See  See <a target=\"blank\" href=\"https://moment.github.io/luxon/api-docs/index.html#datetimefrommillis\">Luxon docs</a> for more info.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromObject": "Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromRFC2822": "Create a DateTime from an RFC 2822 string",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromString": "Deprecated: use `fromFormat` instead.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromStringExplain": "Deprecated: use `fromFormatExplain` instead.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromSQL": "Create a DateTime from a SQL date, time, or datetime",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromSeconds": "Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromSeconds.args.seconds": "Number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC)",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.fromSeconds.args.opts": "Configuration options. See <a target=\"blank\" href=\"https://moment.github.io/luxon/api-docs/index.html#datetimefromseconds\">Luxon docs</a> for more info.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.invalid": "Create an invalid DateTime.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.isDateTime": "Check if an object is a DateTime. Works across context boundaries",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.isDateTime.args.maybeDateTime": "Potential DateTime to check. Only instances of the Luxon DateTime class will return <code>true</code>.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.local": "Create a local DateTime",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.max": "Return the max of several date times.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.max.args.dateTimes": "DateTime objects to compare",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.min": "Return the min of several date times.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.min.args.dateTimes": "DateTime objects to compare",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.now": "Create a DateTime for the current instant, in the workflow's local time zone",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.parseFormatForOpts": "Produce the the fully expanded format token for the locale Does NOT quote characters, so quoted tokens will not round trip correctly.",
	"codeNodeEditor.completer.luxon.dateTimeStaticMethods.utc": "Create a DateTime in UTC",
	"codeNodeEditor.completer.luxon.instanceMethods.day": "The day of the month (1-31).",
	"codeNodeEditor.completer.luxon.instanceMethods.daysInMonth": "Returns the number of days in this DateTime's month.",
	"codeNodeEditor.completer.luxon.instanceMethods.daysInYear": "Returns the number of days in this DateTime's year.",
	"codeNodeEditor.completer.luxon.instanceMethods.diff": "Return the difference between two DateTimes as a Duration.",
	"codeNodeEditor.completer.luxon.instanceMethods.diffNow": "Return the difference between this DateTime and right now.",
	"codeNodeEditor.completer.luxon.instanceMethods.endOf": "Rounds the DateTime up to the end of one of its units, e.g. the end of the month",
	"codeNodeEditor.completer.luxon.instanceMethods.endOf.args.unit": "The unit to round to the end of. Can be <code>year</code>, <code>quarter</code>, <code>month</code>, <code>week</code>, <code>day</code>, <code>hour</code>, <code>minute</code>, <code>second</code>, or <code>millisecond</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.endOf.args.opts": "Object with options that affect the output. Possible properties:\n<code>useLocaleWeeks</code> (boolean): Whether to use the locale when calculating the start of the week. Defaults to false.",
	"codeNodeEditor.completer.luxon.instanceMethods.equals": "Returns <code>true</code> if the two DateTimes represent exactly the same moment and are in the same time zone. For a less strict comparison, use <code>hasSame()</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.equals.args.other": "The other DateTime to compare",
	"codeNodeEditor.completer.luxon.instanceMethods.hasSame": "Returns <code>true</code> if the two DateTimes are the same, down to the unit specified. Time zones are ignored (only local times are compared), so use <code>toUTC()</code> first if needed.",
	"codeNodeEditor.completer.luxon.instanceMethods.hasSame.args.other": "The other DateTime to compare",
	"codeNodeEditor.completer.luxon.instanceMethods.hasSame.args.unit": "The unit of time to check sameness down to. One of <code>year</code>, <code>quarter</code>, <code>month</code>, <code>week</code>, <code>day</code>, <code>hour</code>, <code>minute</code>, <code>second</code>, or <code>millisecond</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.hour": "The hour of the day (0-23).",
	"codeNodeEditor.completer.luxon.instanceMethods.invalidExplanation": "Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid.",
	"codeNodeEditor.completer.luxon.instanceMethods.invalidReason": "Returns an error code if this DateTime is invalid, or null if the DateTime is valid.",
	"codeNodeEditor.completer.luxon.instanceMethods.isInDST": "Whether the DateTime is in daylight saving time.",
	"codeNodeEditor.completer.luxon.instanceMethods.isInLeapYear": "Whether the DateTime is in a leap year.",
	"codeNodeEditor.completer.luxon.instanceMethods.isOffsetFixed": "Get whether this zone's offset ever changes, as in a DST.",
	"codeNodeEditor.completer.luxon.instanceMethods.isValid": "Returns whether the DateTime is valid. Invalid DateTimes occur when The DateTime was created from invalid calendar information, such as the 13th month or February 30. The DateTime was created by an operation on another invalid date.",
	"codeNodeEditor.completer.luxon.instanceMethods.locale": "The locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.max": "Return the max of several date times.",
	"codeNodeEditor.completer.luxon.instanceMethods.millisecond": "The millisecond of the second (0-999).",
	"codeNodeEditor.completer.luxon.instanceMethods.min": "Return the min of several date times",
	"codeNodeEditor.completer.luxon.instanceMethods.minus": "Subtract hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds.",
	"codeNodeEditor.completer.luxon.instanceMethods.minute": "The minute of the hour (0-59).",
	"codeNodeEditor.completer.luxon.instanceMethods.month": "The month (1-12).",
	"codeNodeEditor.completer.luxon.instanceMethods.monthLong": "The textual long month name, e.g. 'October'. Defaults to the system's locale if unspecified.",
	"codeNodeEditor.completer.luxon.instanceMethods.monthShort": "The textual abbreviated month name, e.g. 'Oct'. Defaults to the system's locale if unspecified.",
	"codeNodeEditor.completer.luxon.instanceMethods.numberingSystem": "Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.offset": "Get the UTC offset of this DateTime in minutes",
	"codeNodeEditor.completer.luxon.instanceMethods.offsetNameLong": "Get the long human name for the zone's current offset, for example \"Eastern Standard Time\" or \"Eastern Daylight Time\".",
	"codeNodeEditor.completer.luxon.instanceMethods.offsetNameShort": "Get the short human name for the zone's current offset, for example \"EST\" or \"EDT\".'",
	"codeNodeEditor.completer.luxon.instanceMethods.offsetNumber": "Get the short human name for the zone's current offset, for example \"EST\" or \"EDT\".'",
	"codeNodeEditor.completer.luxon.instanceMethods.ordinal": "Get the ordinal (meaning the day of the year).",
	"codeNodeEditor.completer.luxon.instanceMethods.outputCalendar": "Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.plus": "Add hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds.",
	"codeNodeEditor.completer.luxon.instanceMethods.quarter": "The quarter of the year (1-4).",
	"codeNodeEditor.completer.luxon.instanceMethods.reconfigure": "'Set' the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.resolvedLocaleOptions": "Returns the resolved Intl options for this DateTime. This is useful in understanding the behavior of formatting methods.",
	"codeNodeEditor.completer.luxon.instanceMethods.second": "The second of the minute (0-59).",
	"codeNodeEditor.completer.luxon.instanceMethods.set": "Assigns new values to specified units of the DateTime. To round a DateTime, see also <code>startOf()</code> and <code>endOf()</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.set.args.values": "An object containing the units to set and corresponding values to assign. Possible keys are <code>year</code>, <code>month</code>, <code>day</code>, <code>hour</code>, <code>minute</code>, <code>second</code> and <code>millsecond</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.setLocale": "Sets the locale, which determines the language and formatting for the DateTime. Useful when generating a textual representation of the DateTime, e.g. with <code>format()</code> or <code>toLocaleString()</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.setLocale.args.locale": "The locale to set, e.g. 'en-GB' for British English or 'pt-BR' for Brazilian Portuguese. <a target=\"blank\" href=”https://www.localeplanet.com/icu/”>List</a> (unofficial)",
	"codeNodeEditor.completer.luxon.instanceMethods.setZone": "Converts the DateTime to the given time zone. The DateTime still represents the same moment unless specified in the options. See also <code>toLocal()</code> and <code>toUTC()</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.setZone.args.zone": "A zone identifier, either in the format <code>'America/New_York'</code>, <code>'UTC+3'</code>, or the strings <code>'local'</code> or <code>'utc'</code>. <code>'local'</code> is the workflow's local time zone, this can be changed in workflow settings.",
	"codeNodeEditor.completer.luxon.instanceMethods.setZone.args.opts": "Options that affect the output. Possible properties:\n<code>keepCalendarTime</code> (boolean): Whether to keep the time the same and only change the offset. Defaults to false.",
	"codeNodeEditor.completer.luxon.instanceMethods.startOf": "Rounds the DateTime down to the beginning of one of its units, e.g. the start of the month",
	"codeNodeEditor.completer.luxon.instanceMethods.startOf.args.unit": "The unit to round to the beginning of. One of <code>year</code>, <code>quarter</code>, <code>month</code>, <code>week</code>, <code>day</code>, <code>hour</code>, <code>minute</code>, <code>second</code>, or <code>millisecond</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.startOf.args.opts": "Object with options that affect the output. Possible properties:\n<code>useLocaleWeeks</code> (boolean): Whether to use the locale when calculating the start of the week. Defaults to false.",
	"codeNodeEditor.completer.luxon.instanceMethods.toBSON": "Returns a BSON serializable equivalent to this DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.toFormat": "Returns a string representation of this DateTime formatted according to the specified format string.",
	"codeNodeEditor.completer.luxon.instanceMethods.toHTTP": "Returns a string representation of this DateTime appropriate for use in HTTP headers.",
	"codeNodeEditor.completer.luxon.instanceMethods.toISO": "Returns an ISO 8601-compliant string representation of this DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.toISO.args.opts": "Configuration options. See <a target=\"blank\" href=\"https://moment.github.io/luxon/api-docs/index.html#datetimetoiso\">Luxon docs</a> for more info.",
	"codeNodeEditor.completer.luxon.instanceMethods.toISODate": "Returns an ISO 8601-compliant string representation of this DateTime's date component.",
	"codeNodeEditor.completer.luxon.instanceMethods.toISOTime": "Returns an ISO 8601-compliant string representation of this DateTime's time component.",
	"codeNodeEditor.completer.luxon.instanceMethods.toISOWeekDate": "Returns an ISO 8601-compliant string representation of this DateTime's week date.",
	"codeNodeEditor.completer.luxon.instanceMethods.toJSON": "Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.",
	"codeNodeEditor.completer.luxon.instanceMethods.toJsDate": "Returns a JavaScript Date equivalent to this DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocal": "Converts a DateTime to the workflow's local time zone. The DateTime still represents the same moment unless specified in the parameters. The workflow's time zone can be set in the workflow settings.",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocal.example": "if time zone is Europe/Berlin",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocaleParts": "Returns an array of format \"parts\", meaning individual tokens along with metadata.",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocaleString": "Returns a localized string representing the DateTime, i.e. in the language and format corresponding to its locale. Defaults to the system's locale if none specified.",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocaleString.args.opts": "Configuration options for the rendering. See <a href=”https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#parameters”>Intl.DateTimeFormat</a> for a full list. Defaults to rendering a short date.",
	"codeNodeEditor.completer.luxon.instanceMethods.toLocaleString.example": "Configuration options for the rendering. See <a href=”https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#parameters”>Intl.DateTimeFormat</a> for a full list. Defaults to rendering a short date.",
	"codeNodeEditor.completer.luxon.instanceMethods.toMillis": "Returns a Unix timestamp in milliseconds (the number elapsed since 1st Jan 1970)",
	"codeNodeEditor.completer.luxon.instanceMethods.toObject": "Returns a JavaScript object with this DateTime's year, month, day, and so on.",
	"codeNodeEditor.completer.luxon.instanceMethods.toRFC2822": "Returns an RFC 2822-compatible string representation of this DateTime, always in UTC.",
	"codeNodeEditor.completer.luxon.instanceMethods.toRelative": "Returns a textual representation of the time relative to now, e.g. 'in two days'. Rounds down by default.",
	"codeNodeEditor.completer.luxon.instanceMethods.toRelative.args.opts": "Options that affect the output. Possible properties:\n<code>unit</code> = the unit to default to (<code>years</code>, <code>months</code>, <code>days</code>, etc.).\n<code>locale</code> = the language and formatting to use (e.g. <code>de</code>, <code>fr</code>)",
	"codeNodeEditor.completer.luxon.instanceMethods.toRelativeCalendar": "Returns a string representation of this date relative to today, such as '\"'yesterday' or 'next month'.",
	"codeNodeEditor.completer.luxon.instanceMethods.toSQL": "Returns a string representation of this DateTime appropriate for use in SQL DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.toSQLDate": "Returns a string representation of this DateTime appropriate for use in SQL Date.",
	"codeNodeEditor.completer.luxon.instanceMethods.toSQLTime": "Returns a string representation of this DateTime appropriate for use in SQL Time.",
	"codeNodeEditor.completer.luxon.instanceMethods.toSeconds": "Returns a Unix timestamp in seconds (the number elapsed since 1st Jan 1970)",
	"codeNodeEditor.completer.luxon.instanceMethods.toString": "Returns a string representation of the DateTime. Similar to <code>toISO()</code>. For more formatting options, see <code>format()</code> or <code>toLocaleString()</code>.",
	"codeNodeEditor.completer.luxon.instanceMethods.toUTC": "Converts a DateTime to the UTC time zone. The DateTime still represents the same moment unless specified in the parameters. Use <code>setZone()</code> to convert to other zones.",
	"codeNodeEditor.completer.luxon.instanceMethods.toUTC.args.offset": "An offset from UTC in minutes",
	"codeNodeEditor.completer.luxon.instanceMethods.toUTC.args.opts": "Options that affect the output. Possible properties:\n<code>keepCalendarTime</code> (boolean): Whether to keep the time the same and only change the offset. Defaults to false.",
	"codeNodeEditor.completer.luxon.instanceMethods.toUnixInteger": "Returns the epoch seconds (as a whole number) of this DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.until": "Return an Interval spanning between this DateTime and another DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.valueOf": "Returns the epoch milliseconds of this DateTime.",
	"codeNodeEditor.completer.luxon.instanceMethods.weekNumber": "The week number of the year (1-52ish).",
	"codeNodeEditor.completer.luxon.instanceMethods.weekYear": "Get the week year.",
	"codeNodeEditor.completer.luxon.instanceMethods.weekday": "The day of the week. 1 is Monday and 7 is Sunday.",
	"codeNodeEditor.completer.luxon.instanceMethods.weekdayLong": "The textual long weekday name, e.g. 'Wednesday'. Defaults to the system's locale if unspecified.",
	"codeNodeEditor.completer.luxon.instanceMethods.weekdayShort": "The textual abbreviated weekday name, e.g. 'Wed'. Defaults to the system's locale if unspecified.",
	"codeNodeEditor.completer.luxon.instanceMethods.weeksInWeekYear": "Returns the number of weeks in this DateTime's year.",
	"codeNodeEditor.completer.luxon.instanceMethods.year": "The year.",
	"codeNodeEditor.completer.luxon.instanceMethods.zone": "The time zone associated with the DateTime",
	"codeNodeEditor.completer.luxon.instanceMethods.zoneName": "Get the name of the time zone.",
	"codeNodeEditor.completer.selector.all": "@:_reusableBaseText.codeNodeEditor.completer.all",
	"codeNodeEditor.completer.selector.context": "Extra data about the node",
	"codeNodeEditor.completer.selector.first": "@:_reusableBaseText.codeNodeEditor.completer.first",
	"codeNodeEditor.completer.selector.item": "Returns the matching item, i.e. the one used to produce the current item in the current node.",
	"codeNodeEditor.completer.selector.args.branchIndex": "The output branch of the node to use. Defaults to the first branch (index 0)",
	"codeNodeEditor.completer.selector.args.runIndex": "The run of the node to use. Defaults to the first run (index 0)",
	"codeNodeEditor.completer.selector.itemMatching": "@:_reusableBaseText.codeNodeEditor.completer.itemMatching",
	"codeNodeEditor.completer.selector.itemMatching.args.currentItemIndex": "The index of the item in the current node to be matched with.",
	"codeNodeEditor.completer.selector.last": "@:_reusableBaseText.codeNodeEditor.completer.last",
	"codeNodeEditor.completer.selector.params": "The configuration settings of the given node. These are the parameters you fill out within the node's UI (e.g. its operation).",
	"codeNodeEditor.completer.selector.isExecuted": "Is <code>true</code> if the node has executed, <code>false</code> otherwise",
	"codeNodeEditor.completer.section.input": "Input",
	"codeNodeEditor.completer.section.prevNodes": "Earlier nodes",
	"codeNodeEditor.completer.section.metadata": "Metadata",
	"codeNodeEditor.completer.section.fields": "Fields",
	"codeNodeEditor.completer.section.properties": "Properties",
	"codeNodeEditor.completer.section.methods": "Methods",
	"codeNodeEditor.completer.section.otherMethods": "Other methods",
	"codeNodeEditor.completer.section.recommended": "Suggested",
	"codeNodeEditor.completer.section.recommendedMethods": "Suggested methods",
	"codeNodeEditor.completer.section.other": "Other",
	"codeNodeEditor.completer.section.edit": "Edit",
	"codeNodeEditor.completer.section.query": "Query",
	"codeNodeEditor.completer.section.format": "Format",
	"codeNodeEditor.completer.section.component": "Component",
	"codeNodeEditor.completer.section.case": "Case",
	"codeNodeEditor.completer.section.cast": "Cast",
	"codeNodeEditor.completer.section.compare": "Compare",
	"codeNodeEditor.completer.section.validation": "Validate",
	"codeNodeEditor.completer.section.variable.project": "Project Variables",
	"codeNodeEditor.completer.section.variable.global": "Global Variables",
	"codeNodeEditor.linter.allItems.firstOrLastCalledWithArg": "expects no argument.",
	"codeNodeEditor.linter.allItems.emptyReturn": "Code doesn't return items properly. Please return an array of objects, one for each item you would like to output.",
	"codeNodeEditor.linter.allItems.itemCall": "`item` is a property to access, not a method to call. Did you mean `.item` without brackets?",
	"codeNodeEditor.linter.allItems.itemMatchingNoArg": "`.itemMatching()` expects an item index to be passed in as its argument.",
	"codeNodeEditor.linter.allItems.unavailableItem": "Legacy `item` is only available in the 'Run Once for Each Item' mode.",
	"codeNodeEditor.linter.allItems.unavailableProperty": "`.item` only works correctly in 'Run Once for Each Item' mode. It will always return the first item here. Use `.first()` instead.",
	"codeNodeEditor.linter.allItems.unavailableVar": "is only available in the 'Run Once for Each Item' mode.",
	"codeNodeEditor.linter.bothModes.directAccess.firstOrLastCall": "@:_reusableBaseText.codeNodeEditor.linter.useJson",
	"codeNodeEditor.linter.bothModes.directAccess.itemProperty": "@:_reusableBaseText.codeNodeEditor.linter.useJson",
	"codeNodeEditor.linter.bothModes.varDeclaration.itemProperty": "@:_reusableBaseText.codeNodeEditor.linter.useJson",
	"codeNodeEditor.linter.bothModes.varDeclaration.itemSubproperty": "@:_reusableBaseText.codeNodeEditor.linter.useJson",
	"codeNodeEditor.linter.eachItem.emptyReturn": "Code doesn't return an object. Please return an object representing the output item",
	"codeNodeEditor.linter.eachItem.legacyItemAccess": "`item` is a legacy var. Consider using `$input.item`",
	"codeNodeEditor.linter.eachItem.returnArray": "Code doesn't return an object. Array found instead. Please return an object representing the output item",
	"codeNodeEditor.linter.eachItem.unavailableItems": "Legacy `items` is only available in the 'Run Once for All Items' mode.",
	"codeNodeEditor.linter.eachItem.unavailableMethod": "Method `$input.{method}()` is only available in the 'Run Once for All Items' mode.",
	"codeNodeEditor.linter.eachItem.preferFirst": "Prefer `.first()` over `.item` so n8n can optimize execution",
	"codeNodeEditor.linter.bothModes.syntaxError": "Syntax error",
	"codeNodeEditor.linter.bothModes.dollarSignVariable": "Use a string literal instead of a variable so n8n can optimize execution.",
	"codeNodeEditor.askAi.placeholder": "Tell AI what you want the code to achieve. You can reference input data fields using dot notation (e.g. user.email)",
	"codeNodeEditor.askAi.intro": "Hey AI, generate JavaScript code that...",
	"codeNodeEditor.askAi.help": "Help",
	"codeNodeEditor.askAi.generateCode": "Generate Code",
	"codeNodeEditor.askAi.noInputData": "You can generate code once this node has incoming input data (from a node earlier in your workflow)",
	"codeNodeEditor.askAi.sureLeaveTab": "Are you sure you want to switch tab? The code generation will stop",
	"codeNodeEditor.askAi.areYouSure": "Are you sure?",
	"codeNodeEditor.askAi.switchTab": "Switch Tab",
	"codeNodeEditor.askAi.noPrompt": "First enter a prompt above before generating code",
	"codeNodeEditor.askAi.onlyAllItemsMode": "Ask AI generation works only in 'Run Once for All Items' mode",
	"codeNodeEditor.askAi.promptTooShort": "Enter a minimum of {minLength} characters before attempting to generate code",
	"codeNodeEditor.askAi.generateCodeAndReplace": "Generate and Replace Code",
	"codeNodeEditor.askAi.replaceCurrentCode": "Replace current code?",
	"codeNodeEditor.askAi.areYouSureToReplace": "Are you sure you want to generate new code? Your current code will be replaced.",
	"codeNodeEditor.askAi.loadingPhrase0": "AI cogs whirring, almost there…",
	"codeNodeEditor.askAi.loadingPhrase1": "up up down down left right b a start…",
	"codeNodeEditor.askAi.loadingPhrase2": "Consulting Jan Oberhauser…",
	"codeNodeEditor.askAi.loadingPhrase3": "Gathering bytes and pieces…",
	"codeNodeEditor.askAi.loadingPhrase4": "Checking if another AI knows the answer…",
	"codeNodeEditor.askAi.loadingPhrase5": "Checking on Stack Overflow…",
	"codeNodeEditor.askAi.loadingPhrase6": "Crunching data, AI-style…",
	"codeNodeEditor.askAi.loadingPhrase7": "Stand by, AI magic at work…",
	"codeNodeEditor.askAi.generationCompleted": "✨ Code generation completed",
	"codeNodeEditor.askAi.generationFailed": "Code generation failed",
	"codeNodeEditor.askAi.generationFailedUnknown": "Code generation failed due to an unknown reason. Try again in a few minutes",
	"codeNodeEditor.askAi.generationFailedWithReason": "Code generation failed with error: {error}. Try again in a few minutes",
	"codeNodeEditor.askAi.generationFailedDown": "We're sorry, our AI service is currently unavailable. Please try again later. If the problem persists, contact support.",
	"codeNodeEditor.askAi.generationFailedRate": "We've hit our rate limit with our AI partner (too many requests). Please wait a minute before trying again.",
	"codeNodeEditor.askAi.generationFailedTooLarge": "Your workflow data is too large for AI to process. Simplify the data being sent into the Code node and retry.",
	"codeNodeEditor.tabs.askAi": "✨ Ask AI",
	"codeNodeEditor.tabs.code": "Code",
	"codeNodeEditor.examples": "Examples",
	"codeNodeEditor.parameters": "Parameters",
	"codeNodeEditor.optional": "optional",
	"codeNodeEditor.defaultsTo": "Defaults to {default}.",
	"collectionParameter.choose": "Choose...",
	"collectionParameter.addItem": "Add item",
	"collectionParameter.deleteItem": "Delete",
	"collectionParameter.dragItem": "Drag to reorder",
	"collectionParameter.noProperties": "No properties",
	"collectionParameter.allOptionsAdded": "All options have been added",
	"communityNodeFooter.legacy": "Legacy",
	"communityNodeFooter.manage": "Manage",
	"communityNodeFooter.reportIssue": "Report issue",
	"credentialEdit.credentialConfig.accountConnected": "Account connected",
	"credentialEdit.credentialConfig.accountNotConnected": "Connect your account to use this credential",
	"credentialEdit.credentialConfig.accountNotConnected.endUser": "Connect your own account — it's private to you and only used in executions you trigger.",
	"credentialEdit.credentialConfig.connect": "Connect",
	"credentialEdit.credentialConfig.connectOAuth2Credential": "Connect OAuth2 Credential",
	"credentialEdit.credentialConfig.clickToCopy": "Click To Copy",
	"credentialEdit.credentialConfig.connectionTestedSuccessfully": "Connection tested successfully",
	"credentialEdit.credentialConfig.couldntConnectWithTheseSettings": "Couldn’t connect with these settings",
	"credentialEdit.credentialConfig.couldntConnectWithTheseSettings.sharee": "Problem with connection settings. {owner} may be able to fix this",
	"credentialEdit.credentialConfig.needHelpFillingOutTheseFields": "Need help filling out these fields?",
	"credentialEdit.credentialConfig.oAuthRedirectUrl": "OAuth Redirect URL",
	"credentialEdit.credentialConfig.openDocs": "Read our docs",
	"credentialEdit.credentialConfig.assistantHelp.forSetupInstructions": "for setup instructions",
	"credentialEdit.credentialConfig.assistantHelp.orReadThe": "or read the",
	"credentialEdit.credentialConfig.assistantHelp.docs": "docs",
	"credentialEdit.credentialConfig.pleaseCheckTheErrorsBelow": "Please check the errors below",
	"credentialEdit.credentialConfig.pleaseCheckTheErrorsBelow.sharee": "Problem with connection settings. {owner} may be able to fix this",
	"credentialEdit.credentialConfig.reconnect": "Reconnect",
	"credentialEdit.credentialConfig.reconnectOAuth2Credential": "Reconnect OAuth2 Credential",
	"credentialEdit.credentialConfig.disconnect": "Disconnect",
	"credentialEdit.credentialConfig.jwksUri.label": "OAuth2 JWKS URI",
	"credentialEdit.credentialConfig.jwksUri.hint": "Provide this URL to your OAuth2 provider so it can fetch the public keys this instance uses to encrypt tokens.",
	"credentialEdit.credentialConfig.jwksUri.copiedToast": "JWKS URI copied to clipboard",
	"credentialEdit.credentialConfig.redirectUrlCopiedToClipboard": "Redirect URL copied to clipboard",
	"credentialEdit.credentialConfig.retry": "Retry",
	"credentialEdit.credentialConfig.retryCredentialTest": "Retry credential test",
	"credentialEdit.credentialConfig.retrying": "Retrying",
	"credentialEdit.credentialConfig.subtitle": "In {appName}, use the URL above when prompted to enter an OAuth callback or redirect URL",
	"credentialEdit.credentialConfig.theServiceYouReConnectingTo": "the service you're connecting to",
	"credentialEdit.credentialConfig.missingCredentialType": "This credential's type isn't available. This usually happens when a previously installed community or custom node was uninstalled.",
	"credentialEdit.credentialConfig.oauthModeManaged": "Managed OAuth2 (recommended)",
	"credentialEdit.credentialConfig.oauthModeCustom": "Custom OAuth2",
	"credentialEdit.credentialConfig.setupCredential": "Setup credential",
	"credentialEdit.credentialConfig.quickConnect": "Use quick connect",
	"credentialEdit.credentialConfig.quickConnectTitle": "Connect to set up a credential",
	"credentialEdit.credentialConfig.setupManually": "Set up manually",
	"credentialEdit.credentialConfig.recommendedAuthTypeSuffix": "(recommended)",
	"credentialEdit.credentialConfig.switchTo": "Use {name}",
	"credentialEdit.credentialConfig.externalSecrets": "Enterprise plan users can pull in credentials from external vaults.",
	"credentialEdit.credentialConfig.externalSecrets.moreInfo": "More info",
	"credentialEdit.credentialConfig.dynamicCredentials.title": "Set up for end-user credentials",
	"credentialEdit.credentialConfig.dynamicCredentials.infoTip": "An end-user credential resolves to each member's own connection at runtime, based on who triggers the workflow. It requires a trigger that can identify the user. The credential you connect here is used for manual test runs, the MCP trigger, and Chat Hub.",
	"credentialEdit.credentialConfig.endUserCredential.connectSubtext": "This is an end-user credential. The account you connect is yours alone, no one else in the workspace can see or use it.",
	"credentialEdit.credentialConfig.credentialType.title": "Credential type",
	"credentialEdit.credentialConfig.credentialType.endUser.title": "End-user credential",
	"credentialEdit.credentialConfig.credentialType.endUser.subtitle": "Each user's credential is used at run time and only by them.",
	"credentialEdit.credentialConfig.credentialType.fixed.title": "Fixed credential",
	"credentialEdit.credentialConfig.credentialType.fixed.subtitle": "The same credential is used regardless of who runs it.",
	"credentialEdit.credentialConfig.oauthDisabledTooltip": "Complete all fields to connect",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose1.cancelButtonText": "Close",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose1.confirmButtonText": "Keep Editing",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose1.headline": "Close without saving?",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose1.message": "Are you sure you want to throw away the changes you made to the {credentialDisplayName} credential?",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose2.cancelButtonText": "Close",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose2.confirmButtonText": "Keep Editing",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose2.headline": "Close without connecting?",
	"credentialEdit.credentialEdit.confirmMessage.beforeClose2.message": "You need to connect your credential for it to work",
	"credentialEdit.credentialEdit.confirmMessage.deleteCredential.cancelButtonText": "",
	"credentialEdit.credentialEdit.confirmMessage.deleteCredential.confirmButtonText": "Yes, delete",
	"credentialEdit.credentialEdit.confirmMessage.deleteCredential.headline": "Delete Credential?",
	"credentialEdit.credentialEdit.confirmMessage.deleteCredential.message": "Are you sure you want to delete \"{savedCredentialName}\"? This may break any workflows that use it.",
	"credentialEdit.credentialEdit.confirmMessage.deleteConnected.headline": "Delete \"{credentialName}\"?",
	"credentialEdit.credentialEdit.confirmMessage.deleteConnected.message": "Deleting this disconnects everyone using it, including you. {people} will lose their connection, and it can't be undone. Any workflows with nodes that use this credential will stop working.",
	"credentialEdit.credentialEdit.confirmMessage.deleteConnected.confirmButtonText": "Delete",
	"credentialEdit.credentialEdit.confirmMessage.connectedPeople": "{count} person | {count} people",
	"credentialEdit.credentialEdit.confirmMessage.typeToConfirm": "Type \"{keyword}\" to confirm",
	"credentialEdit.credentialEdit.confirmMessage.disconnectCredential.confirmButtonText": "Disconnect",
	"credentialEdit.credentialEdit.confirmMessage.disconnectCredential.headline": "Disconnect account?",
	"credentialEdit.credentialEdit.confirmMessage.disconnectCredential.message": "Disconnect your account from \"{savedCredentialName}\"? This only removes your connection, not anyone else's, and you can reconnect anytime.",
	"credentialEdit.credentialEdit.confirmMessage.switchToFixed.headline": "Switch \"{credentialName}\" to Fixed?",
	"credentialEdit.credentialEdit.confirmMessage.switchToFixed.message": "Switching to Fixed disconnects everyone using this credential, including you. {people} will lose their connection, and it can't be undone. Any workflows with nodes that use this credential will stop working.",
	"credentialEdit.credentialEdit.confirmMessage.switchToFixed.confirmButtonText": "Switch to Fixed",
	"credentialEdit.credentialEdit.confirmMessage.switchToEndUser.headline": "Switch \"{credentialName}\" to end-user credential?",
	"credentialEdit.credentialEdit.confirmMessage.switchToEndUser.message": "Switching \"{credentialName}\" to an end-user credential will remove your saved connection. Each user will need to connect their own account.",
	"credentialEdit.credentialEdit.confirmMessage.switchToEndUser.confirmButtonText": "Yes, switch to end-user credential",
	"credentialEdit.credentialEdit.confirmMessage.sharedFieldsChanged.headline": "Save changes to \"{credentialName}\"?",
	"credentialEdit.credentialEdit.confirmMessage.sharedFieldsChanged.message": "You've made changes to this credential. Saving will disconnect everyone using \"{credentialName}\" credential.",
	"credentialEdit.credentialEdit.confirmMessage.sharedFieldsChanged.confirmButtonText": "Save",
	"credentialEdit.credentialEdit.connection": "Connection",
	"credentialEdit.credentialEdit.sharing": "Sharing",
	"credentialEdit.credentialEdit.couldNotFindCredentialOfType": "Could not find credential of type",
	"credentialEdit.credentialEdit.couldNotFindCredentialWithId": "Could not find credential with ID",
	"credentialEdit.credentialEdit.delete": "Delete",
	"credentialEdit.credentialEdit.details": "Details",
	"credentialEdit.credentialEdit.saving": "Saving",
	"credentialEdit.credentialEdit.showError.createCredential.title": "Problem creating credential",
	"credentialEdit.credentialEdit.showError.deleteCredential.title": "Problem deleting credential",
	"credentialEdit.credentialEdit.showError.disconnectCredential.title": "Problem disconnecting account",
	"credentialEdit.credentialEdit.showError.generateAuthorizationUrl.message": "There was a problem generating the authorization URL",
	"credentialEdit.credentialEdit.showError.generateAuthorizationUrl.title": "OAuth Authorization Error",
	"credentialEdit.credentialEdit.showError.invalidOAuthUrl.message": "Authorization URL must use HTTP or HTTPS protocol.",
	"credentialEdit.credentialEdit.showError.invalidOAuthUrl.title": "Invalid OAuth URL",
	"credentialEdit.credentialEdit.showError.loadCredential.title": "Problem loading credential",
	"credentialEdit.credentialEdit.showError.updateCredential.title": "Problem updating credential",
	"credentialEdit.credentialEdit.showMessage.title": "Credential deleted",
	"credentialEdit.credentialEdit.showMessage.disconnected.title": "Account disconnected",
	"credentialEdit.credentialEdit.testing": "Testing",
	"credentialEdit.credentialEdit.info.sharee": "Only {credentialOwnerName} can edit this connection",
	"credentialEdit.credentialEdit.info.sharee.team": "Only users with credential edit permission can edit this connection",
	"credentialEdit.credentialInfo.allowUseBy": "Allow use by",
	"credentialEdit.credentialInfo.created": "Created",
	"credentialEdit.credentialInfo.id": "ID",
	"credentialEdit.credentialInfo.lastModified": "Last modified",
	"credentialEdit.credentialEdit.setupGuide": "Setup guide",
	"credentialEdit.credentialEdit.docs": "Docs",
	"credentialEdit.oAuthButton.connectMyAccount": "Connect my account",
	"credentialEdit.oAuthButton.signInWithGoogle": "Sign in with Google",
	"credentialEdit.credentialSharing.info.owner": "Sharing a credential allows people to use it in their workflows. They cannot access credential details.",
	"credentialEdit.credentialSharing.info.sharee.team": "Only users with credential sharing permission can change who this credential is shared with",
	"credentialEdit.credentialSharing.info.sharee.personal": "Only {credentialOwnerName} or users with credential sharing permission can change who this credential is shared with",
	"credentialEdit.credentialSharing.info.sharee.fallback": "the owner",
	"credentialEdit.credentialSharing.info.personalSpaceRestricted": "Sharing is disabled in personal spaces. Move the credential to a team project to share",
	"credentialEdit.credentialSharing.list.delete": "Remove",
	"credentialEdit.credentialSharing.list.delete.confirm.title": "Remove access?",
	"credentialEdit.credentialSharing.list.delete.confirm.message": "This may break any workflows in which {name} has used this credential",
	"credentialEdit.credentialSharing.list.delete.confirm.confirmButtonText": "Remove",
	"credentialEdit.credentialSharing.list.delete.confirm.cancelButtonText": "Cancel",
	"credentialEdit.credentialSharing.role.user": "User",
	"credentialSelectModal.addNewCredential": "Add new credential",
	"credentialSelectModal.continue": "Continue",
	"credentialSelectModal.searchForApp": "Search for app...",
	"credentialSelectModal.selectAnAppOrServiceToConnectTo": "Select an app or service to connect to",
	"credentialsList.addNew": "Add New",
	"credentialsList.confirmMessage.cancelButtonText": "",
	"credentialsList.confirmMessage.confirmButtonText": "Yes, delete",
	"credentialsList.confirmMessage.headline": "Delete Credential?",
	"credentialsList.confirmMessage.message": "Are you sure you want to delete {credentialName}?",
	"credentialsList.created": "Created",
	"credentialsList.credentials": "Credentials",
	"credentialsList.deleteCredential": "Delete Credential",
	"credentialsList.editCredential": "Edit Credential",
	"credentialsList.errorLoadingCredentials": "Error loading credentials",
	"credentialsList.name": "@:_reusableBaseText.name",
	"credentialsList.operations": "Operations",
	"credentialsList.showError.deleteCredential.title": "Problem deleting credential",
	"credentialsList.showMessage.title": "Credential deleted",
	"credentialsList.type": "Type",
	"credentialsList.updated": "Updated",
	"credentialsList.yourSavedCredentials": "Your saved credentials",
	"credentials.heading": "Credentials",
	"credentials.add": "Add credential",
	"credentials.project.add": "Add credential to project",
	"credentials.empty.heading": "Create your first credential",
	"credentials.empty.description": "Credentials let workflows interact with your apps and services",
	"credentials.empty.button.disabled.tooltip": "Your current role in the project does not allow you to create credentials",
	"credentials.item.open": "Open",
	"credentials.item.delete": "Delete",
	"credentials.item.move": "Move",
	"credentials.item.disconnect": "Disconnect",
	"credentials.item.updated": "Last updated",
	"credentials.item.created": "Created",
	"credentials.item.owner": "Owner",
	"credentials.item.readonly": "Read only",
	"credentials.item.needsSetup": "Needs first setup",
	"credentials.item.connect": "Connect",
	"credentials.item.connect.tooltip": "Connect your own account to use this credential in workflows. Only you can use your end-user credential.",
	"credentials.private.tooltip": "This credential is set up to use the account of the person the workflow is running on behalf of, resolved at execution time. You can connect your own account, but no one else can see or use it.",
	"credentials.private.tooltipTitle": "End-user credentials",
	"credentials.private.row.connect": "Connect",
	"credentials.private.row.connect.noPermission": "You don't have permission to connect this credential.",
	"credentials.private.row.connected": "Connected",
	"credentials.private.row.connectedStatus": "Connected",
	"credentials.private.row.connectedAs": "Connected as {account}",
	"credentials.private.row.notConnected": "Not connected",
	"credentials.private.row.modify": "Modify",
	"credentials.private.row.disconnect": "Disconnect",
	"credentials.private.disconnect.dialog.title": "Disconnect your credential?",
	"credentials.private.disconnect.dialog.message": "This removes only your connection to \"{credentialName}\". Workflows you run with this credential won't work until you reconnect. This will not affect any other member using it.",
	"credentials.private.disconnect.dialog.confirm": "Disconnect me",
	"credentials.private.disconnect.dialog.dontShowAgain": "Don't show again",
	"credentials.private.disconnected.success": "Account disconnected",
	"credentials.private.disconnected.error": "Problem disconnecting account",
	"credentials.search.placeholder": "Search credentials...",
	"credentials.filters.type": "Type",
	"credentials.filters.setup": "Needs first setup",
	"credentials.filters.status": "Status",
	"credentials.filters.secretStore": "External Secret Store",
	"credentials.filters.active": "Some credentials may be hidden since filters are applied.",
	"credentials.filters.active.reset": "Remove filters",
	"credentials.sort.lastUpdated": "Sort by last updated",
	"credentials.sort.lastCreated": "Sort by last created",
	"credentials.sort.nameAsc": "Sort by name (A-Z)",
	"credentials.sort.nameDesc": "Sort by name (Z-A)",
	"credentials.noResults": "No credentials found",
	"credentials.noResults.withSearch.switchToShared.preamble": "some credentials may be",
	"credentials.noResults.withSearch.switchToShared.link": "hidden",
	"credentials.create.personal.toast.title": "Credential successfully created inside your personal space",
	"credentials.create.project.toast.title": "Credential successfully created in {projectName}",
	"credentials.create.project.toast.text": "All members from {projectName} will have access to this credential.",
	"credentials.update.toast.title": "Credential saved",
	"dataDisplay.needHelp": "Need help?",
	"dataDisplay.nodeDocumentation": "Node Documentation",
	"dataDisplay.openDocumentationFor": "Open {nodeTypeDisplayName} documentation",
	"dataMapping.dragColumnToFieldHint": "Drag onto a field to map column to that field",
	"dataMapping.dragFromPreviousHint": "Map data from previous nodes to <b>{name}</b> by first clicking this button",
	"dataMapping.success.title": "You just mapped some data!",
	"dataMapping.success.moreInfo": "Check out our <a href=\"https://docs.n8n.io/data/data-mapping\" target=\"_blank\">docs</a> for more details on mapping data in n8n",
	"dataMapping.tableView.tableColumnsExceeded": "Some columns are hidden",
	"dataMapping.tableView.tableColumnsExceeded.tooltip": "Your data has more than {columnLimit} columns so some are hidden. Switch to {link} to see all data.",
	"dataMapping.tableView.tableColumnsExceeded.tooltip.link": "JSON view",
	"dataMapping.tableView.columnCollapsing": "Collapse rows",
	"dataMapping.tableView.columnCollapsing.tooltip": "Collapse rows (to compare values in this column)",
	"dataMapping.schemaView.emptyData": "No fields - node executed, but no items were sent on this branch",
	"dataMapping.schemaView.emptySchema": "No fields - item(s) exist, but they're empty",
	"dataMapping.schemaView.emptySchemaWithBinary": "Only binary data exists. View it using the 'Binary' tab",
	"dataMapping.schemaView.executeSchema": "{link} to view input data",
	"dataMapping.schemaView.disabled": "This node is disabled and will just pass data through",
	"dataMapping.schemaView.noMatches": "No results for '{search}'",
	"dataMapping.schemaView.preview": "Usually outputs the following fields. {execute} to see the actual ones. {link}",
	"dataMapping.schemaView.previewLastExecution": "The fields below come from the last successful execution. {execute} to refresh them.",
	"dataMapping.schemaView.previewLastExecution.executePreviousNodes": "Execute node",
	"dataMapping.schemaView.preview.executeNode": "Execute the node",
	"dataMapping.schemaView.previewExtraFields": "There may be more fields. Execute the node to be sure.",
	"dataMapping.schemaView.previewNode": "Preview",
	"dataMapping.schemaView.variablesContextTitle": "Variables and context",
	"dataMapping.schemaView.execution.resumeUrl": "The URL for resuming a 'Wait' node",
	"dataMapping.schemaView.variablesUpgrade": "Set global variables and use them across workflows with the Pro or Enterprise plan. <a href=\"https://docs.n8n.io/code/variables/\" target=\"_blank\">Details</a>",
	"dataMapping.schemaView.variablesEmpty": "Create variables that can be used across workflows <a href=\"/variables\" target=\"_blank\">here</a>",
	"dataMapping.schemaView.mergeNotice": "This schema shows fields from multiple items. Some fields may be absent in individual items.",
	"displayWithChange.cancelEdit": "Cancel Edit",
	"displayWithChange.clickToChange": "Click to Change",
	"displayWithChange.setValue": "Set Value",
	"duplicateWorkflowDialog.cancel": "@:_reusableBaseText.cancel",
	"duplicateWorkflowDialog.chooseOrCreateATag": "Choose or create a tag",
	"duplicateWorkflowDialog.duplicateWorkflow": "Duplicate Workflow",
	"duplicateWorkflowDialog.enterWorkflowName": "Enter workflow name",
	"duplicateWorkflowDialog.save": "Duplicate",
	"duplicateWorkflowDialog.errors.missingName.title": "Name missing",
	"duplicateWorkflowDialog.errors.missingName.message": "Please enter a name.",
	"duplicateWorkflowDialog.errors.forbidden.title": "Duplicate workflow failed",
	"duplicateWorkflowDialog.errors.forbidden.message": "This action is forbidden. Do you have the correct permissions?",
	"duplicateWorkflowDialog.errors.generic.title": "Duplicate workflow failed",
	"editor.mainHeader.githubButton.label": "Star n8n-io/n8n on GitHub",
	"experiments.instanceAiProactiveAgent.message": "Hey, I can build your first workflow in a few minutes. Do you know what you want to automate, or do you want help with ideas?",
	"experiments.instanceAiProactiveAgent.typingLabel": "AI Assistant is typing",
	"experiments.instanceAiPromptSuggestionsV2.emptyState.title": "What do you want to automate?",
	"experiments.instanceAiPromptSuggestionsV2.input.placeholder": "Tell me what to build or ask me a question",
	"experiments.instanceAiPromptSuggestionsV2.nextSuggestions": "Show more prompt suggestions",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.processInvoices.label": "Process invoices",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.processInvoices.prompt": "Every morning, scan Gmail for new invoices, use Claude to extract details and cross-check them against purchase orders in Google Sheets, flag any discrepancies for review, and add all payment due dates to Google Calendar automatically.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.qualifyInboundLeads.label": "Qualify inbound leads",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.qualifyInboundLeads.prompt": "When a new lead fills in our contact form, use Claude to research their company online, score their fit based on size, industry, and intent, draft a personalised first-touch reply, and assign them to the right sales rep in HubSpot based on region and product interest.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.whatsappSupportAgent.label": "WhatsApp support agent",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.whatsappSupportAgent.prompt": "When a customer sends a WhatsApp message, use Claude to match their question against our FAQ in Google Sheets and reply instantly. If it cannot resolve it, create a support ticket in Notion and alert the team on Slack.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.scheduleSocialPosts.label": "Schedule social posts",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.scheduleSocialPosts.prompt": "Every Monday, read this week's content ideas from a Google Sheet, use Claude to write tailored captions for LinkedIn, Instagram, and X, then schedule them to post throughout the week.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.analyzeExitInterviews.label": "Analyse exit interviews",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.analyzeExitInterviews.prompt": "When an exit interview transcript is added to Google Drive, use Gemini to extract themes and sentiment, compare against previous exits stored in Notion, and update a running trends report flagging recurring retention risks.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.postToLinkedIn.label": "Post to LinkedIn",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.postToLinkedIn.prompt": "Every time I publish a new blog post, use OpenAI to generate a LinkedIn post with a hook, 3 key takeaways, and relevant hashtags, then publish it to my LinkedIn company page automatically.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.detectAtRiskAccounts.label": "Detect at-risk accounts",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.detectAtRiskAccounts.prompt": "Every week, scan emails and support tickets for each active customer, use Claude to detect at-risk accounts based on tone and drop in engagement, draft a proactive outreach email for each one flagged, and notify the CSM on Slack.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.automateOrderFlow.label": "Automate order flow",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.automateOrderFlow.prompt": "When a new order is placed in Shopify, send the customer a confirmation email, update the stock count in Google Sheets, and post a summary to the #fulfillment Slack channel.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.recoverAbandonedCarts.label": "Recover abandoned carts",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.recoverAbandonedCarts.prompt": "Every hour, check for abandoned carts in Shopify, use Claude to write a personalised recovery email based on the cart contents and customer history, and send it automatically if they haven't returned within 2 hours.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.monitorMarketNews.label": "Monitor market news",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.monitorMarketNews.prompt": "Every week, use Gemini to scan financial news for mentions of our key suppliers and customers, assess potential business impact, and send me a briefing with any risks or opportunities I should act on before the week's trading.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.onboardNewHires.label": "Onboard new hires",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.onboardNewHires.prompt": "When a new employee is added to our HR database, send them a welcome email with their first-week schedule, create their Notion onboarding page, and post an intro message in the #welcome Slack channel.",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.extractDataFromEmails.label": "Extract data from emails",
	"experiments.instanceAiPromptSuggestionsV2.suggestions.extractDataFromEmails.prompt": "When an email arrives in Gmail with a PDF attachment, use Gemini to extract key data such as amounts, dates, or contract terms, save the structured data to a Google Sheet, and move the PDF to the right Google Drive folder.",
	"experiments.instanceAiPersonalizedPromptSuggestions.fallbackSuggestions.processInvoices.description": "Extract, check, and track invoice details automatically.",
	"experiments.instanceAiPersonalizedPromptSuggestions.fallbackSuggestions.qualifyInboundLeads.description": "Research, score, and route new leads.",
	"experiments.instanceAiPersonalizedPromptSuggestions.fallbackSuggestions.scheduleSocialPosts.description": "Turn weekly ideas into scheduled posts.",
	"experiments.instanceAiPersonalizedPromptSuggestions.fallbackSuggestions.whatsappSupportAgent.description": "Reply to common support questions instantly.",
	"experiments.instanceAiPersonalizedPromptSuggestions.heading": "Start from an example",
	"experiments.instanceAiPersonalizedPromptSuggestions.helper": "Picked for you. Change anything.",
	"experiments.instanceAiPersonalizedPromptSuggestions.seeMore": "See more",
	"experiments.instanceAiPersonalizedPromptSuggestions.input.placeholder": "Tip: Ask me for suggestions if you're not sure what to build",
	"experiments.instanceAiSplitEmptyState.canvas.ready": "Ready when you are",
	"experiments.instanceAiSplitEmptyState.canvas.tip": "You can build new automations, edit existing ones, or ask questions",
	"experiments.instanceAiSplitEmptyState.canvas.tipLabel": "Tip:",
	"experiments.instanceAiSplitEmptyState.cta.buildManually": "Build manually",
	"experiments.instanceAiSplitEmptyState.cta.buildWithAi": "Build with AI",
	"experiments.instanceAiSplitEmptyState.emptyState.title": "What do you want to automate?",
	"experiments.instanceAiSplitEmptyState.examples.editPrompt": "Edit prompt before sending",
	"experiments.instanceAiSplitEmptyState.examples.seeMore": "Explore community examples",
	"experiments.instanceAiSplitEmptyState.examples.startFromAnExample": "Start from an example",
	"experiments.instanceAiSplitEmptyState.input.placeholder": "Tell me what to build, or ask me for ideas",
	"experiments.instanceAiWorkflowPreviewSuggestions.emptyState.title": "What do you want to automate?",
	"experiments.instanceAiWorkflowPreviewSuggestions.input.placeholder": "Tell me what to build or ask me a question",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.scoreMyLeads.label": "Score my leads",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.scoreMyLeads.prompt": "When a new lead is created in my CRM, enrich it with Lemlist, score it based on fit, then update the lead if qualified and notify the sales team on Slack.",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.processInvoices.label": "Process invoices",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.processInvoices.prompt": "Every morning, scan Gmail for new invoices, use Claude to extract details and cross-check them against purchase orders in Google Sheets, flag any discrepancies for review, and add all payment due dates to Google Calendar automatically.",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.whatsappSupport.label": "WhatsApp support agent",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.whatsappSupport.prompt": "When a customer sends a WhatsApp message, use Gemini to match their question against our FAQ in Google Sheets and reply instantly. If it cannot resolve it, create a support ticket in Notion and alert the team on Slack.",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.scheduleSocialPosts.label": "Schedule social posts",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.scheduleSocialPosts.prompt": "Every Monday, read this week's content ideas from a Google Sheet, use Gemini to write tailored content then schedule them to post throughout the week.",
	"experiments.instanceAiWorkflowPreviewSuggestions.suggestions.seeAll": "See all",
	"experiments.personalizedTemplatesV3.browseAllTemplates": "Browse our template library",
	"experiments.personalizedTemplatesV3.couldntFind": "Need something different?",
	"experiments.personalizedTemplatesV3.exploreTemplates": "Get started with HubSpot workflows:",
	"experiments.personalizedTemplatesV3.loadingTemplates": "Loading recommendations...",
	"experiments.personalizedTemplatesV3.recommendationTooltip": "Recommended workflows for you",
	"experiments.personalizedTemplatesV3.recommendedForYou": "Recommended for you",
	"experiments.resourceCenter.badge.noCredentials": "No Credentials Needed",
	"experiments.resourceCenter.badge.noSetup": "No Setup Needed",
	"experiments.resourceCenter.badge.readyToRun": "Ready to Run",
	"experiments.resourceCenter.badge.template": "Template",
	"experiments.resourceCenter.badge.video": "Video",
	"experiments.resourceCenter.cta.runWorkflow": "Run workflow",
	"experiments.resourceCenter.getInspired.title": "Get Inspired",
	"experiments.resourceCenter.getStarted.title": "Get started",
	"experiments.resourceCenter.learnN8n.title": "Learn to use n8n",
	"experiments.resourceCenter.sandbox.easySetup": "No setup needed",
	"experiments.resourceCenter.search.noResults": "No results found",
	"experiments.resourceCenter.search.placeholder": "Search templates and guides…",
	"experiments.resourceCenter.sandbox.nodes": "{count} nodes",
	"experiments.resourceCenter.sidebar": "Resources",
	"experiments.resourceCenter.template.setupTime": "{minutes} minute set up",
	"experiments.resourceCenter.title": "Resources",
	"experiments.resourceCenter.video.level": "Level: {level}",
	"experiments.templatesDataQuality.modalTitle": "Featured templates",
	"error": "Error",
	"error.goBack": "Go back",
	"error.pageNotFound": "Oops, couldn’t find that",
	"error.entityNotFound.title": "{entity} not found",
	"error.entityNotFound.text": "We couldn’t find the {entity} you were looking for. Make sure you have the correct URL.",
	"error.entityNotFound.action": "Go to overview",
	"error.entityUnAuthorized.title": "You need access",
	"error.entityUnAuthorized.content": "You don't have permission to view this {entity}. Please contact the person who shared this link to request access.",
	"executions.ExecutionStatus": "Execution status",
	"executions.privateCredential.tooltip": "This execution ran using end-user credentials",
	"executions.concurrency.docsLink": "https://docs.n8n.io/hosting/scaling/concurrency-control/",
	"executionDetails.additionalActions": "Additional Actions",
	"executionDetails.confirmMessage.confirmButtonText": "Yes, delete",
	"executionDetails.confirmMessage.headline": "Delete Execution?",
	"executionDetails.confirmMessage.message": "Are you sure that you want to delete the current execution?",
	"executionDetails.confirmMessage.annotationsNote": "By deleting this you will also remove the associated annotation data.",
	"executionDetails.deleteExecution": "Delete this execution",
	"executionDetails.executionFailed": "Execution failed",
	"executionDetails.executionFailed.recoveredNodeTitle": "Can’t show data",
	"executionDetails.executionFailed.recoveredNodeMessage": "The execution was interrupted, so the data was not saved. Try fixing the workflow and re-executing.",
	"executionDetails.executionId": "Execution ID",
	"executionDetails.executionWaiting": "Execution waiting",
	"executionDetails.executionWasSuccessful": "Execution was successful",
	"executionDetails.of": "of",
	"executionDetails.at": "at",
	"executionDetails.newMessage": "Execution waiting in the queue.",
	"executionDetails.openWorkflow": "Open Workflow",
	"executionDetails.readOnly.readOnly": "Read only",
	"executionDetails.readOnly.youreViewingTheLogOf": "You're viewing the log of a previous execution. You cannot<br />\n\t\tmake changes since this execution already occurred. Make changes<br />\n\t\tto this workflow by clicking on its name on the left.",
	"executionDetails.retry": "Retry of execution",
	"executionDetails.runningTimeFinished": "in {time}",
	"executionDetails.runningTimeRunning": "for",
	"executionDetails.runningMessage": "Execution is running. It will show here once finished.",
	"executionDetails.versionAutosave": "Autosave",
	"executionDetails.versionTooltip": "Created {date}",
	"executionDetails.startingSoon": "Starting soon",
	"executionDetails.workflow": "workflow",
	"executionsLandingPage.emptyState.noTrigger.heading": "Set up the first step. Then execute your workflow",
	"executionsLandingPage.emptyState.noTrigger.buttonText": "Add first step...",
	"executionsLandingPage.clickExecutionMessage": "Click on an execution from the list to view it",
	"executionsLandingPage.emptyState.heading": "Nothing here yet",
	"executionsLandingPage.emptyState.message": "New workflow executions will show here",
	"executionsLandingPage.emptyState.accordion.title": "Which executions is this workflow saving?",
	"executionsLandingPage.emptyState.accordion.titleWarning": "Some executions won’t be saved",
	"executionsLandingPage.emptyState.accordion.productionExecutions": "Production executions",
	"executionsLandingPage.emptyState.accordion.testExecutions": "Test executions",
	"executionsLandingPage.emptyState.accordion.productionExecutionsWarningTooltip": "Not all production executions are being saved. Change this in the workflow's <a href=\"#\">settings</a>",
	"executionsLandingPage.emptyState.accordion.footer": "You can change this in",
	"executionsLandingPage.emptyState.accordion.footer.settingsLink": "Workflow settings",
	"executionsLandingPage.emptyState.accordion.footer.tooltipLink": "Save your workflow",
	"executionsLandingPage.emptyState.accordion.footer.tooltipText": "in order to access workflow settings",
	"executionsLandingPage.noResults": "No executions found",
	"executionsList.activeExecutions.none": "No active executions",
	"executionsList.activeExecutions.header": "{running}/{cap} active",
	"executionsList.activeExecutions.tooltip": "Current active executions: {running} out of {cap}. This instance is limited to {cap} concurrent production executions.",
	"executionsList.activeExecutions.evaluationNote": "Evaluation runs appear in the list of executions but do not count towards your execution concurrency.",
	"executionsList.allWorkflows": "All Workflows",
	"executionsList.anyStatus": "Any Status",
	"executionsList.autoRefresh": "Auto refresh",
	"executionsList.canceled": "Canceled",
	"executionsList.confirmMessage.cancelButtonText": "",
	"executionsList.confirmMessage.confirmButtonText": "Yes, delete",
	"executionsList.confirmMessage.headline": "Delete Executions?",
	"executionsList.confirmMessage.message": "Are you sure that you want to delete the {count} selected execution(s)?",
	"executionsList.confirmMessage.annotationsNote": "By deleting these executions you will also remove the associated annotation data.",
	"executionsList.confirmMessage.annotatedExecutionMessage": "By deleting this you will also remove the associated annotation data. Are you sure that you want to delete the selected execution?",
	"executionsList.error": "Error",
	"executionsList.filters": "Filters",
	"agentSessions.session": "Session",
	"agentSessions.agentName": "Agent",
	"agentSessions.sessionName": "Session",
	"agentSessions.lastMessage": "Last Message",
	"agentSessions.tokenUsage": "Token Usage",
	"agentSessions.testChat": "Test chat",
	"agentSessions.origin": "Origin",
	"agentSessions.origin.agent": "Agent",
	"agentSessions.origin.subAgent": "Sub-agent",
	"agentSessions.goToParentRun": "Go to parent run",
	"agentSessions.actions": "Actions",
	"agentSessions.empty": "No agent sessions",
	"agentSessions.loadMore": "Load more",
	"agentSessions.deleteConfirm.headline": "Delete Session?",
	"agentSessions.deleteConfirm.message": "This will delete the session and all its executions. This cannot be undone.",
	"agentSessions.deleteConfirm.confirmButtonText": "Yes, delete",
	"agentSessions.showMessage.deleted": "Session deleted",
	"agentSessions.showError.delete": "Problem deleting session",
	"agentSessions.showError.load": "Problem loading sessions",
	"agentSessions.status": "Status",
	"agentSessions.duration": "Duration",
	"agentSessions.sessionId": "Session ID",
	"agentSessions.origin.task": "Task",
	"agentSessions.success": "Success",
	"agentSessions.detail.backToSessions": "Back to sessions",
	"agentSessions.detail.selectMessage": "Click an assistant message to view details",
	"agentSessions.detail.tokenUsage": "Token Usage",
	"agentSessions.detail.input": "Input",
	"agentSessions.detail.output": "Output",
	"agentSessions.detail.toolCalls": "Tool Calls",
	"agentSessions.detail.model": "Model",
	"agentSessions.detail.cost": "Cost",
	"agentSessions.detail.toolCallSuspended": "Tool call suspended — waiting for user action",
	"agentSessions.detail.suspendedNote": "This message was part of a tool call suspension. Token usage and cost are reported on the resumed message.",
	"agentSessions.detail.builtInTools": "Built-in",
	"agentSessions.detail.userTools": "Tools",
	"agentSessions.drawer.created": "Created",
	"agentSessions.drawer.lastMessage": "Last message",
	"agentSessions.drawer.duration": "Duration",
	"agentSessions.drawer.tokens": "Tokens",
	"agentSessions.drawer.cost": "Cost",
	"agentSessions.drawer.status": "Status",
	"agentSessions.drawer.noTitle": "Session #{number}",
	"agentSessions.timeline.backToAgent": "Back to agent",
	"agentSessions.timeline.user": "User",
	"agentSessions.timeline.assistant": "Assistant",
	"agentSessions.timeline.tool": "Tool",
	"agentSessions.timeline.memory": "Memory",
	"agentSessions.timeline.suspension": "Tool call suspended",
	"agentSessions.timeline.userFeedback": "User feedback received",
	"agentSessions.timeline.success": "Success",
	"agentSessions.timeline.error": "Error",
	"agentSessions.timeline.id": "ID",
	"agentSessions.timeline.created": "Created",
	"agentSessions.timeline.duration": "Duration",
	"agentSessions.timeline.status": "Status",
	"agentSessions.timeline.input": "Input",
	"agentSessions.timeline.output": "Output",
	"agentSessions.timeline.selectItem": "Select an item to view details",
	"agentSessions.timeline.continueChat": "Continue chat",
	"agentSessions.timeline.workflow": "Workflow",
	"agentSessions.timeline.node": "Node",
	"agentSessions.timeline.memoryUpdated": "Memory updated",
	"agentSessions.timeline.openForm": "Open form",
	"agentSessions.timeline.workflowError": "Workflow call did not produce an execution",
	"agentSessions.timeline.nodeError": "Tool experienced an error",
	"agentSessions.timeline.filter": "Filter",
	"agentSessions.timeline.clearFilter": "Clear",
	"agentSessions.timeline.suspended": "Suspended",
	"agentSessions.timeline.idle": "Idle",
	"agentSessions.timeline.agent": "Agent",
	"agentSessions.timeline.subAgent": "Sub-agent",
	"agentSessions.timeline.waitingForUser": "Waiting for user response",
	"agentSessions.timeline.events": "Events",
	"agentSessions.timeline.searchPlaceholder": "Search",
	"agentSessions.timeline.triggeredVia": "Triggered via {source}",
	"agentSessions.workflowLog.loading": "Loading execution...",
	"agentSessions.workflowLog.stillRunning": "Still running",
	"agentSessions.workflowLog.waiting": "Waiting",
	"agentSessions.workflowLog.unavailable": "Execution data is unavailable",
	"agentSessions.workflowLog.openFull": "Open full execution",
	"agentView.tab.editor": "Editor",
	"agentView.tab.sessions": "Sessions",
	"executionsList.loadMore": "Load more",
	"executionsList.empty": "No executions",
	"executionsList.loadedAll": "No more executions to fetch",
	"executionsList.modes.error": "error",
	"executionsList.modes.integrated": "integrated",
	"executionsList.modes.manual": "manual",
	"executionsList.modes.retry": "retry",
	"executionsList.modes.trigger": "trigger",
	"executionsList.modes.webhook": "webhook",
	"executionsList.name": "@:_reusableBaseText.name",
	"executionsList.new": "Queued",
	"executionsList.openPastExecution": "Open Past Execution",
	"executionsList.retryExecution": "Retry execution",
	"executionsList.retryOf": "Retry of",
	"executionsList.retryWithCurrentlySavedWorkflow": "Retry with currently saved workflow (from node with error)",
	"executionsList.retryWithOriginalWorkflow": "Retry with original workflow (from node with error)",
	"executionsList.running": "Running",
	"executionsList.succeeded": "Succeeded",
	"executionsList.selectStatus": "Select Status",
	"executionsList.selectWorkflow": "Select Workflow",
	"executionsList.selectAll": "Select {count} finished execution | Select all {count} finished executions",
	"executionsList.test": "Test execution",
	"executionsList.evaluation": "Evaluation execution",
	"executionsList.showError.handleDeleteSelected.title": "Problem deleting executions",
	"executionsList.showError.loadMore.title": "Problem loading executions",
	"executionsList.showError.loadWorkflows.title": "Problem loading workflows",
	"executionsList.showError.refreshData.title": "Problem loading data",
	"executionsList.showError.retryExecution.title": "Problem with retry",
	"executionsList.showError.stopExecution.title": "Problem stopping execution",
	"executionsList.showMessage.handleDeleteSelected.title": "Execution deleted",
	"executionsList.showMessage.retryError.title": "Retry unsuccessful",
	"executionsList.showMessage.retrySuccess.title": "Retry successful",
	"executionsList.showMessage.retryWaiting.title": "Retry waiting",
	"executionsList.showMessage.retryCrashed.title": "Retry crashed",
	"executionsList.showMessage.retryCanceled.title": "Retry canceled",
	"executionsList.showMessage.retryRunning.title": "Retry running",
	"executionsList.showMessage.stopExecution.message": "Execution ID {activeExecutionId}",
	"executionsList.showMessage.stopExecution.title": "Execution stopped",
	"executionsList.startedAt": "Started",
	"executionsList.trigger": "Triggered by",
	"executionsList.runTime": "Run time",
	"executionsList.startingSoon": "Starting soon",
	"executionsList.started": "{date}, {time}",
	"executionsList.id": "Exec. ID",
	"executionsList.status": "Status",
	"executionsList.statusCanceled": "Canceled",
	"executionsList.statusText": "{status} in {time}",
	"executionsList.statusTextWithoutTime": "{status}",
	"executionsList.statusRunning": "{status} for {time}",
	"executionsList.statusWaiting": "{status} until {time}",
	"executionsList.statusUnknown": "Could not complete",
	"executionsList.stopExecution": "Stop Execution",
	"executionsList.success": "Success",
	"executionsList.successRetry": "Success retry",
	"executionsList.unknown": "Could not complete",
	"executionsList.unsavedWorkflow": "[UNSAVED WORKFLOW]",
	"executionsList.waiting": "Waiting",
	"executionsList.workflowExecutions": "Executions",
	"executionsList.view": "View",
	"executionsList.stop": "Stop",
	"executionsList.statusTooltipText.waitingForWebhook": "The workflow is waiting indefinitely for an incoming webhook call.",
	"executionsList.statusTooltipText.waitingForConcurrencyCapacity": "This execution will start once concurrency capacity is available. {instance}",
	"executionsList.statusTooltipText.waitingForConcurrencyCapacity.cloud": "Your plan is limited to {concurrencyCap} concurrent production executions. {link}",
	"executionsList.statusTooltipText.waitingForConcurrencyCapacity.self": "This instance is limited to {concurrencyCap} concurrent production executions. {link}",
	"executionsList.statusTooltipText.theWorkflowIsWaitingIndefinitely": "The workflow is waiting indefinitely for an incoming webhook call.",
	"executionsList.debug.button.copyToEditor": "Copy to editor",
	"executionsList.debug.button.debugInEditor": "Debug in editor",
	"executionsList.debug.paywall.title": "Upgrade to access Debug In Editor",
	"executionsList.debug.paywall.content": "Debug in Editor allows you to debug a previous execution with the actual data pinned, right in your editor.",
	"executionsList.debug.paywall.subContent": "It's available on our Cloud plans, Enterprise and the",
	"executionsList.debug.paywall.link.text": "Registered Community Edition.",
	"executionsList.debug.paywall.link.url": "https://docs.n8n.io/hosting/community-edition-features/#registered-community-edition",
	"executionStopManyModal.title": "Stop executions",
	"executionStopManyModal.description": "Select which type of executions you want to stop:",
	"executionStopManyModal.button.close": "Close",
	"executionStopManyModal.button.submit": "Stop Executions",
	"executionStopManyModal.queued": "Queued",
	"executionStopManyModal.running": "Running",
	"executionStopManyModal.waiting": "Waiting",
	"executionStopManyModal.success": "Stopped {count} executions.",
	"executionStopManyModal.error.failure": "Failed to stop executions.",
	"executionStopManyModal.dateHint.startEnd": "Will only affect executions between '{startedAfter}' and '{startedBefore}' based on your current filter.",
	"executionStopManyModal.dateHint.startOnly": "Will only affect executions from '{startedAfter}' based on your current filter.",
	"executionStopManyModal.dateHint.endOnly": "Will only affect executions to '{startedBefore}' based on your current filter.",
	"executionStopManyModal.allWorkflowsHint": "This will affect ALL workflows you have access to",
	"fromAiParametersModal.title": "Test {nodeName}",
	"fromAiParametersModal.execute": "Execute step",
	"fromAiParametersModal.description": "Provide the data that would normally come from the \"{parentNodeName}\" node",
	"fromAiParametersModal.cancel": "Cancel",
	"workerList.pageTitle": "Workers",
	"workerList.empty": "No workers are responding or available",
	"workerList.item.lastUpdated": "Last updated",
	"workerList.item.jobList.empty": "No current jobs",
	"workerList.item.jobListTitle": "Current Jobs",
	"workerList.item.netListTitle": "Network Interfaces",
	"workerList.item.memoryMonitorTitle": "Memory Monitoring",
	"workerList.item.chartsTitle": "Performance Monitoring",
	"workerList.item.copyAddressToClipboard": "Address copied to clipboard",
	"workerList.actionBox.title": "Available on the Enterprise plan",
	"workerList.actionBox.description": "View the current state of workers connected to your instance.",
	"workerList.actionBox.description.link": "More info",
	"workerList.actionBox.buttonText": "See plans",
	"workerList.docs.url": "https://docs.n8n.io/hosting/scaling/queue-mode/#view-running-workers",
	"executionSidebar.executionName": "Execution {id}",
	"executionSidebar.searchPlaceholder": "Search executions...",
	"executionView.onPaste.title": "Cannot paste here",
	"executionView.onPaste.message": "This view is read-only. Switch to <i>Workflow</i> tab to be able to edit the current workflow",
	"executionView.notFound.message": "Execution with id '{executionId}' could not be found!",
	"executionAnnotationView.data.notFound": "Show important data from executions here by adding an <a target=\"_blank\" href=\"https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.executiondata/\">execution data</a> node to your workflow",
	"executionAnnotationView.vote.error": "Unable to save annotation vote",
	"executionAnnotationView.vote.up": "Vote up",
	"executionAnnotationView.vote.down": "Vote down",
	"executionAnnotationView.vote.removeUp": "Remove up vote",
	"executionAnnotationView.vote.removeDown": "Remove down vote",
	"executionAnnotationView.tag.error": "Unable to save annotation tags",
	"executionAnnotationView.addTag": "Add tag",
	"executionAnnotationView.chooseOrCreateATag": "Choose or create a tag",
	"executionsFilter.annotation.tags": "Execution tags",
	"executionsFilter.annotation.rating": "Rating",
	"executionsFilter.annotation.rating.all": "Any rating",
	"executionsFilter.annotation.rating.good": "Good",
	"executionsFilter.annotation.rating.bad": "Bad",
	"executionsFilter.annotation.selectVoteFilter": "Select Rating",
	"executionsFilter.version": "Version",
	"executionsFilter.version.all": "Any version",
	"executionsFilter.version.select": "Select Version",
	"executionsFilter.version.hint": "Filter executions by the workflow version they ran on.",
	"executionsFilter.version.noVersions": "No version data available for this workflow's executions.",
	"executionsFilter.version.label": "{name} {date}",
	"executionsFilter.selectStatus": "Select Status",
	"executionsFilter.selectWorkflow": "Select Workflow",
	"executionsFilter.start": "Execution start",
	"executionsFilter.startDate": "Earliest",
	"executionsFilter.endDate": "Latest",
	"executionsFilter.savedData": "Highlighted data",
	"executionsFilter.savedDataExactMatch": "Exact match",
	"executionsFilter.savedDataKey": "Key",
	"executionsFilter.savedDataKeyPlaceholder": "ID",
	"executionsFilter.savedDataValue": "Value",
	"executionsFilter.savedDataValuePlaceholder": "123",
	"executionsFilter.reset": "Reset all",
	"executionsFilter.customData.inputTooltip": "Upgrade plan to filter executions by custom data set at runtime. {link}",
	"executionsFilter.customData.inputTooltip.link": "View plans",
	"executionsFilter.customData.docsTooltip": "Filter executions by data you have saved in them using an ‘Execution Data’ node. {link}",
	"executionsFilter.customData.docsTooltip.link": "More info",
	"expressionEdit.anythingInside": "Anything inside ",
	"expressionEdit.isJavaScript": " is JavaScript.",
	"expressionEdit.learnMore": "Learn more",
	"expressionEdit.editExpression": "Edit Expression",
	"expressionEdit.expression": "Expression",
	"expressionEdit.resultOfItem1": "Result of item 1",
	"expressionEditor.uncalledFunction": "[this is a function, please add ()]",
	"expressionEditor.deprecated.getPairedItem": "$getPairedItem is deprecated and will be removed",
	"expressionModalInput.empty": "[empty]",
	"expressionModalInput.undefined": "[undefined]",
	"expressionModalInput.null": "null",
	"expressionTip.noExecutionData": "Execute previous nodes to use input data",
	"expressionTip.typeDotPrimitive": "Type <code>.</code> for data transformation options. <a target=\"_blank\" href=\"https://docs.n8n.io/code/builtin/data-transformation-functions/\">Learn more</a>",
	"expressionTip.typeDotObject": "Type <code>.</code> for data transformation options, or to access fields. <a target=\"_blank\" href=\"https://docs.n8n.io/code/builtin/data-transformation-functions/\">Learn more</a>",
	"expressionTip.javascript": "Anything inside <code>{'{{ }}'}</code> is JavaScript. <a target=\"_blank\" href=\"https://docs.n8n.io/code-examples/expressions/\">Learn more</a>",
	"expressionModalInput.noExecutionData": "Execute previous nodes for preview",
	"expressionModalInput.noNodeExecutionData": "Execute node ‘{node}’ for preview",
	"expressionModalInput.noInputConnection": "No input connected",
	"expressionModalInput.pairedItemConnectionError": "No path back to node",
	"expressionModalInput.pairedItemInvalidPinnedError": "Unpin node ‘{node}’ and execute",
	"expressionModalInput.pairedItemError": "Can’t determine which item to use",
	"expressionModalInput.pairedItemError.noRunData": "Can't determine which item to use - execute node for more info",
	"fixedCollectionParameter.addItem": "Add item",
	"fixedCollectionParameter.addParameter": "Add {parameter}",
	"fixedCollectionParameter.allOptionsAdded": "All options have been added",
	"fixedCollectionParameter.addField": "Add Field",
	"fixedCollectionParameter.choose": "Choose...",
	"fixedCollectionParameter.currentlyNoItemsExist": "Currently no items exist",
	"fixedCollectionParameter.deleteItem": "Delete item",
	"fixedCollectionParameter.deleteParameter": "Delete {parameter}",
	"fixedCollectionParameter.dragItem": "Drag item",
	"fixedCollectionParameter.moveDown": "Move down",
	"fixedCollectionParameter.moveUp": "Move up",
	"forgotPassword": "Forgot my password",
	"forgotPassword.emailSentIfExists": "We’ve emailed {email} (if there’s a matching account)",
	"forgotPassword.getRecoveryLink": "Email me a recovery link",
	"forgotPassword.noSMTPToSendEmailWarning": "Please contact your admin. n8n isn’t set up to send email right now.",
	"forgotPassword.recoverPassword": "Recover password",
	"forgotPassword.recoveryEmailSent": "Recovery email sent",
	"forgotPassword.returnToSignIn": "Back to sign in",
	"forgotPassword.sendingEmailError": "Problem sending email",
	"forgotPassword.ldapUserPasswordResetUnavailable": "Please contact your LDAP administrator to reset your password",
	"forgotPassword.oidcUserPasswordResetUnavailable": "Please contact your OIDC administrator to reset your password",
	"forgotPassword.smtpErrorContactAdministrator": "Please contact your administrator (problem with your SMTP setup)",
	"forgotPassword.tooManyRequests": "You’ve reached the password reset limit. Please try again in a few minutes.",
	"forms.resourceFiltersDropdown.filters": "Filters",
	"forms.resourceFiltersDropdown.owner": "Owner",
	"forms.resourceFiltersDropdown.owner.placeholder": "Filter by owner",
	"forms.resourceFiltersDropdown.reset": "Reset all",
	"folders.actions.create": "Create folder inside",
	"folders.actions.create.workflow": "Create workflow inside",
	"folders.actions.moveToFolder": "Move",
	"folders.add": "Add folder",
	"folders.add.here.message": "Create a new folder here",
	"folders.add.to.parent.message": "Create folder in '{parent}'",
	"folders.add.success.title": "Folder created",
	"folders.add.success.message": "Created new folder '{folderName}'<br><a href=\"{link}\">Open folder</a>",
	"folders.invalidName.empty.message": "Folder name cannot be empty",
	"folders.invalidName.tooLong.message": "Folder name cannot be longer than {maxLength} characters",
	"folders.invalidName.invalidCharacters.message": "Folder name cannot contain the following characters: {illegalChars}",
	"folders.invalidName.starts.with.dot..message": "Folder name cannot start with a dot",
	"folders.invalidName.only.dots.message": "Folder name cannot contain only dots",
	"folders.delete.confirm.title": "Delete '{folderName}'",
	"folders.delete.typeToConfirm": "delete {folderName}",
	"folders.delete.confirm.message": "Are to sure you want to delete this folder?",
	"folders.delete.success.message": "Folder deleted",
	"folder.delete.modal.confirmation": "What should we do with {folders} {workflows} in this folder?",
	"folder.count": "the {count} folder | the {count} folders",
	"workflow.count": "the {count} workflow | the {count} workflows",
	"workflow.description.mcp": "Clear descriptions help other users and MCP clients understand the purpose of your workflow",
	"workflow.description.nomcp": "Clear descriptions help other users understand the purpose of your workflow",
	"workflow.description.error.title": "Problem updating workflow description",
	"folder.and.workflow.separator": "and",
	"folders.delete.action": "Archive all workflows and delete subfolders",
	"folders.delete.error.message": "Problem while deleting folder",
	"folders.delete.confirmation.message": "Type 'delete {folderName}' to confirm",
	"folders.transfer.confirm.message": "Data transferred to '{folderName}'",
	"folders.transfer.action": "Transfer workflows and subfolders to another folder inside '{projectName}'",
	"folders.transfer.action.noProject": "Transfer workflows and subfolders to another folder",
	"folders.transfer.selectFolder": "Folder to transfer to",
	"folders.transfer.select.placeholder": "Select folder",
	"folders.rename.message": "Rename '{folderName}'",
	"folders.rename.error.title": "Problem renaming folder",
	"folders.rename.success.message": "Folder renamed",
	"folders.rename.placeholder": "Enter new folder name",
	"folders.not.found.message": "Folder not found",
	"folders.move.modal.folder.count": "{count} folder | {count} folders",
	"folders.move.modal.workflow.count": "{count} workflow | {count} workflows",
	"folders.move.modal.title": "Move {resourceTypeLabel} {folderName}",
	"folders.move.modal.description": "This will also move{folders}{workflows}.",
	"folders.move.modal.confirm": "Move {resourceTypeLabel}",
	"folders.move.modal.project.label": "Project or user",
	"folders.move.modal.project.placeholder": "Select a project or user",
	"folders.move.modal.folder.label": "Folder",
	"folders.move.modal.folder.placeholder": "Select a folder",
	"folders.move.modal.folder.noData.label": "No folders found",
	"folders.move.modal.message.usedCredentials.workflow": "Also share the {usedCredentials} used by this workflow to ensure it will continue to run correctly",
	"folders.move.modal.message.usedCredentials.folder": "Also share the {usedCredentials} used by these workflows to keep them running correctly",
	"folders.move.modal.message.usedCredentials.warning": "Workflow may not execute correctly if you choose not to share the credentials.",
	"folders.move.success.title": "Successfully moved folder",
	"folders.move.success.message": "<b>{folderName}</b> has been moved to <b>{newFolderName}</b>, along with all its workflows and subfolders.<br/><br/><a href=\"{link}\">View {newFolderName}</a>",
	"folders.move.success.messageNoAccess": "<b>{folderName}</b> has been moved to <b>{newFolderName}</b>, along with all its workflows and subfolders.",
	"folders.move.error.title": "Problem moving folder",
	"folders.move.workflow.error.title": "Problem moving workflow",
	"folders.move.workflow.success.title": "Successfully moved workflow",
	"folders.move.workflow.success.message": "<b>{workflowName}</b> has been moved to <b>{newFolderName}</b>.<br/><br/><a href=\"{link}\">View {newFolderName}</a>",
	"folders.move.workflow.success.messageNoAccess": "<b>{workflowName}</b> has been moved to <b>{newFolderName}</b>.",
	"folders.move.project.root.name": "No folder (project root)",
	"folders.open.error.title": "Problem opening folder",
	"folders.create.error.title": "Problem creating folder",
	"folders.empty.actionbox.title": "Nothing in folder \"{folderName}\" yet",
	"folders.registeredCommunity.cta.heading": "Get access to folders with registered community",
	"folders.breadcrumbs.noTruncated.message": "No hidden items in path",
	"generic.oauth1Api": "OAuth1 API",
	"generic.oauth2Api": "OAuth2 API",
	"genericHelpers.loading": "Loading",
	"genericHelpers.hrsShort": "h",
	"genericHelpers.min": "min",
	"genericHelpers.minShort": "m",
	"genericHelpers.sec": "sec",
	"genericHelpers.secShort": "s",
	"genericHelpers.millis": "ms",
	"readOnly.showMessage.executions.message": "Executions are read-only. Make changes from the <b>Workflow</b> tab.",
	"readOnly.showMessage.executions.title": "Cannot edit execution",
	"readOnlyEnv.showMessage.executions.message": "Executions are read-only.",
	"readOnlyEnv.showMessage.executions.title": "Cannot edit execution",
	"readOnlyEnv.showMessage.workflows.message": "Workflows are read-only in protected instances.",
	"readOnlyEnv.showMessage.workflows.title": "Cannot edit workflow",
	"readOnlyEnv.tooltip": "This is a protected instance where modifications are restricted. {link}",
	"readOnlyEnv.tooltip.link": "More info.",
	"readOnlyEnv.cantAdd.workflow": "You can't add new workflows to a protected n8n instance",
	"readOnlyEnv.cantAdd.credential": "You can't add new credentials to a protected n8n instance",
	"readOnlyEnv.cantAdd.project": "You can't add new projects to a protected n8n instance",
	"readOnlyEnv.cantAdd.any": "You can't add new resources to a protected n8n instance",
	"readOnlyEnv.cantEditOrRun": "This workflow can't be edited or run manually because it's on a protected instance",
	"readOnlyEnv.instanceAi.notice": "This is a protected instance. Some actions like creating or modifying workflows are restricted.",
	"logs.overview.header.title": "Logs",
	"logs.overview.header.actions.clearExecution": "Clear execution",
	"logs.overview.header.actions.clearExecution.tooltip": "Clear execution data",
	"logs.overview.header.switch.details": "Details",
	"logs.overview.header.switch.overview": "Overview",
	"logs.overview.body.empty.message": "Nothing to display yet. Execute the workflow to see execution logs.",
	"logs.overview.body.dataTooLarge.message": "This execution's data is too large to display.",
	"logs.overview.body.empty.action": "Execute the workflow",
	"logs.overview.body.summaryText.for": "{status} for {time}",
	"logs.overview.body.summaryText.in": "{status} in {time}",
	"logs.overview.body.started": "Started {time}",
	"logs.overview.body.run": "Execute step",
	"logs.overview.body.open": "Open...",
	"logs.overview.body.openTooltip": "Open node",
	"logs.overview.body.toggleRow": "Toggle row",
	"logs.details.header.actions.input": "Input",
	"logs.details.header.actions.output": "Output",
	"logs.details.header.actions.viewAgentSession": "View session",
	"logs.details.body.itemCount": "{count} item | {count} items",
	"logs.details.body.multipleInputs": "Multiple inputs. View them by {button}",
	"logs.details.body.multipleInputs.openingTheNode": "opening the node",
	"mainSidebar.userMenu": "User menu",
	"mainSidebar.aboutN8n": "About n8n",
	"mainSidebar.state.collapse": "Collapse sidebar",
	"mainSidebar.state.expand": "Expand sidebar",
	"mainSidebar.confirmMessage.workflowArchive.cancelButtonText": "",
	"mainSidebar.confirmMessage.workflowArchive.confirmButtonText": "Yes, archive",
	"mainSidebar.confirmMessage.workflowArchive.headline": "Archive Workflow?",
	"mainSidebar.confirmMessage.workflowArchive.message": "Are you sure that you want to archive '{workflowName}'?",
	"mainSidebar.confirmMessage.workflowDelete.cancelButtonText": "",
	"mainSidebar.confirmMessage.workflowDelete.confirmButtonText": "Yes, delete",
	"mainSidebar.confirmMessage.workflowDelete.headline": "Delete Workflow?",
	"mainSidebar.confirmMessage.workflowDelete.message": "Are you sure that you want to delete '{workflowName}' permanently?",
	"mainSidebar.credentials": "Credentials",
	"mainSidebar.variables": "Variables",
	"mainSidebar.help": "Help",
	"mainSidebar.helpMenuItems.course": "Course",
	"mainSidebar.helpMenuItems.documentation": "Documentation",
	"mainSidebar.helpMenuItems.forum": "Forum",
	"mainSidebar.helpMenuItems.quickstart": "Quickstart",
	"mainSidebar.helpMenuItems.reportBug": "Report a bug",
	"mainSidebar.new": "New",
	"mainSidebar.newTemplate": "New from template",
	"mainSidebar.open": "Open",
	"mainSidebar.prompt.cancel": "@:_reusableBaseText.cancel",
	"mainSidebar.prompt.import": "Import",
	"mainSidebar.prompt.importWorkflowFromUrl": "Import Workflow from URL",
	"mainSidebar.prompt.invalidUrl": "Invalid URL",
	"mainSidebar.prompt.workflowUrl": "Workflow URL",
	"mainSidebar.save": "@:_reusableBaseText.save",
	"mainSidebar.settings": "Settings",
	"mainSidebar.showError.stopExecution.title": "Problem stopping execution",
	"mainSidebar.showMessage.handleFileImport.message": "The file does not contain valid JSON data",
	"mainSidebar.showMessage.handleFileImport.title": "Could not import file",
	"mainSidebar.showMessage.handleSelect1.title": "Workflow '{workflowName}' deleted",
	"mainSidebar.showMessage.handleSelect2.title": "Workflow created",
	"mainSidebar.showMessage.handleSelect3.title": "Workflow created",
	"mainSidebar.showMessage.handleArchive.title": "Workflow '{workflowName}' archived",
	"mainSidebar.showMessage.handleArchive.message": "Delete permanently",
	"mainSidebar.showMessage.handleUnarchive.title": "Workflow '{workflowName}' unarchived",
	"mainSidebar.showMessage.stopExecution.title": "Execution stopped",
	"mainSidebar.workflows": "Workflows",
	"mainSidebar.workflows.readOnlyEnv.tooltip": "Protected instances prevent editing workflows (recommended for production environments). {link}",
	"mainSidebar.workflows.readOnlyEnv.tooltip.link": "More info",
	"mainSidebar.executions": "Executions",
	"mainSidebar.workersView": "Workers",
	"mainSidebar.whatsNew": "What’s New",
	"mainSidebar.whatsNew.fullChangelog": "Full changelog",
	"mcp.workflowNotEligable.description": "Only published workflows with one of the following trigger nodes can be accessible via MCP: {triggers}",
	"mcp.instanceLevelAccessDisabled.description": "Instance-level MCP access is disabled. Enable it to allow workflow-level access.",
	"mcp.workflowDeactivated.title": "MCP Access Disabled",
	"mcp.productionChecklist.title": "Enable MCP access",
	"mcp.productionChecklist.workflow.description": "Allow MCP clients to access this workflow",
	"mcp.productionChecklist.instance.description": "Enable instance-level MCP access to allow MCP clients to access workflows.",
	"mcp.workflowDeactivated.message": "MCP Access has been disabled for this workflow because it is deactivated",
	"menuActions.duplicate": "Duplicate",
	"menuActions.download": "Download",
	"menuActions.push": "Push to git",
	"menuActions.editDescription": "Edit description",
	"menuActions.importFromUrl": "Import from URL...",
	"menuActions.importFromFile": "Import from file...",
	"menuActions.delete": "Delete",
	"menuActions.archive": "Archive",
	"menuActions.unarchive": "Unarchive",
	"menuActions.unpublish": "Unpublish",
	"multipleParameter.addItem": "Add item",
	"multipleParameter.currentlyNoItemsExist": "Currently no items exist",
	"multipleParameter.deleteItem": "Delete item",
	"multipleParameter.moveDown": "Move down",
	"multipleParameter.moveUp": "Move up",
	"ndv.backToCanvas": "Back to canvas",
	"ndv.backToCanvas.waitingForTriggerWarning": "Waiting for a Trigger node to execute. Close this view to see the Workflow Canvas.",
	"ndv.close.tooltip": "Data stored, safe to close",
	"ndv.execute.testNode": "Execute step",
	"ndv.execute.testNode.description": "Runs the current node. Will also run previous nodes if they have not been run yet",
	"ndv.execute.generateCodeAndTestNode.description": "Generates code and then runs the current node",
	"ndv.execute.generateCode.message": "The instructions in '{nodeName}' have changed",
	"ndv.execute.generateCode.title": "Generating transformation code",
	"ndv.execute.executing": "Executing",
	"ndv.execute.fetchEvent": "Fetch Test Event",
	"ndv.execute.fixPrevious": "Fix previous node first",
	"ndv.execute.generatingCode": "Generating code from instructions",
	"ndv.execute.listenForTestEvent": "Listen for test event",
	"ndv.execute.testChat": "Test chat",
	"ndv.execute.testStep": "Execute step",
	"ndv.execute.stopListening": "Stop Listening",
	"ndv.execute.nodeIsDisabled": "Enable node to execute",
	"ndv.execute.requiredFieldsMissing": "Complete required fields first",
	"ndv.execute.upstreamNodeHasIssues": "A previous node has missing required fields",
	"ndv.execute.stopWaitingForWebhook.error": "Problem deleting test webhook",
	"ndv.execute.workflowAlreadyRunning": "Workflow is already running",
	"ndv.execute.deactivated": "This node is deactivated and can't be run",
	"ndv.featureRequest": "I wish this node would...",
	"ndv.input": "Input",
	"ndv.input.nodeDistance": "{count} node back | {count} nodes back",
	"ndv.input.noNodesFound": "No nodes found",
	"ndv.input.mapping": "Mapping",
	"ndv.input.fromAI": "From AI",
	"ndv.input.parentNodes": "Parent nodes",
	"ndv.input.noOutputDataInBranch": "No input data in this branch",
	"ndv.input.noOutputDataInNode": "Node did not output any data. n8n stops executing the workflow when a node has no output data.",
	"ndv.input.noOutputData": "No data",
	"ndv.input.noOutputData.executePrevious": "Execute previous nodes",
	"ndv.input.noOutputData.title": "No input data yet",
	"ndv.input.noOutputData.v2.title": "No input data",
	"ndv.input.noOutputData.v2.description": "{link} to view input data",
	"ndv.input.noOutputData.v2.action": "Execute previous nodes",
	"ndv.input.noOutputData.v2.tooltip": "From the earliest node which is unexecuted, or is executed but has since been changed",
	"ndv.input.noOutputData.hint": "(From the earliest node that needs it {info} )",
	"ndv.input.noOutputData.hint.tooltip": "From the earliest node which is unexecuted, or is executed but has since been changed",
	"ndv.input.noOutputData.schemaPreviewHint": "switch to {schema} to use the schema preview",
	"ndv.input.noOutputData.or": "or",
	"ndv.input.noOutputData.embeddedNdv.link": "Execute previous nodes",
	"ndv.input.noOutputData.embeddedNdv.description": "{link} to use their data here",
	"ndv.input.executingPrevious": "Executing previous nodes...",
	"ndv.input.notConnected.title": "Wire me up",
	"ndv.input.notConnected.v2.title": "No input connected",
	"ndv.input.notConnected.v2.description": "This node can only receive input data if you connect it to another node. {link}",
	"ndv.input.notConnected.message": "This node can only receive input data if you connect it to another node.",
	"ndv.input.notConnected.learnMore": "Learn more",
	"ndv.input.disabled": "The '{nodeName}' node is disabled and won’t execute.",
	"ndv.input.disabled.cta": "Enable it",
	"ndv.input.rootNodeHasNotRun.title": "Parent node hasn’t run yet",
	"ndv.input.rootNodeHasNotRun.description": "Inputs that the parent node sends to this one will appear here. To map data in from previous nodes, use the {link} view.",
	"ndv.input.rootNodeHasNotRun.description.link": "mapping",
	"ndv.input.redacted.title": "Input data redacted",
	"ndv.output.redacted.title": "Output data redacted",
	"ndv.redacted.description.sentence1": "Execution data has been redacted.",
	"ndv.redacted.description.sentence2": "Adjust redaction rules in {link}.",
	"ndv.redacted.description.link": "workflow settings",
	"ndv.redacted.noPermission.description": "Execution data has been redacted. You do not have the permissions to reveal it.",
	"ndv.redacted.dynamicCredentials.description": "This execution used end-user credentials. Data from end-user credential executions cannot be revealed.",
	"ndv.redacted.revealButton": "Reveal data",
	"ndv.redacted.revealModal.title": "Reveal redacted data",
	"ndv.redacted.revealModal.warning": "This data is redacted, because it likely contains sensitive information. Please read the following before proceeding.",
	"ndv.redacted.revealModal.logged": "This action will be logged",
	"ndv.redacted.revealModal.legitimate": "Reveal this data if you have a legitimate reason to do so.",
	"ndv.redacted.revealModal.policy": "Unnecessary access may violate your organization's policy",
	"ndv.redacted.revealModal.confirmButton": "Reveal data",
	"ndv.redacted.revealError": "Failed to reveal execution data",
	"ndv.redacted.error.title": "This node encountered an error",
	"ndv.redacted.error.description": "Error details have been redacted because the execution data contains sensitive information.",
	"ndv.output": "Output",
	"ndv.output.ai.empty": "👈 Use these logs to see information on how the {node} node completed processing. You can click on a node to see the input it received and data it output.",
	"ndv.output.ai.waiting": "Waiting for message",
	"ndv.output.outType.logs": "Logs",
	"ndv.output.outType.regular": "Output",
	"ndv.output.edit": "Edit Output",
	"ndv.output.all": "all",
	"ndv.output.branch": "Branch",
	"ndv.output.executing": "Executing node...",
	"ndv.output.items": "{count} item | {count} items",
	"ndv.output.itemsTotal": "{count} item total | {count} items total",
	"ndv.output.andSubExecutions": ", {count} sub-execution | , {count} sub-executions",
	"ndv.output.noOutputData.message": "n8n stops executing the workflow when a node has no output data. You can change this default behaviour via",
	"ndv.output.noOutputData.message.settings": "Settings",
	"ndv.output.noOutputData.message.settingsOption": "> \"Always Output Data\".",
	"ndv.output.noOutputData.title": "No output data returned",
	"ndv.output.noOutputData.v2.title": "No output data",
	"ndv.output.noOutputData.v2.description": "{link} to view output data",
	"ndv.output.noOutputData.v2.action": "Execute step",
	"ndv.output.noOutputData.trigger.title": "No trigger output",
	"ndv.output.noOutputData.trigger.action": "Test this trigger",
	"ndv.output.noOutputDataInBranch": "No output data in this branch",
	"ndv.output.of": "{current} of {total}",
	"ndv.output.pageSize": "Page Size",
	"ndv.output.run": "Run",
	"ndv.output.runNodeHint": "Execute this node to view data",
	"ndv.output.runNodeHintSubNode": "Output will appear here once the parent node is run",
	"ndv.output.githubNodeWaitingForWebhook": "Execution will continue when the following webhook URL is called: ",
	"ndv.output.sendAndWaitWaitingApproval": "Execution will continue after the user's response",
	"ndv.output.waitNodeWaiting.title": "Waiting for input",
	"ndv.output.waitNodeWaiting.description.webhook": "Execution will continue when webhook is received on ",
	"ndv.output.waitNodeWaiting.description.form": "Execution will continue when form is submitted on ",
	"ndv.output.waitNodeWaiting.description.timer": "Execution will continue when wait time is over",
	"ndv.output.insertTestData": "set mock data",
	"ndv.output.staleDataWarning.regular": "Node parameters have changed.<br>Test node again to refresh output.",
	"ndv.output.staleDataWarning.pinData": "Node parameter changes will not affect pinned output data.",
	"ndv.output.waitingToRun": "Waiting to execute...",
	"ndv.output.noToolUsedInfo": "None of your tools were used in this run. Try giving your tools clearer names and descriptions to help the AI",
	"ndv.title.cancel": "Cancel",
	"ndv.title.rename": "Rename",
	"ndv.title.rename.placeholder": "Enter new name...",
	"ndv.title.renameNode": "Rename node",
	"ndv.pinData.pin.title": "Pin data",
	"ndv.pinData.pin.description": "Node will always output current data instead of executing. Doesn't apply to production executions.",
	"ndv.pinData.pin.binary": "Pin Data is disabled as this node's output contains binary data.",
	"ndv.pinData.pin.link": "More info",
	"ndv.pinData.unpin.title": "Unpin data",
	"ndv.pinData.pin.multipleRuns.title": "Run #{index} was pinned",
	"ndv.pinData.pin.multipleRuns.description": "This run will be outputted each time the node is run.",
	"ndv.pinData.unpinAndExecute.title": "Unpin output data?",
	"ndv.pinData.unpinAndExecute.description": "Testing a node overwrites pinned data.",
	"ndv.pinData.unpinAndExecute.cancel": "Cancel",
	"ndv.pinData.unpinAndExecute.confirm": "Unpin and test",
	"ndv.pinData.beforeClosing.title": "Save output changes before closing?",
	"ndv.pinData.beforeClosing.cancel": "Discard",
	"ndv.pinData.beforeClosing.confirm": "Save",
	"ndv.pinData.error.syntaxError.title": "Unable to save due to invalid JSON",
	"ndv.pinData.error.tooLarge.title": "Unable to pin data due to size limit",
	"ndv.pinData.error.tooLarge.description": "Workflow has reached the maximum allowed pinned data size ({size} mb / {limit} mb)",
	"ndv.pinData.error.tooLargeWorkflow.title": "Unable to pin data due to size limit",
	"ndv.pinData.error.tooLargeWorkflow.description": "Workflow has reached the maximum allowed size ({size} mb / {limit} mb)",
	"ndv.tooMuchData.message": "This may temporarily slow down your browser.",
	"ndv.tooMuchData.showDataAnyway": "Show data",
	"ndv.tooMuchData.title": "Show {size} MB of data?",
	"ndv.httpRequest.credentialOnly.docsNotice": "Use the <a target=\"_blank\" href=\"{docsUrl}\">{nodeName} docs</a> to construct your request. We'll take care of the authentication part if you add a {nodeName} credential below.",
	"ndv.binaryData.combinedTooltip": "Specify the path to the binary data entry in the input item or use an expression to access the binary data in previous nodes, e.g. {example}",
	"ndv.binaryData.separateTooltip": "Specify the property name of the binary data in the input item or use an expression to access the binary data in previous nodes, e.g. {example}",
	"network.error.message": "Offline",
	"network.error.tooltip": "No network connection. Workflow changes will be saved once the connection is restored.",
	"noTagsView.createTag": "Create a tag",
	"noTagsView.readyToOrganizeYourWorkflows": "Ready to organize your workflows?",
	"noTagsView.withWorkflowTagsYouReFree": "With workflow tags, you're free to create the perfect tagging system for your flows",
	"noAnnotationTagsView.title": "Organize your executions",
	"noAnnotationTagsView.description": "Execution tags help you label and identify different classes of execution. Plus once you tag an execution, it’s never deleted",
	"node.thisIsATriggerNode": "This is a Trigger node. <a target=\"_blank\" href=\"https://docs.n8n.io/workflows/components/nodes/\">Learn more</a>",
	"node.activateDeactivateNode": "Activate/Deactivate Node",
	"node.changeColor": "Change color",
	"node.customColor": "Custom color",
	"node.disabled": "Deactivated",
	"node.testStep": "Execute step",
	"node.disable": "Deactivate",
	"node.enable": "Activate",
	"node.delete": "Delete",
	"node.addToAi": "Add to n8n AI",
	"node.focusNode": "Focus node",
	"node.moreActions": "More actions",
	"node.add": "Add",
	"node.addNode": "Add node",
	"node.deleteConnection": "Delete connection",
	"node.add-human-review-step": "Add human review step",
	"node.issues": "Issues",
	"node.install-to-use": "Install the package to use this node",
	"node.dirty": "Node configuration changed. Output data may change when this node is run again",
	"node.subjectToChange": "Because of changes in the workflow, output data may change when this node is run again",
	"node.nodeIsExecuting": "Node is executing",
	"node.nodeIsWaitingTill": "Node is waiting until {date} {time}",
	"node.theNodeIsWaitingIndefinitelyForAnIncomingWebhookCall": "The node is waiting for an incoming webhook call (indefinitely)",
	"node.theNodeIsWaitingWebhookCall": "The node is waiting for an incoming webhook call",
	"node.theNodeIsWaitingFormCall": "The node is waiting for a form submission",
	"node.theNodeIsWaitingUserInput": "The node is waiting for user input",
	"node.waitingForYouToCreateAnEventIn": "Waiting for you to create an event in {nodeType}",
	"node.discovery.pinData.canvas": "You can pin this output instead of waiting for a test event. Open node to do so.",
	"node.discovery.pinData.ndv": "You can pin this output instead of waiting for a test event.",
	"node.executionError.openNode": "Open node",
	"node.settings.continuesOnError": "Execution will continue even if the node fails",
	"node.settings.continuesOnError.title": "Continue On Fail",
	"node.settings.retriesOnFailure": "This node will automatically retry if it fails",
	"node.settings.executeOnce": "This node executes only once, no matter how many input items there are",
	"node.settings.alwaysOutputData": "This node will output an empty item if nothing would normally be returned",
	"node.settings.dynamicCredentials": "This node is set up to use the credentials of the person it's running on behalf of.",
	"node.settings.contextEstablishmentHooks": "This webhook extracts the triggering user's identity token to resolve credentials at runtime.",
	"sticky.markdownHint": "<a target=\"_blank\" href=\"https://docs.n8n.io/workflows/sticky-notes/\">Markdown</a> supported",
	"nodeBase.clickToAddNodeOrDragToConnect": "Click to add node \n or drag to connect",
	"nodeCreator.actionsPlaceholderNode.scheduleTrigger": "On a Schedule",
	"nodeCreator.actionsPlaceholderNode.webhook": "On a Webhook call",
	"nodeCreator.actionsCategory.actions": "Actions",
	"nodeCreator.actionsCategory.onNewEvent": "On new {event} event",
	"nodeCreator.actionsCategory.onEvent": "On {event}",
	"nodeCreator.actionsCategory.triggers": "Triggers",
	"nodeCreator.actionsCategory.triggerNodes": "Trigger Nodes",
	"nodeCreator.actionsCategory.regularNodes": "Regular Nodes",
	"nodeCreator.actionsCategory.regularAndTriggers": "Regular & Trigger Nodes",
	"nodeCreator.actionsCategory.searchActions": "Search {node} Actions...",
	"nodeCreator.actionsCategory.noMatchingActions": "No matching Actions. <i>Reset search</i>",
	"nodeCreator.actionsCategory.noMatchingTriggers": "No matching Triggers. <i>Reset search</i>",
	"nodeCreator.actionsList.apiCall": "Didn't find the right event? Make a <a data-action='addHttpNode'>custom {node} API call</a>",
	"nodeCreator.actionsCallout.noActionItems": "We don't have <strong>{nodeName}</strong> actions yet. Have one in mind? Make a <a target=\"_blank\" href=\"https://community.n8n.io/c/feature-requests/5\"> request in our community</a>",
	"nodeCreator.actionsCallout.triggersStartWorkflow": "Actions need to be triggered by another node, e.g. at regular intervals with the <strong>Schedule</strong> node. <a target=\"_blank\" href=\"https://docs.n8n.io/integrations/builtin/\"> Learn more</a>",
	"nodeCreator.actionsTooltip.triggersStartWorkflow": "A trigger is a step that starts your workflow. <a target=\"_blank\" href=\"https://docs.n8n.io/integrations/builtin/\"> Learn more</a>",
	"nodeCreator.actionsTooltip.actionsPerformStep": "Actions perform a step once your workflow has already started. <a target=\"_blank\" href=\"https://docs.n8n.io/integrations/builtin/\"> Learn more</a>",
	"nodeCreator.actionsCallout.noTriggerItems": "No <strong>{nodeName}</strong> Triggers available. Users often combine the following Triggers with <strong>{nodeName}</strong> Actions.",
	"nodeCreator.categoryNames.otherCategories": "Results in other categories",
	"nodeCreator.categoryNames.moreFromCommunity": "More from the community",
	"nodeCreator.subnodes": "sub-nodes",
	"nodeCreator.noResults.dontWorryYouCanProbablyDoItWithThe": "Don’t worry, you can probably do it with the",
	"nodeCreator.noResults.httpRequest": "HTTP Request",
	"nodeCreator.noResults.node": "node",
	"nodeCreator.noResults.or": "or",
	"nodeCreator.noResults.requestTheNode": "Request the node",
	"nodeCreator.noResults.wantUsToMakeItFaster": "Want us to make it faster?",
	"nodeCreator.noResults.weDidntMakeThatYet": "We didn't make that... yet",
	"nodeCreator.noResults.webhook": "Webhook",
	"nodeCreator.ragStarterTemplate.openTemplateItem.title": "RAG starter template",
	"nodeCreator.ragStarterTemplate.openTemplateItem.description": "Get a feel for vector stores in n8n",
	"nodeCreator.searchBar.searchNodes": "Search nodes...",
	"nodeCreator.subcategoryDescriptions.appTriggerNodes": "Runs the flow when something happens in an app like Telegram, Notion or Airtable",
	"nodeCreator.subcategoryDescriptions.appRegularNodes": "Do something in an app or service like Google Sheets, Telegram or Notion",
	"nodeCreator.subcategoryDescriptions.dataTransformation": "Manipulate, filter or convert data",
	"nodeCreator.subcategoryDescriptions.files": "CSV, XLS, XML, text, images, etc.",
	"nodeCreator.subcategoryDescriptions.flow": "Branch, merge or loop the flow, etc.",
	"nodeCreator.subcategoryDescriptions.helpers": "Run code, make HTTP requests, set webhooks, etc.",
	"nodeCreator.subcategoryDescriptions.otherTriggerNodes": "Runs the flow on workflow errors, file changes, etc.",
	"nodeCreator.subcategoryDescriptions.agents": "Autonomous entities that interact and make decisions.",
	"nodeCreator.subcategoryDescriptions.chains": "Structured assemblies for specific tasks.",
	"nodeCreator.subcategoryDescriptions.documentLoaders": "Handles loading of documents for processing.",
	"nodeCreator.subcategoryDescriptions.embeddings": "Transforms text into vector representations.",
	"nodeCreator.subcategoryDescriptions.languageModels": "AI models that understand and generate language.",
	"nodeCreator.subcategoryDescriptions.memory": "Manages storage and retrieval of information during execution.",
	"nodeCreator.subcategoryDescriptions.outputParsers": "Ensures the output adheres to a defined format.",
	"nodeCreator.subcategoryDescriptions.retrievers": "Fetches relevant information from a source.",
	"nodeCreator.subcategoryDescriptions.textSplitters": "Breaks down text into smaller parts.",
	"nodeCreator.subcategoryDescriptions.tools": "Utility components providing various functionalities.",
	"nodeCreator.subcategoryDescriptions.vectorStores": "Store and access vector data in services like Supabase, Pinecone and MongoDB",
	"nodeCreator.subcategoryDescriptions.miscellaneous": "Other AI related nodes.",
	"nodeCreator.subcategoryDescriptions.humanInTheLoop": "Request approval via services like Slack and Telegram before making tool calls",
	"nodeCreator.subcategoryDescriptions.otherTools": "Do something in an app or service like Google Sheets, Telegram or Notion",
	"nodeCreator.subcategoryDescriptions.modelContextProtocol": "Add a toolset from an external MCP server",
	"nodeCreator.subcategoryInfos.languageModels": "Chat models are designed for interactive conversations and follow instructions well, while text completion models focus on generating continuations of a given text input",
	"nodeCreator.subcategoryInfos.memory": "Memory allows an AI model to remember and reference past interactions with it",
	"nodeCreator.subcategoryInfos.vectorStores": "Vector stores allow an AI model to reference relevant pieces of documents, useful for question answering and document search",
	"nodeCreator.subcategoryNames.appTriggerNodes": "On app event",
	"nodeCreator.subcategoryNames.otherTools": "Action in an app",
	"nodeCreator.subcategoryNames.appRegularNodes": "Action in an app",
	"nodeCreator.subcategoryNames.dataTransformation": "Data transformation",
	"nodeCreator.subcategoryNames.files": "Files",
	"nodeCreator.subcategoryNames.flow": "Flow",
	"nodeCreator.subcategoryNames.helpers": "Core",
	"nodeCreator.subcategoryNames.otherTriggerNodes": "Other ways...",
	"nodeCreator.subcategoryNames.agents": "Agents",
	"nodeCreator.subcategoryNames.chains": "Chains",
	"nodeCreator.subcategoryNames.documentLoaders": "Document Loaders",
	"nodeCreator.subcategoryNames.embeddings": "Embeddings",
	"nodeCreator.subcategoryNames.languageModels": "Language Models",
	"nodeCreator.subcategoryNames.memory": "Memory",
	"nodeCreator.subcategoryNames.outputParsers": "Output Parsers",
	"nodeCreator.subcategoryNames.retrievers": "Retrievers",
	"nodeCreator.subcategoryNames.textSplitters": "Text Splitters",
	"nodeCreator.subcategoryNames.tools": "Tools",
	"nodeCreator.subcategoryNames.vectorStores": "Vector Stores",
	"nodeCreator.subcategoryNames.miscellaneous": "Miscellaneous",
	"nodeCreator.subcategoryNames.humanInTheLoop": "Human review",
	"nodeCreator.subcategoryNames.modelContextProtocol": "MCP servers",
	"nodeCreator.sectionNames.includedInN8n": "Included in n8n",
	"nodeCreator.sectionNames.popular": "Popular",
	"nodeCreator.sectionNames.other": "Other",
	"nodeCreator.sectionNames.sendAndWait": "Send and wait for response",
	"nodeCreator.sectionNames.transform.combine": "Combine items",
	"nodeCreator.sectionNames.transform.addOrRemove": "Add or remove items",
	"nodeCreator.sectionNames.transform.convert": "Convert data",
	"nodeCreator.triggerHelperPanel.addAnotherTrigger": "Add another trigger",
	"nodeCreator.triggerHelperPanel.addAnotherTriggerDescription": "Triggers start your workflow. Workflows can have multiple triggers.",
	"nodeCreator.triggerHelperPanel.title": "When should this workflow run?",
	"nodeCreator.triggerHelperPanel.scheduleTriggerDisplayName": "On a schedule",
	"nodeCreator.triggerHelperPanel.scheduleTriggerDescription": "Runs the flow every day, hour, or custom interval",
	"nodeCreator.triggerHelperPanel.webhookTriggerDisplayName": "On webhook call",
	"nodeCreator.triggerHelperPanel.webhookTriggerDescription": "Runs the flow on receiving an HTTP request",
	"nodeCreator.triggerHelperPanel.formTriggerDisplayName": "On form submission",
	"nodeCreator.triggerHelperPanel.formTriggerDescription": "Generate webforms in n8n and pass their responses to the workflow",
	"nodeCreator.triggerHelperPanel.formDisplayName": "Form",
	"nodeCreator.triggerHelperPanel.formDescription": "Add next form page",
	"nodeCreator.triggerHelperPanel.manualTriggerDisplayName": "Trigger manually",
	"nodeCreator.triggerHelperPanel.manualTriggerDescription": "Runs the flow on clicking a button in n8n. Good for getting started quickly",
	"nodeCreator.triggerHelperPanel.manualChatTriggerDisplayName": "On chat message",
	"nodeCreator.triggerHelperPanel.manualChatTriggerDescription": "Runs the flow when a user sends a chat message. For use with AI nodes",
	"nodeCreator.triggerHelperPanel.chatTriggerDisplayName": "On chat message",
	"nodeCreator.triggerHelperPanel.chatTriggerDescription": "Runs the flow when a user sends a chat message. For use with AI nodes",
	"nodeCreator.triggerHelperPanel.whatHappensNext": "What happens next?",
	"nodeCreator.triggerHelperPanel.selectATrigger": "What triggers this workflow?",
	"nodeCreator.triggerHelperPanel.selectATriggerDescription": "A trigger is a step that starts your workflow",
	"nodeCreator.triggerHelperPanel.workflowTriggerDisplayName": "When executed by another workflow",
	"nodeCreator.triggerHelperPanel.workflowTriggerDescription": "Runs the flow when called by the Execute Workflow node from a different workflow",
	"nodeCreator.replaceNode.title": "Replace this step",
	"nodeCreator.agentsPanel.searchPlaceholder": "Search agents...",
	"nodeCreator.agentsPanel.createNewAgent": "Create new agent",
	"nodeCreator.agentsPanel.createNewAgentDescription": "Build a fresh agent inline in this workflow",
	"nodeCreator.agentsPanel.existingAgentsLabel": "Or message an existing agent",
	"nodeCreator.agentsPanel.empty": "No agents in this project yet",
	"nodeCreator.agentsPanel.noMatchingAgents": "No agents matching your search",
	"nodeCreator.agentsPanel.loadError": "Could not load agents",
	"nodeCreator.aiPanel.aiNodes": "AI Nodes",
	"nodeCreator.aiPanel.aiOtherNodes": "Other AI Nodes",
	"nodeCreator.aiPanel.aiOtherNodesDescription": "Embeddings, Vector Stores, LLMs and other AI nodes",
	"nodeCreator.aiPanel.selectAiNode": "Select an AI Node to add to your workflow",
	"nodeCreator.aiPanel.nodesForAi": "Build autonomous agents, summarize or search documents, etc.",
	"nodeCreator.aiPanel.newTag": "New",
	"nodeCreator.aiPanel.langchainAiNodes": "AI",
	"nodeCreator.aiPanel.title": "When should this workflow run?",
	"nodeCreator.aiPanel.linkItem.description": "See what's possible and get started 5x faster",
	"nodeCreator.aiPanel.linkItem.title": "AI Templates",
	"nodeCreator.aiPanel.scheduleTriggerDisplayName": "On a schedule",
	"nodeCreator.aiPanel.scheduleTriggerDescription": "Runs the flow every day, hour, or custom interval",
	"nodeCreator.aiPanel.webhookTriggerDisplayName": "On webhook call",
	"nodeCreator.aiPanel.webhookTriggerDescription": "Runs the flow when another app sends a webhook",
	"nodeCreator.aiPanel.manualTriggerDisplayName": "Manually",
	"nodeCreator.aiPanel.manualTriggerDescription": "Runs the flow on clicking a button in n8n",
	"nodeCreator.aiPanel.whatHappensNext": "What happens next?",
	"nodeCreator.aiPanel.selectATrigger": "Select an AI Component",
	"nodeCreator.aiPanel.selectATriggerDescription": "A trigger is a step that starts your workflow",
	"nodeCreator.aiPanel.workflowTriggerDisplayName": "When Executed by Another Workflow",
	"nodeCreator.aiPanel.workflowTriggerDescription": "Runs the flow when called by the Execute Workflow node from a different workflow",
	"nodeCreator.nodeItem.triggerIconTitle": "Trigger Node",
	"nodeCreator.nodeItem.aiIconTitle": "LangChain AI Node",
	"nodeCreator.nodeItem.deprecated": "Deprecated",
	"nodeCreator.nodeItem.earlyPreview": "Early preview",
	"nodeCreator.nodeItem.beta": "Beta",
	"nodeCredentials.createNew": "Create new credential",
	"nodeCredentials.createNew.permissionDenied": "Your current role does not allow you to create credentials",
	"nodeCredentials.credentialFor": "Credential for {credentialType}",
	"nodeCredentials.credentialsLabelShort": "Credential",
	"nodeCredentials.issues": "Issues",
	"nodeCredentials.selectCredential": "Select Credential",
	"nodeCredentials.selectedCredentialUnavailable": "{name} (unavailable)",
	"nodeCredentials.showMessage.message": "Nodes that used credential \"{oldCredentialName}\" have been updated to use \"{newCredentialName}\"",
	"nodeCredentials.showMessage.title": "Node credential updated",
	"nodeCredentials.autoAssigned.message": "Added this credential to {count} other node(s)",
	"nodeCredentials.updateCredential": "Update Credential",
	"nodeCredentials.updateCredential.permissionDenied": "Your current role does not allow you to update credentials",
	"nodeCredentials.deleteCredential": "Delete Credential",
	"nodeCredentials.deleteCredential.permissionDenied": "Your current role does not allow you to delete credentials",
	"nodeCredentials.quickConnect.connect": "Connect",
	"nodeCredentials.quickConnect.connectTo": "Connect to {provider}",
	"nodeCredentials.quickConnect.or": "or",
	"nodeCredentials.quickConnect.setupManually": "setup manually",
	"nodeCredentials.quickConnect.consent.cancel": "Cancel",
	"nodeCredentials.quickConnect.consent.confirm": "Confirm",
	"nodeCredentials.quickConnect.credential.created.success": "Credential created successfully",
	"nodeCredentials.quickConnect.credential.created.error": "Failed to create the credential",
	"nodeCredentials.emptyState.noCredentials": "No credentials yet",
	"nodeCredentials.emptyState.setupCredential": "Set up credential",
	"nodeCredentials.oauth.accountConnected": "Account connected successfully",
	"aiGateway.toggle.label": "Use n8n credits",
	"aiGateway.toggle.description": "n8n credits is the easy way to manage AI model usage",
	"aiGateway.toggle.topUp": "Top up",
	"aiGateway.wallet.balanceRemaining": "{balance} remaining",
	"aiGateway.wallet.noCredits": "No credits",
	"aiGateway.credentialMode.sectionLabel": "Credential",
	"aiGateway.credentialMode.n8nConnect.title": "n8n credits",
	"aiGateway.credentialMode.n8nConnect.subtitle": "No API key required",
	"aiGateway.credentialMode.own.title": "My own credential",
	"aiGateway.credentialMode.own.subtitle": "Use your own API key",
	"aiGateway.unsupportedAction.notice": "{actionName} is currently not supported via n8n credits. Switch to using your own credential to use it.",
	"nodeCredentials.oauth.accountConnectionFailed": "Account connection failed",
	"nodeErrorView.cause": "Cause",
	"nodeErrorView.copyToClipboard": "Copy to Clipboard",
	"nodeErrorView.copyToClipboard.tooltip": "Copy error details for debugging. Copied data may contain sensitive information. Proceed with caution when sharing.",
	"nodeErrorView.dataBelowMayContain": "Data below may contain sensitive information. Proceed with caution when sharing.",
	"nodeErrorView.details": "Details",
	"nodeErrorView.details.from": "From {node}",
	"nodeErrorView.details.rawMessages": "Full message",
	"nodeErrorView.details.errorData": "Error data",
	"nodeErrorView.details.errorExtra": "Error extra",
	"nodeErrorView.details.request": "Request",
	"nodeErrorView.details.title": "Error details",
	"nodeErrorView.details.message": "Error message",
	"nodeErrorView.details.info": "Other info",
	"nodeErrorView.details.nodeVersion": "Node version",
	"nodeErrorView.details.nodeType": "Node type",
	"nodeErrorView.details.n8nVersion": "n8n version",
	"nodeErrorView.details.errorCause": "Error cause",
	"nodeErrorView.details.causeDetailed": "Cause detailed",
	"nodeErrorView.details.stackTrace": "Stack trace",
	"nodeErrorView.error": "ERROR",
	"nodeErrorView.errorSubNode": "Error in sub-node ‘{node}’",
	"nodeErrorView.httpCode": "HTTP Code",
	"nodeErrorView.errorCode": "Error code",
	"nodeErrorView.inParameter": "In or underneath Parameter",
	"nodeErrorView.itemIndex": "Item Index",
	"nodeErrorView.runIndex": "Run Index",
	"nodeErrorView.showMessage.title": "Copied to clipboard",
	"nodeErrorView.stack": "Stack",
	"nodeErrorView.theErrorCauseIsTooLargeToBeDisplayed": "The error cause is too large to be displayed",
	"nodeErrorView.time": "Time",
	"nodeErrorView.inputPanel.previousNodeError.title": "Error running node '{nodeName}'",
	"nodeErrorView.description.pairedItemInvalidInfo": "An expression here won't work because it uses <code>.item</code> and n8n can't figure out the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">matching item</a>. This is because the node <strong>'{nodeCause}'</strong> returned incorrect matching information (for item {itemIndex} of run {runIndex}).  <br/><br/>Try using <code>.first()</code>, <code>.last()</code> or <code>.all()[index]</code> instead of <code>.item</code>.",
	"nodeErrorView.description.pairedItemNoInfo": "An expression here won't work because it uses <code>.item</code> and n8n can't figure out the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">matching item</a>. The node <strong>'{nodeCause}'</strong> didn't return enough information.",
	"nodeErrorView.description.pairedItemNoInfoCodeNode": "An expression here won't work because it uses <code>.item</code> and n8n can't figure out the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">matching item</a>. You can either: <ul><li>Add the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-code-node/\">missing information</a> to the node <strong>'{nodeCause}'</strong></li><li>Or use <code>.first()</code>, <code>.last()</code> or <code>.all()[index]</code> instead of <code>.item</code></li></ul>",
	"nodeErrorView.description.pairedItemNoConnection": "There is no connection back to the node <strong>'{nodeCause}'</strong>, but it's used in an expression here.<br/><br/>Please wire up the node (there can be other nodes in between).",
	"nodeErrorView.description.pairedItemNoConnectionCodeNode": "There is no connection back to the node <strong>'{nodeCause}'</strong>, but it's used in code here.<br/><br/>Please wire up the node (there can be other nodes in between).",
	"nodeErrorView.description.noNodeExecutionData": "An expression references the node <strong>'{nodeCause}'</strong>, but it hasn't been executed yet. Either change the expression, or re-wire your workflow to make sure that node executes first.",
	"nodeErrorView.description.nodeNotFound": "The node <strong>'{nodeCause}'</strong> doesn't exist, but it's used in an expression here.",
	"nodeErrorView.description.noInputConnection": "This node has no input data. Please make sure this node is connected to another node.",
	"nodeErrorView.description.pairedItemMultipleMatches": "An expression here won't work because it uses <code>.item</code> and n8n can't figure out the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">matching item</a>. (There are multiple possible matches) <br/><br/>Try using <code>.first()</code>, <code>.last()</code> or <code>.all()[index]</code> instead of <code>.item</code> or <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-code-node/\">reference a different node</a>.",
	"nodeErrorView.description.pairedItemMultipleMatchesCodeNode": "The code here won't work because it uses <code>.item</code> and n8n can't figure out the <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">matching item</a>. (There are multiple possible matches) <br/><br/>Try using <code>.first()</code>, <code>.last()</code> or <code>.all()[index]</code> instead of <code>.item</code> or <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-code-node/\">reference a different node</a>.",
	"nodeErrorView.description.pairedItemPinned": "The <a target=\"_blank\" href=\"https://docs.n8n.io/data/data-mapping/data-item-linking/item-linking-errors/\">item-matching</a> data in that node may be stale. It is needed by an expression in this node that uses <code>.item</code>.",
	"nodeHelpers.credentialsUnset": "Credentials for '{credentialType}' are not set.",
	"nodeSettings.alwaysOutputData.description": "If active, will output a single, empty item when the output would have been empty. Use to prevent the workflow finishing on this node.",
	"nodeSettings.alwaysOutputData.displayName": "Always Output Data",
	"nodeSettings.clickOnTheQuestionMarkIcon": "Click the '?' icon to open this node on n8n.io",
	"nodeSettings.customSpanAttributes.displayName": "Custom span attributes",
	"nodeSettings.customSpanAttributes.description": "Add custom span attributes to this node's OpenTelemetry spans. Values support expressions.",
	"nodeSettings.customSpanAttributes.placeholder": "Add attribute",
	"nodeSettings.customSpanAttributes.tag.displayName": "Attribute",
	"nodeSettings.customSpanAttributes.tag.key.displayName": "Key",
	"nodeSettings.customSpanAttributes.tag.value.displayName": "Value",
	"nodeSettings.onError.description": "Action to take when the node execution fails",
	"nodeSettings.onError.displayName": "On Error",
	"nodeSettings.onError.options.continueRegularOutput.description": "Pass error message as item in regular output",
	"nodeSettings.onError.options.continueRegularOutput.displayName": "Continue",
	"nodeSettings.onError.options.continueErrorOutput.description": "Pass item to an extra `error` output",
	"nodeSettings.onError.options.continueErrorOutput.displayName": "Continue (using error output)",
	"nodeSettings.onError.options.stopWorkflow.description": "Halt execution and fail workflow",
	"nodeSettings.onError.options.stopWorkflow.displayName": "Stop Workflow",
	"nodeSettings.docs": "Docs",
	"nodeSettings.executeButtonTooltip.times": "Will execute {inputSize} times, once for each input item",
	"nodeSettings.executeOnce.description": "If active, the node executes only once, with data from the first item it receives",
	"nodeSettings.executeOnce.displayName": "Execute Once",
	"nodeSettings.dynamicCredentials.displayName": "End-user credentials",
	"nodeSettings.maxTries.description": "Number of times to attempt to execute the node before failing the execution",
	"nodeSettings.maxTries.displayName": "Max. Tries",
	"nodeSettings.noDescriptionFound": "No description found",
	"nodeSettings.nodeDescription": "Node Description",
	"nodeSettings.notes.description": "Optional note to save with the node",
	"nodeSettings.notes.displayName": "Notes",
	"nodeSettings.notesInFlow.description": "If active, the note above will display in the flow as a subtitle",
	"nodeSettings.notesInFlow.displayName": "Display Note in Flow?",
	"nodeSettings.parameters": "Parameters",
	"nodeSettings.parametersShort": "Params",
	"nodeSettings.settings": "Settings",
	"nodeSettings.action": "Action",
	"nodeSettings.credential": "Auth",
	"nodeSettings.communityNodeTooltip": "This is a <a href=\"{docUrl}\" target=\"_blank\"/>community node</a>",
	"nodeSettings.retryOnFail.description": "If active, the node tries to execute again when it fails",
	"nodeSettings.retryOnFail.displayName": "Retry On Fail",
	"nodeSettings.scopes.expandedNoticeWithScopes": "<a data-key=\"toggle-expand\">{count} scope</a> available for {activeCredential} credentials<br>{scopes}<br><a data-key=\"show-less\">Show less</a> | <a data-key=\"toggle-expand\">{count} scopes</a> available for {activeCredential} credentials<br>{scopes}<br><a data-key=\"show-less\">Show less</a>",
	"nodeSettings.scopes.notice": "<a data-key=\"toggle-expand\">{count} scope</a> available for {activeCredential} credentials | <a data-key=\"toggle-expand\">{count} scopes</a> available for {activeCredential} credentials",
	"nodeSettings.theNodeIsNotValidAsItsTypeIsUnknown": "The node is not valid as its type ({nodeType}) is unknown",
	"nodeSettings.communityNodeDetails.title": "Node details",
	"nodeSettings.communityNodeUnknown.title": "Install this node to use it",
	"nodeSettings.communityNodeUnknown.title.preview": "Detailed node info is not available",
	"nodeSettings.communityNodeUnknown.description": "This node is not currently installed. It's part of the {action} community package.",
	"nodeSettings.communityNodeUnknown.installLink.text": "How to install community nodes",
	"nodeSettings.communityNodeUnknown.installButton.label": "Install",
	"nodeSettings.communityNodeUnknown.viewDetailsButton.label": "View details",
	"nodeSettings.nodeTypeUnknown.description": "This node is not currently installed. It is either from a newer version of n8n, a {action}, or has an invalid structure",
	"nodeSettings.nodeTypeUnknown.description.customNode": "custom node",
	"nodeSettings.thisNodeDoesNotHaveAnyParameters": "This node does not have any parameters",
	"nodeSettings.useTheHttpRequestNode": "Use the <b>HTTP Request</b> node to make a custom API call. We'll take care of the {nodeTypeDisplayName} auth for you. <a target=\"_blank\" href=\"https://docs.n8n.io/integrations/custom-operations/\">Learn more</a>",
	"nodeSettings.waitBetweenTries.description": "How long to wait between each attempt (in milliseconds)",
	"nodeSettings.waitBetweenTries.displayName": "Wait Between Tries (ms)",
	"nodeSettings.hasForeignCredential": "To edit this node, either:<br/>a) Ask {owner} to share the credential with you, or<br/>b) Duplicate the node and add your own credential",
	"nodeSettings.latest": "Latest",
	"nodeSettings.deprecated": "Deprecated",
	"nodeSettings.latestVersion": "Latest version: {version}",
	"nodeSettings.outputCleared.title": "Parameters changed",
	"nodeSettings.outputCleared.message": "Order of parameters changed, outgoing connections were cleared",
	"nodeSettings.nodeVersion": "{node} node version {version}",
	"nodeView.addNode": "Add node",
	"nodeView.openFocusPanel": "Open focus panel",
	"nodeView.openSidePanel": "Open side panel",
	"nodeView.openNodesPanel": "Open nodes panel",
	"nodeView.openCommandBar": "Command bar",
	"nodeView.addATriggerNodeFirst": "Add a <a data-action='showNodeCreator'>Trigger Node</a> first",
	"nodeView.addOrEnableTriggerNode": "<a data-action='showNodeCreator'>Add</a> or enable a Trigger node to execute the workflow",
	"nodeView.addSticky": "Click to add sticky note",
	"nodeView.addStickyHint": "Add sticky note",
	"nodeView.cantExecuteNoTrigger": "Cannot execute workflow",
	"nodeView.canvasAddButton.addATriggerNodeBeforeExecuting": "Add a Trigger Node before executing the workflow",
	"nodeView.canvasAddButton.addFirstStep": "Add first step…",
	"nodeView.templateLink": "or start from a template",
	"nodeView.confirmMessage.onClipboardPasteEvent.cancelButtonText": "",
	"nodeView.confirmMessage.onClipboardPasteEvent.confirmButtonText": "Yes, import",
	"nodeView.confirmMessage.onClipboardPasteEvent.headline": "Import Workflow?",
	"nodeView.confirmMessage.onClipboardPasteEvent.message": "Workflow will be imported from<br /><i>{plainTextData}<i>",
	"nodeView.confirmMessage.debug.cancelButtonText": "Cancel",
	"nodeView.confirmMessage.debug.confirmButtonText": "Unpin",
	"nodeView.confirmMessage.debug.headline": "Unpin workflow data",
	"nodeView.confirmMessage.debug.message": "Loading this execution will unpin the data currently pinned in these nodes",
	"nodeView.couldntImportWorkflow": "Could not import workflow",
	"nodeView.couldntLoadWorkflow.invalidWorkflowObject": "Invalid workflow object",
	"nodeView.deletesTheCurrentExecutionData": "Deletes the current execution data",
	"nodeView.focusPanel.noExecutionData": "Execute previous node for autocomplete",
	"nodeView.focusPanel.noParameters.title": "Show a node parameter here, to iterate easily",
	"nodeView.focusPanel.noParameters.subtitle": "For example, keep your prompt always visible so you can run the workflow while tweaking it",
	"nodeView.focusPanel.v2.noParameters.title": "Select a node to edit it here",
	"nodeView.focusPanel.v2.noParameters.subtitle": "Or show single node parameter you’d like to iterate on by clicking this button next to it:",
	"nodeView.focusPanel.missingParameter": "This parameter is no longer visible on the node. A related parameter was likely changed, removing this one.",
	"nodeView.itLooksLikeYouHaveBeenEditingSomething": "It looks like you made some edits. If you leave before saving, your changes might be lost.",
	"nodeView.loadingTemplate": "Loading template",
	"nodeView.moreInfo": "More info",
	"nodeView.noNodesGivenToAdd": "No nodes to add specified",
	"nodeView.prompt.cancel": "@:_reusableBaseText.cancel",
	"nodeView.prompt.invalidName": "Invalid Name",
	"nodeView.prompt.newName": "New Name",
	"nodeView.prompt.rename": "Rename",
	"nodeView.prompt.renameNode": "Rename Node",
	"nodeView.redirecting": "Redirecting",
	"nodeView.refresh": "Refresh",
	"nodeView.resetZoom": "Reset Zoom",
	"nodeView.tidyUp": "Tidy Up",
	"nodeView.runButtonText.executeWorkflow": "Execute workflow",
	"nodeView.runButtonText.executingWorkflow": "Executing workflow",
	"nodeView.runButtonText.waitingForTriggerEvent": "Waiting for trigger event",
	"nodeView.runButtonText.from": "from {nodeName}",
	"nodeView.showError.workflowError": "Workflow execution had an error",
	"nodeView.showError.getWorkflowDataFromUrl.title": "Problem loading workflow",
	"nodeView.showError.importWorkflowData.title": "Problem importing workflow",
	"nodeView.showError.importWorkflowData.invalidNodes": "Skipped {count} node(s) with missing type",
	"nodeView.showError.importWorkflowData.invalidStructure": "The imported data does not contain valid workflow data ('nodes' and 'connections' are missing)",
	"nodeView.showError.mounted1.message": "There was a problem loading init data",
	"nodeView.showError.mounted1.title": "Init Problem",
	"nodeView.showError.mounted2.message": "There was a problem initializing the workflow",
	"nodeView.showError.mounted2.title": "Init Problem",
	"nodeView.showError.openExecution.title": "Problem loading execution",
	"nodeView.showError.openExecution.node": "Problem opening node in execution",
	"nodeView.showError.openWorkflow.title": "Problem opening workflow",
	"nodeView.showError.stopExecution.title": "Problem stopping execution",
	"nodeView.showError.stopWaitingForWebhook.title": "Problem deleting test webhook",
	"nodeView.showError.nodeNodeCompatible.title": "Connection not possible",
	"nodeView.showError.nodeNodeCompatible.message": "The node \"{sourceNodeName}\" can't be connected to the node \"{targetNodeName}\" because they are not compatible.",
	"nodeView.showMessage.addNodeButton.message": "'{nodeTypeName}' is an unknown node type",
	"nodeView.showMessage.addNodeButton.title": "Could not insert node",
	"nodeView.showMessage.keyDown.title": "Workflow created",
	"nodeView.showMessage.importWorkflowTags.title": "Workflow imported without tags",
	"nodeView.showMessage.importWorkflowTags.message": "You don't have permission to create tags, so the workflow's tags were not added.",
	"nodeView.showMessage.showMaxNodeTypeError.message": "Only one '{nodeTypeDataDisplayName}' node is allowed in a workflow | Only {count} '{nodeTypeDataDisplayName}' nodes are allowed in a workflow",
	"nodeView.showMessage.showMaxNodeTypeError.title": "Could not insert node",
	"nodeView.showMessage.stopExecutionCatch.unsaved.message": "This execution was canceled",
	"nodeView.showMessage.stopExecutionCatch.unsaved.title": "Execution canceled",
	"nodeView.showMessage.stopExecutionCatch.message": "It completed before it could be stopped",
	"nodeView.showMessage.stopExecutionCatch.title": "Workflow finished executing",
	"nodeView.showMessage.stopExecutionTry.title": "Execution stopped",
	"nodeView.showMessage.debug.title": "Execution data imported",
	"nodeView.showMessage.debug.content": "You can make edits and re-execute. Once you're done, unpin the the first node.",
	"nodeView.showMessage.debug.missingNodes.title": "Some execution data wasn't imported",
	"nodeView.showMessage.debug.missingNodes.content": "Some nodes have been deleted or renamed or added to the workflow since the execution ran.",
	"nodeView.showMessage.ndvUrl.missingNodes.title": "Node not found",
	"nodeView.showMessage.ndvUrl.missingNodes.content": "URL contained a reference to an unknown node. Maybe the node was deleted?",
	"nodeView.stopCurrentExecution": "Stop current execution",
	"nodeView.stopWaitingForWebhookCall": "Stop waiting for webhook call",
	"nodeView.stoppingCurrentExecution": "Stopping current execution",
	"nodeView.thereWasAProblemLoadingTheNodeParametersOfNode": "There was a problem loading the parameters of the node",
	"nodeView.thisExecutionHasntFinishedYet": "This execution hasn't finished yet",
	"nodeView.toSeeTheLatestStatus": "to see the latest status",
	"nodeView.workflowTemplateWithIdCouldNotBeFound": "Workflow template with ID \"{templateId}\" could not be found",
	"nodeView.workflowWithIdCouldNotBeFound": "Workflow with ID \"{workflowId}\" could not be found",
	"nodeView.zoomIn": "Zoom In",
	"nodeView.zoomOut": "Zoom Out",
	"nodeView.zoomToFit": "Zoom to Fit",
	"nodeView.replaceMe": "Replace Me",
	"nodeView.setupTemplate": "Set up template",
	"nodeView.expandAllNodes": "Expand all nodes",
	"nodeView.collapseAllNodes": "Collapse all nodes",
	"nodeView.enterZoomMode": "Enter zoom mode",
	"nodeView.leaveZoomMode": "Leave zoom mode",
	"nodeViewV2.showError.editingNotAllowed": "Editing is not allowed",
	"nodeViewV2.showError.failedToCreateNode": "Failed to create node",
	"contextMenu.node": "node | {count} nodes",
	"contextMenu.sticky": "sticky note | {count} sticky notes",
	"contextMenu.nodeGroup": "group",
	"contextMenu.selectAll": "Select all",
	"contextMenu.deselectAll": "Clear selection",
	"contextMenu.tidyUpWorkflow": "Tidy up workflow",
	"contextMenu.tidyUpSelection": "Tidy up selection",
	"contextMenu.extract": "Convert node to sub-workflow | Convert {subject} to sub-workflow",
	"contextMenu.group": "Group node | Group nodes",
	"contextMenu.renameGroup": "Rename group",
	"contextMenu.ungroupNodes": "Ungroup nodes",
	"contextMenu.expandAllGroups": "Expand all groups",
	"contextMenu.collapseAllGroups": "Collapse all groups",
	"contextMenu.expandSelectedGroups": "Expand selected",
	"contextMenu.collapseSelectedGroups": "Collapse selected",
	"contextMenu.showAllGroupDescriptions": "Show group descriptions",
	"contextMenu.hideAllGroupDescriptions": "Hide group descriptions",
	"contextMenu.showGroupDescription": "Show group description",
	"contextMenu.hideGroupDescription": "Hide group description",
	"contextMenu.replace": "Replace",
	"contextMenu.duplicate": "Duplicate | Duplicate {subject}",
	"contextMenu.open": "Open...",
	"contextMenu.test": "Execute step",
	"contextMenu.rename": "Rename",
	"contextMenu.openSubworkflow": "Go to Sub-workflow",
	"contextMenu.copy": "Copy | Copy {subject}",
	"contextMenu.deactivate": "Deactivate | Deactivate {subject}",
	"contextMenu.activate": "Activate | Activate {subject}",
	"contextMenu.pin": "Pin | Pin {subject}",
	"contextMenu.unpin": "Unpin | Unpin {subject}",
	"contextMenu.delete": "Delete | Delete {subject}",
	"contextMenu.addNode": "Add node",
	"contextMenu.addSticky": "Add sticky note",
	"contextMenu.editSticky": "Edit sticky note",
	"contextMenu.changeColor": "Change color",
	"contextMenu.copyTestUrl": "Copy test url",
	"contextMenu.copyProductionUrl": "Copy production url",
	"contextMenu.focusAiOnSelected": "Add to n8n AI | Add {subject} to n8n AI",
	"contextMenu.addToAi": "Add to n8n AI",
	"nodeWebhooks.clickToCopyWebhookUrls": "Click to copy webhook URLs",
	"nodeWebhooks.clickToCopyWebhookUrls.formTrigger": "Click to copy Form URL",
	"nodeWebhooks.clickToCopyWebhookUrls.chatTrigger": "Click to copy Chat URL",
	"nodeWebhooks.clickToCopyWebhookUrls.mcpTrigger": "Click to copy MCP URL",
	"nodeWebhooks.clickToDisplayWebhookUrls": "Click to display webhook URLs",
	"nodeWebhooks.clickToDisplayWebhookUrls.formTrigger": "Click to display Form URL",
	"nodeWebhooks.clickToDisplayWebhookUrls.chatTrigger": "Click to display Chat URL",
	"nodeWebhooks.clickToDisplayWebhookUrls.mcpTrigger": "Click to display MCP URL",
	"nodeWebhooks.clickToHideWebhookUrls": "Click to hide webhook URLs",
	"nodeWebhooks.clickToHideWebhookUrls.formTrigger": "Click to hide Form URL",
	"nodeWebhooks.clickToHideWebhookUrls.chatTrigger": "Click to hide Chat URL",
	"nodeWebhooks.clickToHideWebhookUrls.mcpTrigger": "Click to hide MCP URL",
	"nodeWebhooks.invalidExpression": "[INVALID EXPRESSION]",
	"nodeWebhooks.productionUrl": "Production URL",
	"nodeWebhooks.showMessage.title": "URL copied",
	"nodeWebhooks.showMessage.testWebhookUrl": "This node is only supports production webhooks",
	"nodeWebhooks.showMessage.not.active": "Workflow is not active",
	"nodeWebhooks.showMessage.title.formTrigger": "Form URL copied",
	"nodeWebhooks.showMessage.title.chatTrigger": "Chat URL copied",
	"nodeWebhooks.showMessage.title.mcpTrigger": "MCP URL copied",
	"nodeWebhooks.showMessage.message.formTrigger": "Form submissions made via this URL will trigger the workflow when it's activated",
	"nodeWebhooks.showMessage.message.chatTrigger": "Chat submissions made via this URL will trigger the workflow when it's activated",
	"nodeWebhooks.testUrl": "Test URL",
	"nodeWebhooks.webhookUrls": "Webhook URLs",
	"nodeWebhooks.webhookUrls.formTrigger": "Form URLs",
	"nodeWebhooks.webhookUrls.chatTrigger": "Chat URL",
	"nodeWebhooks.webhookUrls.mcpTrigger": "MCP URL",
	"openWorkflow.workflowImportError": "Could not import workflow",
	"openWorkflow.workflowDataInvalidError": "Workflow data is invalid",
	"openWorkflow.workflowNotFoundError": "Could not find workflow",
	"oauth.consentView.title": "OAuth access consent",
	"oauth.consentView.heading": "{clientName} wants access to your n8n instance",
	"oauth.consentView.headingWithWorkflow": "{clientName} requests access to workflow {resourceName}",
	"oauth.consentView.description": "This will allow {clientName} to perform the following actions:",
	"oauth.consentView.descriptionWithWorkflow": "This will allow {clientName} to access this workflow on your behalf.",
	"oauth.consentView.action.listWorkflows": "Get a list of your workflows",
	"oauth.consentView.action.workflowDetails": "Get details for a specific workflow",
	"oauth.consentView.action.executeWorkflows": "Execute workflows on your behalf",
	"oauth.consentView.action.executionDetails": "Get details for a specific workflow execution",
	"oauth.consentView.action.createUpdateWorkflows": "Create and update workflows on your behalf",
	"oauth.consentView.action.createDataTables": "Create and update data tables on your behalf",
	"oauth.consentView.action.searchProjectsAndFolders": "Search for projects and folders",
	"oauth.consentView.scopes.description": "Choose what {clientName} is allowed to do.",
	"oauth.consentView.scopes.label": "Scopes",
	"oauth.consentView.scopes.all": "All",
	"oauth.consentView.scopes.readOnly": "Read only",
	"oauth.consentView.scopes.custom": "Custom",
	"oauth.consentView.scopes.search.placeholder": "Search scopes",
	"oauth.consentView.scopes.toggleGroup": "Toggle {group} scopes",
	"oauth.consentView.scopes.count": "{selected} of {total} scopes selected",
	"oauth.consentView.scopes.badge.read": "read",
	"oauth.consentView.scopes.badge.write": "write",
	"oauth.consentView.scopes.group.workflows": "Workflows",
	"oauth.consentView.scopes.group.executions": "Executions",
	"oauth.consentView.scopes.group.credentials": "Credentials",
	"oauth.consentView.scopes.group.dataTables": "Data tables",
	"oauth.consentView.scopes.group.projectsAndFolders": "Projects and folders",
	"oauth.consentView.scopes.note": "Applies only to this connection. Other clients keep their own permissions.",
	"oauth.consentView.scopes.tools.count": "{count} tool | {count} tools",
	"oauth.consentView.scopes.tools.enabledOf": "{enabled} of {total} tools enabled",
	"oauth.consentView.readMore": "Read more <a href='{docsUrl}' target='_blank'>here</a>",
	"oauth.consentView.redirectWarning.title": "You will be redirected to the following location:",
	"oauth.consentView.redirectWarning.confirm": "I recognize and trust this URL",
	"oauth.consentView.error.deny": "Error denying access",
	"oauth.consentView.error.allow": "Error allowing access",
	"oauth.consentView.error.fetchDetails": "Error fetching client details",
	"oauth.consentView.error.heading": "Authorization unavailable",
	"oauth.consentView.error.resourceUnavailable": "This authorization can no longer be completed because the target is no longer available.",
	"oauth.consentView.error.insufficientScope": "You do not have sufficient permissions to authorize this request.",
	"oauth.consentView.success.title": "Success",
	"oauth.consentView.success.description": "You will soon be redirected back to the client.",
	"parameterInput.expressionResult": "e.g. {result}",
	"parameterInput.dragTipBeforePill": "Drag an",
	"parameterInput.inputField": "input field",
	"parameterInput.dragTipAfterPill": "from the left to use it here.",
	"parameterInput.learnMore": "Learn more",
	"parameterInput.result": "Result",
	"parameterInput.item": "Item",
	"parameterInput.hoverTableItemTip": "You can also do this by hovering over input/output items in the table view",
	"parameterInput.emptyString": "[empty]",
	"parameterInput.customApiCall": "Custom API Call",
	"parameterInput.iconPicker.tooltip": "Select icon or emoji",
	"parameterInput.selectIcon": "Select icon",
	"parameterInput.error": "ERROR",
	"parameterInput.expression": "Expression",
	"parameterInput.fixed": "Fixed",
	"parameterInput.formatHtml": "Format HTML",
	"parameterInput.issues": "Issues",
	"parameterInput.loadingOptions": "Loading options...",
	"parameterInput.loadOptionsErrorService": "Error fetching options from {service}",
	"parameterInput.loadOptionsError": "Error fetching options",
	"parameterInput.loadOptionsCredentialsRequired": "Set up credential to see options",
	"parameterInput.openEditWindow": "Open Edit Window",
	"parameterInput.edit": "Edit",
	"parameterInput.parameter": "Parameter: \"{shortPath}\"",
	"parameterInput.parameterHasExpression": "Parameter: \"{shortPath}\" has an expression",
	"parameterInput.parameterHasIssues": "Parameter: \"{shortPath}\" has issues",
	"parameterInput.parameterHasIssuesAndExpression": "Parameter: \"{shortPath}\" has issues and an expression",
	"parameterInput.refreshList": "Refresh List",
	"parameterInput.clearContents": "Clear Contents",
	"parameterInput.focusParameter": "Focus parameter",
	"parameterInput.resetValue": "Reset Value",
	"parameterInput.select": "Select",
	"parameterInput.selectDate": "Select date",
	"parameterInput.selectDateAndTime": "Select date and time",
	"parameterInput.selectACredentialTypeFromTheDropdown": "Select a credential type from the dropdown",
	"parameterInput.theValueIsNotSupported": "The value \"{checkValue}\" is not supported!",
	"parameterInput.selectedWorkflowIsArchived": "The selected workflow is archived",
	"parameterInput.invalidJson": "Invalid JSON format",
	"parameterInputExpanded.openDocs": "Open docs",
	"parameterInputExpanded.thisFieldIsRequired": "This field is required",
	"parameterInputList.delete": "Delete",
	"parameterInputList.deleteParameter": "Delete Parameter",
	"parameterInputList.parameterOptions": "Parameter Options",
	"parameterInputList.loadingFields": "Loading fields...",
	"parameterInputList.loadingError": "Error loading fields. Refresh you page and try again.",
	"parameterInputList.callout.dismiss.confirm.text": "Do you want to permanently hide this?",
	"parameterInputList.callout.dismiss.confirm.confirmButtonText": "Confirm",
	"parameterInputList.callout.dismiss.confirm.cancelButtonText": "Cancel",
	"parameterInputList.autoRequiresChatTriggerDescription": "Available when connected to a Chat Trigger node.",
	"parameterOverride.overridePanelText": "Defined automatically by the <b>model</b>",
	"parameterOverride.applyOverrideButtonTooltip": "Let the model define this parameter",
	"parameterOverride.descriptionTooltip": "Explain to the LLM how it should generate this value, a good, specific description would allow LLMs to produce expected results much more often",
	"personalizationModal.businessOwner": "Business Owner",
	"personalizationModal.continue": "Continue",
	"personalizationModal.cicd": "CI/CD",
	"personalizationModal.cloudInfrastructureOrchestration": "Cloud infrastructure orchestration",
	"personalizationModal.customerIntegrations": "Customer integrations",
	"personalizationModal.customerSupport": "Customer support",
	"personalizationModal.customizeN8n": "Customize n8n to you",
	"personalizationModal.dataScience": "Data Science",
	"personalizationModal.devops": "Devops",
	"personalizationModal.digitalAgencyOrConsultant": "Marketing agency / consultancy",
	"personalizationModal.eCommerce": "Ecommerce",
	"personalizationModal.education": "Education",
	"personalizationModal.engineering": "Engineering",
	"personalizationModal.engineeringOrDevops": "Engineering / Devops",
	"personalizationModal.errorWhileSubmittingResults": "Error while submitting results",
	"personalizationModal.financeOrAccounting": "Finance / Accounting",
	"personalizationModal.financeOrInsurance": "Finance / Insurance",
	"personalizationModal.getStarted": "Get started",
	"personalizationModal.government": "Government",
	"personalizationModal.healthcare": "Healthcare",
	"personalizationModal.howAreYourCodingSkills": "How are your coding skills?",
	"personalizationModal.howBigIsYourCompany": "How big is your company?",
	"personalizationModal.hr": "HR",
	"personalizationModal.imNotUsingN8nForWork": "I'm not using n8n for work",
	"personalizationModal.it": "IT",
	"personalizationModal.legal": "Legal",
	"personalizationModal.lessThan20People": "Less than 20 people",
	"personalizationModal.managedServiceProvider": "Managed service provider",
	"personalizationModal.manufacturing": "Manufacturing",
	"personalizationModal.marketing": "Marketing",
	"personalizationModal.media": "Media",
	"personalizationModal.notSureYet": "Not sure yet",
	"personalizationModal.operations": "Operations",
	"personalizationModal.other": "Other",
	"personalizationModal.otherPleaseSpecify": "Other (please specify)",
	"personalizationModal.specifyReportedSource": "Specify how you heard about n8n",
	"personalizationModal.people": "people",
	"personalizationModal.physicalRetailOrServices": "Physical retail or services",
	"personalizationModal.product": "Product (e.g. fast prototyping)",
	"personalizationModal.realEstateOrConstruction": "Real estate / Construction",
	"personalizationModal.saas": "Software as a service",
	"personalizationModal.salesAndMarketing": "Sales and Marketing",
	"personalizationModal.security": "Security",
	"personalizationModal.select": "Select...",
	"personalizationModal.howDidYouHearAboutN8n": "How did you hear about n8n?",
	"personalizationModal.friendWordOfMouth": "Friend / Word of mouth",
	"personalizationModal.podcast": "Podcast",
	"personalizationModal.event": "Event",
	"personalizationModal.myself": "Myself",
	"personalizationModal.myTeam": "My team",
	"personalizationModal.otherTeams": "Other teams",
	"personalizationModal.specifyAutomationBeneficiary": "Who will your automations mainly be for?",
	"personalizationModal.specifyYourRole": "Please specify your role",
	"personalizationModal.specifyYourAutomationGoal": "Please specify your automation goal",
	"personalizationModal.specifyYourCompanysIndustry": "Specify your company's industry",
	"personalizationModal.support": "Support",
	"personalizationModal.systemsIntegrator": "Systems integrator / Automation agency",
	"personalizationModal.telecoms": "Telecoms",
	"personalizationModal.thanks": "Thanks!",
	"personalizationModal.theseQuestionsHelpUs": "These questions help us tailor n8n to you",
	"personalizationModal.whichRoleBestDescribesYou": "Which role best describes you?",
	"personalizationModal.whatAreYouLookingToAutomate": "What are you looking to automate?",
	"personalizationModal.whatBestDescribesYourCompany": "What best describes your company?",
	"personalizationModal.whichIndustriesIsYourCompanyIn": "Which industries is your company in?",
	"personalizationModal.specifySalesMarketingGoal": "Which parts of Sales and Marketing?",
	"personalizationModal.leadGeneration": "Lead generation, enrichment, routing",
	"personalizationModal.customerCommunication": "Customer communication",
	"personalizationModal.customerActions": "Actions when lead changes status",
	"personalizationModal.yourEmailAddress": "Your email address",
	"personalizationModal.email": "Enter your email..",
	"personalizationModal.adCampaign": "Ad campaign management",
	"personalizationModal.reporting": "Reporting",
	"personalizationModal.ticketingSystemsIntegrations": "Ticketing systems integrations",
	"personalizationModal.dataSynching": "Data syncing",
	"personalizationModal.incidentResponse": "Incident response",
	"personalizationModal.monitoringAndAlerting": "Monitoring and alerting",
	"personalizationModal.specifyUsageMode": "Are you looking to do any of these?",
	"personalizationModal.connectToInternalDB": "Connect to my company’s internal databases",
	"personalizationModal.buildBackendServices": "Build backend services (endpoints)",
	"personalizationModal.manipulateFiles": "Manipulate/transfer files",
	"personalizationModal.specifyOtherSalesAndMarketingGoal": "Specify your other Sales and Marketing goals",
	"personalizationModal.registerEmailForTrial": "Register your email to activate a free 14 day trial of our {trial}",
	"personalizationModal.registerEmailForTrial.enterprise": "Enterprise features",
	"personalizationModal.registerEmailForTrial.notice": "By checking this box, you agree to let us store your name and email to activate your trial and send over your license key. We’ll check-in at the end of the trial to ensure you’re getting the most out of our Enterprise features.",
	"personalizationModal.registerEmailForTrial.success.title": "Your enterprise license is on its way",
	"personalizationModal.registerEmailForTrial.success.message": "You'll shortly receive an email to activate your enterprise license. If you don't see it, check your spam folder.",
	"personalizationModal.registerEmailForTrial.success.button": "Start using n8n",
	"personalizationModal.registerEmailForTrial.error": "Error while registering for enterprise trial",
	"pushConnection.nodeExecutedSuccessfully": "Node executed successfully",
	"pushConnection.nodeNotExecuted": "Node was not executed",
	"pushConnection.nodeNotExecuted.message": "The execution took a different path and didn't reach this node. This typically happens with conditional nodes like If or Switch.",
	"pushConnection.workflowExecutedSuccessfully": "Workflow executed successfully",
	"pushConnection.error.message": "Connection lost",
	"pushConnection.error.tooltip": "You have a connection issue or the server is down. <br />n8n should reconnect automatically once the issue is resolved.",
	"pushConnection.pollingNode.dataNotFound": "No {service} data found",
	"pushConnection.pollingNode.dataNotFound.message": "We didn’t find any data in {service} to simulate an event. Please create one in {service} and try again.",
	"pushConnection.executionFailed": "Execution failed",
	"pushConnection.executionFailed.message": "There might not be enough memory to finish the execution. Tips for avoiding this <a target=\"_blank\" href=\"https://docs.n8n.io/flow-logic/error-handling/memory-errors/\">here</a>",
	"pushConnection.executionError": "There was a problem executing the workflow{error}",
	"pushConnection.executionError.openNode": "Open errored node",
	"pushConnection.executionError.details": "<br /><strong>{details}</strong>",
	"pushConnection.workflowHasIssues.title": "Workflow execution cannot start",
	"prompts.npsSurvey.recommendationQuestion": "How likely are you to recommend n8n to a friend or colleague?",
	"prompts.npsSurvey.greatFeedbackTitle": "Great to hear! Can we reach out to see how we can make n8n even better for you?",
	"prompts.npsSurvey.defaultFeedbackTitle": "Thanks for your feedback! We'd love to understand how we can improve. Can we reach out?",
	"prompts.npsSurvey.feedbackQuestionTitle": "Thank you! Why did you choose this score?",
	"prompts.npsSurvey.notLikely": "Not likely",
	"prompts.npsSurvey.veryLikely": "Very likely",
	"prompts.npsSurvey.send": "Send",
	"prompts.npsSurvey.reviewUs": "If you’d like to help even more, leave us a <a target=\"_blank\" href=\"https://www.g2.com/products/n8n/reviews/start\">review on G2</a>.",
	"prompts.npsSurvey.thanks": "Thanks for your feedback",
	"projectRoles.manageRoles.paywall.title": "Available on the Enterprise plan",
	"projectRoles.manageRoles.paywall.text": "Create custom roles with granular permissions to control exactly what team members can do inside projects.",
	"roles.paywall.title": "Upgrade to Enterprise",
	"roles.paywall.description": "Upgrade to Enterprise to unlock custom roles. It will allow to create custom, granular permissions that let you fine-tune access.",
	"roles.paywall.viewPlans": "View plans",
	"projectRoles.project:read": "View",
	"projectRoles.project:read.tooltip": "View project name, icon, description, and navigate within the project",
	"projectRoles.project:update": "Edit",
	"projectRoles.project:update.tooltip": "Edit project details and manage users",
	"projectRoles.project:delete": "Delete",
	"projectRoles.project:delete.tooltip": "Delete the entire project and all its contents",
	"projectRoles.project:export": "Export",
	"projectRoles.project:export.tooltip": "Export the entire project and all its contents",
	"projectRoles.folder:read": "View",
	"projectRoles.folder:read.tooltip": "View folders and subfolders within a project",
	"projectRoles.folder:update": "Edit",
	"projectRoles.folder:update.tooltip": "Rename folders, move workflows between folders, and change parent folder",
	"projectRoles.folder:create": "Create",
	"projectRoles.folder:create.tooltip": "Create new folders or subfolders",
	"projectRoles.folder:move": "Transfer",
	"projectRoles.folder:move.tooltip": "Move a folder and its workflows to another project.",
	"projectRoles.folder:delete": "Delete",
	"projectRoles.folder:delete.tooltip": "Delete an empty folder. If not empty, ask further action",
	"projectRoles.workflow:read": "View",
	"projectRoles.workflow:read.tooltip": "View workflows within the project",
	"projectRoles.workflow:export": "Export",
	"projectRoles.workflow:export.tooltip": "Include workflows in a package export",
	"projectRoles.workflow:import": "Import",
	"projectRoles.workflow:import.tooltip": "Import workflows from a portable package into the project",
	"projectRoles.workflow:execute": "Execute",
	"projectRoles.workflow:execute.tooltip": "Execute workflows within the project",
	"projectRoles.workflow:execute-chat": "Execute in Chat",
	"projectRoles.workflow:execute-chat.tooltip": "Execute workflows in chat",
	"projectRoles.workflow:update": "Edit",
	"projectRoles.workflow:update.tooltip": "Edit workflow content",
	"projectRoles.workflow:create": "Create",
	"projectRoles.workflow:create.tooltip": "Create new workflows",
	"projectRoles.workflow:share": "Share",
	"projectRoles.workflow:move": "Transfer",
	"projectRoles.workflow:move.tooltip": "Transfer workflows to another project",
	"projectRoles.workflow:delete": "Delete",
	"projectRoles.workflow:delete.tooltip": "Delete workflows",
	"projectRoles.workflow:publish": "Publish",
	"projectRoles.workflow:publish.tooltip": "Publish and unpublish workflows",
	"projectRoles.workflow:unpublish": "Unpublish",
	"projectRoles.workflow:unpublish.tooltip": "Unpublish workflows",
	"projectRoles.workflow:enableRedaction": "Enable data redaction",
	"projectRoles.workflow:enableRedaction.tooltip": "Allow enabling data redaction on workflows in the project",
	"projectRoles.workflow:disableRedaction": "Disable data redaction",
	"projectRoles.workflow:disableRedaction.tooltip": "Allow disabling data redaction on workflows in the project",
	"projectRoles.workflow:updateRedactionSetting": "Manage data redaction",
	"projectRoles.workflow:updateRedactionSetting.tooltip": "Manage the data redaction policy for workflows in the project",
	"projectRoles.agent:create": "Create",
	"projectRoles.agent:create.tooltip": "Create new agents",
	"projectRoles.agent:read": "View",
	"projectRoles.agent:read.tooltip": "View agents within the project",
	"projectRoles.agent:execute": "Execute",
	"projectRoles.agent:execute.tooltip": "Execute agents within the project",
	"projectRoles.agent:update": "Edit",
	"projectRoles.agent:update.tooltip": "Edit agents",
	"projectRoles.agent:delete": "Delete",
	"projectRoles.agent:delete.tooltip": "Delete agents",
	"projectRoles.agent:list": "List",
	"projectRoles.agent:list.tooltip": "List agents within the project",
	"projectRoles.agent:publish": "Publish",
	"projectRoles.agent:publish.tooltip": "Publish agents",
	"projectRoles.agent:unpublish": "Unpublish",
	"projectRoles.agent:unpublish.tooltip": "Unpublish agents",
	"projectRoles.credential:read": "View",
	"projectRoles.credential:read.tooltip": "View credentials details (secret masked) and use them in workflows",
	"projectRoles.credential:update": "Edit",
	"projectRoles.credential:update.tooltip": "Edit credential details including secret",
	"projectRoles.credential:create": "Create",
	"projectRoles.credential:create.tooltip": "Create new credentials",
	"projectRoles.credential:createEndUser": "Manage end-user credentials",
	"projectRoles.credential:createEndUser.tooltip": "Create, delete, or change the type of end-user credentials, where each user connects their own account",
	"projectRoles.credential:share": "Share",
	"projectRoles.credential:share.tooltip": "Share credentials with other projects or users",
	"projectRoles.credential:unshare": "Unshare",
	"projectRoles.credential:unshare.tooltip": "Remove credential sharing with other projects or users",
	"projectRoles.credential:move": "Transfer",
	"projectRoles.credential:move.tooltip": "Move credentials to another project",
	"projectRoles.credential:connect": "Connect end-user credentials",
	"projectRoles.credential:connect.tooltip": "Connect your own account to an end-user credential without editing it",
	"projectRoles.credential:delete": "Delete",
	"projectRoles.credential:delete.tooltip": "Delete credentials",
	"projectRoles.execution:reveal": "Reveal redacted data",
	"projectRoles.execution:reveal.tooltip": "Reveal redacted execution data on workflows that have data redaction enabled",
	"projectRoles.dataTable:read": "View",
	"projectRoles.dataTable:read.tooltip": "View the structure of data table (columns, name) and to view metadata",
	"projectRoles.dataTable:update": "Edit",
	"projectRoles.dataTable:update.tooltip": "Modify schema/columns",
	"projectRoles.dataTable:create": "Create",
	"projectRoles.dataTable:create.tooltip": "Create new data tables",
	"projectRoles.dataTable:delete": "Delete",
	"projectRoles.dataTable:delete.tooltip": "Delete data tables",
	"projectRoles.dataTable:readRow": "View Rows",
	"projectRoles.dataTable:readRow.tooltip": "View data table rows",
	"projectRoles.dataTable:writeRow": "Edit Rows",
	"projectRoles.dataTable:writeRow.tooltip": "Modify data table rows",
	"projectRoles.dataTable:readColumn": "View Columns",
	"projectRoles.dataTable:readColumn.tooltip": "View data table columns",
	"projectRoles.dataTable:writeColumn": "Edit Columns",
	"projectRoles.dataTable:writeColumn.tooltip": "Modify data table columns",
	"projectRoles.projectVariable:read": "View",
	"projectRoles.projectVariable:read.tooltip": "View project variable values and use them in workflows",
	"projectRoles.projectVariable:update": "Edit",
	"projectRoles.projectVariable:update.tooltip": "Modify existing project variables",
	"projectRoles.projectVariable:create": "Create",
	"projectRoles.projectVariable:create.tooltip": "Create new project variables",
	"projectRoles.projectVariable:delete": "Delete",
	"projectRoles.projectVariable:delete.tooltip": "Delete project variables",
	"projectRoles.sourceControl:pull": "Pull",
	"projectRoles.sourceControl:push": "Push",
	"projectRoles.sourceControl:push.tooltip": "Push changes (workflows, credentials, tags) to the remote repository",
	"projectRoles.sourceControl:manage": "Configure",
	"roles.table.name": "Name",
	"roles.table.type": "Type",
	"projectRoles.sourceControl.table.assignedTo": "Assigned to",
	"roles.table.lastEdited": "Last edited",
	"projectRoles.backToProjectRoles": "Back to project roles",
	"projectRoles.backToProjectSettings": "Back to project settings",
	"projectRoles.newRole": "New Role",
	"roles.addRole.instance": "Create instance role",
	"roles.addRole.project": "Create project role",
	"roles.description": "Roles allow you to manage specific permissions tailored to your team's needs. Define granular access to workflows, credentials, project resources and instance settings. Learn more in",
	"roles.description.docsLink": "documentation",
	"projectRoles.discardChanges": "Discard changes",
	"projectRoles.save": "Save",
	"projectRoles.create": "Create",
	"projectRoles.roleName": "Role name",
	"projectRoles.description": "Description",
	"projectRoles.optional": "Optional",
	"projectRoles.permissions": "Permissions",
	"projectRoles.preset": "Preset",
	"projectRoles.admin": "Admin",
	"projectRoles.editor": "Editor",
	"projectRoles.viewer": "Viewer",
	"projectRoles.type.project": "Project",
	"projectRoles.type.folder": "Folders",
	"projectRoles.type.workflow": "Workflows",
	"projectRoles.type.agent": "Agents",
	"projectRoles.type.credential": "Credentials",
	"projectRoles.type.execution": "Executions",
	"projectRoles.type.sourceControl": "Source control",
	"projectRoles.type.dataTable": "Data tables",
	"projectRoles.type.projectVariable": "Project variables",
	"projectRoles.type.externalSecretsProvider": "Secrets vaults",
	"projectRoles.type.externalSecret": "Secrets",
	"projectRoles.externalSecretsProvider:read": "View",
	"projectRoles.externalSecretsProvider:read.tooltip": "View secrets vault connections and see available secret names",
	"projectRoles.externalSecretsProvider:create": "Create",
	"projectRoles.externalSecretsProvider:create.tooltip": "Add new secrets vault connections to the project",
	"projectRoles.externalSecretsProvider:update": "Edit",
	"projectRoles.externalSecretsProvider:update.tooltip": "Edit secrets vault connection settings",
	"projectRoles.externalSecretsProvider:delete": "Delete",
	"projectRoles.externalSecretsProvider:delete.tooltip": "Remove secrets vault connections from the project",
	"projectRoles.externalSecretsProvider:sync": "Sync",
	"projectRoles.externalSecretsProvider:sync.tooltip": "Manually trigger a sync to refresh secrets from the provider",
	"projectRoles.externalSecret:list": "List",
	"projectRoles.externalSecret:list.tooltip": "List available secrets names from connected secrets vaults",
	"roles.literal.system": "System",
	"roles.literal.custom": "Custom",
	"roles.action.cancel": "Cancel",
	"roles.action.delete": "Delete",
	"projectRoles.action.delete.button": "Delete role",
	"roles.action.delete.success": "Role deleted",
	"roles.action.delete.error": "Error deleting role",
	"roles.action.delete.title": "Delete '{roleName}'?",
	"roles.action.delete.text": "Are you sure that you want to delete '{roleName}' permanently? This action cannot be undone.",
	"projectRoles.action.delete.warning": "Deleting a role is permanent. This can’t be undone.",
	"projectRoles.action.delete.useWarning.before": "You can't delete this role while it's assigned in",
	"projectRoles.action.delete.useWarning.linkText": "{count} project | {count} projects",
	"projectRoles.action.delete.useWarning.after": "To delete it, first reassign users within projects to a different role.",
	"projectRoles.dangerZone": "Danger zone",
	"roles.action.duplicate": "Duplicate",
	"roles.action.duplicate.name": "Copy of {roleName}",
	"roles.action.duplicate.success": "Role '{roleName}' duplicated successfully as '{roleDuplicateName}'",
	"roles.action.duplicate.error": "Error duplicating role",
	"projectRoles.action.create.success": "Role created successfully",
	"projectRoles.action.create.error": "Couldn't create role",
	"projectRoles.action.update": "Update role",
	"projectRoles.action.update.success": "Role updated successfully",
	"projectRoles.action.update.error": "Error updating role",
	"projectRoles.action.update.title": "Update role for '{count}' users?",
	"projectRoles.action.update.text": "These changes will instantly affect all {count} users with this role. Are you sure you want to continue?",
	"projectRoles.tab.permissions": "Permissions",
	"projectRoles.tab.assignments": "Assignments",
	"projectRoles.sourceControl.table.projectsAssigned": "Projects assigned",
	"roles.tab.instance": "Instance roles",
	"roles.tab.project": "Project roles",
	"instanceRoles.table.membersAssigned": "Members assigned",
	"instanceRoles.resource.settings": "Instance settings",
	"instanceRoles.resource.user": "Users",
	"instanceRoles.resource.role": "Roles",
	"instanceRoles.resource.apiKey": "API keys",
	"instanceRoles.resource.tag": "Tags",
	"instanceRoles.resource.project": "Projects",
	"instanceRoles.resource.insights": "Insights",
	"instanceRoles.option.view": "View",
	"instanceRoles.option.create": "Create",
	"instanceRoles.option.manage": "Manage",
	"instanceRoles.option.manageOwn": "Manage own",
	"instanceRoles.option.manageAll": "Manage others",
	"instanceRoles.option.manageProjectRoles": "Manage project roles",
	"instanceRoles.option.manageAllRoles": "Manage all roles (instance and project)",
	"instanceRoles.option.includedIn": "Included in {option}",
	"instanceRoles.description.settings.manage": "View and change instance-wide settings",
	"instanceRoles.description.user.manage": "Invite, remove, and update users across the instance",
	"instanceRoles.description.role.manageProjectRoles": "Create, edit, and delete custom project roles only",
	"instanceRoles.description.role.manage": "Create, edit, and delete all custom roles (instance and project).",
	"instanceRoles.description.apiKey.manageOwn": "Create and delete the user's own API keys",
	"instanceRoles.description.apiKey.manageAll": "View and delete other users' API keys.",
	"instanceRoles.description.tag.manage": "Create, edit, and delete tags",
	"instanceRoles.description.project.create": "Create new projects",
	"instanceRoles.description.insights.view": "View instance-level insights",
	"instanceRoles.warning.manageMembers": "A user with this permission can give themselves or an account they invite permissions they don't currently hold. {link}",
	"instanceRoles.warning.manageRoles": "A user with this permission can edit their own custom role to add permissions they weren't originally granted. {link}",
	"instanceRoles.warning.viewDocs": "View docs",
	"roles.instance.newRole": "New instance role",
	"roles.instance.editRole": "Custom instance role",
	"roles.instance.backToRoles": "Back to roles",
	"roles.instance.preset": "Preset",
	"roles.instance.permissions": "Permissions",
	"roles.instance.dangerZone": "Danger zone",
	"roles.instance.action.fetch.error": "Error fetching role",
	"roles.instance.action.delete.warning": "Deleting this role is permanent and cannot be undone.",
	"roles.instance.action.delete.button": "Delete role",
	"roles.instance.action.create.success": "Role created successfully",
	"roles.instance.action.create.error": "Couldn't create role",
	"roles.create.validation.nameMinLength": "Enter a name of at least {min} characters",
	"roles.instance.action.update.success": "Role updated successfully",
	"roles.instance.action.update.error": "Error updating role",
	"roles.instance.assignments.memberColumn": "Member",
	"roles.instance.assignments.roleColumn": "Instance role",
	"roles.instance.assignments.emptyState": "No users have this role yet.",
	"roles.instance.assignments.fetch.error": "Error loading members",
	"roles.fetch.error": "Error loading roles",
	"projectRoles.assignments.emptyState": "This role is not assigned in any projects yet.",
	"projectRoles.assignments.projectColumn": "Project",
	"projectRoles.assignments.membersColumn": "Members assigned",
	"projectRoles.assignments.lastAssignedColumn": "Last assigned",
	"projectRoles.assignments.membersModal.title": "\"{projectName}\" members",
	"projectRoles.assignments.membersModal.manageMembers": "Manage members",
	"projectRoles.assignments.membersModal.cancel": "Cancel",
	"projectRoles.action.delete.inUse.title": "{roleName}",
	"projectRoles.action.delete.inUse.goToAssignments": "Go to assignments",
	"projectRoles.systemRoleNotEditable": "System roles are not editable",
	"renameAction.emptyName.message": "Please enter a name, or press 'esc' to go back to the old one",
	"renameAction.emptyName.title": "Name missing",
	"renameAction.invalidName.title": "Invalid name",
	"resourceLocator.id.placeholder": "Enter ID...",
	"resourceLocator.mode.id": "By ID",
	"resourceLocator.mode.url": "By URL",
	"resourceLocator.mode.list": "From list",
	"resourceLocator.mode.list.disabled.title": "Change to Fixed mode to choose From List",
	"resourceLocator.mode.list.error.title": "Could not load list",
	"resourceLocator.mode.list.error.description.checkCredentials": "Check your credential",
	"resourceLocator.mode.list.error.description.noCredentials": "Add your credential",
	"resourceLocator.mode.list.noResults": "No results",
	"resourceLocator.mode.list.openUrl": "Open URL",
	"resourceLocator.mode.list.placeholder": "Choose...",
	"resourceLocator.mode.list.searchRequired": "Enter a search term to show results",
	"resourceLocator.mode.list.addNewResource.vectorStoreInMemory": "Create key '{resourceName}'",
	"resourceLocator.dataTable.createNew": "Create new data table",
	"resourceLocator.modeSelector.placeholder": "Mode...",
	"resourceLocator.openSpecificResource": "Open {entity} in {appName}",
	"resourceLocator.openResource": "Open in {appName}",
	"resourceLocator.placeholder.searchOrCreate": "Search or create...",
	"resourceLocator.placeholder.search": "Search...",
	"resourceLocator.url.placeholder": "Enter URL...",
	"resourceLocator.workflow.inactive.tooltip": "Not published. Can be used for manual testing, but must be published before running in production.",
	"resourceMapper.autoMappingNotice": "In this mode, make sure the incoming data fields are named the same as the {fieldWord} in {serviceName}. (Use an 'Edit Fields' node before this node to change them if required.)",
	"resourceMapper.mappingMode.label": "Mapping Column Mode",
	"resourceMapper.mappingMode.defineBelow.name": "Map Each Column Manually",
	"resourceMapper.mappingMode.defineBelow.description": "Set the value for each {fieldWord}",
	"resourceMapper.mappingMode.autoMapInputData.name": "Map Automatically",
	"resourceMapper.mappingMode.autoMapInputData.description": "Look for incoming data that matches the {fieldWord} in {serviceName}",
	"resourceMapper.fetchingFields.message": "Fetching {fieldWord}",
	"resourceMapper.fetchingFields.errorMessage": "Can't get {fieldWord}.",
	"resourceMapper.fetchingFields.noFieldsFound": "No {fieldWord} found in {serviceName}.",
	"resourceMapper.columnsToMatchOn.label": "{fieldWord} to match on",
	"resourceMapper.columnsToMatchOn.multi.description": "The {fieldWord} to use when matching rows in {nodeDisplayName} to the input items of this node. Usually an ID.",
	"resourceMapper.columnsToMatchOn.single.description": "The {fieldWord} to use when matching rows in {nodeDisplayName} to the input items of this node. Usually an ID.",
	"resourceMapper.columnsToMatchOn.tooltip": "The {fieldWord} to compare when finding the rows to update",
	"resourceMapper.columnsToMatchOn.noFieldsFound": "No {fieldWord} that can be used for matching found in {serviceName}.",
	"resourceMapper.valuesToSend.label": "Values to Send",
	"resourceMapper.valuesToUpdate.label": "Values to Update",
	"resourceMapper.usingToMatch": "(using to match)",
	"resourceMapper.usingToMatch.description": "This {fieldWord} won't be updated and can't be removed, as it's used for matching",
	"resourceMapper.removeField": "Remove {fieldWord}",
	"resourceMapper.mandatoryField.title": "This {fieldWord} is mandatory and can’t be removed",
	"resourceMapper.addFieldToSend": "Add {fieldWord} to send",
	"resourceMapper.matching.title": "This {fieldWord} is used for matching and can’t be removed",
	"resourceMapper.addAllFields": "Add All {fieldWord}",
	"resourceMapper.removeAllFields": "Remove All {fieldWord}",
	"resourceMapper.refreshFieldList": "Refresh {fieldWord} List",
	"resourceMapper.staleDataWarning.tooltip": "{fieldWord} are outdated. Refresh to see the changes.",
	"resourceMapper.staleDataWarning.notice": "Refresh to see the updated fields",
	"resourceMapper.attemptToConvertTypes.displayName": "Attempt To Convert Types",
	"resourceMapper.attemptToConvertTypes.description": "Attempt to convert types when mapping fields",
	"runData.pinData.insertedExecutionData": "💡 Inserted data from last successful execution. You can edit as needed.",
	"runData.openSubExecutionSingle": "View sub-execution",
	"runData.openSubExecutionWithId": "View sub-execution {id}",
	"runData.openParentExecution": "View parent execution {id}",
	"runData.emptyItemHint": "This is an item, but it's empty.",
	"runData.emptyArray": "[empty array]",
	"runData.emptyString": "empty",
	"runData.emptyObject": "{'{empty object}'}",
	"runData.unnamedField": "[Unnamed field]",
	"runData.switchToBinary.info": "This item only has",
	"runData.switchToBinary.binary": "binary data",
	"runData.linking.hint": "Link displayed input and output runs",
	"runData.unlinking.hint": "Unlink displayed input and output runs",
	"runData.binary": "Binary",
	"runData.copyItemPath": "Copy Item Path",
	"runData.copyItemPath.toast": "Item path copied",
	"runData.copyParameterPath": "Copy Parameter Path",
	"runData.copyParameterPath.toast": "Parameter path copied",
	"runData.copyValue": "Copy Selection",
	"runData.copyValue.toast": "Output data copied",
	"runData.copyToClipboard": "Copy to Clipboard",
	"runData.copyDisabled": "First click on the output data you want to copy, then click this button.",
	"runData.editOutput": "Edit Output",
	"runData.editOutputInvalid": "Problem with output data",
	"runData.editOutputInvalid.singleQuote": "Unexpected single quote. Please use double quotes (\") instead",
	"runData.editOutputInvalid.onLine": "On line {line}:",
	"runData.editOutputInvalid.atPosition": "(at position {position})",
	"runData.editValue": "Edit Value",
	"runData.executionStatus.success": "Executed successfully",
	"runData.executionStatus.failed": "Execution failed",
	"runData.executionStatus.canceled": "Execution canceled",
	"runData.downloadBinaryData": "Download",
	"runData.downloadBinaryData.error.title": "Error downloading file",
	"runData.downloadBinaryData.error.message": "File could not be downloaded",
	"runData.executeNode": "Test Node",
	"runData.executionTime": "Execution Time",
	"runData.fileExtension": "File Extension",
	"runData.directory": "Directory",
	"runData.url": "URL",
	"runData.fileName": "File Name",
	"runData.invalidPinnedData": "Invalid pinned data",
	"runData.items": "Items",
	"runData.json": "JSON",
	"runData.rendered": "Rendered",
	"runData.schema": "Schema",
	"runData.mimeType": "Mime Type",
	"runData.fileSize": "File Size",
	"runData.ms": "ms",
	"runData.noBinaryDataFound": "No binary data found",
	"runData.noData": "No data",
	"runData.noTextDataFound": "No text data found",
	"runData.nodeReturnedALargeAmountOfData": "Node returned a large amount of data",
	"runData.output": "Output",
	"runData.showBinaryData": "View",
	"runData.legacyBinaryMode": "Try the new \"v2\" Execution Logic mode by selecting the corresponding option in the workflow",
	"runData.startTime": "Start Time",
	"runData.table": "Table",
	"runData.table.viewSubExecution": "View sub-execution {id}",
	"runData.pindata.learnMore": "Learn more",
	"runData.pindata.thisDataIsPinned": "This data is pinned for test executions.",
	"runData.pindata.unpin": "Unpin",
	"runData.editor.save": "Save",
	"runData.editor.cancel": "Cancel",
	"runData.editor.copyDataInfo": "You can copy data from previous executions and paste it above.",
	"runData.aiContentBlock.startedAt": "Started at {startTime}",
	"runData.aiContentBlock.tokens": "{count} Tokens",
	"runData.aiContentBlock.tokens.prompt": "Prompt:",
	"runData.aiContentBlock.tokens.completion": "Completion:",
	"runData.trimmedData.loading": "Loading data",
	"runData.trimmedData.corrupted": "Pinned data on this node is corrupted and can't be displayed.",
	"runData.trimmedData.unpin": "Unpin data",
	"runData.panel.actions.collapse": "Collapse panel",
	"runData.panel.actions.open": "Open panel",
	"runData.panel.actions.popOut": "Pop out panel",
	"runData.panel.actions.sync": "Sync selection with canvas",
	"saveButton.save": "@:_reusableBaseText.save",
	"saveButton.saved": "Saved",
	"saveButton.saving": "Saving",
	"settings": "Settings",
	"settings.communityNodes": "Community nodes",
	"settings.communityNodes.empty.title": "Supercharge your workflows with community nodes",
	"settings.communityNodes.empty.verified.only.title": "Supercharge your workflows with verified community nodes",
	"settings.communityNodes.empty.description": "Install over {count} node packages contributed by our community.",
	"settings.communityNodes.empty.verified.only.description": "You can install community and partner built node packages that have been verified by n8n directly from the nodes panel. Installed packages will show up here.",
	"settings.communityNodes.empty.description.no-packages": "Install node packages contributed by our community.",
	"settings.communityNodes.empty.installPackageLabel": "Install a community node",
	"settings.communityNodes.npmUnavailable.warning": "To use this feature, please <a href=\"{npmUrl}\" target=\"_blank\" title=\"How to install npm\">install npm</a> and restart n8n.",
	"settings.communityNodes.packageNodes.label": "{count} node | {count} nodes",
	"settings.communityNodes.updateAvailable.tooltip": "A newer version is available",
	"settings.communityNodes.viewDocsAction.label": "Documentation",
	"settings.communityNodes.uninstallAction.label": "Uninstall package",
	"settings.communityNodes.upToDate.tooltip": "You are up to date",
	"settings.communityNodes.failedToLoad.tooltip": "There is a problem with this package, try uninstalling it then reinstalling to resolve this issue",
	"settings.communityNodes.managedByEnv": "Community packages are managed via environment variables and cannot be modified from the UI.",
	"settings.communityNodes.fetchError.title": "Problem fetching installed packages",
	"settings.communityNodes.fetchError.message": "There may be a problem with your internet connection or your n8n instance",
	"settings.communityNodes.installModal.title": "Install community nodes",
	"settings.communityNodes.installModal.description": "Find community nodes to add on the npm public registry.",
	"settings.communityNodes.browseButton.label": "Browse",
	"settings.communityNodes.installModal.packageName.label": "npm Package Name",
	"settings.communityNodes.installModal.packageName.tooltip": "<img src='/static/community_package_tooltip_img.png'/><p>This is the title of the package on <a href='{npmURL}'>npmjs.com</a></p><p>Install a specific version by adding it after {'@'}, e.g. <code>package-name{'@'}0.15.0</code></p>",
	"settings.communityNodes.installModal.packageName.placeholder": "e.g. n8n-nodes-chatwork",
	"settings.communityNodes.installModal.checkbox.label": "I understand the risks of installing unverified code from a public source.",
	"settings.communityNodes.installModal.installButton.label": "Install",
	"settings.communityNodes.installModal.installButton.label.loading": "Installing",
	"settings.communityNodes.installModal.error.packageNameNotValid": "Package name must start with n8n-nodes-",
	"settings.communityNodes.messages.install.success": "Package installed",
	"settings.communityNodes.messages.install.error": "Error installing new package",
	"settings.communityNodes.messages.uninstall.error": "Problem uninstalling package",
	"settings.communityNodes.messages.uninstall.success.title": "Package uninstalled",
	"settings.communityNodes.messages.update.success.title": "Package updated",
	"settings.communityNodes.messages.update.success.message": "{packageName} updated to version {version}",
	"settings.communityNodes.messages.update.error.title": "Problem updating package",
	"settings.communityNodes.confirmModal.uninstall.title": "Uninstall node package",
	"settings.communityNodes.confirmModal.uninstall.message": "Any workflows that use nodes from the {packageName} package won't be able to run. Are you sure?",
	"settings.communityNodes.confirmModal.uninstall.description": "Uninstalling the package will remove every instance of nodes included in this package. The following workflows will be effected:",
	"settings.communityNodes.confirmModal.noWorkflowsUsingNodes": "Nodes from this package are not used in any workflows",
	"settings.communityNodes.confirmModal.uninstall.buttonLabel": "Confirm uninstall",
	"settings.communityNodes.confirmModal.uninstall.buttonLoadingLabel": "Uninstalling",
	"settings.communityNodes.confirmModal.update.title": "Update node package",
	"settings.communityNodes.confirmModal.update.message": "You are about to update {packageName} to version {version}",
	"settings.communityNodes.confirmModal.includedNodes": "Package includes: {nodes}",
	"settings.communityNodes.confirmModal.update.warning": "This version has not been verified by n8n and may contain breaking changes or bugs.",
	"settings.communityNodes.confirmModal.update.description": "Updating to the latest version will update every instance of these nodes. The following workflows will be effected:",
	"settings.communityNodes.confirmModal.update.buttonLabel": "Confirm update",
	"settings.communityNodes.confirmModal.update.buttonLoadingLabel": "Updating...",
	"settings.communityNodes.confirmModal.cancel": "Cancel",
	"settings.opentelemetry": "OpenTelemetry",
	"settings.opentelemetry.title": "OpenTelemetry",
	"settings.opentelemetry.description": "Export workflow and node spans to any OTLP collector. Every setting mirrors an n8n environment variable.",
	"settings.opentelemetry.docsLink": "Learn more in the documentation",
	"settings.opentelemetry.envVarTooltip": "Environment variable: {envVar}",
	"settings.opentelemetry.envVarManagedTooltip": "Managed via environment variable",
	"settings.opentelemetry.enable.label": "Enable OpenTelemetry",
	"settings.opentelemetry.enable.description": "When disabled, no traces leave this instance.",
	"settings.opentelemetry.enable.option.enabled": "Enabled",
	"settings.opentelemetry.enable.option.disabled": "Disabled",
	"settings.opentelemetry.collectorConnection.title": "Collector connection",
	"settings.opentelemetry.exporterEndpoint.label": "OTLP endpoint",
	"settings.opentelemetry.exporterEndpoint.description": "The base URL of your OTLP collector (e.g. https://collector.example.com).",
	"settings.opentelemetry.exporterEndpoint.placeholder": "https://collector.example.com",
	"settings.opentelemetry.exporterServiceName.label": "Service name",
	"settings.opentelemetry.exporterServiceName.description": "How this instance appears in your collector.",
	"settings.opentelemetry.exporterServiceName.placeholder": "n8n-production",
	"settings.opentelemetry.exporterHeaders.label": "Custom headers",
	"settings.opentelemetry.exporterHeaders.description": "Sent with every OTLP export. Use for Bearer tokens or tenant IDs.",
	"settings.opentelemetry.exporterHeaders.keyLabel": "Key",
	"settings.opentelemetry.exporterHeaders.valueLabel": "Value",
	"settings.opentelemetry.exporterHeaders.remove": "Remove header",
	"settings.opentelemetry.exporterHeaders.keyPlaceholder": "Key",
	"settings.opentelemetry.exporterHeaders.valuePlaceholder": "Value",
	"settings.opentelemetry.exporterHeaders.addHeader": "Add header",
	"settings.opentelemetry.exporterTracingPath.label": "Trace path",
	"settings.opentelemetry.exporterTracingPath.description": "Appended to the endpoint. /v1/traces is the OTLP default.",
	"settings.opentelemetry.exporterTracingPath.placeholder": "/v1/traces",
	"settings.opentelemetry.startupConnectivityTimeoutMs.label": "Startup connectivity timeout",
	"settings.opentelemetry.startupConnectivityTimeoutMs.description": "Reachability check at startup. n8n boots regardless.",
	"settings.opentelemetry.startupConnectivityTimeoutMs.placeholder": "2000",
	"settings.opentelemetry.startupConnectivityTimeoutMs.slug": "ms",
	"settings.opentelemetry.testTrace.label": "Verify configuration",
	"settings.opentelemetry.testTrace.description": "Send a test span to check n8n can reach your collector.",
	"settings.opentelemetry.testTrace.send": "Send test trace",
	"settings.opentelemetry.testTrace.sending": "Sending…",
	"settings.opentelemetry.testTrace.sent": "Sent",
	"settings.opentelemetry.testTrace.success": "{spanName} span sent to collector at {time}",
	"settings.opentelemetry.testTrace.error": "Test send failed. The collector returned: {error}",
	"settings.opentelemetry.tracing.title": "Tracing",
	"settings.opentelemetry.tracesSampleRate.label": "Trace sample rate",
	"settings.opentelemetry.tracesSampleRate.description": "Fraction of traces exported. 1.00 = all traces.",
	"settings.opentelemetry.tracesSampleRate.placeholder": "1.00",
	"settings.opentelemetry.tracesSampleRate.slug": "of 1.00",
	"settings.opentelemetry.includeNodeSpans.label": "Include node spans",
	"settings.opentelemetry.includeNodeSpans.description": "One span per node, or workflow-level spans only.",
	"settings.opentelemetry.injectOutbound.label": "Inject outbound traceparent",
	"settings.opentelemetry.injectOutbound.description": "Add a W3C traceparent header to outbound HTTP so downstream services join the same trace.",
	"settings.opentelemetry.productionExecutionsOnly.label": "Track published workflows only",
	"settings.opentelemetry.productionExecutionsOnly.description": "Skip manual canvas runs. Less noise in production.",
	"settings.opentelemetry.save": "Save settings",
	"settings.opentelemetry.discard": "Discard changes",
	"settings.opentelemetry.savedSuccess": "Settings saved",
	"settings.opentelemetry.savedError": "Failed to save settings",
	"settings.opentelemetry.unsavedChanges.title": "Unsaved changes",
	"settings.opentelemetry.unsavedChanges.message": "You have unsaved changes to your collector and tracing settings. If you leave now, they'll be discarded.",
	"settings.opentelemetry.unsavedChanges.cancel": "Cancel",
	"settings.opentelemetry.unsavedChanges.leaveWithoutSaving": "Leave without saving",
	"settings.opentelemetry.unsavedChanges.saveAndLeave": "Save and leave",
	"settings.mcp": "Instance-level MCP",
	"settings.mcp.description": "Connect MCP clients like Claude Code and Cursor to build, run, and iterate on workflows in your instance",
	"settings.mcp.header.toggle.enabled": "Enabled",
	"settings.mcp.header.toggle.disabled": "Disabled",
	"settings.mcp.actionBox.heading": "Connect AI assistants to build and run workflows",
	"settings.mcp.actionBox.button.label": "Enable MCP access",
	"settings.mcp.emptyState.description": "Let MCP clients like Claude Code and Cursor build, run, and iterate on workflows in your instance.",
	"settings.mcp.tabs.workflows": "Workflows",
	"settings.mcp.tabs.oauth": "Connected clients",
	"settings.mcp.tabs.oauthSettings": "OAuth settings",
	"settings.mcp.instanceCapacity.warning": "MCP client registrations are at the instance limit ({count}/{limit}). New OAuth connections will be rejected until clients are revoked or N8N_MCP_MAX_REGISTERED_CLIENTS is raised.",
	"settings.mcp.access.token.notice": "Make sure to copy your access token, you won't be able to see it again",
	"settings.mcp.workflows.table.action.removeMCPAccess": "Remove access",
	"settings.mcp.workflows.table.action.updateDescription": "Edit description",
	"settings.mcp.workflows.table.column.name": "Name",
	"settings.mcp.workflows.table.column.location": "Location",
	"settings.mcp.workflows.table.column.description.emptyContent": "No description",
	"settings.mcp.workflows.table.column.description.emptyTooltip": "The description helps MCP clients understand when and how to use this workflow",
	"settings.mcp.workflows.table.column.description.editTooltip": "Click to edit",
	"settings.mcp.workflows.table.empty.title": "No workflows enabled",
	"settings.mcp.workflows.table.empty.description": "Add compatible workflows so MCP clients can discover and execute them",
	"settings.mcp.oauth.table.empty.title": "No OAuth clients connected",
	"settings.mcp.oauth.table.empty.description": "Clients that connect via OAuth will show up here",
	"settings.mcp.oauth.table.empty.button": "See connection instructions",
	"settings.mcp.toggle.disabled.tooltip": "Only instance admins can change this",
	"settings.mcp.toggle.error": "Error updating MCP access",
	"settings.mcp.managedByEnv.tooltip": "Managed via environment variables",
	"settings.mcp.instructions.rotateKey.tooltip": "Generate new token.<br/>This one will be automatically revoked",
	"settings.mcp.instructions.apiKey.tip": "Use this as an authorization token. May be named differently in different clients",
	"settings.mcp.error.fetching.apiKey": "Error fetching access token",
	"settings.mcp.error.rotating.apiKey": "Error generating new access token",
	"settings.mcp.error.fetching.oAuthClients": "Error fetching list of OAuth clients",
	"settings.mcp.oAuthClients.table.clientName": "Client",
	"settings.mcp.oAuthClients.table.connectedAt": "Connected on",
	"settings.mcp.oAuthClients.table.access": "Access",
	"settings.mcp.oAuthClients.table.action.revokeAccess": "Revoke access",
	"settings.mcp.oAuthClients.clientType.cli": "CLI",
	"settings.mcp.oAuthClients.clientType.ide": "IDE",
	"settings.mcp.oAuthClients.clientType.editor": "Editor",
	"settings.mcp.oAuthClients.clientType.assistant": "Assistant",
	"settings.mcp.oAuthClients.scope.workflow.read": "List workflows",
	"settings.mcp.oAuthClients.scope.workflow.write": "Create and update workflows",
	"settings.mcp.oAuthClients.scope.workflow.execute": "Run workflows",
	"settings.mcp.oAuthClients.scope.execution.read": "Get execution details",
	"settings.mcp.oAuthClients.scope.credential.read": "List credentials",
	"settings.mcp.oAuthClients.scope.dataTable.read": "List data tables",
	"settings.mcp.oAuthClients.scope.dataTable.write": "Create and update data tables",
	"settings.mcp.oAuthClients.scope.project.read": "Search projects and folders",
	"settings.mcp.oAuthClients.scope.tag.read": "List tags",
	"settings.mcp.oAuthClients.scope.more": "+{count}",
	"settings.mcp.oAuthClients.access.full": "Full access",
	"settings.mcp.oAuthClients.access.none": "No access",
	"settings.mcp.oAuthClients.details.subtitle": "Connected to this instance over MCP",
	"settings.mcp.oAuthClients.details.subtitleWithType": "{type} · Connected to this instance over MCP",
	"settings.mcp.oAuthClients.details.connectedOn": "Connected on",
	"settings.mcp.oAuthClients.details.access": "Access",
	"settings.mcp.oAuthClients.details.enablesTools": "Enables {count} tool | Enables {count} tools",
	"settings.mcp.oAuthClients.details.badge.read": "Read",
	"settings.mcp.oAuthClients.details.badge.write": "Write",
	"settings.mcp.oAuthClients.resource.workflow": "Workflow",
	"settings.mcp.oAuthClients.resource.execution": "Execution",
	"settings.mcp.oAuthClients.resource.credential": "Credential",
	"settings.mcp.oAuthClients.resource.dataTable": "Data table",
	"settings.mcp.oAuthClients.resource.project": "Project",
	"settings.mcp.oAuthClients.resource.tag": "Tag",
	"settings.mcp.oAuthClients.revoke.success.title": "Access revoked",
	"settings.mcp.oAuthClients.revoke.success.message": "Client {name} access has been revoked",
	"settings.mcp.oAuthClients.revoke.error": "Error revoking client access",
	"settings.mcp.oAuthClients.revoke.title": "Revoke access for \"{name}\"?",
	"settings.mcp.oAuthClients.revoke.description.own": "The client will lose access to this instance immediately and will need to reconnect. This can't be undone.",
	"settings.mcp.oAuthClients.revoke.description.other": "The client {ownerName} connected will lose access to this instance immediately and will need to reconnect. This can't be undone.",
	"settings.mcp.oAuthClients.revoke.button": "Revoke",
	"settings.mcp.oAuthClients.tabs.mine": "Mine",
	"settings.mcp.oAuthClients.tabs.all": "All",
	"settings.mcp.oAuthClients.search.placeholder": "Search clients",
	"settings.mcp.oAuthClients.search.noResults": "No clients match your search or filters",
	"settings.mcp.oAuthClients.filters.clientType": "Client type",
	"settings.mcp.oAuthClients.filters.clientType.all": "All types",
	"settings.mcp.oAuthClients.filters.clientType.ide": "IDE",
	"settings.mcp.oAuthClients.filters.clientType.cli": "CLI",
	"settings.mcp.oAuthClients.filters.clientType.web": "Web",
	"settings.mcp.oAuthClients.filters.connectedBy": "Connected by",
	"settings.mcp.oAuthClients.filters.connectedBy.all": "All users",
	"settings.mcp.oAuthClients.filters.connected": "Connected",
	"settings.mcp.oAuthClients.filters.connected.allTime": "All time",
	"settings.mcp.oAuthClients.filters.connected.lastXDays": "Last {count} days",
	"settings.mcp.oAuthClients.filters.connected.older": "Older",
	"settings.mcp.oAuthClients.table.connectedBy": "Connected by",
	"settings.mcp.oAuthClients.details.connectedBy": "Connected by",
	"settings.mcp.refresh.tooltip": "Refresh list",
	"settings.mcp.connectWorkflows": "Enable workflows",
	"settings.mcp.connectWorkflows.modalTitle": "Enable workflow MCP access",
	"settings.mcp.connectWorkflows.notice": "Workflows that are published and have one of webhook, form, schedule or chat trigger nodes can be enabled for MCP access. <a href='{docsLink}' target='_blank'>Read more</a>",
	"settings.mcp.connectWorkflows.input.placeholder": "Search workflows to connect",
	"settings.mcp.connectWorkflows.confirm.label": "Enable",
	"settings.mcp.connectWorkflows.error": "Error fetching available workflows",
	"settings.mcp.workflows.enableAccess.success.title": "MCP access enabled for {count} workflow | MCP access enabled for {count} workflows",
	"settings.mcp.workflows.removeAccess.success.title": "MCP access removed for {count} workflow | MCP access removed for {count} workflows",
	"settings.mcp.connectWorkflows.emptyState": "No available workflows",
	"settings.mcp.connectPopover.tab.oauth": "OAuth",
	"settings.mcp.connectPopover.tab.accessToken": "Access token",
	"settings.mcp.connectPopover.serverUrl": "Server URL",
	"settings.mcp.connectPopover.jsonConfig": "Configuration JSON",
	"settings.mcp.connectPopover.triggerLabel": "Connection details",
	"settings.mcp.allowedRedirectUris.label": "Allowed OAuth Redirect URLs",
	"settings.mcp.allowedRedirectUris.description": "Comma-separated list of allowed OAuth redirect URLs for MCP clients. When configured, only clients with these redirect URLs can complete the OAuth flow. Leave empty to allow all redirect URLs (not recommended for production). This is a security feature to prevent authorization code interception attacks. For local clients (e.g. desktop or CLI apps) the callback is usually http://localhost/callback; the port is ignored, so you don't need to match it.",
	"settings.mcp.allowedRedirectUris.placeholder": "http://localhost/callback, https://your-mcp-client.example.com/callback",
	"settings.mcp.allowedRedirectUris.save": "Save Redirect URLs",
	"settings.mcp.allowedRedirectUris.success": "Redirect URLs updated successfully",
	"settings.mcp.allowedRedirectUris.error.loading": "Error loading redirect URLs",
	"settings.mcp.allowedRedirectUris.error.saving": "Error saving redirect URLs",
	"settings.mcp.allowedRedirectUris.validation.invalidUrl": "Invalid URL: {url}",
	"settings.mcp.allowedRedirectUris.validation.invalidProtocol": "Invalid protocol for URL: {url}. Only http and https are allowed.",
	"settings.mcp.allowedRedirectUris.validation.httpsRequired": "HTTPS required in production: {url}",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.title": "Build from your assistant",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.description": "Connect MCP clients like Claude Code and Cursor to build, run, and iterate on workflows in your instance",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.client.claude": "Claude",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.client.claudeCode": "Claude Code",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.client.cursor": "Cursor",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.client.codex": "Codex",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.client.chatgpt": "ChatGPT",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.eyebrow": "New · Model Context Protocol",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.title": "Try MCP with Claude Code, Cursor, or Codex",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.description": "Connect MCP clients like Claude Code and Cursor to build, run, and iterate on workflows in your instance.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.settingsHint": "Set it up now, or later in {settingsLink}.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.settingsLink": "Settings > Instance-level MCP",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.tryIt": "Try MCP",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.intro.skip": "Skip for now",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.prompt.claude": "Show me the n8n MCP connector and walk me through enabling it if it isn't already on. I'll paste my server URL when you tell me where it goes.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.prompt.claudeCode": "Set up the n8n MCP server for Claude Code so it's available across all projects.\n\n1. Register the server at user scope by running:\n\n   claude mcp add --scope user --transport http n8n \"{serverUrl}\"\n\n2. Once it's registered, remind me to restart Claude Code — I'll complete the n8n OAuth flow when prompted in the new session, so don't try to list or call its tools yet.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.prompt.cursor": "Set up the n8n MCP server for Cursor across all projects.\n\n1. Open ~/.cursor/mcp.json (create the file and directory if they don't exist). Add the entry below, merging with any existing config so other servers stay intact:\n\n   {'{'}\n     \"mcpServers\": {'{'}\n       \"n8n\": {'{'}\n         \"url\": \"{serverUrl}\"\n       {'}'}\n     {'}'}\n   {'}'}\n\n2. Once it's saved, remind me to restart Cursor and complete the n8n OAuth flow when it prompts me — the server's tools won't be available until then.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.prompt.codex": "Set up the n8n MCP server for Codex across all projects.\n\n1. Open ~/.codex/config.toml (create the file and directory if they don't exist). Append the section below, leaving any existing config in place:\n\n   [mcp_servers.n8n]\n   url = \"{serverUrl}\"\n\n2. Once it's saved, remind me to restart Codex and complete the n8n OAuth flow in my browser when it prompts me — the server's tools won't be available until then.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.client.title": "Choose your assistant",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.access.title": "Enable MCP for my instance",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.prompt.title": "Paste the prompt in {assistant}",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.serverUrl.title": "Paste Server URL",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.restart.title": "Restart {assistant} and connect to n8n",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptDeveloperMode.title": "Enable developer mode in ChatGPT",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptDeveloperMode.description": "In ChatGPT, go to Settings > Apps & Connectors > Advanced settings. Turn on developer mode.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptCustomApp.title": "Create a custom app",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptCustomApp.appName.label": "App name",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptCustomApp.appName.value": "n8n",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.section.chatgptCustomApp.serverUrl.label": "Server URL",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.footer": "You can disable this later from {settingsLink}. Read more about this feature {docsLink}.",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.footer.docsLink": "here",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.copy.tooltip": "Copy setup prompt",
	"experiments.surfaceMcpToNewCloudUsers.onboarding.copy.copied": "Copied",
	"experiments.surfaceMcpToNewCloudUsers.emptyState.tile.variant1.cta": "Build from your assistant",
	"experiments.surfaceMcpToNewCloudUsers.emptyState.tile.variant2.cta": "Connect to your AI",
	"experiments.surfaceMcpToNewCloudUsers.emptyState.tile.badge.new": "New",
	"experiments.surfaceMcpToNewCloudUsers.emptyState.tile.badge.enabled": "Enabled",
	"experiments.surfaceMcpToNewCloudUsers.emptyState.reminder": "You can enable this later in Settings > MCP.",
	"experiments.exposeAllWorkflowsToMcp.modal.title": "Expose all workflows to MCP?",
	"experiments.exposeAllWorkflowsToMcp.modal.description": "This lets connected clients reach every workflow on this instance right away. You can remove MCP access for individual workflows at any time.",
	"experiments.exposeAllWorkflowsToMcp.modal.notNow": "Not now",
	"experiments.exposeAllWorkflowsToMcp.modal.confirm": "Expose all workflows",
	"experiments.exposeAllWorkflowsToMcp.modal.success.title": "Workflows exposed to MCP",
	"experiments.exposeAllWorkflowsToMcp.modal.success.message": "{count} workflow is now available to connected clients | {count} workflows are now available to connected clients",
	"experiments.exposeAllWorkflowsToMcp.modal.error.title": "Error exposing workflows to MCP",
	"settings.chatHub": "Chat",
	"settings.chatHub.enabled.label": "Enable Chat",
	"settings.chatHub.enabled.description": "When disabled, Chat is hidden across the app and its API endpoints are turned off. You can re-enable it here at any time.",
	"settings.chatHub.enabled.disabled.tooltip": "Only instance admins and owners can enable or disable Chat.",
	"settings.chatHub.toggled.success": "Chat settings updated",
	"settings.chatHub.toggled.error": "Error updating Chat settings",
	"settings.chatHub.disabled.notice": "Chat is currently disabled. Enable it above to configure providers.",
	"settings.chatHub.providers.fetching.error": "Error fetching chat provider settings",
	"settings.chatHub.providers.updated.success": "Chat provider settings updated",
	"settings.chatHub.providers.updated.error": "Error updating chat provider settings",
	"settings.chatHub.providers.table.provider": "Provider",
	"settings.chatHub.providers.table.models": "Models",
	"settings.chatHub.providers.table.createdAt": "Created",
	"settings.chatHub.providers.table.updatedAt": "Last edited",
	"settings.chatHub.providers.table.action.editProvider": "Edit provider",
	"settings.chatHub.providers.table.action.editProvider.disabled": "Only instance admins and owners can edit chat providers.",
	"settings.chatHub.providers.table.title": "Providers",
	"settings.chatHub.providers.table.refresh.tooltip": "Refresh list",
	"settings.chatHub.providers.table.addProvider.button": "Add provider",
	"settings.chatHub.providers.table.empty.title": "No chat providers configured",
	"settings.chatHub.providers.table.empty.description": "Configure chat providers to restrict available models and credentials.",
	"settings.chatHub.providers.modal.edit.title": "Configure {provider}",
	"settings.chatHub.providers.modal.edit.cancel": "Cancel",
	"settings.chatHub.providers.modal.edit.confirm": "Confirm",
	"settings.chatHub.providers.modal.edit.enabled.label": "Enable {provider}",
	"settings.chatHub.providers.modal.edit.enabled.tooltip": "When disabled, models from this provider won't be available for use in Chat.",
	"settings.chatHub.providers.modal.edit.credential.label": "Default credential",
	"settings.chatHub.providers.modal.edit.credential.clearButton": "Clear selection",
	"settings.chatHub.providers.modal.edit.limitModels.label": "Limit models",
	"settings.chatHub.providers.modal.edit.limitModels.tooltip": "When enabled only selected models will be available for use in Chat.",
	"settings.chatHub.providers.modal.edit.allowedModels.label": "Models",
	"settings.chatHub.providers.modal.edit.errorFetchingModels": "Error fetching chat models",
	"settings.chatHub.providers.modal.edit.models.placeholder": "Select a model",
	"settings.chatHub.providers.modal.edit.models.create": "Add model \"{filter}\"",
	"settings.chatHub.providers.modal.edit.responsesApi.label": "Use Responses API",
	"settings.chatHub.providers.modal.edit.responsesApi.description": "Disable this if your OpenAI credential uses a custom base URL that doesn't support the Responses API (e.g. Gemini via OpenAI compatibility layer)",
	"settings.chatHub.providers.modal.edit.contextWindowLength.label": "Context window (messages)",
	"settings.chatHub.providers.modal.edit.contextWindowLength.description": "Number of previous interactions (message and reply pairs) to include as context for the model (default: 20)",
	"settings.chatHub.providers.table.models.disabled": "Disabled",
	"settings.chatHub.providers.table.models.allModels": "All models",
	"settings.chatHub.providers.table.models.noModels": "No models",
	"settings.chatHub.providers.table.models.more": " and {count} more",
	"settings.chatHub.semanticSearch.title": "Semantic Search",
	"settings.chatHub.semanticSearch.save.success": "Semantic search settings updated",
	"settings.chatHub.vectorStore.title": "Vector Store",
	"settings.chatHub.vectorStore.description": "Database used to store and retrieve document embeddings for agent knowledge.",
	"settings.chatHub.vectorStore.notShared": "Share the credential globally to ensure all users can use file knowledge in their personal agents.",
	"settings.chatHub.vectorStore.missing": "Vector store credential is not set up yet. Select a provider and credential to enable file knowledge for personal agents.",
	"settings.chatHub.vectorStore.save.error": "Error saving vector store credential",
	"settings.chatHub.vectorStore.changeProvider.confirm.title": "Change Vector Store Provider",
	"settings.chatHub.vectorStore.changeProvider.confirm.message": "Changing the vector store provider will make existing indexed documents unsearchable. Users will need to re-upload files to agents that use file knowledge.",
	"settings.chatHub.vectorStore.changeProvider.confirm.button": "Change Provider",
	"settings.chatHub.embeddingModel.title": "Embedding Model",
	"settings.chatHub.embeddingModel.description": "AI model used to convert documents and queries into vector embeddings.",
	"settings.chatHub.embeddingModel.save.error": "Error saving embedding model credential",
	"settings.chatHub.embeddingModel.changeProvider.confirm.title": "Change Embedding Provider",
	"settings.chatHub.embeddingModel.changeProvider.confirm.message": "Changing the embedding provider will make existing indexed documents unsearchable. Users will need to re-upload files to agents that use file knowledge.",
	"settings.chatHub.embeddingModel.changeProvider.confirm.button": "Change Provider",
	"settings.chatHub.embeddingModel.missing": "Embedding model credential is not set up yet. Select a provider and credential to enable file knowledge for personal agents.",
	"settings.chatHub.embeddingModel.notShared": "Share the credential globally to ensure all users can use file knowledge in their personal agents.",
	"settings.chatHub.label.provider": "Provider",
	"settings.chatHub.label.credential": "Credential",
	"settings.goBack": "Go back",
	"settings.personal": "Personal",
	"settings.personal.basicInformation": "Basic Information",
	"settings.personal.managedByEnv": "Your account credentials are managed via environment variables and cannot be changed here.",
	"settings.personal.personalSettings": "Personal Settings",
	"settings.personal.personalSettingsUpdated": "Personal details updated",
	"settings.personal.personalSettingsUpdatedError": "Problem updating your details",
	"settings.personal.role.tooltip.default": "Default role for new users",
	"settings.personal.role.tooltip.member": "Create and manage own workflows and credentials",
	"settings.personal.role.tooltip.chatUser": "Access to Chat feature only",
	"settings.personal.role.tooltip.admin": "Full access to manage workflows,tags, credentials, projects, users and more",
	"settings.personal.role.tooltip.owner": "Manage everything{cloudAccess}",
	"settings.personal.role.tooltip.cloud": " and access Cloud dashboard",
	"settings.personal.save": "Save",
	"settings.personal.security": "Security",
	"settings.signup.signUpInviterInfo": "{firstName} {lastName} has invited you to n8n",
	"settings.users": "Users",
	"settings.users.count": "{count} user | {count} users",
	"settings.users.search.placeholder": "Search by name or email",
	"settings.users.confirmDataHandlingAfterDeletion": "What should we do with their data?",
	"settings.users.confirmUserDeletion": "Are you sure you want to delete this invited user?",
	"settings.users.delete": "Delete",
	"settings.users.deleteConfirmationMessage": "Type \"delete all data\" to confirm",
	"settings.users.deleteConfirmationText": "delete all data",
	"settings.users.deleteUser": "Delete {user}",
	"settings.users.actions.delete": "Delete User",
	"settings.users.actions.reinvite": "Resend Invite",
	"settings.users.actions.copyInviteLink": "Copy Invite Link",
	"settings.users.actions.generateInviteLink": "Generate Invite Link",
	"settings.users.actions.copyPasswordResetLink": "Copy Password Reset Link",
	"settings.users.actions.allowSSOManualLogin": "Allow Manual Login",
	"settings.users.actions.disallowSSOManualLogin": "Disallow Manual Login",
	"settings.users.deleteWorkflowsAndCredentials": "Delete their workflows, credentials and data tables",
	"settings.users.emailInvitesSent": "An invite email was sent to {emails}",
	"settings.users.emailInvitesSentError": "Could not invite {emails}",
	"settings.users.emailSentTo": "Email sent to {email}",
	"settings.users.invalidEmailError": "{email} is not a valid email",
	"settings.users.inviteLink.copy": "Copy Invite Link",
	"settings.users.inviteLink.error": "Could not retrieve invite link",
	"settings.users.invite": "Invite",
	"settings.users.invite.tooltip": "SAML login is activated. Users should be created in the IdP and will be provisioned in n8n on their first sign on.",
	"settings.users.inviteNewUsers": "Invite new users",
	"settings.users.copyInviteUrls": "You can now send the invitation links directly to your users",
	"settings.users.inviteResent": "Invite resent",
	"settings.users.inviteUser": "Invite user",
	"settings.users.inviteUser.inviteUrl": "Create invite link",
	"settings.users.inviteXUser": "Invite {count} users",
	"settings.users.inviteXUser.inviteUrl": "Create {count} invite links",
	"settings.users.inviteUrlCreated": "Invite link copied to clipboard",
	"settings.users.inviteUrlCreated.message": "Send the invite link to your invitee for activation",
	"settings.users.inviteLinkError": "Could not generate invite link",
	"settings.users.passwordResetUrlCreated": "Password reset link copied to clipboard",
	"settings.users.passwordResetUrlCreated.message": "Send the reset link to your user for them to reset their password",
	"settings.users.passwordResetLinkError": "Could not retrieve password reset link",
	"settings.users.allowSSOManualLogin": "Manual Login Allowed",
	"settings.users.allowSSOManualLogin.message": "User can now login manually and through SSO",
	"settings.users.disallowSSOManualLogin": "Manual Login Disallowed",
	"settings.users.disallowSSOManualLogin.message": "User must now login through SSO only",
	"settings.users.multipleInviteUrlsCreated": "Invite links created",
	"settings.users.multipleInviteUrlsCreated.message": "Send the invite links to your invitees for activation",
	"settings.users.newEmailsToInvite": "New User Email Addresses",
	"settings.users.noUsersToInvite": "No users to invite",
	"settings.users.setupMyAccount": "Set up my owner account",
	"settings.users.setupToInviteUsers": "To invite users, set up your own account",
	"settings.users.setupToInviteUsersInfo": "Invited users won’t be able to see workflows and credentials of other users unless you upgrade. <a href=\"https://docs.n8n.io/user-management/\" target=\"_blank\">More info</a> <br /> <br />",
	"settings.users.smtpToAddUsersWarning": "Set up SMTP before adding users (so that n8n can send them invitation emails). <a target=\"_blank\" href=\"https://docs.n8n.io/hosting/authentication/user-management-self-hosted/\">Instructions</a>",
	"settings.users.transferWorkflowsAndCredentials": "Transfer their workflows, credentials and data tables to another user or project",
	"settings.users.transferWorkflowsAndCredentials.user": "User or project to transfer to",
	"settings.users.transferWorkflowsAndCredentials.placeholder": "Select project or user",
	"settings.users.transferredToUser": "Data transferred to {projectName}",
	"settings.users.userNotFound": "User not found",
	"settings.users.userDeleted": "User deleted",
	"settings.users.userDeletedError": "Problem while deleting user",
	"settings.users.userInvited": "User invited",
	"settings.users.userInvitedError": "User could not be invited",
	"settings.users.userReinviteError": "Could not reinvite user",
	"settings.users.userToTransferTo": "User to transfer to",
	"settings.users.usersEmailedError": "Couldn't send invite email",
	"settings.users.usersInvited": "Users invited",
	"settings.users.usersInvitedError": "Could not invite users",
	"settings.users.advancedPermissions.warning": "{link} to unlock the ability to create additional admin users",
	"settings.users.userRoleUpdated": "Changes saved",
	"settings.users.userRoleUpdated.message": "{user} has been successfully updated to a {role}",
	"settings.users.userRoleUpdatedError": "Unable to update role",
	"settings.users.userRoleUpdated.confirm.message": "Are you sure you want to change user to a {role}? This will revoke their current project roles.",
	"settings.users.userRoleUpdated.confirm.title": "Update role for {user}?",
	"settings.users.userRoleUpdated.confirm.button": "Yes, update and revoke",
	"settings.users.userRoleUpdated.cancel.button": "Cancel",
	"settings.users.table.update.error": "Failed to update table",
	"settings.users.table.header.user": "@:_reusableBaseText.user",
	"settings.users.table.header.accountType": "Instance role",
	"settings.users.table.header.2fa": "2FA",
	"settings.users.table.header.lastActive": "Last Active",
	"settings.users.table.row.allProjects": "All projects",
	"settings.users.table.row.personalProject": "Personal project",
	"settings.users.table.row.deleteUser": "Remove user",
	"settings.users.table.row.role.description.admin": "Full access to all workflows, credentials, projects, users and more",
	"settings.users.table.row.role.description.member": "Manage and create own workflows and credentials",
	"settings.users.table.row.role.description.chatUser": "Can use Chat but cannot create or view workflows or access other features",
	"settings.users.table.row.2fa.enabled": "@:_reusableBaseText.enabled",
	"settings.users.table.row.2fa.disabled": "@:_reusableBaseText.disabled",
	"settings.roles": "Roles",
	"settings.api": "API",
	"settings.n8napi": "n8n API",
	"settings.log-streaming": "Log Streaming",
	"settings.log-streaming.heading": "Log Streaming",
	"settings.log-streaming.add": "Add new destination",
	"settings.log-streaming.actionBox.title": "Available on the Enterprise plan",
	"settings.log-streaming.actionBox.description": "Log Streaming is available as a paid feature. Learn more about it.",
	"settings.log-streaming.actionBox.button": "See plans",
	"settings.log-streaming.infoText": "Send logs to external endpoints of your choice. You can also write logs to a file or the console using environment variables. <a href=\"https://docs.n8n.io/log-streaming/\" target=\"_blank\">More info</a>",
	"settings.log-streaming.managedByEnv": "Log streaming destinations are managed via environment variables and cannot be modified from the UI.",
	"settings.log-streaming.addFirstTitle": "Set up a destination to get started",
	"settings.log-streaming.addFirst": "Add your first destination by clicking on the button and selecting a destination type.",
	"settings.log-streaming.saving": "Saving",
	"settings.log-streaming.delete": "Delete",
	"settings.log-streaming.continue": "Continue",
	"settings.log-streaming.selecttype": "Select type to create",
	"settings.log-streaming.selecttypehint": "Select the type for the new log stream destination",
	"settings.log-streaming.tab.settings": "Settings",
	"settings.log-streaming.tab.events": "Events",
	"settings.log-streaming.tab.events.title": "Select groups or single events to subscribe to:",
	"settings.log-streaming.tab.events.anonymize": "Anonymize sensitive data",
	"settings.log-streaming.tab.events.anonymize.info": "Fields containing personal information like name or email are anonymized",
	"settings.log-streaming.eventGroup.n8n.ai": "AI node logs",
	"settings.log-streaming.eventGroup.n8n.audit": "Audit Events",
	"settings.log-streaming.eventGroup.n8n.audit.info": "Will send events when user details or other audit data changes",
	"settings.log-streaming.eventGroup.n8n.workflow": "Workflow Events",
	"settings.log-streaming.eventGroup.n8n.workflow.info": "Will send workflow execution events",
	"settings.log-streaming.eventGroup.n8n.user": "User",
	"settings.log-streaming.eventGroup.n8n.node": "Node Executions",
	"settings.log-streaming.eventGroup.n8n.node.info": "Will send step-wise execution events every time a node executes. Please note that this can lead to a high frequency of logged events and is probably not suitable for general use.",
	"settings.log-streaming.eventGroup.n8n.runner": "Runner tasks",
	"settings.log-streaming.eventGroup.n8n.runner.info": "Will send an event when a Code node execution is requested from a task runner, and when a response is received from the runner with the result.",
	"settings.log-streaming.eventGroup.n8n.queue": "Queue events",
	"settings.log-streaming.eventGroup.n8n.queue.info": "Will send an event when a queue-related event occurs, e.g. enqueuing, dequeueing, completion, failure, or stalling.",
	"settings.log-streaming.eventGroup.n8n.worker": "Worker",
	"settings.log-streaming.$$AbstractMessageEventBusDestination": "Generic",
	"settings.log-streaming.$$MessageEventBusDestinationWebhook": "Webhook",
	"settings.log-streaming.$$MessageEventBusDestinationSentry": "Sentry",
	"settings.log-streaming.$$MessageEventBusDestinationRedis": "Redis",
	"settings.log-streaming.$$MessageEventBusDestinationSyslog": "Syslog",
	"settings.log-streaming.destinationDelete.cancelButtonText": "",
	"settings.log-streaming.destinationDelete.confirmButtonText": "Yes, delete",
	"settings.log-streaming.destinationDelete.headline": "Delete Destination?",
	"settings.log-streaming.destinationDelete.message": "Are you sure that you want to delete '{destinationName}'?",
	"settings.log-streaming.addDestination": "Add new destination",
	"settings.log-streaming.destinations": "Log destinations",
	"settings.api.trial.upgradePlan.title": "Upgrade to use API",
	"settings.api.trial.upgradePlan.description": "To prevent abuse, we limit API access to your workspace during your trial. If this is hindering your evaluation of n8n, please contact <a href=\"mailto:support{'@'}n8n.io\">support{'@'}n8n.io</a>",
	"settings.api.trial.upgradePlan.cta": "Upgrade plan",
	"settings.api.create.description": "Control n8n programmatically using the <a href=\"https://docs.n8n.io/api\" target=\"_blank\">n8n API</a>",
	"settings.api.create.button": "Create API key",
	"settings.api.create.button.loading": "Creating API key...",
	"settings.api.search.placeholder": "Search",
	"settings.api.search.noResults": "No API keys match your search.",
	"settings.api.owners.all": "All owners",
	"settings.api.owners.selected": "{count} owner | {count} owners",
	"settings.api.owners.search": "Search owners",
	"settings.api.owners.noResults": "No matching users",
	"settings.api.owners.you": "(you)",
	"settings.api.owners.clear": "Clear",
	"settings.api.owners.summary.all": "Showing all {count} key | Showing all {count} keys",
	"settings.api.owners.summary.filtered": "Showing {count} key | Showing {count} keys",
	"settings.api.create.error": "API Key creation failed.",
	"settings.api.edit.error": "API Key update failed.",
	"settings.api.delete.title": "Delete this API Key?",
	"settings.api.delete.description": "Any application using this API Key will no longer have access to n8n. This operation cannot be undone.",
	"settings.api.delete.button": "Delete Forever",
	"settings.api.delete.error": "Deleting the API Key failed.",
	"settings.api.delete.toast": "API Key deleted",
	"settings.api.create.toast": "API Key created",
	"settings.api.update.toast": "API Key updated",
	"settings.api.creationTime": "API key was created on {time}",
	"settings.api.expirationTime": "Expires on {time}",
	"settings.api.expired": "This API key has expired",
	"settings.api.neverExpires": "Never expires",
	"settings.api.view.copy.toast": "API Key copied to clipboard",
	"settings.api.view.info": "Use your API key to control n8n programmatically. Try it in the {apiPlayground}, or use the {webhook} if you only need to trigger workflows. You can learn more in the {documentation}.",
	"settings.api.view.info.apiPlayground": "API playground",
	"settings.api.view.info.webhook": "Webhook node",
	"settings.api.view.info.documentation": "documentation",
	"settings.api.view.copy": "Make sure to copy your API key now as you will not be able to see this again.",
	"settings.api.view.error": "Could not check if an api key already exists.",
	"settings.api.view.modal.form.label": "Label",
	"settings.api.view.modal.form.expiration": "Expiration",
	"settings.api.view.modal.form.expirationText": "The API key will expire on {expirationDate}",
	"settings.api.view.modal.form.label.placeholder": "e.g Internal Project",
	"settings.api.view.modal.form.expiration.custom": "Custom",
	"settings.api.view.modal.form.expiration.days": "{numberOfDays} days",
	"settings.api.view.modal.form.expiration.none": "Never",
	"settings.api.view.modal.title.created": "API key created successfully",
	"settings.api.view.modal.title.create": "Create API Key",
	"settings.api.view.modal.title.edit": "Edit API Key",
	"settings.api.view.modal.title.readonly": "API Key owned by {email}",
	"settings.api.view.modal.done.button": "Done",
	"settings.api.view.modal.save.button": "Save",
	"settings.api.view.modal.close.button": "Close",
	"settings.api.scopes.label": "Scopes",
	"settings.api.scopes.all": "All",
	"settings.api.scopes.readOnly": "Read only",
	"settings.api.scopes.custom": "Custom",
	"settings.api.scopes.search.placeholder": "Search",
	"settings.api.scopes.toggleGroup": "Toggle {group} scopes",
	"settings.api.scopes.count": "{selected} of {total} scopes selected",
	"settings.api.scopes.badge.read": "read",
	"settings.api.scopes.badge.write": "write",
	"settings.api.scopes.group.workflowsAndExecutions": "Workflow and executions",
	"settings.api.scopes.group.credentialsAndVariables": "Credentials and variables",
	"settings.api.scopes.group.dataTables": "Data tables",
	"settings.api.scopes.group.projects": "Projects",
	"settings.api.scopes.group.foldersTags": "Folders, tags",
	"settings.api.scopes.group.members": "Members",
	"settings.api.scopes.group.instanceOperations": "Instance operations",
	"settings.api.scopes.modal.title": "{label} scopes",
	"settings.api.scopes.modal.empty": "This API key has no scopes.",
	"settings.api.columns.name": "Name",
	"settings.api.columns.owner": "Owner",
	"settings.api.columns.scopes": "Scopes",
	"settings.api.columns.expiration": "Expiration",
	"settings.api.columns.lastUsed": "Last used",
	"settings.api.columns.actions": "Actions",
	"settings.api.actions.edit": "Edit",
	"settings.api.actions.view": "View",
	"settings.api.actions.revoke": "Revoke",
	"settings.api.actions.rotate": "Rotate",
	"settings.api.expiration.never": "Never",
	"settings.api.lastUsed.never": "Never",
	"settings.api.revoke.title": "Revoke \"{label}\" API key?",
	"settings.api.revoke.description.own": "Workflows, scripts, and integrations using this key will stop working immediately. This can't be undone.",
	"settings.api.revoke.description.other": "Any integrations or scripts {ownerName} has set up will stop working immediately. This can't be undone.",
	"settings.api.revoke.button": "Revoke",
	"settings.api.revoke.toast": "API key revoked",
	"settings.api.rotate.title": "Rotate \"{label}\" API key?",
	"settings.api.rotate.description": "Rotating revokes this key and issues a new one with the same name and scopes. Workflows, scripts, and integrations using this key will stop working until you update them with the new key. This can't be undone.",
	"settings.api.rotate.button": "Rotate",
	"settings.api.rotate.toast": "API key rotated",
	"settings.api.rotate.error": "Rotating the API key failed.",
	"settings.api.rotate.success.title": "API key rotated successfully",
	"settings.api.empty.title": "No API keys yet",
	"settings.api.empty.mine": "You don't have any API keys yet. Switch to All to see other users' keys, or create your own.",
	"settings.api.tabs.mine": "Mine",
	"settings.api.tabs.all": "All",
	"settings.version": "Version",
	"settings.usageAndPlan.title": "Usage and plan",
	"settings.usageAndPlan.description": "You’re on the {name} {type}",
	"settings.usageAndPlan.plan": "Plan",
	"settings.usageAndPlan.callOut": "{link} selected paid features for free (forever)",
	"settings.usageAndPlan.callOut.link": "Unlock",
	"settings.usageAndPlan.edition": "Edition",
	"settings.usageAndPlan.error": "@:_reusableBaseText.error",
	"settings.usageAndPlan.activeWorkflows": "Published workflows",
	"settings.usageAndPlan.activeWorkflows.unlimited": "@:_reusableBaseText.unlimited",
	"settings.usageAndPlan.activeWorkflows.count": "{count} of {limit}",
	"settings.usageAndPlan.activeWorkflows.hint": "Published workflows with multiple triggers count multiple times. Error and Sub-workflow triggers are excluded.",
	"settings.usageAndPlan.button.activation": "Enter activation key",
	"settings.usageAndPlan.button.plans": "View plans",
	"settings.usageAndPlan.button.manage": "Manage plan",
	"settings.usageAndPlan.dialog.activation.title": "Enter activation key",
	"settings.usageAndPlan.dialog.activation.label": "Activation key",
	"settings.usageAndPlan.dialog.activation.activate": "@:_reusableBaseText.activate",
	"settings.usageAndPlan.dialog.activation.cancel": "@:_reusableBaseText.cancel",
	"settings.usageAndPlan.license.activation.error.title": "Activation failed",
	"settings.usageAndPlan.license.activation.success.title": "License activated",
	"settings.usageAndPlan.license.activation.success.message": "Your {name} {type} has been successfully activated.",
	"settings.usageAndPlan.license.activation.success.message.eula": "You have accepted the EULA and successfully activated your {name} plan.",
	"settings.usageAndPlan.dialog.eula.title": "Confirmation needed",
	"settings.usageAndPlan.dialog.eula.description": "To activate your license, you must review and accept our End User License Agreement (EULA). Please confirm that you have read and agree to the terms in order to continue.",
	"settings.usageAndPlan.dialog.eula.audit.notice": "Your acceptance will be recorded for audit purposes.",
	"settings.usageAndPlan.dialog.eula.checkbox.label": "I have read and accept the",
	"settings.usageAndPlan.dialog.eula.link.text": "EULA",
	"settings.usageAndPlan.dialog.eula.button.accept": "Accept & activate",
	"settings.usageAndPlan.dialog.eula.button.cancel": "@:_reusableBaseText.cancel",
	"settings.usageAndPlan.license.communityRegistered.tooltip": "You have registered your email to unlock additional features on your community plan",
	"settings.provisioning.title": "Provisioning",
	"settings.provisioning.description": "Configure user provisioning settings and manage automated user lifecycle management.",
	"settings.provisioning.loadError": "Failed to load provisioning configuration",
	"settings.provisioning.saveError": "Failed to save provisioning configuration",
	"settings.provisioning.saveSuccess": "Configuration Saved",
	"settings.provisioning.saveSuccessMessage": "Provisioning configuration has been successfully updated.",
	"settings.provisioning.save": "Save Configuration",
	"settings.provisioning.scopesName": "Scopes Name",
	"settings.provisioning.scopesName.placeholder": "Enter scope name",
	"settings.provisioning.scopesName.help": "The name of the scope for provisioning, this is the scope that will be requested during Oauth flows",
	"settings.provisioning.scopesInstanceRoleClaimName": "Instance Role Claim Name",
	"settings.provisioning.scopesInstanceRoleClaimName.placeholder": "Enter instance role claim name",
	"settings.provisioning.scopesInstanceRoleClaimName.help": "The claim name used to provision instance roles from Oauth. For SAML / LDAP, this will be the attribute name checked.",
	"settings.provisioning.scopesProjectsRolesClaimName": "Projects Roles Claim Name",
	"settings.provisioning.scopesProjectsRolesClaimName.placeholder": "Enter projects roles claim name",
	"settings.provisioning.scopesProjectsRolesClaimName.help": "The claim name used to provision projects and their roles from Oauth. For SAML / LDAP, this will be the attribute name checked.",
	"settings.provisioning.toggle": "Provision instance and project roles",
	"settings.provisioning.toggle.help": "Project access can only be defined on external provider. Any existing project access configured in n8n, but not on the provider, will be removed once a user logs in.",
	"settings.provisioningConfirmDialog.enable.title": "Change role assignment method",
	"settings.provisioningConfirmDialog.enable.description": "You're changing how roles are assigned for SSO users. Download your current role and access mappings as a backup before saving to ensure your SSO provider is configured correctly.",
	"settings.provisioningConfirmDialog.enable.checkbox": "I have downloaded and reviewed the CSV export. My SSO provider is correctly configured for the new assignment method.",
	"settings.provisioningConfirmDialog.disable.title": "Manage user role provisioning in n8n only",
	"settings.provisioningConfirmDialog.disable.description": "Roles and project access for SSO users will no longer be provided by your IdP. Users will be assigned roles and project access directly in n8n.",
	"settings.provisioningConfirmDialog.disable.checkbox": "I confirm that I want to manage user roles and access directly in n8n, and no longer provision them from my SSO provider.",
	"settings.provisioningConfirmDialog.link.docs": "Link to docs",
	"settings.provisioningConfirmDialog.button.enable.confirm": "Save changes",
	"settings.provisioningConfirmDialog.button.disable.confirm": "Save",
	"settings.provisioningConfirmDialog.button.cancel": "Cancel",
	"settings.provisioningConfirmDialog.button.downloadProjectRolesCsv": "Existing project role access settings CSV",
	"settings.provisioningConfirmDialog.button.downloadInstanceRolesCsv": "Existing instance role settings CSV",
	"settings.provisioningConfirmDialog.projectRulesDeletion.warning": "Existing project mapping rules will be permanently deleted.",
	"settings.provisioningConfirmDialog.projectRulesDeletion.description": "Saving this change removes all project role mapping rules. Download the project roles CSV above before saving so you can recreate them if needed.",
	"settings.provisioningInstanceRolesHandledBySsoProvider.description": "User management and instance roles are controlled by your SSO provider. Contact your n8n instance owner or admin to make changes.",
	"settings.provisioningInstanceRolesHandledByExpressionMapping.description": "Instance roles are managed automatically by expression-based role mapping rules. Manual role changes are disabled.",
	"settings.projectRolesManaged.description": "Project roles are managed automatically. Manual role changes are disabled.",
	"settings.externalSecrets.title": "External Secrets",
	"settings.externalSecrets.info": "Connect external secrets tools for centralized credentials management across environments, and to enhance system security.",
	"settings.externalSecrets.info.link": "More info",
	"settings.externalSecrets.actionBox.title": "Available on the Enterprise plan",
	"settings.externalSecrets.actionBox.description": "Connect external secrets tools for centralized credentials management across instances. {link}",
	"settings.externalSecrets.actionBox.description.link": "More info",
	"settings.externalSecrets.actionBox.buttonText": "See plans",
	"settings.externalSecrets.card.setUp": "Set Up",
	"settings.externalSecrets.card.secretsCount": "{count} secret | {count} secrets",
	"settings.externalSecrets.card.connectedAt": "Connected {date}",
	"settings.externalSecrets.card.connected": "Enabled",
	"settings.externalSecrets.card.disconnected": "Disabled",
	"settings.externalSecrets.card.actionDropdown.setup": "Edit connection",
	"settings.externalSecrets.card.actionDropdown.reload": "Reload secrets",
	"settings.externalSecrets.card.reload.success.title": "Reloaded successfully",
	"settings.externalSecrets.card.reload.success.description": "All secrets have been reloaded from {provider}.",
	"settings.externalSecrets.provider.title": "Commit and push changes",
	"settings.externalSecrets.provider.description": "Select the files you want to stage in your commit and add a commit message. ",
	"settings.externalSecrets.provider.buttons.cancel": "Cancel",
	"settings.externalSecrets.provider.buttons.save": "Save",
	"settings.externalSecrets.provider.buttons.saving": "Saving",
	"settings.externalSecrets.card.connectedSwitch.title": "Enable {provider}",
	"settings.externalSecrets.provider.save.success.title": "Provider settings saved successfully",
	"settings.externalSecrets.provider.connected.success.title": "Provider connected successfully",
	"settings.externalSecrets.provider.disconnected.success.title": "Provider disconnected successfully",
	"settings.externalSecrets.provider.testConnection.success.connected": "Service enabled, {count} secrets available on {provider}.",
	"settings.externalSecrets.provider.testConnection.success.connected.usage": "Use secrets in credentials by setting a parameter to an expression and typing: {code}. ",
	"settings.externalSecrets.provider.testConnection.success.connected.docs": "More info",
	"settings.externalSecrets.provider.testConnection.success": "Connection to {provider} executed successfully. Enable the service to use the secrets in credentials.",
	"settings.externalSecrets.provider.testConnection.error.connected": "Connection unsuccessful, please check your {provider} settings",
	"settings.externalSecrets.provider.testConnection.error": "Connection unsuccessful, please check your {provider} settings",
	"settings.externalSecrets.provider.closeWithoutSaving.title": "Close without saving?",
	"settings.externalSecrets.provider.closeWithoutSaving.description": "Are you sure you want to throw away the changes you made to the {provider} settings?",
	"settings.externalSecrets.provider.closeWithoutSaving.cancel": "Close",
	"settings.externalSecrets.provider.closeWithoutSaving.confirm": "Keep editing",
	"settings.externalSecrets.docs": "https://docs.n8n.io/external-secrets/",
	"settings.externalSecrets.docs.use": "https://docs.n8n.io/external-secrets/#use-secrets-in-n8n-credentials",
	"settings.externalSecrets.systemRoles.title": "Enable external secrets for project roles",
	"settings.externalSecrets.systemRoles.description": "Add scopes to project editor and project admin role allowing them to access external secrets within their project by default.",
	"settings.externalSecrets.systemRoles.enabled.toast": "External secrets access enabled for project roles",
	"settings.externalSecrets.systemRoles.disabled.toast": "External secrets access disabled for project roles",
	"settings.externalSecrets.systemRoles.error": "Failed to update external secrets settings",
	"settings.externalSecrets.systemRoles.confirm.headline": "Disable external secrets for project roles?",
	"settings.externalSecrets.systemRoles.confirm.message": "Project admins and editors will lose access to external secrets within their projects.",
	"settings.externalSecrets.systemRoles.confirm.confirmButtonText": "Disable",
	"settings.externalSecrets.systemRoles.confirm.cancelButtonText": "Cancel",
	"settings.secretsProviderConnections.title": "External Secrets",
	"settings.secretsProviderConnections.emptyState.heading": "Add an external secrets vault",
	"settings.secretsProviderConnections.emptyState.description": "Manage credentials across multiple environments by adding an external secrets store. Keep sensitive credential information in your vault for added security.",
	"settings.secretsProviderConnections.buttons.addSecretsStore": "Add secrets vault",
	"settings.secretsProviderConnections.description": "Manage credentials across multiple environments by connecting an external secrets store. Keep sensitive credential information in your vault for added security.",
	"settings.secretsProviderConnections.card.createdAt": "Created on {date}",
	"settings.secretsProviderConnections.actions.share": "Share",
	"settings.secretsProviderConnections.actions.activate.success.title": "Secret store active",
	"settings.secretsProviderConnections.actions.activate.success.description": "\"{provider}\" is now active.",
	"settings.secretsProviderConnections.actions.activate.error.title": "Couldn't activate secret store",
	"settings.secretsProviderConnections.actions.activate.error.description": "Try again to make \"{provider}\" active.",
	"settings.secretsProviderConnections.oneSecret": "1 secret",
	"settings.secretsProviderConnections.secrets": "{count} secrets",
	"settings.secretsProviderConnections.modal.items.connection": "Connection",
	"settings.secretsProviderConnections.modal.items.scope": "Share",
	"settings.secretsProviderConnections.modal.scope.placeholder.project": "Assign globally or within selected project",
	"settings.secretsProviderConnections.modal.scope.global": "Global",
	"settings.secretsProviderConnections.modal.scope.emptyOptionsText": "No matching projects found",
	"settings.secretsProviderConnections.modal.scope.info": "Assigning a secret vault allows people to use external secrets in their credentials.",
	"settings.secretsProviderConnections.modal.scope.label": "Scope",
	"settings.secretsProviderConnections.modal.connectionName": "Vault name",
	"settings.secretsProviderConnections.modal.providerType": "External secrets provider",
	"settings.secretsProviderConnections.modal.providerType.placeholder": "External secrets provider",
	"settings.secretsProviderConnections.modal.saving": "Saving...",
	"settings.secretsProviderConnections.modal.readOnly.notice.admin": "This vault is managed at the instance level. To make changes, go to External Secrets in Settings.",
	"settings.secretsProviderConnections.modal.readOnly.notice.noPermission": "This vault is managed at the instance level. Contact your instance admin to make changes.",
	"settings.secretsProviderConnections.modal.unsavedChanges.title": "Close without saving?",
	"settings.secretsProviderConnections.modal.unsavedChanges.text": "You have unsaved changes. Are you sure you want to close?",
	"settings.secretsProviderConnections.modal.testConnection.success.serviceEnabled": "Service enabled, {count} secrets available on {providerName}.",
	"settings.secretsProviderConnections.modal.testConnection.success.reference": "Reference secrets in credentials using expression:",
	"settings.secretsProviderConnections.modal.testConnection.error": "Couldn't connect with these settings",
	"settings.secretsProviderConnections.modal.validation.connectionName.required": "Vault name is required. Enter a unique name for your secret store.",
	"settings.secretsProviderConnections.modal.validation.connectionName.format": "Name must start with a letter and use only letters or numbers (e.g., \"awsProduction\").",
	"settings.secretsProviderConnections.modal.connectionName.hint": "Enter a unique name for your secret store. This can not be changed later.",
	"settings.secretsProviderConnections.modal.connectionName.unique": "A secret store with this name already exists. Enter a unique name for your secret store.",
	"settings.secretsProviderConnections.state.disconnected": "Disconnected",
	"settings.secretsProviderConnections.state.disabled": "Inactive",
	"settings.secretsProviderConnections.delete.title": "Delete \"{name}\"",
	"settings.secretsProviderConnections.delete.description": "Deleting this vault will remove it and all {secretsCount} imported from it. This will impact credentials that rely on those secrets.",
	"settings.secretsProviderConnections.delete.impact.title": "Impact:",
	"settings.secretsProviderConnections.delete.impact.oneCredential": "1 credential",
	"settings.secretsProviderConnections.delete.impact.credentials": "{count} credentials",
	"settings.secretsProviderConnections.delete.impact.description": "will stop working",
	"settings.secretsProviderConnections.delete.description.noImpact": "Deleting this vault will remove it. This action can't be undone. No secrets were imported from it, and no credentials will be affected.",
	"settings.secretsProviderConnections.delete.confirmationLabel": "Type \"{name}\" to confirm.",
	"settings.secretsProviderConnections.delete.success": "Secret store \"{name}\" deleted successfully",
	"settings.secretsProviderConnections.delete.error": "Failed to delete secret store",
	"settings.secretsProviderConnections.badge.tooltip.project": "This secrets vault is shared with {projectName}.",
	"settings.secretsProviderConnections.badge.tooltip.global": "This secrets vault is available to all projects and users of this instance.",
	"settings.sourceControl.title": "Environments",
	"settings.sourceControl.actionBox.title": "Available on the Enterprise plan",
	"settings.sourceControl.actionBox.description": "Use multiple instances for different environments (dev, prod, etc.), deploying between them via a Git repository.",
	"settings.sourceControl.actionBox.description.link": "More info",
	"settings.sourceControl.actionBox.buttonText": "See plans",
	"settings.sourceControl.connection.error": "Source control failed to connect",
	"settings.sourceControl.connection.error.message": "We couldn't find the repository connected to this instance. Please double-check your {link} on this instance.",
	"settings.sourceControl.connection.error.link": "Git configuration",
	"settings.sourceControl.description": "Use multiple instances for different environments (dev, prod, etc.), deploying between them via a Git repository. {link}",
	"settings.sourceControl.description.link": "More info",
	"settings.sourceControl.gitConfig": "Git configuration",
	"settings.sourceControl.connectionType": "Connection Type",
	"settings.sourceControl.enterValidHttpsUrl": "Please enter a valid HTTPS URL",
	"settings.sourceControl.repoUrl": "Git repository URL (SSH)",
	"settings.sourceControl.repoUrlPlaceholder": "e.g. git{'@'}github.com:my-team/my-repository",
	"settings.sourceControl.repoUrlInvalid": "The Git repository URL is not valid",
	"settings.sourceControl.authorName": "Commit author  name",
	"settings.sourceControl.authorEmail": "Commit author  email",
	"settings.sourceControl.authorEmailInvalid": "The provided email is not correct",
	"settings.sourceControl.sshKey": "SSH Key",
	"settings.sourceControl.sshKeyDescription": "Paste the SSH key in your git repository/account settings. {link}",
	"settings.sourceControl.sshKeyDescriptionLink": "More info",
	"settings.sourceControl.refreshSshKey": "Refresh Key",
	"settings.sourceControl.refreshSshKey.successful.title": "SSH Key refreshed successfully",
	"settings.sourceControl.refreshSshKey.error.title": "SSH Key refresh failed",
	"settings.sourceControl.button.continue": "Continue",
	"settings.sourceControl.button.connect": "Connect",
	"settings.sourceControl.button.disconnect": "Disconnect Git",
	"settings.sourceControl.button.save": "Save settings",
	"settings.sourceControl.instanceSettings": "Instance settings",
	"settings.sourceControl.branches": "Branch connected to this n8n instance",
	"settings.sourceControl.protected": "{bold}: prevent editing workflows (recommended for production environments).",
	"settings.sourceControl.protected.bold": "Protected instance",
	"settings.sourceControl.color": "Color",
	"settings.sourceControl.switchBranch.title": "Switch to {branch} branch",
	"settings.sourceControl.switchBranch.description": "Please confirm you want to switch the current n8n instance to the branch: {branch}",
	"settings.sourceControl.sync.prompt.title": "Sync changes in {branch} branch",
	"settings.sourceControl.sync.prompt.description": "All the changes on your n8n instances will be synced with branch {branch} on the remote git repository. The following git sequence will be executed: pull > commit > push.",
	"settings.sourceControl.sync.prompt.placeholder": "Commit message",
	"settings.sourceControl.sync.prompt.error": "Please enter a commit message",
	"settings.sourceControl.button.push": "Push",
	"settings.sourceControl.button.pull": "Pull",
	"settings.sourceControl.button.pull.forbidden": "Only the instance owner or instance admins can pull changes",
	"settings.sourceControl.button.push.forbidden": "You can't push changes from a protected instance",
	"settings.sourceControl.modals.push.title": "Commit and push changes",
	"settings.sourceControl.modals.push.description": "The following will be committed: ",
	"settings.sourceControl.modals.push.description.learnMore": "More info",
	"settings.sourceControl.modals.push.filesToCommit": "Files to commit",
	"settings.sourceControl.modals.push.filter": "Filters are applied. Showing {count} {entity}.",
	"settings.sourceControl.modals.push.workflowsToCommit": "Select workflows",
	"settings.sourceControl.modals.push.everythingIsUpToDate": "Everything is up to date",
	"settings.sourceControl.modals.push.noWorkflowChanges": "There are no workflow changes but the following will be committed: {link}",
	"settings.sourceControl.modals.push.noWorkflowChanges.moreInfo": "More info",
	"settings.sourceControl.modals.push.commitMessage": "Commit message",
	"settings.sourceControl.modals.push.commitMessage.placeholder": "e.g. My commit",
	"settings.sourceControl.modals.push.buttons.cancel": "Cancel",
	"settings.sourceControl.modals.push.buttons.save": "Commit and push",
	"settings.sourceControl.modals.push.modifiedCredentialsNotice": "Modified credentials will update expressions, numbers, and boolean values, any other values will not be synced, because they would be exposed as plain text in the connected git repository.",
	"settings.sourceControl.modals.push.success.title": "Pushed successfully",
	"settings.sourceControl.modals.push.success.description": "was committed and pushed to your remote repository | were committed and pushed to your remote repository",
	"settings.sourceControl.modals.push.projectAdmin.callout": "If you want to push workflows from your personal space, move them to a project first.",
	"settings.sourceControl.modals.push.currentWorkflow": "Current workflow",
	"settings.sourceControl.status.modified": "Modified",
	"settings.sourceControl.status.deleted": "Deleted",
	"settings.sourceControl.status.created": "New",
	"settings.sourceControl.status.renamed": "Renamed",
	"settings.sourceControl.pull.oneLastStep.title": "One last step",
	"settings.sourceControl.pull.oneLastStep.description": "You have new creds/vars. Fill them out to make sure your workflows function properly",
	"settings.sourceControl.pull.success.title": "Pulled successfully",
	"settings.sourceControl.pull.success.description": "was pulled | were pulled",
	"settings.sourceControl.pull.upToDate.title": "Up to date",
	"settings.sourceControl.pull.upToDate.description": "No workflow changes to pull from Git",
	"settings.sourceControl.pull.upToDate.variables.title": "Finish setting up your new variables to use in workflows",
	"settings.sourceControl.pull.upToDate.variables.description": "Review Variables",
	"settings.sourceControl.pull.upToDate.credentials.title": "Finish setting up your new credentials to use in workflows",
	"settings.sourceControl.pull.upToDate.credentials.description": "Review Credentials",
	"settings.sourceControl.modals.pull.title": "Pull changes",
	"settings.sourceControl.modals.pull.description": "These resources will be updated or deleted, and any local changes to them will be lost. To keep the local version, push it before pulling.",
	"settings.sourceControl.modals.pull.description.learnMore": "More info",
	"settings.sourceControl.modals.pull.autoPublish.title": "Auto-publish pulled version",
	"settings.sourceControl.modals.pull.autoPublish.options.off": "Off",
	"settings.sourceControl.modals.pull.autoPublish.options.off.description": "Don't attempt to publish any workflows",
	"settings.sourceControl.modals.pull.autoPublish.options.published": "If workflow already published",
	"settings.sourceControl.modals.pull.autoPublish.options.published.description": "Workflows that are published in this instance",
	"settings.sourceControl.modals.pull.autoPublish.options.on": "On",
	"settings.sourceControl.modals.pull.autoPublish.options.on.description": "Attempt to publish all workflows",
	"settings.sourceControl.modals.pull.autoPublishing": "Auto-publish",
	"settings.sourceControl.modals.pull.willBeArchived": "Archive",
	"settings.sourceControl.modals.pull.modifiedCredentialsNotice": "Modified credentials will update expressions, numbers, and boolean values, any other values are not available to pull via environments, because secret values cannot be synced.",
	"settings.sourceControl.modals.pull.buttons.cancel": "@:_reusableBaseText.cancel",
	"settings.sourceControl.modals.pull.buttons.save": "Pull and override",
	"settings.sourceControl.modals.pull.buttons.pull": "Pull",
	"settings.sourceControl.modals.pull.dataTablesWarning": "The following data table has schema changes. Column removal will cause data loss that cannot be recovered: | The following data table has schema changes. Column removal will cause data loss that cannot be recovered: | The following {count} data tables have schema changes. Column removal will cause data loss that cannot be recovered:",
	"settings.sourceControl.modals.pullResult.title": "Auto-publish results",
	"settings.sourceControl.modals.pullResult.tabs.failed": "Failed to publish",
	"settings.sourceControl.modals.pullResult.tabs.published": "Published",
	"settings.sourceControl.modals.pullResult.noWorkflows": "No workflows.",
	"settings.sourceControl.modals.pullResult.itemCount": "{count} item | {count} items",
	"settings.sourceControl.modals.pullResult.tableHeader.title": "Title",
	"settings.sourceControl.modals.pullResult.buttons.close": "Close",
	"settings.sourceControl.modals.disconnect.title": "Disconnect Git repository",
	"settings.sourceControl.modals.disconnect.message": "Please confirm you want to disconnect this n8n instance from the Git repository",
	"settings.sourceControl.modals.disconnect.confirm": "Disconnect Git",
	"settings.sourceControl.modals.disconnect.cancel": "@:_reusableBaseText.cancel",
	"settings.sourceControl.modals.refreshSshKey.title": "Refresh SSH Key",
	"settings.sourceControl.modals.refreshSshKey.message": "This will delete the current SSH key and create a new one. You will not be able to authenticate with the current key anymore.",
	"settings.sourceControl.modals.refreshSshKey.cancel": "Cancel",
	"settings.sourceControl.modals.refreshSshKey.confirm": "Refresh key",
	"settings.sourceControl.loading.connecting": "Connecting",
	"settings.sourceControl.toast.connected.title": "Git repository connected",
	"settings.sourceControl.toast.connected.message": "Select the branch to complete the configuration",
	"settings.sourceControl.toast.connected.error": "Error connecting to Git",
	"settings.sourceControl.toast.disconnected.title": "Git repository disconnected",
	"settings.sourceControl.toast.disconnected.message": "You can no longer sync your instance with the remote repository",
	"settings.sourceControl.toast.disconnected.error": "Error disconnecting from Git",
	"settings.sourceControl.loading.pull": "Pulling from remote",
	"settings.sourceControl.loading.checkingForChanges": "Checking for changes",
	"settings.sourceControl.loading.push": "Pushing to remote",
	"settings.sourceControl.lastUpdated": "Last updated {date} at {time}",
	"settings.sourceControl.saved.title": "Settings successfully saved",
	"settings.sourceControl.refreshBranches.tooltip": "Reload branches list",
	"settings.sourceControl.refreshBranches.success": "Branches successfully refreshed",
	"settings.sourceControl.refreshBranches.error": "Error refreshing branches",
	"settings.sourceControl.docs.url": "https://docs.n8n.io/source-control-environments/",
	"settings.sourceControl.docs.setup.url": "https://docs.n8n.io/source-control-environments/setup/",
	"settings.sourceControl.docs.setup.ssh.url": "https://docs.n8n.io/source-control-environments/setup/#step-3-set-up-a-deploy-key",
	"settings.sourceControl.docs.using.url": "https://docs.n8n.io/source-control-environments/using/",
	"settings.sourceControl.docs.using.pushPull.url": "https://docs.n8n.io/source-control-environments/using/push-pull",
	"settings.sourceControl.error.not.connected.title": "Environments have not been enabled",
	"settings.sourceControl.error.not.connected.message": "Please head over to <a href='/settings/environments'>environment settings</a> to connect a git repository first to activate this functionality.",
	"settings.sourceControl.saved.error": "Error setting branch",
	"settings.sourceControl.sshRepoUrl": "SSH Repository URL",
	"settings.sourceControl.httpsRepoUrl": "HTTPS Repository URL",
	"settings.sourceControl.sshRepoUrlPlaceholder": "git{'@'}github.com:user/repository.git",
	"settings.sourceControl.httpsRepoUrlPlaceholder": "https://github.com/user/repository.git",
	"settings.sourceControl.sshFormatNotice": "Use SSH format: git{'@'}github.com:user/repository.git",
	"settings.sourceControl.httpsFormatNotice": "Use HTTPS format: https://github.com/user/repository.git",
	"settings.sourceControl.httpsUsername": "Username",
	"settings.sourceControl.httpsUsernamePlaceholder": "Enter your GitHub username",
	"settings.sourceControl.httpsPersonalAccessToken": "Personal Access Token",
	"settings.sourceControl.httpsPersonalAccessTokenPlaceholder": "Enter your Personal Access Token (PAT)",
	"settings.sourceControl.httpsWarningNotice": "{strong} To create one for GitHub: Go to Settings → Developer settings → Personal access tokens → Tokens (classic). Required scopes: {repo} for private repositories or {publicRepo} for public ones. Other providers are also supported.",
	"settings.sourceControl.httpsWarningNotice.strong": "Personal Access Token required:",
	"settings.migrationReport": "Migration Report",
	"settings.migrationReport.title": "Compatibility report for version {version}",
	"settings.migrationReport.description": "{compatibleCount} of your {totalCount} workflows are already compatible with version {version}. Review the details below to understand and resolve any compatibility problems. Learn more about all breaking changes in our",
	"settings.migrationReport.documentationLink": "documentation",
	"settings.migrationReport.refreshButton": "Refresh",
	"settings.migrationReport.tabs.workflowIssues": "Workflow issues",
	"settings.migrationReport.tabs.instanceIssues": "Instance issues",
	"settings.migrationReport.workflowTooltip.critical": "Affected workflows will break after the update. You need to update or replace impacted nodes.",
	"settings.migrationReport.workflowTooltip.medium": "Workflows may still run but could produce incorrect results. Review and test before updating.",
	"settings.migrationReport.workflowTooltip.low": "Behavior might change slightly in specific cases. Most workflows will keep working as expected.",
	"settings.migrationReport.instanceTooltip.critical": "This issue will likely prevent the instance from starting or working correctly after the update. Must be fixed before proceeding.",
	"settings.migrationReport.instanceTooltip.medium": "This may affect performance, compatibility, or connected services. Review and fix if relevant to your setup.",
	"settings.migrationReport.instanceTooltip.low": "Minor configuration change. Doesn't block the update but may cause subtle changes in behavior.",
	"settings.migrationReport.emptyWorkflowIssues.title": "No workflow issues detected",
	"settings.migrationReport.emptyWorkflowIssues.description": "Your workflows are fully compatible with version {version}. You're good to go!",
	"settings.migrationReport.emptyInstanceIssues.title": "No instance issues detected",
	"settings.migrationReport.emptyInstanceIssues.description": "Your instance is fully compatible with version {version}. You're good to go!",
	"settings.migrationReport.documentation": "Documentation",
	"settings.migrationReport.workflowsCount": "{count} Workflow | {count} Workflows",
	"settings.migrationReport.detail.affectedTag": "{count} affected",
	"settings.migrationReport.detail.table.name": "Name",
	"settings.migrationReport.detail.table.status": "Status",
	"settings.migrationReport.detail.table.active": "Active",
	"settings.migrationReport.detail.table.deactivated": "Deactivated",
	"settings.migrationReport.detail.table.nodesAffected": "Nodes affected",
	"settings.migrationReport.detail.table.numberOfExecutions": "Number of executions",
	"settings.migrationReport.detail.table.lastExecuted": "Last executed",
	"settings.migrationReport.detail.table.lastUpdated": "Last updated",
	"settings.migrationReport.detail.table.never": "Never",
	"settings.migrationReport.detail.search.placeholder": "Search workflows...",
	"settings.migrationReport.detail.filter.status.label": "Status",
	"settings.migrationReport.detail.filter.status.all": "All",
	"settings.migrationReport.detail.filter.status.active": "Active",
	"settings.migrationReport.detail.filter.status.deactivated": "Deactivated",
	"showMessage.cancel": "@:_reusableBaseText.cancel",
	"showMessage.ok": "OK",
	"showMessage.showDetails": "Show Details",
	"startupError": "Error connecting to n8n",
	"startupError.message": "Could not connect to server. <a data-action='reload'>Refresh</a> to try again",
	"tagsDropdown.createTag": "Create tag \"{filter}\"",
	"tagsDropdown.manageTags": "Manage tags",
	"tagsDropdown.noMatchingTagsExist": "No matching tags exist",
	"tagsDropdown.noTagsExist": "No tags exist",
	"tagsDropdown.showError.message": "A problem occurred when trying to create the '{name}' tag",
	"tagsDropdown.showError.title": "Could not create tag",
	"tagsDropdown.typeToCreateATag": "Type to create a tag",
	"tagsManager.couldNotDeleteTag": "Could not delete tag",
	"tagsManager.done": "Done",
	"tagsManager.manageTags": "Manage tags",
	"tagsManager.showError.onFetch.title": "Could not fetch tags",
	"tagsManager.showError.onFetch.message": "A problem occurred when trying to fetch tags",
	"tagsManager.showError.onCreate.message": "A problem occurred when trying to create the tag '{escapedName}'",
	"tagsManager.showError.onCreate.title": "Could not create tag",
	"tagsManager.showError.onDelete.message": "A problem occurred when trying to delete the tag '{escapedName}'",
	"tagsManager.showError.onDelete.title": "Could not delete tag",
	"tagsManager.showError.onUpdate.message": "A problem occurred when trying to update the tag '{escapedName}'",
	"tagsManager.showError.onUpdate.title": "Could not update tag",
	"tagsManager.showMessage.onDelete.title": "Tag deleted",
	"tagsManager.showMessage.onUpdate.title": "Tag updated",
	"tagsManager.tagNameCannotBeEmpty": "Tag name cannot be empty",
	"tagsTable.areYouSureYouWantToDeleteThisTag": "Are you sure you want to delete this tag?",
	"tagsTable.cancel": "@:_reusableBaseText.cancel",
	"tagsTable.createTag": "Create tag",
	"tagsTable.deleteTag": "Delete tag",
	"tagsTable.editTag": "Edit Tag",
	"tagsTable.name": "@:_reusableBaseText.name",
	"tagsTable.noMatchingTagsExist": "No matching tags exist",
	"tagsTable.saveChanges": "Save changes?",
	"tagsTable.usage": "Usage",
	"tagsTableHeader.addNew": "Add new",
	"tagsTableHeader.searchTags": "Search Tags",
	"tagsView.inUse": "{count} workflow | {count} workflows",
	"tagsView.notBeingUsed": "Not being used",
	"onboarding.title": "Demo: {name}",
	"template.buttons.goBackButton": "Go back",
	"template.buttons.startWithAi": "Customize with AI",
	"template.buttons.tryTemplate": "Try template",
	"template.buttons.useThisWorkflowButton": "Use this workflow",
	"template.details.appsInTheCollection": "This collection features",
	"template.details.appsInTheWorkflow": "Apps in this workflow",
	"template.details.by": "by",
	"template.details.categories": "Categories",
	"template.details.created": "Created",
	"template.details.details": "Details",
	"template.details.times": "times",
	"template.details.viewed": "Viewed",
	"template.byAuthor": "By {name}",
	"templates.allCategories": "All Categories",
	"templates.categoriesHeading": "Categories",
	"templates.collection": "Collection",
	"templates.collections": "Collections",
	"templates.collectionsNotFound": "Collection could not be found",
	"templates.connectionWarning": "! There was a problem fetching workflow templates. Check your internet connection.",
	"templates.heading": "Workflow templates",
	"templates.shareWorkflow": "Share template",
	"templates.noSearchResults": "Nothing found. Try adjusting your search to see more.",
	"templates.searchPlaceholder": "Search workflows",
	"templates.workflows": "Workflows",
	"templates.workflowsNotFound": "Workflow could not be found",
	"templates.card.setupTime": "{count} min setup",
	"templates.card.verified": "Verified",
	"templates.card.readyToRun": "Ready to run",
	"textEdit.edit": "Edit",
	"userActivity.daysAgo": "{count} days ago",
	"userActivity.lastTime": "Last {time}",
	"userActivity.today": "Today",
	"userActivity.yesterday": "Yesterday",
	"timeAgo.daysAgo": "%s days ago",
	"timeAgo.hoursAgo": "%s hours ago",
	"timeAgo.inDays": "in %s days",
	"timeAgo.inHours": "in %s hours",
	"timeAgo.inMinutes": "in %s minutes",
	"timeAgo.inMonths": "in %s months",
	"timeAgo.inOneDay": "in 1 day",
	"timeAgo.inOneHour": "in 1 hour",
	"timeAgo.inOneMinute": "in 1 minute",
	"timeAgo.inOneMonth": "in 1 month",
	"timeAgo.inOneWeek": "in 1 week",
	"timeAgo.inOneYear": "in 1 year",
	"timeAgo.inWeeks": "in %s weeks",
	"timeAgo.inYears": "in %s years",
	"timeAgo.justNow": "Just now",
	"timeAgo.minutesAgo": "%s minutes ago",
	"timeAgo.monthsAgo": "%s months ago",
	"timeAgo.oneDayAgo": "1 day ago",
	"timeAgo.oneHourAgo": "1 hour ago",
	"timeAgo.oneMinuteAgo": "1 minute ago",
	"timeAgo.oneMonthAgo": "1 month ago",
	"timeAgo.oneWeekAgo": "1 week ago",
	"timeAgo.oneYearAgo": "1 year ago",
	"timeAgo.rightNow": "Right now",
	"timeAgo.weeksAgo": "%s weeks ago",
	"timeAgo.yearsAgo": "%s years ago",
	"nodeIssues.credentials.notSet": "Credentials for {type} are not set.",
	"nodeIssues.credentials.notAvailable": "Credential is not available",
	"nodeIssues.credentials.doNotExist": "Credentials with name {name} do not exist for {type}.",
	"nodeIssues.credentials.doNotExist.hint": "You can create credentials with the exact name and then they get auto-selected on refresh..",
	"nodeIssues.credentials.notIdentified": "Credentials with name {name} exist for {type}.",
	"nodeIssues.credentials.notIdentified.hint": "Credentials are not clearly identified. Please select the correct credentials.",
	"nodeIssues.credentials.privateNotConnected": "'{name}' end-user credential is not connected for you. Connect yours to execute this step manually.",
	"nodeIssues.credentials.privateRequiresManualTrigger": "End-user credentials aren't supported with the {triggerName} trigger. Use a Manual, Chat, MCP server, or Sub-workflow trigger, or switch this credential to Fixed.",
	"nodeIssues.credentials.privateRequiresIdentityExtractor": "End-user credentials with this resolver need a trigger that extracts an identity. Configure an identity extractor on the {triggerName} trigger, or switch this credential to Fixed.",
	"nodeIssues.input.missing": "No node connected to required input \"{inputName}\"",
	"ndv.trigger.moreInfo": "More info",
	"ndv.trigger.copiedTestUrl": "Test URL copied to clipboard",
	"ndv.trigger.webhookBasedNode.executionsHelp.inactive": "<b>While building your workflow</b>, click the 'execute step' button, then go to {service} and make an event happen. This will trigger an execution, which will show up in this editor.<br /> <br /> <b>Once you're happy with your workflow</b>, publish it. Then every time there's a matching event in {service}, the workflow will execute. These executions will show up in the <a data-key=\"executions\">executions list</a>, but not in the editor.",
	"ndv.trigger.webhookBasedNode.executionsHelp.active": "<b>While building your workflow</b>, click the 'execute step' button, then go to {service} and make an event happen. This will trigger an execution, which will show up in this editor.<br /> <br /> <b>Your workflow will also execute automatically</b>, since it's activated. Every time there’s a matching event in {service}, this node will trigger an execution. These executions will show up in the <a data-key=\"executions\">executions list</a>, but not in the editor. ",
	"ndv.trigger.webhookNode.listening": "Listening for test event",
	"ndv.trigger.chatTrigger.openChat": "Open Chat Window",
	"ndv.trigger.webhookNode.formTrigger.listening": "Listening for a test form submission",
	"ndv.trigger.webhookBasedNode.listening": "Listening for your trigger event",
	"ndv.trigger.webhookNode.requestHint": "Make a {type} request to:",
	"ndv.trigger.webhookBasedNode.serviceHint": "Go to {service} and create an event",
	"ndv.trigger.webhookBasedNode.chatTrigger.serviceHint": "Send a message in the chat",
	"ndv.trigger.webhookBasedNode.formTrigger.serviceHint": "Submit the test form that just opened in a new tab",
	"ndv.trigger.webhookBasedNode.activationHint.inactive": "Once you’ve finished building your workflow, publish it to have it also listen continuously (you just won’t see those executions here).",
	"ndv.trigger.webhookBasedNode.activationHint.active": "This node will also trigger automatically on new {service} events (but those executions won’t show up here).",
	"ndv.trigger.pollingNode.activationHint.inactive": "Once you’ve finished building your workflow, publish it to have it also check for events regularly (you just won’t see those executions here).",
	"ndv.trigger.pollingNode.activationHint.active": "This node will also trigger automatically on new {service} events (but those executions won’t show up here).",
	"ndv.trigger.executionsHint.question": "When will this node trigger my flow?",
	"ndv.trigger.pollingNode.fetchingEvent": "Fetching event",
	"ndv.trigger.pollingNode.fetchingHint": "This node is looking for an event in {name} that is similar to the one you defined",
	"ndv.trigger.pollingNode.executionsHelp.inactive": "<b>While building your workflow</b>, click the 'fetch' button to fetch a single mock event. It will show up in this editor.<br /><br /><b>Once you're happy with your workflow</b>, publish it. Then n8n will regularly check {service} for new events, and execute this workflow if it finds any. These executions will show up in the <a data-key=\"executions\">executions list</a>, but not in the editor.",
	"ndv.trigger.pollingNode.executionsHelp.active": "<b>While building your workflow</b>, click the 'fetch' button to fetch a single mock event. It will show up in this editor.<br /><br /><b>Your workflow will also execute automatically</b>, since it's activated. n8n will regularly check {app_name} for new events, and execute this workflow if it finds any. These executions will show up in the <a data-key=\"executions\">executions list</a>, but not in the editor.",
	"ndv.trigger.webhookBasedNode.action": "Pull in events from {name}",
	"ndv.search.placeholder.output": "Search output",
	"ndv.search.placeholder.input": "Search selected node",
	"ndv.search.placeholder.input.schema": "Search previous nodes' fields",
	"ndv.search.placeholder.shortcutHint": "Search ({shortcut})",
	"ndv.search.noMatch.title": "No matching items",
	"ndv.search.noNodeMatch.title": "No matching fields",
	"ndv.search.noMatch.description": "Try changing or {link} the filter to see more",
	"ndv.search.noMatch.description.link": "clearing",
	"ndv.search.noMatchSchema.description": "To search field values, switch to table or JSON view. {link}",
	"ndv.search.noMatchSchema.description.link": "Clear filter",
	"ndv.search.items": "{matched} of {count} item | {matched} of {count} items",
	"ndv.render.text": "Text",
	"ndv.render.html": "Html",
	"ndv.render.markdown": "Markdown",
	"ndv.nodeHints.disabled": "This node is disabled, and will simply pass the input through",
	"ndv.nodeHints.alwaysOutputData": "This node will output an empty item if nothing would normally be returned",
	"ndv.nodeHints.alwaysOutputData.short": "output an empty item if nothing would normally be returned",
	"ndv.nodeHints.executeOnce": "This node will execute only once, no matter how many input items there are",
	"ndv.nodeHints.executeOnce.short": "execute only once, no matter how many input items there are",
	"ndv.nodeHints.retryOnFail": "This node will automatically retry if it fails",
	"ndv.nodeHints.retryOnFail.short": "automatically retry if it fails",
	"ndv.nodeHints.continueOnError": "Execution will continue even if the node fails",
	"ndv.nodeHints.continueOnError.short": "continue executing even if the node fails",
	"updatesPanel.andIs": "and is",
	"updatesPanel.behindTheLatest": "behind the latest and greatest n8n",
	"updatesPanel.howToUpdateYourN8nVersion": "How to update your n8n version",
	"updatesPanel.version": "{numberOfVersions} version{howManySuffix}",
	"updatesPanel.weVeBeenBusy": "We’ve been busy ✨",
	"updatesPanel.youReOnVersion": "You’re on {currentVersionName}, which was released",
	"versionCard.breakingChanges": "Breaking changes",
	"versionCard.released": "Released",
	"versionCard.securityUpdate": "Security update",
	"versionCard.thisVersionHasASecurityIssue": "This version has a security issue.<br />It is listed here for completeness.",
	"versionCard.unknown": "unknown",
	"versionCard.version": "Version",
	"workflowActivator.workflowIsActive": "Workflow is already active",
	"workflowActivator.activateWorkflow": "Activate workflow",
	"workflowActivator.deactivateWorkflow": "Deactivate workflow",
	"workflowActivator.active": "Active",
	"workflowActivator.inactive": "Inactive",
	"workflowActivator.showError.title": "Workflow could not be {newStateName}",
	"workflowActivator.showError.nodeError": "Error in node \"{nodeName}\":",
	"workflowActivator.showError.partialTitle": "Some triggers could not be activated",
	"workflowActivator.showMessage.activeChangedNodesIssuesExistTrue.message": "Please resolve outstanding issues before publishing",
	"workflowActivator.showMessage.activeChangedNodesIssuesExistTrue.title": "{count} node has issues, fix them before publishing. | {count} nodes have issues, fix them before publishing.",
	"workflowActivator.showMessage.activeChangedWorkflowIdUndefined.message": "Please save it before activating",
	"workflowActivator.showMessage.activeChangedWorkflowIdUndefined.title": "Problem activating workflow",
	"workflowActivator.showMessage.displayActivationError.message.catchBlock": "Sorry there was a problem requesting the error",
	"workflowActivator.showMessage.displayActivationError.message.errorDataNotUndefined": "The following error occurred on workflow activation:",
	"workflowActivator.showMessage.displayActivationError.message.errorDataUndefined": "Unknown error",
	"workflowActivator.showMessage.displayActivationError.title": "Problem activating workflow",
	"workflowActivator.theWorkflowIsSetToBeActiveBut": "The workflow is activated but could not be started.<br />Click to display error message.",
	"workflowActivator.thisWorkflowHasNoTriggerNodes": "This workflow has no trigger nodes that require activation",
	"workflowActivator.thisWorkflowIsArchived": "This workflow is archived so it cannot be activated",
	"workflowActivator.thisWorkflowHasOnlyOneExecuteWorkflowTriggerNode": "'Execute Workflow Trigger' doesn't require activation as it is triggered by another workflow",
	"workflowActivator.conflictingWebhook.unknownWorkflow": "Unknown workflow (ID: {id})",
	"workflowDetails.share": "Share",
	"workflowDetails.addTag": "Add tag",
	"workflowDetails.chooseOrCreateATag": "Choose or create a tag",
	"workflowProductionChecklist.title": "Production Checklist",
	"workflowProductionChecklist.readOnlyNotice": "Read-only environment. Update these items in development and push changes.",
	"workflowProductionChecklist.ignoreAllConfirmation.title": "Ignore suggested actions globally",
	"workflowProductionChecklist.ignoreAllConfirmation.description": "Turning this off dismisses these suggestions from every workflow",
	"workflowProductionChecklist.ignoreAllConfirmation.confirm": "Ignore for all workflows",
	"workflowProductionChecklist.turnOffWorkflowSuggestions": "Ignore for all workflows",
	"workflowProductionChecklist.evaluations.title": "Test reliability of AI steps",
	"workflowProductionChecklist.evaluations.description": "Use evaluations to check performance on a range of inputs.",
	"workflowProductionChecklist.errorWorkflow.title": "Set up error notifications",
	"workflowProductionChecklist.errorWorkflow.description": "Customize exactly how you’re notified by setting up an error workflow",
	"workflowProductionChecklist.timeSaved.title": "Track time saved",
	"workflowProductionChecklist.timeSaved.description": "Configure the time saved on each run to track the manual work it saves.",
	"canvas.selection.toolbar.group": "Group nodes",
	"canvas.selection.toolbar.ungroup": "Ungroup nodes",
	"canvas.nodeGroup.defaultTitle": "Group",
	"canvas.nodeGroup.connectionAddBlocked.title": "Connection not added",
	"canvas.nodeGroup.connectionRemoveBlocked.title": "Connection not removed",
	"canvas.nodeGroup.connectionChangeBlocked.message": "This change would break '{group}'. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.nonMainBoundary": "The sub-node connection between '{source}' and '{target}' crosses the boundary of '{group}'. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.multipleInputNodes": "'{group}' can have only one entry point. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.inputEdgeToNonRoot": "Connections into '{group}' must go to its first node. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.multipleOutputNodes": "'{group}' can have only one exit point. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.outputEdgeFromNonLeaf": "Connections out of '{group}' must come from its last node. You can make this change after ungrouping it.",
	"canvas.nodeGroup.connectionChangeBlocked.noContinuousPathFromRootToLeaf": "'{group}' must stay connected from first node to last node. You can make this change after ungrouping it.",
	"canvas.nodeGroup.autoExtended.title": "'{group}' extended",
	"canvas.nodeGroup.autoExtended.message": "Added '{node}' to keep '{group}' valid with the new connection.",
	"canvas.nodeGroup.removedOnSave.title": "Groups removed",
	"canvas.nodeGroup.removedOnSave.message": "The following groups are incompatible with your n8n version and have been removed: {groups}",
	"canvas.nodeGroup.titlePlaceholder": "Group name",
	"canvas.nodeGroup.expand": "Expand",
	"canvas.nodeGroup.collapse": "Collapse",
	"canvas.nodeGroup.prompt.renameGroup": "Rename group",
	"canvas.nodeGroup.duplicateName": "A group with this name already exists",
	"canvas.nodeGroup.renameBlocked.title": "Group not renamed",
	"canvas.nodeGroup.descriptionPlaceholder": "Add description",
	"canvas.nodeGroup.editDescription": "Edit description",
	"canvas.nodeGroup.saveDescription": "Save description",
	"canvas.nodeGroup.cancelEdit": "Cancel edit",
	"canvas.nodeGroup.pinDescription": "Show description",
	"canvas.nodeGroup.unpinDescription": "Hide description",
	"workflowExtraction.error.failure": "Sub-workflow conversion failed",
	"workflowExtraction.error.selectionGraph.inputEdgeToNonRoot": "Non-input node '{node}' has a connection from a node outside the current selection.",
	"workflowExtraction.error.selectionGraph.outputEdgeFromNonLeaf": "Non-output node '{node}' has a connection to a node outside the current selection.",
	"workflowExtraction.error.selectionGraph.multipleInputNodes": "Multiple nodes [{nodes}] have inputs from outside the selection.",
	"workflowExtraction.error.selectionGraph.multipleOutputNodes": "Multiple nodes [{nodes}] have outputs to outside the selection.",
	"workflowExtraction.error.selectionGraph.noContinuousPathFromRootToLeaf": "First node '{start}' has no selected path to last node '{end}'.",
	"workflowExtraction.error.selectionGraph.listHeader": "Selection is invalid because of these errors:<br><br>{body}<br><br><a href=\"https://docs.n8n.io/workflows/subworkflow-conversion/\" target=\"_blank\">See docs</a> for more info.",
	"workflowExtraction.error.inputNodeHasMultipleInputBranches": "First node '{node}' has multiple input branches, which sub-workflows do not support.",
	"workflowExtraction.error.outputNodeHasMultipleOutputBranches": "Last node '{node}' has multiple output branches, which sub-workflows do not support.",
	"workflowExtraction.error.triggerSelected": "Triggers cannot be converted to a sub-workflow. Please unselect {nodes}.",
	"workflowExtraction.error.subworkflowCreationFailed": "Sub-workflow creation failed, aborting conversion.",
	"workflowExtraction.success.title": "Created sub-workflow",
	"workflowExtraction.success.message": "<a href=\"{url}\" target=\"_blank\">Open in new Tab</a>",
	"workflowExtraction.modal.title": "Convert to sub-workflow",
	"workflowExtraction.modal.description": "Convert {nodeCount} node to a new sub-workflow | Convert {nodeCount} nodes to a new sub-workflow",
	"workflowHelpers.showMessage.title": "Problem saving workflow",
	"workflowOpen.created": "Created",
	"workflowOpen.filterWorkflows": "Filter by tags",
	"workflowOpen.name": "@:_reusableBaseText.name",
	"workflowOpen.openWorkflow": "Open Workflow",
	"workflowOpen.searchWorkflows": "Search workflows...",
	"workflowOpen.showError.title": "Problem loading workflows",
	"workflowOpen.showMessage.message": "This is the current workflow",
	"workflowOpen.showMessage.title": "Workflow already open",
	"workflowOpen.updated": "Updated",
	"workflowOpen.newWFButton.label": "Add workflow",
	"workflowOpen.newWFButton.title": "Create a new workflow",
	"workflowPreview.showError.arrayEmpty": "Must have an array of nodes",
	"workflowPreview.showError.missingWorkflow": "Missing workflow",
	"workflowPreview.showError.previewError.message": "Unable to preview workflow",
	"workflowPreview.showError.missingExecution": "Missing workflow execution",
	"workflowPreview.executionMode.showError.previewError.message": "Unable to preview workflow execution",
	"workflowPreview.showError.previewError.title": "Preview error",
	"workflowRun.noActiveConnectionToTheServer": "Lost connection to the server",
	"workflowRun.saveBeforeRun.headline": "Save before running?",
	"workflowRun.saveBeforeRun.message": "You have to save your workflow before running a manual execution.",
	"workflowRun.saveBeforeRun.confirmButtonText": "Save & run",
	"workflowRun.saveBeforeRun.cancelButtonText": "Cancel",
	"workflowRun.showError.deactivate": "Deactivate workflow to execute",
	"workflowRun.showError.title": "Problem running workflow",
	"workflowRun.showError.payloadTooLarge": "Please execute the whole workflow, rather than just the node. (Existing execution data is too large.)",
	"workflowRun.showError.resolveOutstandingIssues": "Please resolve outstanding issues before you activate it",
	"workflowRun.showError.unsupportedExecutionLogic.title": "Unsupported Execution Logic",
	"workflowRun.showError.unsupportedExecutionLogic.description": "Execution Logic \"v2\" is not supported when filesystem mode is \"default\". Please change the Execution Logic to \"v1\" in workflow settings and update expressions accordingly.",
	"workflowRun.showWarning.noChatResponseNodes.title": "No response node detected",
	"workflowRun.showWarning.noChatResponseNodes.description": "Add a Chat or Respond to Webhook node to send a reply, or change the response mode in the Chat Trigger.",
	"workflowRun.showMessage.message": "Please fix them before executing",
	"workflowRun.showMessage.title": "Workflow has issues",
	"workflowSettings.executionLogic.v0.title": "v0 (legacy)",
	"workflowSettings.executionLogic.v1.title": "v1 (recommended)",
	"workflowSettings.executionLogic.v2.title": "v2 (experimental)",
	"workflowSettings.executionLogic.v0.description": "Executes the first node of each branch, then the second node of each branch, and so on.",
	"workflowSettings.executionLogic.v1.description": "Executes each branch in turn, from topmost to bottommost, completing one branch before starting another.",
	"workflowSettings.executionLogic.v2.description": "Executes each branch in turn, with binaries included directly in the item structure to simplify expressions.",
	"workflowSettings.executionLogic.changed.title": "Execution Logic changed",
	"workflowSettings.executionLogic.changed.description": "Please update expressions that reference binary data to match the new execution logic mode. ",
	"workflowSettings.callerIds": "IDs of workflows that can call this one",
	"workflowSettings.callerIds.placeholder": "e.g. 14, 18",
	"workflowSettings.callerPolicy": "This workflow can be called by",
	"workflowSettings.callerPolicy.options.any": "Any workflow",
	"workflowSettings.callerPolicy.options.workflowsFromPersonalProject": "Workflows created by {projectName}",
	"workflowSettings.callerPolicy.options.workflowsFromTeamProject": "Only workflows in {projectName}",
	"workflowSettings.callerPolicy.options.workflowsFromSameProject": "Only workflows in the same project",
	"workflowSettings.callerPolicy.options.workflowsFromAList": "Selected workflows",
	"workflowSettings.callerPolicy.options.none": "No other workflows",
	"workflowSettings.customSpanAttributes.displayName": "Custom span attributes",
	"workflowSettings.customSpanAttributes.description": "Add custom span attributes to this workflow's OpenTelemetry spans.",
	"workflowSettings.customSpanAttributes.configure": "Configure",
	"workflowSettings.customSpanAttributes.configuredCount": "{count} attribute configured | {count} attributes configured",
	"workflowSettings.customSpanAttributes.placeholder": "Add attribute",
	"workflowSettings.customSpanAttributes.modal.title": "Custom span attributes",
	"workflowSettings.customSpanAttributes.modal.learnMore": "Learn more in the",
	"workflowSettings.customSpanAttributes.modal.documentation": "documentation",
	"workflowSettings.customSpanAttributes.tag.key.displayName": "Key",
	"workflowSettings.customSpanAttributes.tag.key.placeholder": "Key",
	"workflowSettings.customSpanAttributes.tag.value.displayName": "Value",
	"workflowSettings.customSpanAttributes.tag.value.placeholder": "Value",
	"workflowSettings.customSpanAttributes.delete": "Delete attribute",
	"workflowSettings.customSpanAttributes.error.emptyKey": "Key must not be empty",
	"workflowSettings.customSpanAttributes.error.duplicateKey": "Duplicate keys are not allowed",
	"workflowSettings.defaultTimezone": "Default - {defaultTimezoneValue}",
	"workflowSettings.defaultTimezoneNotValid": "Default Timezone not valid",
	"workflowSettings.errorWorkflow": "Error Workflow (to notify when this one errors)",
	"workflowSettings.executionLogic": "Execution Logic",
	"workflowSettings.binaryMode": "Binary Mode",
	"workflowSettings.helpTexts.errorWorkflow": "A second workflow to run if the current one fails.<br />The second workflow should have an 'Error Trigger' node.",
	"workflowSettings.helpTexts.executionTimeout": "How long the workflow should wait before timing out",
	"workflowSettings.helpTexts.executionTimeoutToggle": "Whether to cancel workflow execution after a defined time",
	"workflowSettings.helpTexts.saveDataErrorExecution": "Whether to save data of executions that fail",
	"workflowSettings.helpTexts.saveDataSuccessExecution": "Whether to save data of executions that finish successfully",
	"workflowSettings.helpTexts.saveExecutionProgress": "Whether to save data after each node execution. This allows you to resume from where execution stopped if there is an error, but may increase latency.",
	"workflowSettings.helpTexts.saveManualExecutions": "Whether to save data of executions that are started manually from the editor",
	"workflowSettings.helpTexts.timezone": "The timezone in which the workflow should run. Used by 'cron' node, for example.",
	"workflowSettings.helpTexts.workflowCallerIds": "The IDs of the workflows that are allowed to execute this one (using an ‘execute workflow’ node). The ID can be found at the end of the workflow’s URL. Separate multiple IDs by commas.",
	"workflowSettings.helpTexts.workflowCallerPolicy": "Workflows that are allowed to call this workflow using the Execute Workflow node",
	"workflowSettings.hours": "hours",
	"workflowSettings.minutes": "minutes",
	"workflowSettings.name": "Workflow name",
	"workflowSettings.noWorkflow": "- No Workflow -",
	"workflowSettings.save": "@:_reusableBaseText.save",
	"workflowSettings.saveDataErrorExecution": "Save failed production executions",
	"workflowSettings.saveDataErrorExecutionOptions.defaultSave": "Default - {defaultValue}",
	"workflowSettings.saveDataErrorExecutionOptions.doNotSave": "Do not save",
	"workflowSettings.saveDataErrorExecutionOptions.save": "@:_reusableBaseText.save",
	"workflowSettings.saveDataSuccessExecution": "Save successful production executions",
	"workflowSettings.saveDataSuccessExecutionOptions.defaultSave": "Default - {defaultValue}",
	"workflowSettings.saveDataSuccessExecutionOptions.doNotSave": "Do not save",
	"workflowSettings.saveDataSuccessExecutionOptions.save": "@:_reusableBaseText.save",
	"workflowSettings.saveExecutionProgress": "Save execution progress",
	"workflowSettings.saveExecutionProgressOptions.defaultSave": "Default - {defaultValue}",
	"workflowSettings.saveExecutionProgressOptions.doNotSave": "Do not save",
	"workflowSettings.saveExecutionProgressOptions.save": "@:_reusableBaseText.save",
	"workflowSettings.redactProductionData": "Redact production execution data",
	"workflowSettings.redactProductionData.dynamicCredentialsHint": "Prod. execution data is always redacted in workflows that use end-user credentials.",
	"workflowSettings.redactManualData": "Redact manual execution data",
	"workflowSettings.redactManualData.requiresProductionHint": "Manual execution data can only be redacted when production execution data is also redacted.",
	"workflowSettings.redactionOptions.default": "Default - Do not redact",
	"workflowSettings.redactionOptions.redact": "Redact",
	"workflowSettings.helpTexts.redactProductionData": "Controls whether execution data from production (non-manually triggered) executions is redacted.",
	"workflowSettings.helpTexts.redactManualData": "Controls whether execution data from manually triggered executions is redacted.",
	"workflowSettings.redactionPermissionNotice": "You don't have permission to change data redaction settings.",
	"workflowSettings.redactionPermissionNotice.viewUsers": "View users with access",
	"workflowSettings.redactionFloorNotice": "This option is enforced by your instance's redaction policy.",
	"workflowSettings.redactionMembersModal.title": "Users who can edit data redaction settings",
	"workflowSettings.redactionMembersModal.description": "These users can change data redaction settings. Contact one of them to request a change.",
	"workflowSettings.saveManualExecutions": "Save manual executions",
	"workflowSettings.saveManualOptions.defaultSave": "Default - {defaultValue}",
	"workflowSettings.saveManualOptions.doNotSave": "Do not save",
	"workflowSettings.saveManualOptions.save": "@:_reusableBaseText.save",
	"workflowSettings.seconds": "seconds",
	"workflowSettings.selectOption": "Select Option",
	"workflowSettings.settingsFor": "Workflow settings for {workflowName} (#{workflowId})",
	"workflowSettings.showError.saveSettings1.errorMessage": "Timeout is activated but set to 0",
	"workflowSettings.showError.saveSettings1.message": "There was a problem saving the settings",
	"workflowSettings.showError.saveSettings1.title": "Problem saving settings",
	"workflowSettings.showError.saveSettings2.errorMessage": "Maximum Timeout is: {hours} hours, {minutes} minutes, {seconds} seconds",
	"workflowSettings.showError.saveSettings2.message": "The timeout is longer than allowed",
	"workflowSettings.showError.saveSettings2.title": "Problem saving settings",
	"workflowSettings.showError.saveSettings3.title": "Problem saving settings",
	"workflowSettings.showError.fetchSettings.title": "Problem fetching settings",
	"workflowSettings.showMessage.saveSettings.title": "Workflow settings saved",
	"workflowSettings.timeoutAfter": "Timeout After",
	"workflowSettings.timeoutWorkflow": "Timeout Workflow",
	"workflowSettings.executionTimeout": "Timeout Workflow",
	"workflowSettings.tags": "Tags",
	"workflowSettings.timezone": "Timezone",
	"workflowSettings.credentialResolver": "End-user credential resolver",
	"workflowSettings.credentialResolver.placeholder": "Select resolver",
	"workflowSettings.credentialResolver.createNew": "Create new resolver",
	"workflowSettings.credentialResolver.edit": "Edit resolver",
	"workflowSettings.credentialResolver.none": "Default - None",
	"workflowSettings.helpTexts.credentialResolver": "The resolver uses the identity of the user triggering the workflow to pick the right account for all end-user credentials in this workflow.",
	"credentialResolver.addNew": "Add Resolver",
	"credentialResolver.view.title": "Credential resolvers",
	"credentialResolver.view.description": "Resolvers take an incoming user identity and pick the account used by end-user credentials when the workflow runs. Select a resolver in Workflow settings.",
	"credentialResolver.view.learnMore": "You can learn more in the ",
	"credentialResolver.action.edit": "Edit",
	"credentialResolver.action.delete": "Delete",
	"credentialResolver.item.updated": "Last updated",
	"credentialResolver.item.created": "Created",
	"credentialResolverEdit.icon": "Credential resolver",
	"credentialResolverEdit.title.create": "Create Credential Resolver",
	"credentialResolverEdit.title.edit": "Edit Credential Resolver",
	"credentialResolverEdit.saveSuccess.title": "Credential Resolver was saved successfully",
	"credentialResolverEdit.deleteSuccess.title": "Credential Resolver was deleted successfully",
	"credentialResolverEdit.defaultName": "New resolver",
	"credentialResolverEdit.type.label": "Type",
	"credentialResolverEdit.type.placeholder": "Select resolver type",
	"credentialResolverEdit.config.label": "Configuration",
	"credentialResolverEdit.error.missingRequiredFields": "Please fill in all required fields",
	"credentialResolverEdit.error.save": "Failed to save credential resolver",
	"credentialResolverEdit.error.delete": "Failed to delete credential resolver",
	"credentialResolverEdit.error.loadTypes": "Failed to load resolver types",
	"credentialResolverEdit.delete": "Delete",
	"credentialResolverEdit.confirmMessage.deleteResolver.headline": "Delete Credential Resolver?",
	"credentialResolverEdit.confirmMessage.deleteResolver.message": "Are you sure you want to delete the credential resolver {savedResolverName}?",
	"credentialResolverEdit.confirmMessage.deleteResolver.messageWithWorkflows": "Are you sure you want to delete the credential resolver {savedResolverName}? The following workflows use this resolver and will no longer resolve end-user credentials:",
	"credentialResolverEdit.confirmMessage.deleteResolver.andMore": "and {count} more...",
	"credentialResolverEdit.confirmMessage.deleteResolver.confirmButtonText": "Delete",
	"credentialResolverEdit.sidebar.configuration": "Configuration",
	"credentialResolverEdit.sidebar.details": "Details",
	"credentialResolverEdit.details.id": "ID",
	"credentialResolverEdit.details.notSaved": "Not saved yet",
	"credentialResolverEdit.clearCredentials.label": "Clear credentials",
	"credentialResolverEdit.clearCredentials.placeholder": "Select an option",
	"credentialResolverEdit.clearCredentials.yes": "Yes",
	"credentialResolverEdit.clearCredentials.no": "No",
	"credentialResolverEdit.clearCredentials.error.required": "Clear credentials selection is required",
	"credentialResolverEdit.clearCredentials.warning": "When making changes to a resolver, it is advised to clear the existing credentials for that resolver. Please choose whether to take that action.",
	"workflowSettings.timeSavedPerExecution": "Estimated time saved",
	"workflowSettings.timeSavedPerExecution.hint": "Minutes per production execution",
	"workflowSettings.timeSavedPerExecution.tooltip": "Total time savings are summarised in the Overview page.",
	"workflowSettings.timeSavedPerExecution.minutesSaved": "Minutes saved",
	"workflowSettings.timeSavedPerExecution.tab.fixed": "Fixed",
	"workflowSettings.timeSavedPerExecution.tab.dynamic": "Dynamic (uses time saved nodes)",
	"workflowSettings.timeSavedPerExecution.noNodesDetected": "No time saved nodes detected",
	"workflowSettings.timeSavedPerExecution.noNodesDetected.hint": "Add one or more time saved nodes to calculate time saved dynamically",
	"workflowSettings.timeSavedPerExecution.nodesDetected": "Active - {count} time saved nodes currently setup",
	"workflowSettings.timeSavedPerExecution.nodesDetected.hint": "Time saved is calculated dynamically based on each execution",
	"workflowSettings.timeSavedPerExecution.nodesDetected.addMore": "Add more time saved nodes",
	"workflowSettings.timeSavedPerExecution.fixedTabWarning": "Time saved for this workflow is tracked using a fixed value. Any Time Saved nodes in this workflow are ignored with this setting.",
	"workflowSettings.timeSavedPerExecution.fixedTabWarning.link": "time saved nodes",
	"workflowSettings.availableInMCP": "Available in MCP",
	"workflowSettings.availableInMCP.tooltip": "Make this workflow visible to AI Agents through n8n MCP",
	"workflowSettings.toggleMCP.error.title": "Error updating MCP settings",
	"workflowSettings.toggleMCP.notFoundError": "Workflow not found",
	"workflowSettings.toggleMCP.updateSkippedError": "Workflow {workflowId} could not be updated. It may be archived or you may no longer have permission to edit it.",
	"workflowHistory.title": "Version History",
	"workflowHistory.tab.history": "Versions",
	"workflowHistory.tab.publishTimeline": "Publish Timeline",
	"workflowHistory.action.viewTimeline": "View timeline",
	"workflowHistory.content.actions": "Actions",
	"workflowHistory.item.id": "ID: {id}",
	"workflowHistory.item.createdAt": "{date} at {time}",
	"workflowHistory.item.savedAtLabel": "Saved:",
	"workflowHistory.item.publishedAtLabel": "Last published by",
	"workflowHistory.item.actions.restore": "Restore version",
	"workflowHistory.item.actions.publish": "Publish version",
	"workflowHistory.item.actions.unpublish": "Unpublish workflow",
	"workflowHistory.item.actions.clone": "Clone to new workflow",
	"workflowHistory.item.actions.open": "Open version in new tab",
	"workflowHistory.item.actions.download": "Download",
	"workflowHistory.item.actions.name": "Name version",
	"workflowHistory.item.unsaved.title": "Unsaved version",
	"workflowHistory.item.latest": "Latest saved",
	"workflowHistory.item.active": "Published",
	"workflowHistory.item.publishedBy": "Published by",
	"workflowHistory.item.currentChanges": "Current changes",
	"workflowHistory.item.compareTooltip.compareLine": "Compare “{name}”",
	"workflowHistory.item.compareTooltip.withLine": "with “{name}”",
	"workflowHistory.limitDay": "Version history is limited to 1 day",
	"workflowHistory.limitDays": "Version history is limited to {days} days",
	"workflowHistory.limitHour": "Version history is limited to 1 hour",
	"workflowHistory.limitHours": "Version history is limited to {hours} hours",
	"workflowHistory.upgrade": "{link} to activate full history",
	"workflowHistory.upgrade.link": "Upgrade plan",
	"workflowHistory.action.error.title": "Failed to {action}",
	"workflowHistory.action.restore.modal.title": "Restore previous workflow version?",
	"workflowHistory.action.restore.modal.subtitle": "Your workflow will revert to the version from {date}",
	"workflowHistory.action.restore.modal.publishedNote": "This will not affect the published version",
	"workflowHistory.action.restore.modal.button.restore": "Restore",
	"workflowHistory.action.restore.modal.button.cancel": "Cancel",
	"workflowHistory.action.restore.success.title": "Successfully restored workflow version",
	"workflowHistory.action.restore.alreadyRestored": "Workflow version is already restored",
	"workflowHistory.action.clone.success.title": "Successfully cloned workflow version",
	"workflowHistory.action.clone.success.message": "Open cloned workflow in a new tab",
	"workflowHistory.action.unpublish.success.title": "Workflow unpublished successfully",
	"workflowHistory.action.nameVersion.success.title": "Version name updated successfully",
	"workflowHistory.action.nameVersion.error.title": "Failed to update version name",
	"workflowHistory.nameVersionModal.title": "Name version",
	"workflowHistory.nameVersionModal.confirmButton": "Save",
	"workflowHistory.action.unpublish.notAvailable": "This workflow has no published version to unpublish",
	"workflowHistory.action.unpublish.modal.title": "Unpublish {versionName}",
	"workflowHistory.action.unpublish.modal.description": "This will prevent all production executions to this workflow until you publish again.",
	"workflowHistory.action.unpublish.modal.button.unpublish": "Unpublish",
	"workflowHistory.button.tooltip.empty": "This workflow currently has no history to view. Once you've made your first save, you'll be able to view previous versions",
	"workflowHistory.button.tooltip": "Workflow history to view and restore previous versions of your workflows",
	"workflowHistory.button.tooltip.scheduled": "Workflow will be saved shortly",
	"workflowHistory.button.tooltip.saving": "Workflow is being saved",
	"workflowHistory.group.unnamedVersions": "1 version | {count} versions",
	"workflowHistory.publishModal.title": "Publish {versionName}",
	"workflowHistory.publishTimeline.empty": "This workflow has no publish history yet.",
	"workflowHistory.publishTimeline.event.activated": "Published",
	"workflowHistory.publishTimeline.event.activatedVersion": "Published {version}",
	"workflowHistory.publishTimeline.event.activatedDeletedVersion": "Published a version",
	"workflowHistory.publishTimeline.event.activatedDeletedVersion.tooltip": "The published version has since been pruned.",
	"workflowHistory.publishTimeline.event.deactivated": "Unpublished",
	"workflowHistory.publishTimeline.activeDuration": "Active for {duration}",
	"workflowHistory.publishTimeline.inactiveDuration": "Inactive for {duration}",
	"workflowHistory.publishTimeline.tooltip.byUser": "{action} by {user}, {datetime}",
	"workflowHistory.publishTimeline.tooltip.noUser": "{action}, {datetime}",
	"workflowHistory.publishTimeline.deletedVersionsDisclaimer": "History before {date} may be incomplete",
	"workflowHistory.publishTimeline.deletedVersionsDisclaimer.tooltip": "Until version 2.17 pruned workflow versions also removed associated publish history.",
	"favorites.add": "Favorite",
	"favorites.remove": "Unfavorite",
	"favorites.menu.title": "Favorites",
	"workflows.heading": "Workflows",
	"workflows.add": "Add workflow",
	"workflows.addFolder": "Add folder",
	"resourceActions.mcpAccess.manage": "Manage MCP access",
	"resourceActions.mcpAccess.enable": "Enable MCP access",
	"resourceActions.mcpAccess.disable": "Disable MCP access",
	"resourceActions.mcpAccess.enable.tooltip": "Allow MCP access for all workflows in '{scopeName}'",
	"resourceActions.mcpAccess.disable.tooltip": "Disable MCP access for all workflows in '{scopeName}'",
	"resourceActions.mcpAccess.success.enabled.title": "MCP access enabled",
	"resourceActions.mcpAccess.success.disabled.title": "MCP access disabled",
	"resourceActions.mcpAccess.noChanges.title": "No changes needed",
	"resourceActions.mcpAccess.partial.title": "Some workflows weren't updated",
	"resourceActions.mcpAccess.noWorkflows.title": "No workflows to update",
	"resourceActions.mcpAccess.outcome.message": "{summary}<br><br><a href=\"{link}\">Manage MCP settings</a>",
	"resourceActions.mcpAccess.summary.updated.enabled": "Enabled MCP access for 1 workflow in '{scopeName}' | Enabled MCP access for {count} workflows in '{scopeName}'",
	"resourceActions.mcpAccess.summary.updated.disabled": "Disabled MCP access for 1 workflow in '{scopeName}' | Disabled MCP access for {count} workflows in '{scopeName}'",
	"resourceActions.mcpAccess.summary.unchanged.enabled": "1 workflow in '{scopeName}' already has MCP access enabled | {count} workflows in '{scopeName}' already have MCP access enabled",
	"resourceActions.mcpAccess.summary.unchanged.disabled": "1 workflow in '{scopeName}' already doesn't have MCP access | {count} workflows in '{scopeName}' already don't have MCP access",
	"resourceActions.mcpAccess.summary.skipped": "1 workflow in '{scopeName}' couldn't be updated | {count} workflows in '{scopeName}' couldn't be updated",
	"resourceActions.mcpAccess.noWorkflows.message": "There are no workflows in '{scopeName}' that can be updated.<br><br><a href=\"{link}\">Manage MCP settings</a>",
	"resourceActions.mcpAccess.error.enabled.title": "Error enabling MCP access",
	"resourceActions.mcpAccess.error.disabled.title": "Error disabling MCP access",
	"resourceActions.mcpAccess.error.enabled.message": "Could not enable MCP access for all workflows in '{scopeName}'.<br><br><a href=\"{link}\">Manage MCP settings</a>",
	"resourceActions.mcpAccess.error.disabled.message": "Could not disable MCP access for all workflows in '{scopeName}'.<br><br><a href=\"{link}\">Manage MCP settings</a>",
	"resourceActions.mcpAccess.disabled.title": "MCP access is off",
	"resourceActions.mcpAccess.disabled.message": "Turn on instance-level MCP access before managing workflow access<br><br><a href=\"{link}\">Manage MCP settings</a>",
	"workflows.publish": "Publish",
	"workflows.published": "Published",
	"workflows.publish.permissionDenied": "You don't have permission to publish this workflow",
	"workflows.publish.personalSpaceRestricted": "Workflow publishing is disabled in personal spaces. Move the workflow to a team space to activate",
	"workflows.publish.publishing": "Publishing…",
	"workflows.publish.publishing.tooltip": "Activating triggers — this can take a moment.",
	"workflows.publish.partial.tooltip": "The workflow is partially published, but some triggers failed to activate. Publish again to retry.",
	"workflows.publish.failed.tooltip": "This workflow isn't running. Publish again to retry.",
	"workflows.publish.failures.label": "Failed triggers:",
	"workflows.unpublish": "Unpublish",
	"workflows.project.add": "Add workflow to project",
	"workflows.item.open": "Open",
	"workflows.item.share": "Share...",
	"workflows.item.duplicate": "Duplicate",
	"workflows.item.delete": "Delete",
	"workflows.item.archive": "Archive",
	"workflows.item.unarchive": "Unarchive",
	"workflows.item.move": "Move",
	"workflows.item.changeOwner": "Move",
	"workflows.item.updated": "Last updated",
	"workflows.item.created": "Created",
	"workflows.item.readonly": "Read only",
	"workflows.item.archived": "Archived",
	"workflows.item.availableInMCP": "Available in MCP",
	"workflows.dynamic.tooltip": "This workflow has one or more nodes set up to use the credentials of the person it's running on behalf of.",
	"workflows.dynamic.tooltipTitle": "End-user credentials",
	"workflows.dependencies.tooltip.workflow": "Click to view resources referenced by this workflow",
	"workflows.dependencies.tooltip.credential": "Click to view resources referencing this credential",
	"workflows.dependencies.tooltip.dataTable": "Click to view resources referencing this data table",
	"workflows.dependencies.modal.title": "Dependencies",
	"workflows.dependencies.modal.search": "Search dependencies...",
	"workflows.dependencies.type.credentials": "Credentials",
	"workflows.dependencies.type.dataTables": "Data Tables",
	"workflows.dependencies.type.errorWorkflow": "Error workflow",
	"workflows.dependencies.type.errorWorkflowParent": "Error handler for",
	"workflows.dependencies.type.subWorkflows": "Sub-workflows",
	"workflows.dependencies.type.parentWorkflows": "Used by workflows",
	"workflows.dependencies.search.placeholder": "Search...",
	"workflows.dependencies.search.empty": "No matching dependencies",
	"workflows.dependencies.hiddenNotice": "+1 not accessible to you | +{count} not accessible to you",
	"resourceDependents.tooltip": "Used by 1 workflow | Used by {count} workflows",
	"resourceDependents.modal.title": "Used by workflows",
	"resourceDependents.modal.search": "Search workflows...",
	"resourceDependents.type.workflows": "Workflows",
	"workflows.item.enableMCPAccess": "Enable MCP access",
	"workflows.item.disableMCPAccess": "Remove MCP access",
	"workflows.item.mcpDisabledByInstance": "Instance-level MCP is disabled. Ask an admin to enable it.",
	"workflows.itemSuggestion.try": "Try template",
	"workflows.templateRecoV2.starterTemplates": "Starter templates",
	"workflows.templateRecoV2.seeMoreStarterTemplates": "See more starter templates",
	"workflows.templateRecoV2.popularTemplates": "Popular templates",
	"workflows.templateRecoV2.seeMorePopularTemplates": "See more popular templates",
	"workflows.templateRecoV2.tutorials": "Tutorials",
	"workflows.templateRecoV2.loadingTemplates": "Loading templates...",
	"workflows.templateRecoV2.useTemplate": "Use template",
	"workflows.templateRecoV2.exploreTemplates": "Or explore templates to get inspired and learn fast:",
	"templates.featured.loading": "Loading templates...",
	"workflows.search.placeholder": "Search",
	"workflows.filters": "Filters",
	"workflows.filters.tags": "Tags",
	"workflows.filters.status": "Status",
	"workflows.filters.status.all": "All",
	"workflows.filters.status.active": "Published",
	"workflows.filters.status.deactivated": "Unpublished",
	"workflows.filters.showArchived": "Show archived workflows",
	"workflows.filters.ownedBy": "Owned by",
	"workflows.filters.sharedWith": "Shared with",
	"workflows.filters.apply": "Apply filters",
	"workflows.filters.reset": "Reset all",
	"workflows.filters.active": "Some workflows may be hidden since filters are applied.",
	"workflows.filters.active.shortText": "Filters are applied.",
	"workflows.filters.active.reset": "Remove filters",
	"workflows.sort.lastUpdated": "Sort by last updated",
	"workflows.sort.lastCreated": "Sort by last created",
	"workflows.sort.nameAsc": "Sort by name (A-Z)",
	"workflows.sort.nameDesc": "Sort by name (Z-A)",
	"workflows.noResults": "No workflows found",
	"workflows.noResults.withSearch.switchToShared.preamble": "some workflows may be",
	"workflows.noResults.withSearch.switchToShared.link": "hidden",
	"workflows.empty.onboarding.heading": "Let's build your first automation",
	"workflows.empty.list.heading": "Create your first automation",
	"workflows.empty.list.description": "Build multi-step automations connecting your apps and services",
	"workflows.empty.description.readOnlyEnv": "No workflows here yet",
	"workflows.empty.description.noPermission": "There are currently no workflows to view",
	"workflows.empty.browseTemplates": "Explore workflow templates",
	"workflows.empty.learnN8n": "Learn n8n",
	"workflows.empty.button.disabled.tooltip": "Your current role in the project does not allow you to create workflows",
	"workflows.empty.buildAgent": "Build an agent",
	"workflows.empty.buildWorkflow": "Build a workflow",
	"workflows.empty.easyAI": "Test a simple AI Agent example",
	"workflows.empty.tryAiWorkflow": "Run live demo",
	"workflows.empty.shared-with-me": "No {resource} has been shared with you",
	"workflows.empty.shared-with-me.link": "<a href=\"#\">Back to Personal</a>",
	"workflows.empty.readyToRun": "Run live demo",
	"workflows.list.easyAI": "Test the power of AI in n8n with this simple AI Agent Workflow",
	"workflows.list.error.fetching.one": "Error fetching workflow",
	"workflows.list.error.fetching": "Error fetching workflows",
	"workflows.list.error.fetching.emptyStateData": "Error fetching credentials, variables, and data tables",
	"workflows.shareModal.title": "Share '{name}'",
	"workflows.shareModal.title.static": "Shared with {projectName}",
	"workflows.shareModal.select.placeholder": "Add users...",
	"workflows.shareModel.select.notFound": "No matching users",
	"workflows.shareModal.list.delete": "Remove access",
	"workflows.shareModal.list.delete.confirm.title": "Remove {name}'s access?",
	"workflows.shareModal.list.delete.confirm.lastUserWithAccessToCredentials.message": "If you do this, the workflow will lose access to {name}’s credentials. <strong>Nodes that use those credentials will stop working</strong>.",
	"workflows.shareModal.list.delete.confirm.confirmButtonText": "Remove access",
	"workflows.shareModal.list.delete.confirm.cancelButtonText": "Cancel",
	"workflows.shareModal.onSave.success.title": "Sharing updated",
	"workflows.shareModal.onSave.error.title": "There was a problem saving sharing settings",
	"workflows.shareModal.saveBeforeClose.title": "Save sharing changes?",
	"workflows.shareModal.saveBeforeClose.message": "You have unsaved changes. Do you want to save them before closing?",
	"workflows.shareModal.saveBeforeClose.confirmButtonText": "Save",
	"workflows.shareModal.saveBeforeClose.cancelButtonText": "Close without saving",
	"workflows.shareModal.save": "Save",
	"workflows.shareModal.changesHint": "You made changes",
	"workflows.shareModal.info.sharee": "Only {workflowOwnerName} or users with workflow sharing permission can change who this workflow is shared with",
	"workflows.shareModal.info.sharee.fallback": "the owner",
	"workflows.shareModal.info.members": "This workflow is owned by the {projectName} project which currently has {members} with access to this workflow.",
	"workflows.shareModal.info.members.number": "{number} member | {number} members",
	"workflows.shareModal.info.personalSpaceRestricted": "Sharing is disabled in personal spaces. Move the workflow to a team project to share",
	"workflows.shareModal.role.editor": "@:_reusableBaseText.roles.editor",
	"workflows.roles.editor": "@:_reusableBaseText.roles.editor",
	"workflows.concurrentChanges.confirmMessage.title": "Workflow was changed by someone else",
	"workflows.concurrentChanges.confirmMessage.message": "Someone saved this workflow while you were editing it. You can <a href=\"{url}\" target=\"_blank\">view their version</a> (in new tab).<br/><br/>Overwrite their changes with yours?",
	"workflows.concurrentChanges.confirmMessage.cancelButtonText": "Cancel",
	"workflows.concurrentChanges.confirmMessage.confirmButtonText": "Overwrite and Save",
	"workflows.remoteUpdateBlocked.title": "Workflow updated elsewhere",
	"workflows.remoteUpdateBlocked.message": "This workflow was updated in another tab or by another user. We kept your unsaved changes, so the latest version was not applied here. Save to overwrite, or reload to get the latest version.",
	"workflows.autodeactivated": "Workflow auto-deactivated",
	"workflows.ai.starter.collection.callout": "Learn how to build AI Agents in n8n",
	"workflows.ai.starter.collection.card": "Learn how to build AI Agents",
	"workflows.ai.starter.collection.folder.name": "🎁 n8n basics: Learn how to build Agents in n8n",
	"workflows.ai.starter.collection.error": "Error loading AI Agent starter collection. Please try again later.",
	"workflows.readyToRunWorkflows.card": "Try a workflow - no setup neeeded",
	"workflows.readyToRunWorkflows.card2": "Run a workflow",
	"workflows.readyToRunWorkflows.card3": "See n8n in action",
	"workflows.readyToRunWorkflows.callout": "See n8n in action - no setup needed",
	"workflows.readyToRunWorkflows.callout2": "Run a workflow",
	"workflows.readyToRunWorkflows.callout3": "See n8n in action",
	"workflows.readyToRunWorkflows.cta": "Run a workflow",
	"workflows.readyToRunWorkflows.folder.name": "🚀 Ready-to-run workflows",
	"workflows.readyToRunWorkflows.error": "Error loading n8n collection. Please try again later.",
	"workflows.archivedOnly.hint": "Archived workflows are hidden in this view. {link}",
	"workflows.archivedOnly.hint.link": "Update filters",
	"workflowSelectorParameterInput.createNewSubworkflow.name": "My Sub-Workflow",
	"workflows.publishModal.title": "Publish workflow",
	"workflows.publishModal.noTriggerMessage": "This workflow has no trigger nodes that require publishing",
	"workflows.publishModal.versionNameLabel": "Version name",
	"workflows.publishModal.descriptionPlaceholder": "Describe changes (optional)",
	"workflows.publishModal.noChanges": "No changes to publish",
	"workflows.publishModal.reattempt": "Re-publishing will retry the triggers that failed to activate.",
	"workflows.publishModal.changes": "New changes to publish",
	"workflows.publishModal.lastPublished": "Last published by {author}, {date} at {time}",
	"importCurlModal.title": "Import cURL command",
	"importCurlModal.input.label": "cURL Command",
	"importCurlModal.input.placeholder": "Paste the cURL command here",
	"ImportCurlModal.notice.content": "This will overwrite any changes you have already made to the current node",
	"importCurlModal.button.label": "Import",
	"importCurlParameter.label": "Import cURL",
	"importCurlParameter.showError.failedToLoad.title": "Failed to load dependencies",
	"importCurlParameter.showError.failedToLoad.message": "There was an error loading required dependencies.",
	"importCurlParameter.showError.invalidCurlCommand.title": "Couldn’t import cURL command",
	"importCurlParameter.showError.invalidCurlCommand.message": "This command is in an unsupported format",
	"importCurlParameter.showError.invalidProtocol1.title": "Use the {node} node",
	"importCurlParameter.showError.invalidProtocol2.title": "Invalid Protocol",
	"importCurlParameter.showError.invalidProtocol.message": "The HTTP node doesn’t support {protocol} requests",
	"variables.heading": "Variables",
	"variables.add": "Add variable",
	"variables.add.unavailable": "Upgrade plan to keep using variables",
	"variables.add.unavailable.empty": "Upgrade plan to start using variables",
	"variables.add.onlyOwnerCanCreate": "Only owner can create variables",
	"variables.add.button.label": "Create variable",
	"variables.empty.heading": "Create your first variable",
	"variables.empty.description": "Store values you can reference across all your workflows",
	"variables.empty.button.disabled.tooltip": "Your current role in the project does not allow you to create variables",
	"variables.empty.notAllowedToCreate.heading": "{name}, start using variables",
	"variables.empty.notAllowedToCreate.description": "Ask project editors or instance admin to create the variables you need. Once configured, you can utilize them in your workflows using the syntax $vars.MY_VAR.",
	"variables.filters.active": "Some variables may be hidden since filters are applied.",
	"variables.filters.active.reset": "Remove filters",
	"variables.noResults": "No variables found",
	"variables.sort.nameAsc": "Sort by name (A-Z)",
	"variables.sort.nameDesc": "Sort by name (Z-A)",
	"variables.table.key": "Key",
	"variables.table.value": "Value",
	"variables.table.usage": "Usage Syntax",
	"variables.table.scope": "Scope",
	"variables.table.scope.global": "Global",
	"variables.editing.key.placeholder": "Enter a name",
	"variables.editing.value.placeholder": "Enter a value",
	"variables.editing.key.error.regex": "This field may contain only letters, numbers, and underscores",
	"variables.editing.key.error.regex-no-start-with-number": "The key cannot start with a number",
	"variables.row.button.save": "Save",
	"variables.row.button.cancel": "Cancel",
	"variables.row.button.edit": "Edit",
	"variables.row.button.edit.onlyRoleCanEdit": "Only instance owner and admins can edit variables",
	"variables.row.button.delete": "Delete",
	"variables.row.button.delete.onlyRoleCanDelete": "Only instance owner and can delete variables",
	"variables.row.usage.copiedToClipboard": "Copied to clipboard",
	"variables.row.usage.copyToClipboard": "Copy to clipboard",
	"variables.search.placeholder": "Search variables...",
	"variables.delete.successful.message": "Variable {variableName} deleted",
	"variables.errors.save": "Error while saving variable",
	"variables.errors.delete": "Error while deleting variable",
	"variables.modals.deleteConfirm.title": "Delete variable",
	"variables.modals.deleteConfirm.message": "Are you sure you want to delete the variable \"{name}\"? This cannot be undone.",
	"variables.modals.deleteConfirm.confirmButton": "Delete",
	"variables.modals.deleteConfirm.cancelButton": "Cancel",
	"variables.modal.title.create": "New variable",
	"variables.modal.title.edit": "Edit variable",
	"variables.modal.key.label": "Key",
	"variables.modal.value.label": "Value",
	"variables.modal.scope.label": "Scope",
	"variables.modal.scope.global": "Global",
	"variables.modal.scope.all": "All",
	"variables.modal.button.cancel": "Cancel",
	"variables.modal.button.save": "Save",
	"variables.modal.error.keyExistsInProject": "The key already exists in this project",
	"variables.modal.warning.globalKeyExists": "The same key already exists in global scope. This variable will override the global variable inside the project",
	"contextual.credentials.sharing.unavailable.title": "Upgrade to collaborate",
	"contextual.credentials.sharing.unavailable.title.cloud": "Upgrade to collaborate",
	"contextual.credentials.sharing.unavailable.description": "You can share credentials with others when you upgrade your plan.",
	"contextual.credentials.sharing.unavailable.description.cloud": "You can share credentials with others when you upgrade your plan.",
	"contextual.credentials.sharing.unavailable.button": "View plans",
	"contextual.credentials.sharing.unavailable.button.cloud": "Upgrade now",
	"contextual.workflows.sharing.title": "Sharing",
	"contextual.workflows.sharing.unavailable.title": "Sharing",
	"contextual.workflows.sharing.unavailable.title.cloud": "Upgrade to collaborate",
	"contextual.workflows.sharing.unavailable.description.modal": "You can collaborate with others on workflows when you upgrade your plan.",
	"contextual.workflows.sharing.unavailable.description.modal.cloud": "You can collaborate with others on workflows when you upgrade your plan.",
	"contextual.workflows.sharing.unavailable.description.tooltip": "You can collaborate with others on workflows when you upgrade your plan. {action}",
	"contextual.workflows.sharing.unavailable.description.tooltip.cloud": "You can collaborate with others on workflows when you upgrade your plan. {action}",
	"contextual.workflows.sharing.unavailable.button": "View plans",
	"contextual.workflows.sharing.unavailable.button.cloud": "Upgrade now",
	"contextual.variables.unavailable.title": "Upgrade to unlock variables",
	"contextual.variables.unavailable.title.cloud": "Available on Pro plan",
	"contextual.variables.unavailable.description": "Variables can be used to store and access data across workflows. Reference them in n8n using the prefix <code>$vars</code> (e.g. <code>$vars.myVariable</code>). Variables are immutable and cannot be modified within your workflows.<br/><a href=\"https://docs.n8n.io/code/variables/\" target=\"_blank\">Learn more in the docs.</a>",
	"contextual.variables.unavailable.button": "View plans",
	"contextual.variables.unavailable.button.cloud": "Upgrade now",
	"contextual.users.settings.unavailable.title": "Upgrade to add users",
	"contextual.users.settings.unavailable.title.cloud": "Upgrade to add users",
	"contextual.users.settings.unavailable.description": "Create multiple users on our higher plans and share workflows and credentials to collaborate",
	"contextual.users.settings.unavailable.description.cloud": "Create multiple users on our higher plans and share workflows and credentials to collaborate",
	"contextual.users.settings.unavailable.button": "View plans",
	"contextual.users.settings.unavailable.button.cloud": "Upgrade now",
	"contextual.feature.unavailable.title": "Available on the Enterprise Plan",
	"contextual.feature.unavailable.title.cloud": "Available on the Pro Plan",
	"dataTable.dataTables": "Data tables",
	"dataTables.noResults": "No data tables found",
	"dataTable.empty.heading": "Create your first data table",
	"dataTable.empty.description": "Use data tables to persist execution results, share data between workflows, and track metrics for evaluation",
	"dataTable.empty.button.disabled.tooltip": "Your current role in the project does not allow you to create data tables",
	"dataTable.card.size": "{size}MB",
	"dataTable.card.column.count": "{count} column | {count} columns",
	"dataTable.add.title": "Create new data table",
	"dataTable.add.button.label": "Create data table",
	"dataTable.add.fromScratch": "From scratch",
	"dataTable.add.importCsv": "Import CSV",
	"dataTable.add.input.name.label": "Data table name",
	"dataTable.add.input.name.placeholder": "Enter data table name",
	"dataTable.add.error": "Error creating data table",
	"dataTable.delete.confirm.title": "Delete data table",
	"dataTable.upload.uploading": "Uploading and processing CSV file...",
	"dataTable.upload.selectFile": "Waiting for file selection...",
	"dataTable.upload.dropOrClick": "Drop file here or click to upload",
	"dataTable.upload.csvOnly": "CSV files only",
	"dataTable.upload.hasHeaders": "My CSV file contains a header row",
	"dataTable.upload.uploadButton": "Upload CSV",
	"dataTable.upload.success": "'{fileName}' has been uploaded successfully. We found {columnCount} column and {rowCount} row | '{fileName}' has been uploaded successfully. We found {columnCount} columns and {rowCount} rows",
	"dataTable.upload.error": "Error uploading CSV file",
	"dataTable.import.columnsFound": "Columns found",
	"dataTable.import.columnName": "Column Name",
	"dataTable.import.columnsDescription": "Review and adjust the column names and types detected from your CSV file",
	"dataTable.import.columnType": "Data Type",
	"dataTable.import.columnNamePlaceholder": "Enter column name",
	"dataTable.import.duplicateColumnName": "Column name must be unique",
	"dataTable.import.systemColumnName": "{columnName} is a reserved column",
	"dataTable.import.includeColumn": "Include",
	"dataTable.import.invalidColumnName": "Only alphabetical and non-leading numbers and underscores allowed",
	"dataTable.delete.confirm.message": "Are you sure you want to delete the data table '{name}'? This action cannot be undone.",
	"dataTable.delete.error": "Error deleting data table",
	"dataTable.download.csv": "Download CSV",
	"dataTable.download.error": "Failed to download data table",
	"dataTable.download.modal.title": "Download CSV",
	"dataTable.download.modal.includeSystemColumns": "Include system columns (id, createdAt, updatedAt)",
	"dataTable.download.modal.confirm": "Download",
	"dataTable.download.modal.cancel": "Cancel",
	"dataTable.importCsv": "Import CSV",
	"dataTable.importCsv.title": "Import CSV to data table",
	"dataTable.importCsv.description": "Column names must match the table's column names. System columns (id, createdAt, updatedAt) found in CSV will be ignored.",
	"dataTable.importCsv.columnMismatch": "The following CSV columns do not match the table: {unrecognized}. The following table columns are missing from CSV: {missing}.",
	"dataTable.importCsv.unrecognizedColumnsOnly": "The following CSV columns do not match the table: {columns}. Remove them and try again.",
	"dataTable.importCsv.missingColumnsOnly": "The following table columns are missing from CSV and will be set to null: {columns}.",
	"dataTable.importCsv.noMatchingColumns": "No matching columns found. CSV column names must exactly match the table's column names.",
	"dataTable.importCsv.readyToImport": "Ready to import {count} row | Ready to import {count} rows",
	"dataTable.importCsv.success": "Successfully imported {count} row | Successfully imported {count} rows",
	"dataTable.importCsv.error": "Failed to import CSV",
	"dataTable.importCsv.importButton": "Import",
	"dataTable.rename.error": "Error renaming data table",
	"dataTable.getDetails.error": "Error fetching data table details",
	"dataTable.notFound": "Data table not found",
	"dataTable.noColumns.heading": "No columns yet",
	"dataTable.noColumns.description": "Add columns to start storing data in this data table.",
	"dataTable.noColumns.button.label": "Add first column",
	"dataTable.addColumn.label": "Add Column",
	"dataTable.addColumn.nameInput.label": "@:_reusableBaseText.name",
	"dataTable.addColumn.nameInput.placeholder": "Enter column name",
	"dataTable.addColumn.typeInput.label": "@:_reusableBaseText.type",
	"dataTable.addColumn.error": "Error adding column",
	"dataTable.column.alreadyExistsError": "This column already exists",
	"dataTable.moveColumn.error": "Error moving column",
	"dataTable.deleteColumn.error": "Error deleting column",
	"dataTable.deleteColumn.confirm.title": "Delete column",
	"dataTable.deleteColumn.confirm.message": "Are you sure you want to delete the column '{name}'? This action cannot be undone.",
	"dataTable.addColumn.invalidName.error": "Invalid column name",
	"dataTable.addColumn.invalidName.description": "Column names must begin with a letter and can only include letters, numbers, or underscores",
	"dataTable.filterColumn": "Filter column",
	"dataTable.renameColumn.label": "Rename column",
	"dataTable.renameColumn.error": "Error renaming column",
	"dataTable.fetchContent.error": "Error fetching data table content",
	"dataTable.addRow.label": "Add Row",
	"dataTable.addRow.error": "Error adding row",
	"dataTable.updateRow.error": "Error updating row",
	"dataTable.updateRow.numberPrecisionWarning.title": "Number precision may be lost",
	"dataTable.updateRow.numberPrecisionWarning.message": "Values above 9,007,199,254,740,991 can lose precision. Store large numbers as text if you need exact values.",
	"dataTable.deleteRows.title": "Delete Rows",
	"dataTable.deleteRows.confirmation": "Are you sure you want to delete {count} row? | Are you sure you want to delete {count} rows?",
	"dataTable.deleteRows.error": "Error deleting rows",
	"dataTable.banner.storageLimitWarning.message": "{usage} of data tables storage used. Delete data to avoid errors",
	"dataTable.banner.storageLimitError.message": "{usage} of data tables storage used, operations may fail. Delete data to avoid errors",
	"dataTable.error.tableNotInitialized": "Table not initialized",
	"dataTable.noRows": "No rows",
	"dataTable.filters.isNull": "Is null",
	"dataTable.filters.isNotNull": "Is not null",
	"dataTable.filters.isEmpty": "Is empty",
	"dataTable.filters.isNotEmpty": "Is not empty",
	"dataTable.filters.between": "Between",
	"dataTable.filters.true": "True",
	"dataTable.filters.false": "False",
	"dataTable.filters.greaterThan": "Greater than",
	"dataTable.filters.greaterThanOrEqual": "Greater than or equal",
	"dataTable.filters.lessThan": "Less than",
	"dataTable.filters.lessThanOrEqual": "Less than or equal",
	"dataTable.addColumn.systemColumnDescription": "This is a system column, choose a different name",
	"dataTable.addColumn.alreadyExistsDescription": "Column name already exists, choose a different name",
	"dataTable.addColumn.testingColumnDescription": "This column is used for testing, choose a different name",
	"dataTable.search.placeholder": "Search",
	"dataTable.sort.sizeDesc": "Sort by largest",
	"dataTable.sort.sizeAsc": "Sort by smallest",
	"dataTable.sort.nameAsc": "Sort by name (A-Z)",
	"dataTable.sort.nameDesc": "Sort by name (Z-A)",
	"dataTable.sort.lastUpdated": "Sort by last updated",
	"dataTable.sort.lastCreated": "Sort by last created",
	"dataTable.noResults": "No data tables found",
	"settings.ai": "AI Usage",
	"settings.ai.description.both": "Control what n8n sends when using the AI Assistant and AI Builder",
	"settings.ai.description.assistantOnly": "Manage how n8n uses your data to improve our AI features. These settings only apply to <b>AI Assistant Chat</b> feature.",
	"settings.ai.description.askAiOnly": "Manage how n8n uses your data to improve our AI features. These settings only apply to <b>Ask AI in the Code node</b> feature.",
	"settings.ai.button.tooltip": "AI usage settings",
	"settings.ai.allowSendingSchema.label": "Send field names and types (schema)",
	"settings.ai.allowSendingSchema.description": "Allow n8n to send key names and types of your data. This helps AI understand your data structure without sending values.",
	"settings.ai.allowSendingParameterValues.label": "Send actual data values",
	"settings.ai.allowSendingParameterValues.description": "Allow n8n to send real values from your executions which may include sensitive data. Turning this off reduces the accuracy of the AI Assistant and disables AI Workflow Builder.",
	"settings.ai.privacyNote.heading": "Privacy Note:",
	"settings.ai.privacyNote.content": "Your data is processed securely and is not used to train our models. These settings will help improve AI accuracy and provide context-aware responses. You can learn more <a href=\"{docsLink}\" target=\"_blank\">here</a>.",
	"settings.ai.updated.success": "AI settings updated",
	"settings.ai.updated.error": "There was a problem updating AI settings",
	"settings.ai.confirm.title": "Stop sending data to AI?",
	"settings.ai.confirm.message.builderDisabled": "Disabling data sending will reduce the effectiveness of AI features. Are you sure you want to proceed?",
	"settings.ai.confirm.message.builderEnabled": "Disabling data sending will turn off the AI Workflow Builder and reduce the effectiveness of AI features. Are you sure you want to proceed?",
	"settings.ai.confirm.confirmButtonText": "Yes, disable",
	"settings.n8nConnect": "n8n Connect",
	"settings.n8nConnect.title": "n8n Connect",
	"settings.n8nConnect.description": "The easy way to manage AI usage and cost",
	"settings.n8nConnect.usage.title": "Usage",
	"settings.n8nConnect.usage.refresh": "Refresh",
	"settings.n8nConnect.usage.col.date": "Date",
	"settings.n8nConnect.usage.col.provider": "Provider",
	"settings.n8nConnect.usage.col.resource": "Resource",
	"settings.n8nConnect.usage.col.inputTokens": "Input Tokens",
	"settings.n8nConnect.usage.col.outputTokens": "Output Tokens",
	"settings.n8nConnect.usage.col.cost": "Cost (USD)",
	"settings.n8nConnect.usage.empty": "No usage records found.",
	"settings.n8nConnect.usage.loadMore": "Load more",
	"settings.n8nConnect.usage.openExecution": "Open execution",
	"settings.n8nConnect.wallet.title": "Balance",
	"settings.n8nConnect.wallet.remaining": "${remaining} / ${budget} remaining",
	"settings.n8nConnect.wallet.quota": "budget",
	"settings.n8nConnect.wallet.topUp": "Top up balance",
	"settings.n8nConnect.usage.refresh.tooltip": "Refresh usage records",
	"settings.n8nAgent": "AI Assistant",
	"settings.n8nAgent.description": "Enable or disable AI Assistant for this instance and control permissions",
	"settings.agentBuilder.title": "Agents",
	"settings.agentBuilder.description": "Choose which model the agent builder runs on. By default it uses the n8n AI assistant; admins can switch to a custom provider and credential.",
	"settings.agentBuilder.section.model": "Builder model",
	"settings.agentBuilder.section.help": "The agent builder is the AI that helps users design and configure agents. This setting controls which LLM that builder runs on.",
	"settings.agentBuilder.mode.default.label": "Use n8n AI",
	"settings.agentBuilder.mode.custom.label": "Use custom provider",
	"settings.agentBuilder.proxyDisabledTooltip": "n8n AI requires an active license and the N8N_AI_ASSISTANT_BASE_URL setting. Pick a custom provider to use the builder on this instance.",
	"settings.agentBuilder.status.proxy": "Builder will use the n8n AI assistant ({model}).",
	"settings.agentBuilder.status.envVar": "Builder will use the N8N_AI_ANTHROPIC_KEY environment variable as a fallback. Configure a credential to make this setup explicit.",
	"settings.agentBuilder.status.custom": "Builder will use {provider}/{model} via the selected credential.",
	"settings.agentBuilder.status.customIncomplete": "Pick a provider and credential to finish setup.",
	"settings.agentBuilder.missingCredential.title": "Credential required",
	"settings.agentBuilder.missingCredential.message": "Pick a credential for this provider before saving.",
	"settings.agentBuilder.saved": "Agent builder settings saved",
	"settings.agentBuilder.saveError": "Could not save agent builder settings",
	"settings.agentBuilder.loadError": "Could not load agent builder settings",
	"agents.modelSelector.defaultLabel": "Select model",
	"agents.modelSelector.noMatch": "No models found",
	"agents.modelSelector.noModels": "No models available for this provider",
	"agents.modelSelector.moreModels": "More {provider} models",
	"agents.modelSelector.configureCredentials": "Configure credentials",
	"agents.modelSelector.credentialsMissing": "Credentials missing",
	"agents.modelSelector.freeCredits.label": "Use free OpenAI credits",
	"agents.modelSelector.freeCredits.badge": "free credits",
	"agents.modelSelector.freeCredits.description": "Get {credits} free OpenAI API credits. Try it with gpt-5-mini.",
	"settings.n8nAgent.enable.label": "Enable AI Assistant",
	"settings.n8nAgent.enable.description": "Enables the feature for all users in the instance",
	"settings.n8nAgent.computerUse.label": "Enable Computer Use for AI Assistant",
	"settings.n8nAgent.computerUse.description": "Allows users on this instance to connect AI Assistant to their computer to work with files and the browser",
	"settings.n8nAgent.computerUse.disabled.warning": "Computer use has been disabled by your administrator",
	"settings.n8nAgent.browserUse.label": "Enable Browser Use for AI Assistant",
	"settings.n8nAgent.browserUse.description": "Allows users on this instance to connect AI Assistant to their browser to view pages and automate tasks",
	"settings.n8nAgent.mcpAccess.label": "Allow users to extend AI Assistant with MCP Servers",
	"settings.n8nAgent.mcpAccess.description": "Allows users on this instance to connect AI Assistant to MCP servers from the registry",
	"settings.n8nAgent.permissions.title": "Permissions",
	"settings.n8nAgent.permissions.description": "Control which actions need approval before agent executes them. These settings don't grant users any extra permissions",
	"settings.n8nAgent.permissions.alwaysAllow": "Always allow",
	"settings.n8nAgent.permissions.needsApproval": "Needs approval",
	"settings.n8nAgent.permissions.blocked": "Blocked",
	"settings.n8nAgent.permissions.createWorkflow": "Create workflows",
	"settings.n8nAgent.permissions.updateWorkflow": "Update workflows",
	"settings.n8nAgent.permissions.runWorkflow": "Run workflows",
	"settings.n8nAgent.permissions.publishWorkflow": "Activate workflows",
	"settings.n8nAgent.permissions.deleteWorkflow": "Delete workflows",
	"settings.n8nAgent.permissions.deleteCredential": "Delete credentials",
	"settings.n8nAgent.permissions.createFolder": "Create folders",
	"settings.n8nAgent.permissions.deleteFolder": "Delete folders",
	"settings.n8nAgent.permissions.moveWorkflowToFolder": "Move workflows to folders",
	"settings.n8nAgent.permissions.tagWorkflow": "Tag workflows",
	"settings.n8nAgent.permissions.createDataTable": "Create data tables",
	"settings.n8nAgent.permissions.mutateDataTableSchema": "Modify data table schema",
	"settings.n8nAgent.permissions.mutateDataTableRows": "Modify data table rows",
	"settings.n8nAgent.permissions.cleanupTestExecutions": "Clean up test executions",
	"settings.n8nAgent.permissions.readFilesystem": "Read filesystem",
	"settings.n8nAgent.permissions.fetchUrl": "Fetch URLs",
	"settings.n8nAgent.permissions.webSearch": "Search the web",
	"settings.n8nAgent.permissions.restoreWorkflowVersion": "Restore workflow versions",
	"settings.n8nAgent.permissions.executeMcpTool": "Execute MCP tools",
	"dataTable.search.dateSearchInfo": "Date searches use UTC format, while the table displays dates in your local timezone",
	"dataTable.cell.oversized": "Value too large to display",
	"dataTable.cell.oversized.tooltip": "The value can be modified using the data table node",
	"settings.ldap": "LDAP",
	"settings.ldap.note": "LDAP allows users to authenticate with their centralized account. It's compatible with services that provide an LDAP interface like Active Directory, Okta and Jumpcloud.",
	"settings.ldap.infoTip": "Learn more about <a href='https://docs.n8n.io/user-management/ldap/' target='_blank'>LDAP in the Docs</a>",
	"settings.ldap.save": "Save connection",
	"settings.ldap.connectionTestError": "Problem testing LDAP connection",
	"settings.ldap.connectionTest": "LDAP connection tested",
	"settings.ldap.runSync.title": "LDAP synchronization done",
	"settings.ldap.runSync.showError.message": "Problem during synchronization. Check the logs",
	"settings.ldap.updateConfiguration": "LDAP configuration updated",
	"settings.ldap.testingConnection": "Testing connection",
	"settings.ldap.testConnection": "Test connection",
	"settings.ldap.synchronizationTable.column.status": "Status",
	"settings.ldap.synchronizationTable.column.endedAt": "Ended At",
	"settings.ldap.synchronizationTable.column.runMode": "Run Mode",
	"settings.ldap.synchronizationTable.column.runTime": "Run Time",
	"settings.ldap.synchronizationTable.column.details": "Details",
	"settings.ldap.synchronizationTable.empty.message": "Test synchronization to preview updates",
	"settings.ldap.dryRun": "Test synchronization",
	"settings.ldap.synchronizeNow": "Run synchronization",
	"settings.ldap.synchronizationError": "LDAP Synchronization Error",
	"settings.ldap.configurationError": "LDAP Configuration Error",
	"settings.ldap.usersScanned": "Users scanned {scanned}",
	"settings.ldap.confirmMessage.beforeSaveForm.cancelButtonText": "No",
	"settings.ldap.confirmMessage.beforeSaveForm.confirmButtonText": "Yes, disable it",
	"settings.ldap.confirmMessage.beforeSaveForm.headline": "Are you sure you want to disable LDAP login?",
	"settings.ldap.confirmMessage.beforeSaveForm.message": "If you do so, all LDAP users will be converted to email users.",
	"settings.ldap.disabled.title": "Available on the Enterprise plan",
	"settings.ldap.disabled.description": "LDAP is available as a paid feature. Learn more about it.",
	"settings.ldap.disabled.buttonText": "See plans",
	"settings.ldap.toast.sync.success": "Synchronization succeeded",
	"settings.ldap.toast.connection.success": "Connection succeeded",
	"settings.ldap.form.loginEnabled.label": "Enable LDAP Login",
	"settings.ldap.form.loginEnabled.tooltip": "Connection settings and data will still be saved if you disable LDAP Login",
	"settings.ldap.form.loginLabel.label": "LDAP Login",
	"settings.ldap.form.loginLabel.placeholder": "e.g. LDAP Username or email address",
	"settings.ldap.form.loginLabel.infoText": "The placeholder text that appears in the login field on the login page",
	"settings.ldap.form.serverAddress.label": "LDAP Server Address",
	"settings.ldap.form.serverAddress.placeholder": "123.123.123.123",
	"settings.ldap.form.serverAddress.infoText": "IP or domain of the LDAP server",
	"settings.ldap.form.port.label": "LDAP Server Port",
	"settings.ldap.form.port.infoText": "Port used to connect to the LDAP server",
	"settings.ldap.form.connectionSecurity.label": "Connection Security",
	"settings.ldap.form.connectionSecurity.infoText": "Type of connection security",
	"settings.ldap.form.allowUnauthorizedCerts.label": "Ignore SSL/TLS Issues",
	"settings.ldap.form.baseDn.label": "Base DN",
	"settings.ldap.form.baseDn.placeholder": "o=acme,dc=example,dc=com",
	"settings.ldap.form.baseDn.infoText": "Distinguished Name of the location where n8n should start its search for user in the AD/LDAP tree",
	"settings.ldap.form.bindingType.label": "Binding as",
	"settings.ldap.form.bindingType.infoText": "Type of binding used to connection to the LDAP server",
	"settings.ldap.form.adminDn.label": "Binding DN",
	"settings.ldap.form.adminDn.placeholder": "uid=2da2de69435c,ou=Users,o=Acme,dc=com",
	"settings.ldap.form.adminDn.infoText": "Distinguished Name of the user to perform the search",
	"settings.ldap.form.adminPassword.label": "Binding Password",
	"settings.ldap.form.adminPassword.infoText": "Password of the user provided in the Binding DN field above",
	"settings.ldap.form.userFilter.label": "User Filter",
	"settings.ldap.form.userFilter.placeholder": "(ObjectClass=user)",
	"settings.ldap.form.userFilter.infoText": "LDAP query to use when searching for user. Only users returned by this filter will be allowed to sign-in in n8n",
	"settings.ldap.form.attributeMappingInfo.label": "Attribute mapping",
	"settings.ldap.form.ldapId.label": "ID",
	"settings.ldap.form.ldapId.placeholder": "uid",
	"settings.ldap.form.ldapId.infoText": "The attribute in the LDAP server used as a unique identifier in n8n. It should be an unique LDAP attribute like uid",
	"settings.ldap.form.loginId.label": "Login ID",
	"settings.ldap.form.loginId.placeholder": "mail",
	"settings.ldap.form.loginId.infoText": "The attribute in the LDAP server used to log-in in n8n",
	"settings.ldap.form.email.label": "Email",
	"settings.ldap.form.email.placeholder": "mail",
	"settings.ldap.form.email.infoText": "The attribute in the LDAP server used to populate the email in n8n",
	"settings.ldap.form.firstName.label": "First Name",
	"settings.ldap.form.firstName.placeholder": "givenName",
	"settings.ldap.form.firstName.infoText": "The attribute in the LDAP server used to populate the first name in n8n",
	"settings.ldap.form.lastName.label": "Last Name",
	"settings.ldap.form.lastName.placeholder": "sn",
	"settings.ldap.form.lastName.infoText": "The attribute in the LDAP server used to populate the last name in n8n",
	"settings.ldap.form.synchronizationEnabled.label": "Enable periodic LDAP synchronization",
	"settings.ldap.form.synchronizationEnabled.tooltip": "Enable users to be synchronized periodically",
	"settings.ldap.form.synchronizationInterval.label": "Synchronization Interval (Minutes)",
	"settings.ldap.form.synchronizationInterval.infoText": "How often the synchronization should run",
	"settings.ldap.form.pageSize.label": "Page Size",
	"settings.ldap.form.pageSize.infoText": "Max number of records to return per page during synchronization. 0 for unlimited",
	"settings.ldap.form.searchTimeout.label": "Search Timeout (Seconds)",
	"settings.ldap.form.searchTimeout.infoText": "The timeout value for queries to the AD/LDAP server. Increase if you are getting timeout errors caused by a slow AD/LDAP server",
	"settings.ldap.form.enforceEmailUniqueness.label": "Enforce Email Uniqueness",
	"settings.ldap.form.enforceEmailUniqueness.tooltip": "Prevents login if multiple LDAP accounts use the same email, blocking account linking attacks.",
	"settings.ldap.section.synchronization.title": "Synchronization",
	"settings.security": "Security & policies",
	"settings.security.description": "Manage workspace security requirements. Enforce two-factor authentication and control personal space actions like publishing workflows and sharing resources.",
	"settings.security.managedByEnv": "These security settings are configured via environment variables and cannot be changed here.",
	"settings.security.workflowReviews.title": "Workflow reviews",
	"settings.security.workflowReviews.description": "Require workflow versions to be submitted for review and approved before they can be published to production.",
	"settings.security.workflowReviews.enable.title": "Enable workflow reviews",
	"settings.security.workflowReviews.enable.description": "Enable the feature to be available on project level.",
	"settings.security.workflowReviews.success.enabled": "Workflow reviews enabled",
	"settings.security.workflowReviews.success.disabled": "Workflow reviews disabled",
	"settings.security.workflowReviews.error": "Failed to update workflow reviews settings",
	"settings.security.workflowReviews.confirmDisable.headline": "Disable workflow reviews",
	"settings.security.workflowReviews.confirmDisable.message": "Workflow reviews will no longer be available on this instance. Existing project-level review settings will be ignored.",
	"settings.security.personalSpace.title": "Personal Space",
	"settings.security.personalSpace.description": "Manage workflow publishing and sharing in personal spaces.",
	"settings.security.personalSpace.publishing.title": "Workflow publishing",
	"settings.security.personalSpace.publishing.description": "Publishing workflows in personal space. Changing the setting doesn't unpublish existing workflows.",
	"settings.security.personalSpace.publishing.success.enabled": "Workflow publishing enabled",
	"settings.security.personalSpace.publishing.success.disabled": "Workflow publishing disabled",
	"settings.security.personalSpace.publishing.error": "Failed to update publishing setting",
	"settings.security.personalSpace.publishing.confirmMessage.disable.headline": "Are you sure you want to disable publishing personal workflows?",
	"settings.security.personalSpace.publishing.confirmMessage.disable.message": "This will prevent all publish actions in personal spaces going forwards. Currently published workflows will remain published.",
	"settings.security.personalSpace.publishing.existingCount.label": "Existing published workflows",
	"settings.security.personalSpace.publishing.existingCount.value": "{count} workflows",
	"settings.security.personalSpace.sharing.title": "Sharing",
	"settings.security.personalSpace.sharing.description": "Sharing of workflows, credentials and other resources from personal space. Changing the setting doesn't revoke existing shares.",
	"settings.security.personalSpace.sharing.success.enabled": "Workflow and credential sharing enabled",
	"settings.security.personalSpace.sharing.success.disabled": "Workflow and credential sharing disabled",
	"settings.security.personalSpace.sharing.error": "Failed to update sharing setting",
	"settings.security.personalSpace.sharing.confirmMessage.disable.headline": "Are you sure you want to disable sharing in personal spaces?",
	"settings.security.personalSpace.sharing.confirmMessage.disable.message": "This will prevent sharing workflows and credentials from personal spaces going forwards. Existing shares will remain in place.",
	"settings.security.personalSpace.sharing.existingCount.label": "Existing shares",
	"settings.security.personalSpace.sharing.existingCount.value": "{workflowCount} workflows, {credentialCount} credentials",
	"settings.security.personalSpace.unlicensed_tooltip": "Upgrade to a plan that includes personal space policies to manage this setting. {action}",
	"settings.security.personalSpace.unlicensed_tooltip.link": "Upgrade now",
	"settings.security.dataRedaction.title": "Data redaction",
	"settings.security.dataRedaction.description": "Manage data redaction settings for your instance.",
	"settings.security.dataRedaction.enforce.title": "Enforce data redaction",
	"settings.security.dataRedaction.enforce.message": "Override workflow-level settings and enforce data redaction on all executions across the instance.",
	"settings.security.dataRedaction.enforce.message.docsLink": "Every account on the instance must enrol a second factor before they can sign in.",
	"settings.security.dataRedaction.enforce.success.enabled": "Data redaction enforced",
	"settings.security.dataRedaction.enforce.success.disabled": "Data redaction no longer enforced",
	"settings.security.dataRedaction.enforce.error": "Failed to update data redaction enforcement",
	"settings.security.dataRedaction.enforce.confirmEnable.headline": "Enable data redaction enforcement",
	"settings.security.dataRedaction.enforce.confirmEnable.message": "Redact execution data for production executions, or manual and production executions. This will apply to all workflows. Users with the manage data redaction permission cannot disable or reduce redaction below this level. New workflows will also inherit this setting.",
	"settings.security.dataRedaction.enforce.confirmEnable.action": "Enable",
	"settings.security.dataRedaction.enforce.confirmDisable.headline": "Disable data redaction enforcement",
	"settings.security.dataRedaction.enforce.confirmDisable.message": "Redaction will no longer be enforced across this instance. Workflows will fall back to their own redaction settings. Users with the manage data redaction permission will be able to adjust those settings.",
	"settings.security.dataRedaction.enforce.confirmDisable.action": "Disable",
	"settings.security.dataRedaction.scope.title": "Redact executions",
	"settings.security.dataRedaction.scope.description": "Select whether to redact production executions, or manual and production executions.",
	"settings.security.dataRedaction.scope.option.manual-only": "Manual executions",
	"settings.security.dataRedaction.scope.option.non-manual": "Production executions (Recommended)",
	"settings.security.dataRedaction.scope.option.all": "Manual and production executions",
	"settings.security.dataRedaction.scope.success": "Redaction scope updated",
	"settings.security.dataRedaction.scope.error": "Failed to update redaction scope",
	"settings.security.dataRedaction.affectedScope.label": "Affected scope",
	"settings.security.dataRedaction.affectedScope.none": "No executions",
	"settings.security.dataRedaction.affectedScope.manual-only": "Manual executions",
	"settings.security.dataRedaction.affectedScope.non-manual": "Production executions",
	"settings.security.dataRedaction.affectedScope.all": "Manual and production executions",
	"settings.security.dataRedaction.unlicensed_tooltip": "Upgrade to a plan that includes data redaction to manage this setting. {action}",
	"settings.security.dataRedaction.unlicensed_tooltip.link": "Upgrade now",
	"settings.encryptionKeys": "Data encryption keys",
	"settings.encryptionKeys.title": "Data encryption keys",
	"settings.encryptionKeys.description": "Data encryption keys protect credentials, variables, and other sensitive data at rest. Rotating generates a new active key. Past keys are archived and retained for audit.",
	"settings.encryptionKeys.description.docsLink": "Learn more in documentation",
	"settings.encryptionKeys.column.key": "Key",
	"settings.encryptionKeys.column.status": "Status",
	"settings.encryptionKeys.column.activated": "Activated",
	"settings.encryptionKeys.column.archived": "Archived",
	"settings.encryptionKeys.status.active": "Active",
	"settings.encryptionKeys.status.inactive": "Inactive",
	"settings.encryptionKeys.sortBy.label": "Sort by",
	"settings.encryptionKeys.sortBy.activated": "Activated",
	"settings.encryptionKeys.sortBy.archived": "Archived",
	"settings.encryptionKeys.sortBy.status": "Status",
	"settings.encryptionKeys.filter.title": "Filter",
	"settings.encryptionKeys.filter.dateRange": "Date range",
	"settings.encryptionKeys.filter.apply": "Apply",
	"settings.encryptionKeys.filter.clear": "Clear",
	"settings.encryptionKeys.rotate.button": "Rotate key",
	"settings.encryptionKeys.rotate.confirm.title": "Rotate encryption key?",
	"settings.encryptionKeys.rotate.confirm.body": "A new encryption key will be generated and used to encrypt new data. The previous key will be archived and kept to decrypt existing data.",
	"settings.encryptionKeys.rotate.confirm.action": "Rotate key",
	"settings.encryptionKeys.rotate.confirm.cancel": "Cancel",
	"settings.encryptionKeys.rotate.success": "Encryption key rotated",
	"settings.encryptionKeys.rotate.error": "Could not rotate encryption key",
	"settings.encryptionKeys.empty.title": "No encryption keys yet",
	"settings.encryptionKeys.empty.description": "Rotate a key to generate your first active encryption key.",
	"settings.encryptionKeys.loadError": "Could not load encryption keys",
	"settings.sso": "SSO",
	"settings.sso.title": "Single Sign-On",
	"settings.sso.subtitle": "SAML 2.0 Configuration",
	"settings.sso.info": "Configure SSO to let your team sign in using your identity provider. Supports SAML 2.0 and OpenID Connect protocols. Learn more in the",
	"settings.sso.info.link": "documentation",
	"settings.sso.activated": "Enable Single Sign On",
	"settings.sso.settings.redirectUrl.label": "Redirect URL",
	"settings.sso.settings.redirectUrl.copied": "Redirect URL copied to clipboard",
	"settings.sso.settings.redirectUrl.help": "Copy the Redirect URL to configure your SAML provider",
	"settings.sso.settings.entityId.label": "Entity ID URL",
	"settings.sso.settings.entityId.copied": "Entity ID copied to clipboard",
	"settings.sso.settings.entityId.help": "Copy the Entity ID URL to configure your SAML provider",
	"settings.sso.settings.ips.label": "Identity Provider Settings",
	"settings.sso.settings.ips.xml.help": "Paste here the raw Metadata XML provided by your Identity Provider",
	"settings.sso.settings.ips.url.help": "Paste here the Identity Provider Metadata URL",
	"settings.sso.settings.ips.url.placeholder": "e.g. https://samltest.id/saml/idp",
	"settings.sso.settings.ips.url.invalid": "The Identity Provider Metadata URL is not valid",
	"settings.sso.settings.ips.options.url": "Metadata URL",
	"settings.sso.settings.ips.options.xml": "XML",
	"settings.sso.settings.oidc.prompt.none": "None (Silent authentication)",
	"settings.sso.settings.oidc.prompt.login": "Login (Force the user to log in)",
	"settings.sso.settings.oidc.prompt.consent": "Consent (Ask the user to consent)",
	"settings.sso.settings.oidc.prompt.select_account": "Select Account (Allow the user to select an account)",
	"settings.sso.settings.oidc.prompt.create": "Create (Ask the OP to show the registration page first)",
	"settings.sso.settings.roleAssignment.label": "Role assignment",
	"settings.sso.settings.roleAssignment.description": "Choose how roles are assigned to SSO users",
	"settings.sso.settings.roleAssignment.manual": "Assigned manually in n8n",
	"settings.sso.settings.roleAssignment.manual.description": "Admins assign roles to each user directly. No automatic role mapping from your IdP",
	"settings.sso.settings.roleAssignment.instanceRoles": "Instance roles via SSO",
	"settings.sso.settings.roleAssignment.instanceRoles.description": "Map IdP claims to n8n instance roles like Admin, Member, or custom roles",
	"settings.sso.settings.roleAssignment.instanceAndProjectRoles": "Instance and project roles via SSO",
	"settings.sso.settings.roleAssignment.instanceAndProjectRoles.description": "Map IdP claims to both instance roles and per-project access with specific roles",
	"settings.sso.settings.roleMappingMethod.label": "Role mapping method",
	"settings.sso.settings.roleMappingMethod.description": "Choose how SSO claims are mapped to n8n roles",
	"settings.sso.settings.roleMappingMethod.idp": "Map rules on your IdP",
	"settings.sso.settings.roleMappingMethod.idp.description": "Roles come directly from your IdP through claims. No rules needed.",
	"settings.sso.settings.roleMappingMethod.rulesInN8n": "Map rules inside n8n",
	"settings.sso.settings.roleMappingMethod.rulesInN8n.description": "Define rules in n8n to control how IdP claims translate to instance and project roles.",
	"settings.sso.settings.roleMappingMethod.idp.instanceInfo": "Instance roles come directly from your identity provider. Users receive whatever roles your IdP sends via SAML/OIDC claims — no mapping rules required.",
	"settings.sso.settings.roleMappingMethod.idp.instanceAndProjectInfo": "Both instance and project roles come directly from your identity provider. Users receive whatever roles your IdP sends via SAML/OIDC claims — no mapping rules required.",
	"settings.sso.settings.roleMappingMethod.idp.learnMore": "Learn more",
	"settings.sso.settings.roleMappingRules.instanceRules.title": "Instance role rules",
	"settings.sso.settings.roleMappingRules.instanceRules.description": "Define rules to assign instance roles based on IdP claims. First matching rule wins.",
	"settings.sso.settings.roleMappingRules.addRule": "Add rule",
	"settings.sso.settings.roleMappingRules.expression.placeholder": "$claims.groups.includes('admins')",
	"settings.sso.settings.authProtocol.label": "Authentication protocol",
	"settings.sso.settings.authProtocol.description": "Choose your SSO protocol",
	"settings.sso.settings.roleMappingRules.projectRules.title": "Project role rules",
	"settings.sso.settings.roleMappingRules.projectRules.description": "Define rules to assign project roles based on IdP claims. First matching rule wins.",
	"settings.sso.settings.roleMappingRules.removeMapping.button": "Remove mapping",
	"settings.sso.settings.roleMappingRules.removeMapping.confirm.title": "Remove mapping",
	"settings.sso.settings.roleMappingRules.removeMapping.confirm.message": "Are you sure you want to remove all role mapping rules? This action cannot be undone.",
	"settings.sso.settings.roleMappingRules.removeMapping.confirm.confirm": "Remove",
	"settings.sso.settings.roleMappingRules.removeMapping.confirm.cancel": "Cancel",
	"settings.sso.settings.ssoToggle.label": "Single sign-on (SSO)",
	"settings.sso.settings.ssoToggle.description": "Allow users to sign in through your identity provider",
	"settings.sso.settings.ssoToggle.enabled": "Enabled",
	"settings.sso.settings.ssoToggle.disabled": "Disabled",
	"settings.sso.settings.test": "Test connection",
	"settings.sso.settings.test.error": "Error testing OIDC SSO configuration",
	"settings.sso.settings.save": "Save settings",
	"settings.sso.settings.save.success": "SSO configuration saved",
	"settings.sso.settings.unsavedChanges.title": "Unsaved changes",
	"settings.sso.settings.unsavedChanges.message": "You have unsaved changes. They'll be lost if you leave.",
	"settings.sso.settings.unsavedChanges.saveAndLeave": "Save and leave",
	"settings.sso.settings.unsavedChanges.leaveWithoutSaving": "Leave without saving",
	"settings.sso.settings.unsavedChanges.keepEditing": "Keep editing",
	"settings.sso.settings.save.testConnection.title": "Test and activate SAML SSO",
	"settings.sso.settings.save.testConnection.message": "You are about to activate SSO via SAML. Test your SAML SSO settings first before proceeding.",
	"settings.sso.settings.save.testConnection.test": "Test settings",
	"settings.sso.settings.save.confirmTestConnection.title": "Confirm successful connection test",
	"settings.sso.settings.save.confirmTestConnection.message": "Was the connection test successful? Confirm to activate SSO via SAML.",
	"settings.sso.settings.save.confirmTestConnection.confirm": "Confirm",
	"settings.sso.settings.save.activate.cancel": "Cancel",
	"settings.sso.settings.save.error": "Error saving SAML SSO configuration",
	"settings.sso.settings.save.error_oidc": "Error saving OIDC SSO configuration",
	"settings.sso.settings.envConfigBanner": "SSO connection is configured via environment variables. To modify, update the environment variables and restart n8n.",
	"settings.sso.settings.envConfigBannerWithRules": "SSO connection is configured via environment variables. To change connection or role assignment settings, update the environment variables and restart n8n. Role mapping rules can still be edited below.",
	"settings.sso.actionBox.title": "Available on the Enterprise plan",
	"settings.sso.actionBox.description": "Use Single Sign On to consolidate authentication into a single platform to improve security and agility.",
	"settings.sso.actionBox.buttonText": "See plans",
	"settings.sso.confirmMessage.beforeSaveForm.headline": "Are you sure you want to disable {protocol} login?",
	"settings.sso.confirmMessage.beforeSaveForm.message": "If you do so, all {protocol} users will be converted to email users.",
	"settings.mfa.secret": "Secret {secret}",
	"settings.mfa": "MFA",
	"settings.mfa.title": "Multi-factor Authentication",
	"settings.mfa.updateConfiguration": "MFA configuration updated",
	"settings.mfa.invalidAuthenticatorCode": "Invalid authenticator code",
	"projects.header.overview.subtitle": "All the workflows, credentials and executions you have access to",
	"projects.header.overview.subtitleWithDataTables": "All the workflows, credentials and data tables you have access to",
	"projects.header.shared.title": "Shared with you",
	"projects.header.personal.subtitle": "Workflows and credentials owned by you",
	"projects.header.personal.subtitleWithDataTables": "Workflows, credentials and data tables owned by you",
	"projects.header.shared.subtitle": "Workflows and credentials other users have shared with you",
	"projects.header.create.workflow": "Create workflow",
	"projects.header.create.credential": "Create credential",
	"projects.header.create.agent": "Create agent",
	"projects.header.create.folder": "Create folder",
	"projects.create": "Create",
	"projects.create.personal": "Create in personal",
	"projects.create.team": "Create in project",
	"projects.menu.overview": "Overview",
	"projects.menu.shared": "Shared with you",
	"projects.menu.title": "Projects",
	"projects.menu.personal": "Personal",
	"projects.menu.addFirstProject": "Add project",
	"projects.menu.chat": "Chat",
	"projects.menu.create.workflow": "New workflow",
	"projects.menu.create.credential": "New credential",
	"projects.menu.create.variable": "New variable",
	"projects.menu.create.dataTable": "New data table",
	"projects.menu.create.agent": "New agent",
	"projects.menu.create.project": "New project",
	"projects.menu.create.instanceAiThread": "New AI chat",
	"projects.settings": "Project settings",
	"projects.settings.info": "Project info",
	"projects.settings.newProjectName": "My project",
	"projects.settings.iconPicker.button.tooltip": "Choose project icon",
	"projects.settings.name": "Icon and name",
	"projects.settings.description": "Description",
	"projects.settings.customSpanAttributes.label": "Custom span attributes",
	"projects.settings.customSpanAttributes.description": "Add custom span attributes to this project's OpenTelemetry spans. Learn more in the",
	"projects.settings.customSpanAttributes.docsLink": "documentation",
	"projects.settings.customSpanAttributes.key.label": "Key",
	"projects.settings.customSpanAttributes.key.placeholder": "e.g. env",
	"projects.settings.customSpanAttributes.value.label": "Value",
	"projects.settings.customSpanAttributes.value.placeholder": "e.g. production",
	"projects.settings.customSpanAttributes.add": "Add attribute",
	"projects.settings.customSpanAttributes.remove": "Remove attribute",
	"projects.settings.customSpanAttributes.error.emptyKey": "Key must not be empty",
	"projects.settings.customSpanAttributes.error.duplicateKey": "Duplicate keys are not allowed",
	"projects.settings.projectMembers": "Project members",
	"projects.settings.danger.message": "When deleting a project, you can also choose to move all workflows and credentials to another project.",
	"projects.settings.danger.title": "Danger zone",
	"projects.settings.danger.deleteProject": "Delete this project",
	"projects.settings.button.save": "@:_reusableBaseText.save",
	"projects.settings.button.cancel": "@:_reusableBaseText.cancel",
	"projects.settings.button.deleteProject": "Delete project",
	"projects.settings.role.admin": "@:_reusableBaseText.roles.admin",
	"projects.settings.role.editor": "@:_reusableBaseText.roles.editor",
	"projects.settings.role.viewer": "@:_reusableBaseText.roles.viewer",
	"projects.settings.delete.title": "Delete \"{projectName}\" Project?",
	"projects.settings.delete.message": "What should we do with the project data?",
	"projects.settings.delete.message.empty": "There are no workflows, credentials or data tables in this project.",
	"projects.settings.delete.question.transfer.label": "Transfer its workflows, credentials and data tables to another project or user",
	"projects.settings.delete.question.transfer.title": "Project or user to transfer to",
	"projects.settings.delete.question.wipe.label": "Delete its workflows, credentials and data tables",
	"projects.settings.delete.question.wipe.title": "Type \"delete all data\" to confirm",
	"projects.settings.delete.question.wipe.placeholder": "delete all data",
	"projects.settings.delete.confirm": "Yes, I am sure",
	"projects.settings.delete.cancel": "No, cancel",
	"projects.settings.delete.successful.title": "Project {projectName} deleted",
	"projects.settings.delete.error.title": "An error occurred while deleting the project",
	"projects.settings.save.successful.title": "Project {projectName} saved successfully",
	"projects.settings.icon.update.successful.title": "Project icon updated successfully",
	"projects.settings.save.error.title": "An error occurred while saving the project",
	"projects.settings.role.upgrade.title": "Upgrade to Enterprise",
	"projects.settings.role.upgrade.message": "You're currently limited to {limit} on the {planName} plan and can only assign the admin role to users within this project. To create more projects and unlock additional roles, upgrade your plan.",
	"projects.settings.role.upgrade.tooltip": "Upgrade to Pro or Enterprise to assign Editor and Viewer roles",
	"projects.settings.table.header.user": "@:_reusableBaseText.user",
	"projects.settings.table.header.role": "@:_reusableBaseText.role",
	"projects.settings.table.row.removeUser": "Remove user",
	"projects.settings.role.admin.description": "Can edit workflows, credentials, and project settings",
	"projects.settings.role.editor.description": "Can edit workflows and credentials",
	"projects.settings.role.viewer.description": "Can view workflows and executions",
	"projects.settings.role.personalOwner": "Owner",
	"projects.settings.role.selector.section.system": "System roles",
	"projects.settings.role.selector.section.custom": "Custom roles",
	"projects.settings.role.selector.addCustomRole": "Add custom role",
	"projects.settings.role.selector.permissionCount": "{count}/{total} permissions",
	"projects.settings.role.popover.viewAndEdit": "View and edit role",
	"projects.settings.role.popover.viewDetails": "View role",
	"projects.settings.role.contactAdmin.title": "Custom roles aren't set up yet",
	"projects.settings.role.contactAdmin.titleWithRoles": "Only instance admins can add custom roles",
	"projects.settings.role.contactAdmin.body": "You can assign system roles, but custom roles need to be created by an instance admin first. Share the {documentation} with your instance admin to get custom roles set up.",
	"projects.settings.role.contactAdmin.bodyWithRoles": "You can assign existing custom roles, but you'll need to contact an instance admin to create any new ones. Learn more in our {documentation}.",
	"projects.settings.role.upgrade.custom.title": "Upgrade to Enterprise",
	"projects.settings.role.upgrade.custom.body": "In order to create and manage custom roles you need to upgrade your plan to enterprise option. Learn more in the {documentation}.",
	"projects.settings.role.upgrade.custom.viewPlans": "View plans",
	"projects.settings.role.details.title": "Role details",
	"projects.settings.role.details.permissions": "Permissions",
	"projects.settings.members.search.placeholder": "Search members...",
	"projects.settings.memberRole.updated.title": "Member role updated successfully",
	"projects.settings.memberRole.update.error.title": "An error occurred while updating member role",
	"projects.settings.member.removed.title": "Member removed successfully",
	"projects.settings.member.added.title": "Member added successfully",
	"projects.settings.users.search.error": "An error occurred while searching for users",
	"projects.settings.externalSecrets": "External secret vaults",
	"projects.settings.externalSecrets.emptyState.heading": "No external secrets available yet",
	"projects.settings.externalSecrets.emptyState.instanceAdmin.noProjectProviders.description": "Share secrets vault with this project to make external secrets available here. Once shared, secrets will appear automatically and can be referenced through aliases in credentials.",
	"projects.settings.externalSecrets.emptyState.projectAdmin.description": "Add a secrets vault and share it with this project to make external secrets available here. Once shared, secrets will appear automatically and can be referenced through aliases in credentials.",
	"projects.settings.externalSecrets.button.addSecretsStore": "Add secrets vault",
	"projects.settings.externalSecrets.button.shareSecretsStore": "Share secrets vault",
	"projects.settings.externalSecrets.table.header.secretName": "Secret name",
	"projects.settings.externalSecrets.table.header.usedInCredentials": "Used in credentials",
	"projects.settings.externalSecrets.search.placeholder": "Search secrets...",
	"projects.settings.externalSecrets.load.error": "An error occurred while loading external secrets",
	"projects.settings.externalSecrets.expand": "Expand external secrets vault",
	"projects.settings.externalSecrets.collapse": "Collapse external secrets vault",
	"projects.sharing.allUsers": "All users and projects",
	"projects.sharing.noMatchingProjects": "There are no available projects",
	"projects.sharing.moreResults": "{count} more results — refine your search",
	"projects.sharing.noMatchingUsers": "No matching users or projects",
	"projects.sharing.select.placeholder": "Select project or user",
	"projects.sharing.select.placeholder.user": "Share with user(s)",
	"projects.sharing.select.placeholder.project": "Share with projects or users",
	"projects.sharing.personalSpace": "Personal space",
	"projects.error.title": "Project error",
	"projects.create.limit": "{count} project | {count} projects",
	"projects.create.limitReached": "You have reached the {planName} plan limit of {limit}. Upgrade your plan to unlock more projects. {link}",
	"projects.create.limitReached.cloud": "You have reached the {planName} plan limit of {limit}. Upgrade your plan to unlock more projects.",
	"projects.create.limitReached.self": "Upgrade to unlock projects for more granular control over sharing, access and organisation of workflows",
	"projects.create.limitReached.link": "View plans",
	"projects.create.permissionDenied": "Your current role does not allow you to create projects. Contact your administrator to request access.",
	"projects.move.resource.modal.title": "Choose a project or user to move this {resourceTypeLabel} to",
	"projects.move.resource.modal.message": "\"{resourceName}\" is currently {inPersonalProject}{inTeamProject}",
	"projects.move.resource.modal.message.team": "in the \"{resourceHomeProjectName}\" project.",
	"projects.move.resource.modal.message.personal": "owned by \"{resourceHomeProjectName}\".",
	"projects.move.resource.modal.message.note": "Note",
	"projects.move.resource.modal.message.sharingNote": "{note}: Moving will remove any existing sharing for this {resourceTypeLabel}.",
	"projects.move.resource.modal.message.sharingInfo": "(Currently shared with {count} project) | (Currently shared with {count} projects)",
	"projects.move.resource.modal.message.usedCredentials": "Also share the {usedCredentials} used by this workflow to ensure it will continue to run correctly",
	"projects.move.resource.modal.message.usedCredentials.number": "{count} credential | {count} credentials",
	"projects.move.resource.modal.message.unAccessibleCredentials": "Some credentials",
	"projects.move.resource.modal.message.unAccessibleCredentials.count": "{count} credential | {count} credentials",
	"projects.move.resource.modal.message.unAccessibleCredentials.note": "{credentials} can't be shared. Move or recreate them in the destination project to keep this workflow running.",
	"projects.move.resource.modal.message.unAccessibleCredentials.personalSpaceNote": "{credentials} can't be shared because your admin has disabled sharing from personal spaces. Move or recreate them in the project or user you're moving into, to keep this workflow running.",
	"projects.move.resource.modal.message.resolvableConnections": "Each user connects their own account to this credential. Users who lose access after the move will lose their connection. Users who keep access (such as admins) aren't affected.",
	"projects.move.resource.modal.message.noProjects": "Currently there are not any projects or users available for you to move this {resourceTypeLabel} to.",
	"projects.move.resource.modal.button": "Move {resourceTypeLabel}",
	"projects.move.resource.modal.selectPlaceholder": "Select project or user...",
	"projects.move.resource.error.title": "Error moving {resourceName} {resourceTypeLabel}",
	"projects.move.resource.success.title": "{resourceTypeLabel} '{resourceName}' is moved to '{targetProjectName}'",
	"projects.move.resource.success.message.workflow": "The workflow's credentials were not shared with the project.",
	"projects.move.resource.success.message.workflow.withAllCredentials": "The workflow's credentials were shared with the project.",
	"projects.move.resource.success.message.workflow.withSomeCredentials": "Due to missing permissions not all the workflow's credentials were shared with the project.",
	"projects.move.resource.success.link": "View {targetProjectName}",
	"projects.badge.global": "Global",
	"projects.badge.tooltip.global": "This {resourceTypeLabel} was shared globally with all users and projects",
	"projects.badge.tooltip.sharedOwned": "This {resourceTypeLabel} is owned by you and shared with {count} other projects or users",
	"projects.badge.tooltip.sharedPersonal": "This {resourceTypeLabel} is owned by {name} and shared with {count} other projects or users",
	"projects.badge.tooltip.personal": "This {resourceTypeLabel} is owned by {name}",
	"projects.badge.tooltip.team": "This {resourceTypeLabel} is owned and accessible by the {name} project.",
	"projects.badge.tooltip.sharedTeam": "This {resourceTypeLabel} is owned by the {name} project and shared with {count} other projects or users",
	"mfa.setup.invalidAuthenticatorCode": "{code} is not a valid number",
	"mfa.setup.invalidCode": "Two-factor code failed. Please try again.",
	"mfa.code.modal.title": "Two-factor authentication",
	"mfa.recovery.modal.title": "Two-factor recovery",
	"mfa.code.input.info": "Don't have your auth device?",
	"mfa.code.input.info.action": "Enter a recovery code",
	"mfa.recovery.input.info.action": "enter a recovery code",
	"mfa.code.button.continue": "Continue",
	"mfa.recovery.button.verify": "Verify",
	"mfa.button.back": "Back",
	"mfa.code.input.label": "Two-factor code",
	"mfa.code.input.placeholder": "e.g. 123456",
	"mfa.code.recovery.input.label": "Two-factor code or recovery code",
	"mfa.code.recovery.input.placeholder": "e.g. 123456 or c79f9c02-7b2e-44...",
	"mfa.recovery.input.label": "Recovery code",
	"mfa.recovery.input.placeholder": "e.g c79f9c02-7b2e-44...",
	"mfa.code.invalid": "This code is invalid, try again or",
	"mfa.recovery.invalid": "This code is invalid or was already used, try again",
	"mfa.setup.step1.title": "Setup Authenticator app [1/2]",
	"mfa.setup.step2.title": "Download your recovery codes [2/2]",
	"mfa.setup.step1.instruction1.title": "1. Scan the QR code",
	"mfa.setup.step1.instruction1.subtitle": "{part1} {part2}",
	"mfa.setup.step1.instruction1.subtitle.part1": "Use an authenticator app from your phone to scan. If you can't scan the QR code, enter",
	"mfa.setup.step1.instruction1.subtitle.part2": "this text code",
	"mfa.setup.step1.instruction2.title": "2. Enter the code from the app",
	"mfa.setup.step2.description": "You can use recovery codes as a second factor to authenticate in case you lose access to your device.",
	"mfa.setup.step2.infobox.description": "{part1} {part2}",
	"mfa.setup.step2.infobox.description.part1": "Keep your recovery codes somewhere safe. If you lose your device and your recovery codes, you will",
	"mfa.setup.step2.infobox.description.part2": "lose access to your account.",
	"mfa.setup.step2.button.download": "Download recovery codes",
	"mfa.setup.step2.button.save": "I have downloaded my recovery codes",
	"mfa.setup.step1.button.continue": "Continue",
	"mfa.setup.step1.input.label": "Code from your authenticator app",
	"mfa.setup.step1.toast.copyToClipboard.title": "Code copied to clipboard",
	"mfa.setup.step1.toast.copyToClipboard.message": "Enter the code in your authenticator app",
	"mfa.setup.step2.toast.setupFinished.message": "Two-factor authentication enabled",
	"mfa.setup.step2.toast.setupFinished.error.message": "Error enabling two-factor authentication",
	"mfa.setup.step2.toast.tokenExpired.error.message": "MFA token expired. Close the modal and enable MFA again",
	"mfa.prompt.code.modal.title": "Two-factor code or recovery code required",
	"settings.personal.mfa.section.title": "Two-factor authentication (2FA)",
	"settings.personal.personalisation": "Personalisation",
	"settings.personal.theme": "Theme",
	"settings.personal.theme.systemDefault": "System default",
	"settings.personal.theme.light": "Light theme",
	"settings.personal.theme.dark": "Dark theme",
	"settings.personal.mfa.button.disabled.infobox": "Two-factor authentication is currently disabled.",
	"settings.personal.mfa.button.enabled.infobox": "Two-factor authentication is currently enabled.",
	"settings.personal.mfa.button.enabled": "Enable 2FA",
	"settings.personal.mfa.button.disabled": "Disable two-factor authentication",
	"settings.personal.mfa.toast.disabledMfa.title": "Two-factor authentication disabled",
	"settings.personal.mfa.toast.disabledMfa.message": "You will no longer need your authenticator app when signing in",
	"settings.personal.mfa.toast.disabledMfa.error.message": "Error disabling two-factor authentication",
	"settings.personal.mfa.toast.canEnableMfa.title": "MFA pre-requisite failed",
	"settings.personal.mfa.enforced": "The settings on this instance <strong>require you to set up 2FA</strong>. Please enable it to continue working in this instance.",
	"settings.personal.mfa.enforce.message": "Enforces 2FA for all users on this instance authenticating with email and password logins.",
	"settings.personal.mfa.enforce.description": "Every account on the instance must enrol a second factor before they can sign in.",
	"settings.personal.mfa.enforce.unlicensed_tooltip": "You can enforce 2FA for all users on this instance authenticating with email and password logins when you upgrade your plan. {action}",
	"settings.personal.mfa.enforce.unlicensed_tooltip.link": "View plans",
	"settings.personal.mfa.enforce.title": "Enforce two-factor authentication",
	"settings.personal.mfa.enforce.error": "Cannot enforce 2FA for all users",
	"settings.personal.mfa.enforce.enabled.title": "2FA Enforced",
	"settings.personal.mfa.enforce.enabled.message": "Two-factor authentication is now required for all users on this instance authenticating with email and password logins.",
	"settings.personal.mfa.enforce.disabled.title": "2FA No Longer Enforced",
	"settings.personal.mfa.enforce.disabled.message": "Two-factor authentication is no longer mandatory for users on this instance authenticating with email and password logins.",
	"settings.mfa.toast.noRecoveryCodeLeft.title": "No 2FA recovery codes remaining",
	"settings.mfa.toast.noRecoveryCodeLeft.message": "You have used all of your recovery codes. Disable then re-enable two-factor authentication to generate new codes. <a href='/settings/personal' target='_blank' >Open settings</a>",
	"sso.login.divider": "or",
	"sso.login.button": "Continue with SSO",
	"executionUsage.currentUsage": "{text} {count}",
	"executionUsage.currentUsage.text": "You are in a free trial with limited executions. You have",
	"executionUsage.currentUsage.count": "{n} day left. | {n} days left.",
	"executionUsage.label.executions": "Executions",
	"executionUsage.button.upgrade": "Upgrade plan",
	"executionUsage.expired.text": "Your trial is over. Upgrade now to keep your data.",
	"executionUsage.ranOutOfExecutions.text": "You’re out of executions. Upgrade your plan to keep automating.",
	"openExecution.missingExeuctionId.title": "Could not find execution",
	"openExecution.missingExeuctionId.message": "Make sure this workflow saves executions via the settings",
	"type.string": "String",
	"type.number": "Number",
	"type.dateTime": "Date & Time",
	"type.boolean": "Boolean",
	"type.array": "Array",
	"type.object": "Object",
	"type.binary": "Binary Data",
	"filter.operator.equals": "is equal to",
	"filter.operator.notEquals": "is not equal to",
	"filter.operator.contains": "contains",
	"filter.operator.notContains": "does not contain",
	"filter.operator.startsWith": "starts with",
	"filter.operator.notStartsWith": "does not start with",
	"filter.operator.endsWith": "ends with",
	"filter.operator.notEndsWith": "does not end with",
	"filter.operator.exists": "exists",
	"filter.operator.notExists": "does not exist",
	"filter.operator.regex": "matches regex",
	"filter.operator.notRegex": "does not match regex",
	"filter.operator.gt": "is greater than",
	"filter.operator.lt": "is less than",
	"filter.operator.gte": "is greater than or equal to",
	"filter.operator.lte": "is less than or equal to",
	"filter.operator.after": "is after",
	"filter.operator.before": "is before",
	"filter.operator.afterOrEquals": "is after or equal to",
	"filter.operator.beforeOrEquals": "is before or equal to",
	"filter.operator.true": "is true",
	"filter.operator.false": "is false",
	"filter.operator.lengthEquals": "length equal to",
	"filter.operator.lengthNotEquals": "length not equal to",
	"filter.operator.lengthGt": "length greater than",
	"filter.operator.lengthLt": "length less than",
	"filter.operator.lengthGte": "length greater than or equal to",
	"filter.operator.lengthLte": "length less than or equal to",
	"filter.operator.empty": "is empty",
	"filter.operator.notEmpty": "is not empty",
	"filter.combinator.or": "OR",
	"filter.combinator.and": "AND",
	"filter.addCondition": "Add condition",
	"filter.removeCondition": "Remove condition",
	"filter.dragCondition": "Drag condition",
	"filter.maxConditions": "Maximum conditions reached",
	"filter.condition.resolvedTrue": "This condition is true for the first input item",
	"filter.condition.resolvedFalse": "This condition is false for the first input item",
	"filter.condition.placeholderLeft": "value1",
	"filter.condition.placeholderRight": "value2",
	"assignment.dragFields": "Drag input fields here",
	"assignment.dropField": "Drop here to add the field",
	"assignment.or": "or",
	"assignment.add": "Add Field",
	"assignment.addAll": "Add All",
	"assignment.clearAll": "Clear All",
	"assignment.binaryData.placeholder": "Name of binary input (or expression referencing it)",
	"assignment.field": "Field {number}",
	"assignment.remove": "Remove field",
	"assignment.dragToReorder": "Drag to reorder",
	"templateSetup.title": "Set up '{name}' template",
	"templateSetup.instructions": "You need {0} account to setup this template",
	"templateSetup.instructions.builder": "You need {0} account to setup this workflow",
	"templateSetup.skip": "Skip",
	"templateSetup.continue.button": "Continue",
	"templateSetup.credential.description": "The credential you select will be used in the {0} node of the workflow template. | The credential you select will be used in the {0} nodes of the workflow template.",
	"templateSetup.credential.description.builder": "The credential you select will be used in the {0} node of this workflow. | The credential you select will be used in the {0} nodes of this workflow.",
	"templateSetup.continue.button.fillRemaining": "Fill remaining credentials to continue",
	"setupCredentialsModal.title": "Set up template",
	"setupCredentialsModal.title.builder": "Set up credentials",
	"setupPanel.empty.heading": "Workflow setup",
	"setupPanel.empty.description": "Nothing to configure at the moment",
	"setupPanel.tabs.setup": "Setup",
	"setupPanel.tabs.focus": "Focus",
	"setupPanel.tabs.evaluations": "Evaluations",
	"setupPanel.test.intro": "Setup panel lives here",
	"setupPanel.test.description": "Here you can configure everything needed to run the current workflow",
	"setupPanel.credentialLabel": "Credential",
	"setupPanel.usedInNodes": "Used in {count} nodes",
	"setupPanel.everythingConfigured.message": "Your workflow is ready to be executed",
	"setupPanel.trigger.credential.note": "Add a credential to listen for events.",
	"setupPanel.trigger.listeningHint": "Go to {service} and create an event",
	"setupPanel.parameter.description": "This node has required parameters that need to be configured.",
	"setupPanel.parameter.configureButton": "Configure node",
	"setupPanel.showCompleted": "Show completed steps",
	"setupPanel.webhookUrl.title": "Webhook URL",
	"setupPanel.webhookUrl.clickToCopy": "Click to copy test URL",
	"setupPanel.webhookUrl.copied": "Test URL copied",
	"becomeCreator.text": "Share your workflows with other users, unlock perks, and become a featured template creator!",
	"becomeCreator.buttonText": "Become a creator",
	"becomeCreator.closeButtonTitle": "Close",
	"feedback.title": "Was this helpful?",
	"feedback.positive": "I found this helpful",
	"feedback.negative": "I didn't find this helpful",
	"communityPlusModal.badge": "Time limited offer",
	"communityPlusModal.title": "Get paid features for free (forever)",
	"communityPlusModal.error.title": "License request failed",
	"communityPlusModal.success.title": "Request sent",
	"communityPlusModal.success.message": "License key will be sent to {email}",
	"communityPlusModal.description": "Receive a free activation key for the advanced features below - lifetime access.",
	"communityPlusModal.features.debugging.title": "Advanced debugging",
	"communityPlusModal.features.debugging.description": "Easily fix any workflow execution that’s errored, then re-run it",
	"communityPlusModal.features.execution.title": "Execution search and tagging",
	"communityPlusModal.features.execution.description": "Search and organize past workflow executions for easier review",
	"communityPlusModal.features.folders.title": "Folders",
	"communityPlusModal.features.folders.description": "Organize your workflows in a nested folder structure",
	"communityPlusModal.input.email.label": "Enter email to receive your license key",
	"communityPlusModal.button.skip": "Skip",
	"communityPlusModal.button.confirm": "Send me a free license key",
	"communityPlusModal.notice": "Included features may change, but once unlocked, you'll keep them forever.",
	"executeWorkflowTrigger.createNewSubworkflow": "Create a Sub-Workflow in {projectName}",
	"executeWorkflowTrigger.createNewSubworkflow.noProject": "Create a New Sub-Workflow",
	"agentSelector.createNewAgent": "Create an agent in {projectName}",
	"agentSelector.createNewAgent.noProject": "Create a new agent",
	"agentSelector.mode.list.placeholder": "Select an agent",
	"agentNode.card.defaultName": "AI Agent",
	"agentNode.card.openAgent": "Open agent",
	"agentNode.card.moreChips": "+{count}",
	"agentNode.card.loadError": "Couldn’t load agent details",
	"agentNode.card.noModel": "No model selected",
	"agentNode.ndv.banner.suffix": ". Alternatively, fill in the form below.",
	"agentNode.ndv.section.agent": "Agent",
	"agentNode.ndv.referenced.editInBuilder": "Edit agent",
	"agentNode.ndv.unavailable": "This agent was deleted or you lost access.",
	"agentSelector.createAgentFailed": "Error creating agent",
	"evaluation.listRuns.status.new": "New",
	"evaluation.listRuns.status.running": "Running",
	"evaluation.listRuns.status.evaluating": "Evaluating",
	"evaluation.listRuns.status.completed": "Completed",
	"evaluation.listRuns.status.cancelled": "Cancelled",
	"evaluation.listRuns.status.error": "Error",
	"evaluation.listRuns.status.success": "Success",
	"evaluation.listRuns.status.warning": "Warning",
	"evaluation.listRuns.metricsOverTime": "Metrics over time",
	"evaluation.listRuns.status": "Status",
	"evaluation.listRuns.allTestCases": "All test cases | All test cases ({count})",
	"evaluation.listRuns.testCasesListHeader": "Run #{index}",
	"evaluation.listRuns.runNumber": "Run",
	"evaluation.listRuns.runDate": "Run date",
	"evaluation.listRuns.runStatus": "Run status",
	"evaluation.listRuns.noRuns": "No test runs",
	"evaluation.listRuns.pastRuns.total": "No runs | All runs | All runs",
	"evaluation.listRuns.noRuns.description": "Run a test to see the results here",
	"evaluation.listRuns.deleteRuns": "No runs to delete | Delete {count} run | Delete {count} runs",
	"evaluation.listRuns.noRuns.button": "Run Test",
	"evaluation.listRuns.toast.error.fetchTestCases": "Failed to load run details",
	"evaluation.listRuns.error.testCasesNotFound": "No matching rows in dataset{description}",
	"evaluation.listRuns.error.testCasesNotFound.description": "Check any filters or limits set in the evaluation trigger",
	"evaluation.listRuns.error.executionInterrupted": "Test run was interrupted",
	"evaluation.listRuns.error.unknownError": "Execution error{description}",
	"evaluation.listRuns.error.cantFetchTestRuns": "Couldn’t fetch test runs",
	"evaluation.listRuns.error.cantStartTestRun": "Couldn’t start test run",
	"evaluation.listRuns.error.cantFetchConfigs": "Couldn’t load evaluation config; runs will use the workflow as-is",
	"evaluation.listRuns.error.cantStopTestRun": "Couldn’t stop test run",
	"evaluation.listRuns.error.unknownError.description": "Click for more details",
	"evaluation.listRuns.error.evaluationTriggerNotFound": "Evaluation trigger missing",
	"evaluation.listRuns.error.evaluationTriggerNotConfigured": "Evaluation trigger is not configured",
	"evaluation.listRuns.error.evaluationTriggerDisabled": "Evaluation trigger is disabled",
	"evaluation.listRuns.error.evaluationConfigNotFound": "Evaluation configuration not found",
	"evaluation.listRuns.error.setOutputsNodeNotConfigured": "'Set outputs' node is not configured",
	"evaluation.listRuns.error.setMetricsNodeNotFound": "No 'Set metrics' node in workflow",
	"evaluation.listRuns.error.setMetricsNodeNotConfigured": "'Set metrics' node is not configured",
	"evaluation.listRuns.error.cantFetchTestCases": "Couldn’t fetch test cases{description}",
	"evaluation.listRuns.error.cantFetchTestCases.description": "Check the Google Sheet setup in the evaluation trigger",
	"evaluation.runDetail.ranAt": "Ran at",
	"evaluation.runDetail.testCase": "Test case",
	"evaluation.runDetail.testCase.id": "Test case ID",
	"evaluation.runDetail.testCase.status": "Test case status",
	"evaluation.runDetail.totalCases": "Total cases",
	"evaluation.runDetail.error.mockedNodeMissing": "Output for a mocked node does not exist in benchmark execution.{link}.",
	"evaluation.runDetail.error.mockedNodeMissing.solution": "Fix test configuration",
	"evaluation.runDetail.error.executionFailed": "Failed to execute workflow",
	"evaluation.runDetail.error.executionFailed.solution": "View execution",
	"evaluation.runDetail.error.datasetTriggerNotFound": "Dataset trigger does not exist in the workflow.{link}.",
	"evaluation.runDetail.error.datasetTriggerNotFound.solution": "View workflow",
	"evaluation.runDetail.error.invalidMetrics": "Evaluation metrics node returned invalid metrics. Only numeric values are expected. View workflow. {link}.",
	"evaluation.runDetail.error.invalidMetrics.solution": "View workflow",
	"evaluation.runDetail.error.unknownError": "An unknown error occurred",
	"evaluation.runDetail.error.unknownError.solution": "View execution",
	"evaluation.runDetail.error.noMetricsCollected": "No 'Set metrics' node executed",
	"evaluation.runDetail.error.partialCasesFailed": "Finished with errors",
	"evaluation.runDetail.notice.useSetInputs": "Tip: Show input columns from your dataset here by adding the evaluation node's 'set inputs' operation to your workflow",
	"evaluation.runDetail.aiSummary.title": "AI Summary",
	"evaluation.runDetail.aiSummary.placeholder": "An AI-generated summary of this run will appear here.",
	"evaluation.runDetail.testCase.title": "Test #{index}",
	"evaluation.runDetail.testCase.viewLink": "View",
	"evaluation.runDetail.metrics.name": "Name",
	"evaluation.runDetail.metrics.result": "Result",
	"evaluation.runDetail.runComparison.comingSoon": "Run comparison coming soon",
	"evaluation.runDetail.backToRuns": "Back to runs",
	"evaluation.runDetail.metricCategory.aiBased": "AI-based",
	"evaluation.runDetail.metricCategory.stringSimilarity": "String similarity",
	"evaluation.runDetail.metricCategory.categorization": "Categorization",
	"evaluation.runDetail.metricCategory.toolsUsed": "Tools used",
	"evaluation.runDetail.metricCategory.custom": "Custom",
	"evaluation.runDetail.testCase.pending": "Pending",
	"evaluation.runDetail.testCase.running": "Running…",
	"evaluation.runDetail.testCase.cancelled": "Cancelled",
	"evaluation.runDetail.testCase.failed": "Failed",
	"evaluation.runDetail.testCase.cancel": "Cancel",
	"evaluation.runDetail.testCase.cancelError": "Couldn't cancel this test case",
	"evaluation.runDetail.testCase.rerun": "Re-run test",
	"evaluation.runDetail.testCase.progress.accomplishing": "Accomplishing",
	"evaluation.runDetail.testCase.progress.actioning": "Actioning",
	"evaluation.runDetail.testCase.progress.actualizing": "Actualizing",
	"evaluation.runDetail.testCase.progress.architecting": "Architecting",
	"evaluation.runDetail.testCase.progress.baking": "Baking",
	"evaluation.runDetail.testCase.progress.beaming": "Beaming",
	"evaluation.runDetail.testCase.progress.beboppin": "Beboppin'",
	"evaluation.runDetail.testCase.progress.befuddling": "Befuddling",
	"evaluation.runDetail.testCase.progress.billowing": "Billowing",
	"evaluation.runDetail.testCase.progress.blanching": "Blanching",
	"evaluation.runDetail.testCase.progress.bloviating": "Bloviating",
	"evaluation.runDetail.testCase.progress.boogieing": "Boogieing",
	"evaluation.runDetail.testCase.progress.boondoggling": "Boondoggling",
	"evaluation.runDetail.testCase.progress.booping": "Booping",
	"evaluation.runDetail.testCase.progress.bootstrapping": "Bootstrapping",
	"evaluation.runDetail.testCase.progress.brewing": "Brewing",
	"evaluation.runDetail.testCase.progress.bunning": "Bunning",
	"evaluation.runDetail.testCase.progress.burrowing": "Burrowing",
	"evaluation.runDetail.testCase.progress.calculating": "Calculating",
	"evaluation.runDetail.testCase.progress.canoodling": "Canoodling",
	"evaluation.runDetail.testCase.progress.caramelizing": "Caramelizing",
	"evaluation.runDetail.testCase.progress.cascading": "Cascading",
	"evaluation.runDetail.testCase.progress.catapulting": "Catapulting",
	"evaluation.runDetail.testCase.progress.cerebrating": "Cerebrating",
	"evaluation.runDetail.testCase.progress.channeling": "Channeling",
	"evaluation.runDetail.testCase.progress.choreographing": "Choreographing",
	"evaluation.runDetail.testCase.progress.churning": "Churning",
	"evaluation.runDetail.testCase.progress.clauding": "Clauding",
	"evaluation.runDetail.testCase.progress.coalescing": "Coalescing",
	"evaluation.runDetail.testCase.progress.cogitating": "Cogitating",
	"evaluation.runDetail.testCase.progress.combobulating": "Combobulating",
	"evaluation.runDetail.testCase.progress.composing": "Composing",
	"evaluation.runDetail.testCase.progress.computing": "Computing",
	"evaluation.runDetail.testCase.progress.concocting": "Concocting",
	"evaluation.runDetail.testCase.progress.considering": "Considering",
	"evaluation.runDetail.testCase.progress.contemplating": "Contemplating",
	"evaluation.runDetail.testCase.progress.cooking": "Cooking",
	"evaluation.runDetail.testCase.progress.crafting": "Crafting",
	"evaluation.runDetail.testCase.progress.creating": "Creating",
	"evaluation.runDetail.testCase.progress.crunching": "Crunching",
	"evaluation.runDetail.testCase.progress.crystallizing": "Crystallizing",
	"evaluation.runDetail.testCase.progress.cultivating": "Cultivating",
	"evaluation.runDetail.testCase.progress.deciphering": "Deciphering",
	"evaluation.runDetail.testCase.progress.deliberating": "Deliberating",
	"evaluation.runDetail.testCase.progress.determining": "Determining",
	"evaluation.runDetail.testCase.progress.dillyDallying": "Dilly-dallying",
	"evaluation.runDetail.testCase.progress.discombobulating": "Discombobulating",
	"evaluation.runDetail.testCase.progress.doing": "Doing",
	"evaluation.runDetail.testCase.progress.doodling": "Doodling",
	"evaluation.runDetail.runStatus.running": "Running",
	"evaluation.runDetail.runStatus.done": "Done",
	"evaluation.runDetail.runStatus.cancelled": "Cancelled",
	"evaluation.runDetail.runStatus.failed": "Failed",
	"evaluation.runTest": "Run Test",
	"evaluation.runWorkflow": "Run workflow",
	"evaluation.stopTest": "Stop Test",
	"evaluation.runInParallel.label.sequential": "Sequential",
	"evaluation.runInParallel.label.concurrent": "Concurrent · {count}",
	"evaluation.runInParallel.tooltip": "Drag the slider to set how many evaluation test cases run at the same time. A value of 1 runs cases sequentially; higher values fan out for speed but may hit LLM rate limits.",
	"evaluation.runInParallel.popover.title": "Concurrency",
	"evaluation.runInParallel.popover.ariaLabel": "Configure parallel execution",
	"evaluation.runInParallel.popover.valuePill": "{count} of {max}",
	"evaluation.runInParallel.popover.scaleSequential": "Sequential",
	"evaluation.runInParallel.popover.scaleFaster": "Faster · may hit rate limits",
	"evaluation.runInParallel.popover.helper": "Set the number of tests you want to run in parallel. Setting a higher number speeds up runs, but can run into rate limits.",
	"evaluation.cancelTestRun": "Cancel Test Run",
	"evaluation.notImplemented": "This feature is not implemented yet!",
	"evaluation.viewDetails": "View Details",
	"evaluation.editTest": "Edit Test",
	"evaluation.deleteTest": "Delete Test",
	"evaluation.deleteTest.warning": "The test and all associated runs will be removed. This cannot be undone",
	"evaluation.testIsRunning": "Test is running. Please wait for it to finish.",
	"evaluation.completeConfig": "Complete the configuration below to run the test:",
	"evaluation.configError.noEvaluationTag": "No evaluation tag set",
	"evaluation.configError.noExecutionsAddedToTag": "No executions added to this tag",
	"evaluation.configError.noEvaluationWorkflow": "No evaluation workflow set",
	"evaluation.configError.noMetrics": "No metrics set",
	"evaluation.workflowInput.subworkflowName": "Evaluation workflow for {name}",
	"evaluation.workflowInput.subworkflowName.default": "My Evaluation Sub-Workflow",
	"evaluation.executions.addTo": "Add to Test",
	"evaluation.executions.addTo.new": "Add to Test",
	"evaluation.executions.addTo.existing": "Add to \"{name}\"",
	"evaluation.executions.addedTo": "Added to \"{name}\"",
	"evaluation.executions.removeFrom": "Remove from \"{name}\"",
	"evaluation.executions.removedFrom": "Execution removed from \"{name}\"",
	"evaluation.executions.toast.addedTo": "Go back to \"{name}\"",
	"evaluation.executions.tooltip.addTo": "Add to new test",
	"evaluation.executions.tooltip.noExecutions": "Evaluation executions can not be added to tests",
	"evaluation.executions.tooltip.onlySuccess": "Only successful executions can be added to tests",
	"evaluation.workflow.createNew": "Create new evaluation workflow",
	"evaluation.workflow.createNew.or": "or use existing evaluation sub-workflow",
	"evaluation.executions.toast.addedTo.title": "Execution added to test ",
	"evaluation.executions.toast.closeTab": "Close this tab",
	"evaluation.executions.toast.removedFrom.title": "Execution removed from test ",
	"evaluation.collections.title": "Evaluation collections",
	"evaluation.collections.subtitle": "Compare how different workflow versions score on the same dataset.",
	"evaluation.collections.newCollection": "New collection",
	"evaluation.collections.section.collections": "Collections",
	"evaluation.collections.section.ungrouped": "Ungrouped runs",
	"evaluation.collections.section.ungrouped.helper": "Runs not yet part of a collection",
	"evaluation.collections.section.ungrouped.empty": "No ungrouped runs.",
	"evaluation.collections.empty.title": "No collections yet",
	"evaluation.collections.empty.subtitle": "Create a collection to compare two or more versions side by side.",
	"evaluation.collections.errors.fetchFailed": "Could not load evaluation collections",
	"evaluation.collections.card.done": "Done",
	"evaluation.collections.card.running": "Running",
	"evaluation.collections.card.failed": "Failed",
	"evaluation.collections.card.currentDraft": "Current draft",
	"evaluation.collections.card.meta.versions": "{count} version | {count} versions",
	"evaluation.collections.card.lastRunToday": "today, {time}",
	"evaluation.collections.card.lastRunOn": "{date}, {time}",
	"evaluation.collections.chart.barValue": "{metric} · {value}%",
	"evaluation.collections.chart.barNoData": "{metric} · no data",
	"evaluation.collections.chart.ariaLabel": "Grouped metric chart for {count} metric | Grouped metric chart for {count} metrics",
	"evaluation.collections.row.noDataset": "No dataset",
	"evaluation.collections.row.status.done": "Done",
	"evaluation.collections.row.status.running": "Running",
	"evaluation.collections.row.status.queued": "Queued",
	"evaluation.collections.row.status.failed": "Failed",
	"evaluation.collections.row.status.cancelled": "Cancelled",
	"evaluation.collections.row.status.warning": "Warning",
	"evaluation.compare.openCompare": "Open compare",
	"evaluation.compare.viewProgress": "View progress",
	"evaluation.compare.backToList": "Evaluations",
	"evaluation.compare.versionsLegend.best": "★ best",
	"evaluation.compare.scoreChart.heading": "Scores by metric",
	"evaluation.compare.scoreChart.empty": "No score-shaped metrics to chart yet.",
	"evaluation.compare.scoreChart.toggle.average": "Average",
	"evaluation.compare.scoreChart.toggle.perCase": "Per case",
	"evaluation.compare.scoreChart.toggle.perCaseComingSoon": "Per-case comparison is coming soon.",
	"evaluation.compare.insights.title": "AI insights",
	"evaluation.compare.insights.generatedAt": "Generated · {time}",
	"evaluation.compare.insights.regenerate": "Regenerate",
	"evaluation.compare.insights.error": "Couldn’t generate insights.",
	"evaluation.compare.insights.retry": "Retry",
	"evaluation.compare.insights.fallbackNote": "Computed from raw scores — AI summary unavailable",
	"evaluation.compare.insights.winner": "Winner",
	"evaluation.compare.insights.regression": "Regression",
	"evaluation.compare.insights.suggestedNext": "Suggested next",
	"evaluation.compare.insights.noRegressions": "No regressions detected",
	"evaluation.compare.errors.loadFailed": "Could not load the comparison.",
	"evaluation.compare.errors.notFound": "This collection could not be found.",
	"evaluation.compare.tabs.cases": "Cases",
	"evaluation.compare.tabs.outputs": "Outputs",
	"evaluation.compare.tabs.metrics": "Metrics",
	"evaluation.compare.tabs.workflowDiff": "Workflow diff",
	"evaluation.compare.datasetMismatch": "Versions ran against different case counts ({counts}). Comparison is aligned by row index.",
	"evaluation.compare.cases.col.index": "#",
	"evaluation.compare.cases.col.input": "Case input",
	"evaluation.compare.cases.col.best": "Best",
	"evaluation.compare.cases.col.deltaVsBest": "Δ vs best",
	"evaluation.compare.cases.bestPill": "{letter} ★",
	"evaluation.compare.cases.loading": "Loading cases…",
	"evaluation.compare.cases.running": "Evaluation in progress — scores fill in as each case completes.",
	"evaluation.compare.cases.empty": "No case-level results to compare yet.",
	"evaluation.compare.cases.loadError": "Some versions' case data couldn't be loaded.",
	"evaluation.compare.outputs.casesSidebarTitle": "Test cases",
	"evaluation.compare.outputs.input": "Input",
	"evaluation.compare.outputs.noOutput": "No output for this version.",
	"evaluation.compare.metrics.col.metric": "Metric",
	"evaluation.compare.metrics.empty": "No score-shaped metrics to compare yet.",
	"evaluation.metric.description.correctness": "Whether the answer’s meaning matches a reference answer. Scored 1 (worst)–5 (best).",
	"evaluation.metric.description.helpfulness": "Whether the response addresses the query. Scored 1 (worst)–5 (best).",
	"evaluation.metric.description.stringSimilarity": "How close the answer is to a reference answer, character by character. Scored 0–1.",
	"evaluation.metric.description.categorization": "Whether the answer exactly matches the reference answer. 1 if so, 0 otherwise.",
	"evaluation.metric.description.toolsUsed": "Whether the expected tool(s) were used. Scored 0–1.",
	"evaluation.metric.criteria.label": "Criteria:",
	"evaluation.metric.criteria.showMore": "Show more",
	"evaluation.metric.criteria.showLess": "Show less",
	"evaluation.compare.workflowDiff.needTwo": "Add at least two versions to this collection to compare their workflows.",
	"evaluation.compare.workflowDiff.loadError": "Could not load the workflows to compare.",
	"evaluation.compare.workflowDiff.base": "Base",
	"evaluation.compare.workflowDiff.compare": "Compare",
	"evaluation.setup.title": "New collection",
	"evaluation.setup.subtitle": "Pick a dataset and the versions you want to compare.",
	"evaluation.setup.collectionName": "Collection name",
	"evaluation.setup.collectionName.placeholder": "e.g. Prompt tuning — March",
	"evaluation.setup.dataset": "Dataset",
	"evaluation.setup.dataset.helper": "Determines which versions can be compared",
	"evaluation.setup.dataset.placeholder": "Select a dataset",
	"evaluation.setup.dataset.matchCount": "{count} version matches | {count} versions match",
	"evaluation.setup.versions": "Versions",
	"evaluation.setup.versions.helper": "Select two or more to compare",
	"evaluation.setup.versions.filter.source": "Source:",
	"evaluation.setup.versions.filter.all": "All",
	"evaluation.setup.versions.sort.label": "Sort:",
	"evaluation.setup.versions.sort.recent": "Most recent",
	"evaluation.setup.versions.sort.oldest": "Oldest",
	"evaluation.setup.versions.col.version": "Version",
	"evaluation.setup.versions.col.lastRun": "Last run on {dataset}",
	"evaluation.setup.versions.col.avgScore": "Avg score",
	"evaluation.setup.versions.noRunYet": "No run yet",
	"evaluation.setup.versions.bestPill": "Best",
	"evaluation.setup.versions.lowPill": "Low",
	"evaluation.setup.versions.viewAction": "View",
	"evaluation.setup.versions.empty": "No versions found for this dataset.",
	"evaluation.setup.metrics": "Metrics",
	"evaluation.setup.metrics.helper": "Metrics recorded for every version in this collection",
	"evaluation.setup.metrics.addMetric": "Add metric",
	"evaluation.setup.metrics.addComingSoon": "Adding metrics is coming soon.",
	"evaluation.setup.metrics.empty": "This dataset's evaluation config has no metrics.",
	"evaluation.setup.footer.summary.pickMore": "Pick 2 or more versions",
	"evaluation.setup.footer.summary.reuse": "Compare {count} version | Compare {count} versions",
	"evaluation.setup.footer.summary.mixed": "Compare {total} versions · {newCount} new",
	"evaluation.setup.footer.runsExplain.reuse": "Reuses existing runs on {dataset}.",
	"evaluation.setup.footer.runsExplain.mixed": "Schedules {newCount} new run(s) on {dataset}.",
	"evaluation.setup.footer.cancel": "Cancel",
	"evaluation.setup.footer.cta.compare": "Compare {count} version | Compare {count} versions",
	"evaluation.setup.footer.cta.runAndCompare": "Run & compare {count} version | Run & compare {count} versions",
	"evaluation.setup.errors.loadDatasetsFailed": "Could not load datasets",
	"evaluation.setup.errors.loadVersionsFailed": "Could not load versions for this dataset",
	"evaluation.setup.errors.createFailed": "Could not create the collection",
	"evaluations.readOnlyNotice": "Evaluations can't be built in read-only mode. Build your evaluation on your development environment.",
	"evaluations.paywall.title": "Register to enable evaluation",
	"evaluations.paywall.description": "Register your Community instance to unlock the evaluation feature",
	"evaluations.paywall.cta": "Register instance",
	"evaluations.setupWizard.title": "Test your AI workflow over multiple inputs",
	"evaluations.setupWizard.description": "Evaluations measure performance against a test dataset.",
	"evaluations.setupWizard.moreInfo": "More info",
	"evaluations.setupWizard.stepHeader.optional": "Optional",
	"evaluations.setupWizard.step1.title": "Wire up a test dataset",
	"evaluations.setupWizard.step1.item1": "Create a Data table or Google Sheet with one input per row",
	"evaluations.setupWizard.step1.item2": "Add an evaluation trigger to your workflow and wire it up",
	"evaluations.setupWizard.step1.button": "Add evaluation trigger",
	"evaluations.setupWizard.step2.title": "Write workflow outputs back to dataset",
	"evaluations.setupWizard.step2.item1": "Add a 'Set Outputs' operation to log each output back to your table",
	"evaluations.setupWizard.step2.button": "Add 'set outputs' node",
	"evaluations.setupWizard.step3.title": "Set up a quality score",
	"evaluations.setupWizard.step3.item1": "Calculate a score, e.g. by comparing expected and actual outputs",
	"evaluations.setupWizard.step3.item2": "Add a 'set metrics' operation to log the score",
	"evaluations.setupWizard.step3.button": "Add 'Set metrics' node",
	"evaluations.setupWizard.step3.skip": "Skip",
	"evaluations.setupWizard.step3.notice": "Your plan supports custom metrics for one workflow only. {link}",
	"evaluations.setupWizard.step3.notice.link": "See plans",
	"evaluations.setupWizard.step4.title": "Run evaluation",
	"evaluations.setupWizard.step4.button": "Run evaluation",
	"evaluations.setupWizard.step4.altButton": "Run in editor",
	"evaluations.setupWizard.limitReached": "Limit reached. Your plan includes custom metrics for one workflow only. Upgrade for unlimited use or delete the workflow with existing evaluation runs.",
	"evaluations.wizardSidepanel.cancel": "Cancel",
	"evaluations.wizardSidepanel.step1.newCustomCheck": "New custom check",
	"evaluations.wizardSidepanel.step1.exploreMoreChecks": "Explore more checks",
	"evaluations.wizardSidepanel.step1.judgeLabel": "Model",
	"evaluations.wizardSidepanel.step1.judgeMissingCredential": "Pick a credential to use this provider",
	"evaluations.wizardSidepanel.metric.judgeTag": "AI-judged",
	"evaluations.wizardSidepanel.metric.correctness.label": "Correctness",
	"evaluations.wizardSidepanel.metric.correctness.description": "Does the AI’s answer mean the same thing as your expected output? An AI judge gives a 1–5 score.",
	"evaluations.wizardSidepanel.metric.helpfulness.label": "Helpfulness",
	"evaluations.wizardSidepanel.metric.helpfulness.description": "Does the response address the query? Scored 1–5.",
	"evaluations.wizardSidepanel.metric.stringSimilarity.label": "String Similarity",
	"evaluations.wizardSidepanel.metric.stringSimilarity.description": "How close the answer is to the reference, character-by-character. Scored 0–1.",
	"evaluations.wizardSidepanel.metric.categorization.label": "Exact match",
	"evaluations.wizardSidepanel.metric.categorization.description": "The AI’s answer must be identical to your expected output.",
	"evaluations.wizardSidepanel.metric.toolsUsed.label": "Right tools used",
	"evaluations.wizardSidepanel.metric.toolsUsed.description": "Did the AI use the tools you expected it to?",
	"evaluations.wizardSidepanel.metric.customMetrics.label": "Custom Metrics",
	"evaluations.wizardSidepanel.metric.customMetrics.description": "Define your own metric(s).",
	"evaluations.addToDataset.button.label": "Add to evaluation dataset",
	"evaluations.addToDataset.button.tooltip.noConfig": "Create an evaluation with a data table dataset to add executions to it",
	"evaluations.addToDataset.title": "Add execution to evaluation dataset",
	"evaluations.addToDataset.config.label": "Evaluation",
	"evaluations.addToDataset.mapping.title": "Map execution data to dataset columns",
	"evaluations.addToDataset.leaveEmpty": "Leave empty",
	"evaluations.addToDataset.field.placeholder": "Select a field",
	"evaluations.addToDataset.source.input": "input",
	"evaluations.addToDataset.source.output": "output",
	"evaluations.addToDataset.submit": "Add to dataset",
	"evaluations.addToDataset.noColumns": "This dataset has no columns to fill.",
	"evaluations.addToDataset.empty": "(empty)",
	"evaluations.addToDataset.success.title": "Execution added to dataset",
	"evaluations.addToDataset.error.candidate": "Could not load execution data",
	"evaluations.addToDataset.error.submit": "Could not add execution to dataset",
	"evaluations.wizardSidepanel.step2.aiNode": "AI node",
	"evaluations.wizardSidepanel.step2.aiNode.placeholder": "Pick an AI node",
	"evaluations.wizardSidepanel.step2.extendToSlice": "Need to evaluate a wider section of the workflow?",
	"evaluations.wizardSidepanel.step2.resetToAiNode": "Select single node",
	"evaluations.wizardSidepanel.step2.start": "Start",
	"evaluations.wizardSidepanel.step2.start.placeholder": "Pick a node",
	"evaluations.wizardSidepanel.step2.end": "End",
	"evaluations.wizardSidepanel.step2.end.placeholder": "Pick a node",
	"evaluations.wizardSidepanel.step2.input": "Input",
	"evaluations.wizardSidepanel.step2.input.placeholder": "Type the input you want to test with",
	"evaluations.wizardSidepanel.step2.expected": "Expected output",
	"evaluations.wizardSidepanel.step2.expected.placeholder": "Type the output you’d expect from your workflow",
	"evaluations.wizardSidepanel.step2.expected.tooltip": "Checks compare the real output against this.",
	"evaluations.wizardSidepanel.step2.expectedAnswer": "Expected answer",
	"evaluations.wizardSidepanel.step2.expectedTools": "Expected tools",
	"evaluations.wizardSidepanel.step2.expectedFieldPlaceholder": "Type the value checks should compare against",
	"evaluations.wizardSidepanel.step2.inputs.heading": "Inputs",
	"evaluations.wizardSidepanel.step2.expected.heading": "Expected outputs",
	"evaluations.wizardSidepanel.step2.persistError": "Couldn’t save your test case. Please try again.",
	"evaluations.wizardSidepanel.step2.dispatchError": "Saved your test case, but couldn’t start the evaluation run. Click Next again to retry.",
	"evaluations.wizardSidepanel.step3.running": "Running tests…",
	"evaluations.wizardSidepanel.step3.scoring": "Scoring…",
	"evaluations.wizardSidepanel.step3.caseLabel": "Case #{index}",
	"evaluations.wizardSidepanel.step3.aiAnswer": "AI’s answer",
	"evaluations.wizardSidepanel.step3.averageLabel": "Average",
	"evaluations.wizardSidepanel.step3.passedLabel": "Passed",
	"evaluations.wizardSidepanel.step3.outputMeta": "Tokens: {tokens} · Time: {time}",
	"evaluations.wizardSidepanel.step3.noRun": "Run the evaluation to see results.",
	"evaluations.wizardSidepanel.gate.message": "Run your workflow at least once first — it tells us what inputs your AI takes.",
	"evaluations.wizardSidepanel.step.chooseSystem.title": "What are we evaluating?",
	"evaluations.wizardSidepanel.step.chooseSystem.description": "Pick the AI node in your workflow you want to check.",
	"evaluations.wizardSidepanel.step.setupChecks.title": "How should we score each case?",
	"evaluations.wizardSidepanel.step.setupChecks.description": "Correctness is the most common way to score an AI’s answers — we’ve selected it for you. Add more checks if you want to score on other dimensions too.",
	"evaluations.wizardSidepanel.step.addTestCases.title": "Add the cases you want to test",
	"evaluations.wizardSidepanel.step.addTestCases.description": "Give the AI an example input, then write what you’d want it to do. n8n uses each case to score your AI when you run your Eval.",
	"evaluations.wizardSidepanel.step.addTestCases.runFirst": "Run your workflow first so we can help you add a test case",
	"evaluations.wizardSidepanel.step.addTestCases.runButton": "Run workflow",
	"evaluations.wizardSidepanel.step.results.title": "Your Eval results",
	"evaluations.wizardSidepanel.step.results.description": "Here’s how your AI did on each case. Run again to see if your changes helped.",
	"evaluations.wizardSidepanel.nav.chooseSystem": "Choose system",
	"evaluations.wizardSidepanel.nav.setupChecks": "Setup checks",
	"evaluations.wizardSidepanel.nav.addTestCases": "Add test cases",
	"evaluations.wizardSidepanel.nav.runTests": "Run tests",
	"evaluations.wizardSidepanel.nav.runAgain": "Run again",
	"evaluations.wizardSidepanel.nav.viewResults": "View Results",
	"evaluations.wizardSidepanel.nav.next.checks": "Next: Choose how to score",
	"evaluations.wizardSidepanel.nav.next.cases": "Next: Add cases",
	"evaluations.wizardSidepanel.nav.next.run": "Next: Run Eval",
	"evaluations.wizardSidepanel.nav.back": "Back",
	"evaluations.wizardSidepanel.nav.editEvals": "Edit evals",
	"evaluations.wizardSidepanel.nav.viewDetailedResults": "View detailed results",
	"evaluations.wizardSidepanel.hydrate.error": "Couldn’t load your previous setup. Starting with a blank wizard.",
	"evaluations.canvasInfoCard.title": "Setup evaluations for workflows",
	"evaluations.canvasInfoCard.description": "Catch issues early and build with confidence with automated tests using model-graded checks.",
	"evaluations.canvasInfoCard.setup": "Setup",
	"evaluations.canvasInfoCard.dismiss": "Dismiss",
	"evaluations.emptyState.title": "Evaluations",
	"evaluations.emptyState.description": "Evaluations are automated tests that assess agent workflow outputs using model-graded checks.",
	"evaluations.emptyState.catchIssues.title": "Catch issues early",
	"evaluations.emptyState.catchIssues.description": "Spot failures and unexpected behaviour before going live.",
	"evaluations.emptyState.buildConfidence.title": "Build with confidence",
	"evaluations.emptyState.buildConfidence.description": "Make changes and iterate without relying on guesswork.",
	"evaluations.emptyState.measurePerformance.title": "Measure performance",
	"evaluations.emptyState.measurePerformance.description": "Track performance and areas for improvement in workflows.",
	"evaluations.emptyState.getStarted": "Get started",
	"evaluations.wizardSidepanel.customCheck.title": "Custom check",
	"evaluations.wizardSidepanel.customCheck.name": "Name",
	"evaluations.wizardSidepanel.customCheck.name.placeholder": "My custom check",
	"evaluations.wizardSidepanel.customCheck.expression": "Expression",
	"evaluations.wizardSidepanel.customCheck.expression.hint": "Must return a numeric or boolean value. Reference workflow data with $json (e.g. $json.output.length).",
	"evaluations.wizardSidepanel.customCheck.expression.placeholder": "e.g. $json.output.length > 0",
	"evaluations.wizardSidepanel.customCheck.expressionTag": "Expression",
	"evaluations.wizardSidepanel.customCheck.submit": "Add check",
	"evaluations.wizardSidepanel.customCheck.remove": "Remove custom check",
	"evaluations.tests.addTestCase": "Add test case",
	"evaluations.tests.runAll": "Run all",
	"evaluations.tests.runAll.error": "Couldn't run all test cases. Please try again.",
	"evaluations.tests.list.heading": "Test cases",
	"evaluations.tests.list.empty": "No test cases yet. Add one below or start from a recent run.",
	"evaluations.tests.list.caseLabel": "Test case {index}",
	"evaluations.tests.list.seedCaseLabel": "First test case",
	"evaluations.tests.list.noInput": "(no input)",
	"evaluations.tests.list.editHint": "Edit",
	"evaluations.tests.executions.heading": "Start from a recent run",
	"evaluations.tests.executions.hint": "Pick a successful execution to prefill a new test case.",
	"evaluations.tests.newCase.title": "New case",
	"evaluations.tests.suite.receivesInput": "receives input, check output",
	"evaluations.tests.results.createCase": "Create case",
	"evaluations.tests.results.empty": "No test cases yet. Create one to get started.",
	"evaluations.tests.empty.noNode": "You need to add a node before you can create tests",
	"evaluations.tests.empty.noNode.button": "Add node",
	"evaluations.tests.empty.noExecutions": "Help us to setup your evaluations by executing your workflow",
	"evaluations.tests.empty.execute": "Execute workflow",
	"evaluations.tests.empty.chooseTrigger": "Choose a trigger",
	"evaluations.tests.results.runLabel": "Run #{number}, {date}",
	"evaluations.tests.results.running": "Running…",
	"evaluations.tests.results.runFailed": "Run failed",
	"evaluations.tests.results.metric.promptTokens": "Prompt tokens",
	"evaluations.tests.results.metric.completionTokens": "Completion tokens",
	"evaluations.tests.results.metric.totalTokens": "Total tokens",
	"evaluations.tests.results.metric.executionTime": "Time",
	"evaluations.tests.chooseAiNode": "Choose an AI node to test",
	"evaluations.tests.chooseAiNode.placeholder": "Select a node",
	"evaluations.tests.chooseExecution": "Use a previous execution to create a test case",
	"evaluations.tests.createManually": "Create manually",
	"evaluations.tests.createManually.hint": "Or start from scratch",
	"evaluations.tests.executions.createCase": "Use execution",
	"evaluations.tests.executions.manualBadge": "Manual execution",
	"evaluations.tests.executions.input": "Input",
	"evaluations.tests.executions.output": "Output",
	"evaluations.tests.executions.empty": "No successful executions yet. Run your workflow to create a test case.",
	"evaluations.tests.seedFromExecution.error": "Couldn't load that execution. Please try another.",
	"evaluations.tests.detail.delete": "Delete case",
	"evaluations.tests.detail.delete.confirm.title": "Delete test case?",
	"evaluations.tests.detail.delete.confirm.message": "This test case will be permanently removed from the dataset. This can't be undone.",
	"evaluations.tests.detail.title": "Test case",
	"evaluations.tests.detail.system.heading": "System under test",
	"evaluations.tests.detail.metrics.heading": "Checks",
	"evaluations.tests.detail.expected.heading": "Expected output",
	"evaluations.tests.detail.run": "Run",
	"evaluations.tests.detail.runAgain": "Run again",
	"evaluations.tests.detail.when": "When",
	"evaluations.tests.detail.receivesInput": "receives input",
	"evaluations.tests.detail.output": "Output",
	"evaluations.tests.detail.addMetric": "Add check",
	"evaluations.tests.detail.addMetric.custom": "Custom",
	"evaluations.tests.detail.removeMetric": "Remove metric",
	"evaluations.tests.detail.tools.empty": "No tools are connected to this node.",
	"evaluations.tests.metric.correctness.option": "To be similar",
	"evaluations.tests.metric.stringSimilarity.option": "To be exactly",
	"evaluations.tests.metric.toolsUsed.option": "To use specific tools",
	"evaluations.tests.metric.correctness.sentence": "Response to be similar to (0-5):",
	"evaluations.tests.metric.helpfulness.sentence": "Response to be helpful (0-5)",
	"evaluations.tests.metric.stringSimilarity.sentence": "Response to be exactly:",
	"evaluations.tests.metric.categorization.sentence": "Response to match category:",
	"evaluations.tests.metric.toolsUsed.sentence": "To use specific tools:",
	"evaluations.tests.metric.custom.sentence": "Custom (expression based):",
	"evaluations.tests.metric.custom.placeholder": "$json.response.length > 1000",
	"evaluations.tests.metrics.label": "Checks",
	"evaluations.tests.metrics.none": "None selected",
	"evaluations.tests.metrics.selected": "{count} selected",
	"freeAi.credits.callout.claim.title": "Get {credits} free OpenAI API credits",
	"freeAi.credits.callout.claim.button.label": "Claim credits",
	"freeAi.credits.callout.success.title.part1": "Claimed {credits} free OpenAI API credits! Please note these free credits are only for the following models:",
	"freeAi.credits.callout.success.title.part2": "gpt-5-mini, gpt-4.1-mini, gpt-4.1-nano, gpt-4o-mini, text-embedding-3-small, dall-e-3, tts-1, whisper-1, and text-moderation-latest",
	"freeAi.credits.callout.success.chatHub.beginning": "We've given you ",
	"freeAi.credits.callout.success.chatHub.credits": "{amount} free OpenAI API credits",
	"freeAi.credits.callout.success.chatHub.end": " to get started",
	"freeAi.credits.credentials.edit": "This is a managed credential and cannot be edited.",
	"freeAi.credits.showError.claim.title": "Free AI credits",
	"freeAi.credits.showError.claim.message": "Enable to claim credits",
	"freeAi.credits.showWarning.workflow.activation.title": "You're using free OpenAI API credits",
	"freeAi.credits.showWarning.workflow.activation.description": "To make sure your workflow runs smoothly in the future, replace the free OpenAI API credits with your own API key.",
	"insights.heading": "Insights",
	"insights.lastNDays": "Last {count} days",
	"insights.lastNHours": "Last {count} hours",
	"insights.months": "{count} months",
	"insights.oneYear": "One year",
	"insights.banner.timeSaved.tooltip": "No estimate available yet. To see potential time savings, {link} to each workflow from workflow settings.",
	"insights.banner.timeSaved.tooltip.link.text": "add time estimates",
	"insights.banner.noData.tooltip": "Manual executions aren’t counted. Data may take up to 24 hours to update after upgrading. {link}",
	"insights.banner.noData.tooltip.link": "Learn more",
	"insights.banner.noData.tooltip.link.url": "https://docs.n8n.io/insights/",
	"insights.banner.title.total": "Prod. executions",
	"insights.banner.title.failed": "Failed prod. executions",
	"insights.banner.title.failureRate": "Failure rate",
	"insights.banner.title.timeSaved": "Time saved",
	"insights.banner.title.timeSavedDailyAverage": "Time saved daily avg.",
	"insights.banner.title.averageRunTime": "Run time (avg.)",
	"insights.dashboard.chart.title": "Breakdown by {granularity}",
	"insights.dashboard.table.projectName": "Project name",
	"insights.dashboard.table.title": "Breakdown by workflow",
	"insights.dashboard.table.estimate": "Estimate",
	"insights.dashboard.table.noAccess": "You don't have access to this workflow",
	"insights.dashboard.title": "Insights",
	"insights.dashboard.search.placeholder": "All projects",
	"insights.dashboard.dataRangeAlert.title": "Your selected range goes back further than your data",
	"insights.dashboard.dataRangeAlert.description": "Insights started collecting data on {date}. The 1 earlier day in your range does not have any data available. | Insights started collecting data on {date}. The {days} earlier days in your range do not have any data available.",
	"insights.dashboard.dataRangeAlert.descriptionNoData": "Insights started collecting data on {date}. Your selected range does not have any data available.",
	"insights.dashboard.dataRangeAlert.dismiss": "Dismiss",
	"insights.dashboard.paywall.title": "Upgrade to access more detailed insights",
	"insights.dashboard.paywall.description": "Gain access to more granular, per-workflow insights and visual breakdown of production executions over different time periods.",
	"insights.banner.title.timeSaved.tooltip": "Total time saved calculated from your estimated time savings per execution across all workflows",
	"insights.banner.queueMode.warning": "We identified and fixed an issue where insights execution counts were duplicated for queue mode users.",
	"insights.banner.queueMode.warning.link.text": "Learn more",
	"insights.banner.queueMode.warning.link.url": "https://community.n8n.io/t/insights-reporting-bug-for-queue-mode-users-on-v1-100-0",
	"insights.banner.failureRate.deviation.tooltip": "Percentage point change from previous period",
	"insights.chart.failed": "Failed",
	"insights.chart.succeeded": "Successful",
	"insights.chart.loading": "Loading data",
	"communityNodesDocsLink.link.title": "Open community node docs",
	"communityNodesDocsLink.title": "Docs",
	"communityNodeItem.node.hint": "Install this node to start using it",
	"communityNodeItem.actions.hint": "Install this node to start using actions",
	"communityNodeItem.label": "Add to workflow",
	"communityNodeDetails.installed": "Installed",
	"communityNodeDetails.install": "Install node",
	"communityNodeInfo.approved": "This community node has been reviewed and approved by n8n",
	"communityNodeInfo.officialApproved": "This node has been reviewed and approved by n8n",
	"communityNodeInfo.approved.label": "Verified",
	"communityNodeInfo.unverified": "This community node was added via npm and has not been verified by n8n",
	"communityNodeInfo.unverified.label": "Via npm",
	"communityNodeInfo.downloads": "{downloads}",
	"communityNodeInfo.publishedBy": "{publisherName}",
	"communityNodeInfo.quickConnect": "Quick connect",
	"communityNodeInfo.quickConnect.tooltip": "This service allows for easy sign in or sign up directly through n8n",
	"communityNodeInfo.contact.admin": "Please contact an administrator to install this community node:",
	"credentialsAppSelection.installToConnect": "Install this node to connect",
	"credentialsAppSelection.askAdminToInstall": "Ask your admin to install this node",
	"credentialsAppSelection.credentialsNotValid": "Credentials are not valid",
	"communityNodeUpdateInfo.available": "A new node package version is available",
	"insights.upgradeModal.button.dismiss": "Dismiss",
	"insights.upgradeModal.content": "Viewing this time period requires an enterprise plan. Upgrade to Enterprise to unlock advanced features.",
	"insights.upgradeModal.perks.0": "View up to one year of insights history",
	"insights.upgradeModal.perks.1": "Zoom into last 24 hours with hourly granularity",
	"insights.upgradeModal.perks.2": "Gain deeper visibility into workflow trends over time",
	"insights.upgradeModal.title": "Upgrade to Enterprise",
	"whatsNew.versionsBehind": "Update ({count} version behind) | Update ({count} versions behind)",
	"whatsNew.update": "Update",
	"whatsNew.updateNudgeTooltip": "Only owners can perform updates",
	"whatsNew.updateAvailable": "You're currently on version {currentVersion}. Update to {latestVersion} to get {count} versions worth of new features, improvements, and fixes. See what changed",
	"whatsNew.updateAvailable.changelogLink": "in the full changelog",
	"workflowDiff.changes": "Changes",
	"workflowDiff.nodes": "Nodes",
	"workflowDiff.connectors": "Connectors",
	"workflowDiff.compare": "Compare versions",
	"workflowDiff.settings": "Settings",
	"workflowDiff.local": "Local",
	"workflowDiff.remote": "Remote ({branchName})",
	"workflowDiff.noChanges": "No changes",
	"workflowDiff.deletedWorkflow": "Missing workflow",
	"workflowDiff.deletedWorkflow.database": "The workflow doesn't exist in the database",
	"workflowDiff.deletedWorkflow.remote": "The workflow doesn't exist on remote",
	"workflowDiff.newWorkflow": "New workflow",
	"workflowDiff.newWorkflow.database": "The workflow will be created in the database",
	"workflowDiff.newWorkflow.remote": "The workflow will be created on remote",
	"workflowDiff.label.before": "Before",
	"workflowDiff.label.after": "After",
	"workflowDiff.waitingForData": "Waiting for workflow data...",
	"workflowDiff.error.loadNodeTypes": "Could not load node types",
	"workflowDiff.compareVersionsLoadError": "Could not load workflow versions for comparison",
	"workflowDiff.versionMismatchError": "Cannot compare versions from different workflows",
	"commandBar.placeholder": "Type a command or search...",
	"commandBar.noResults": "No results found",
	"commandBar.sections.recent": "Recent",
	"commandBar.sections.nodes": "Nodes",
	"commandBar.sections.workflow": "Workflow",
	"commandBar.sections.workflows": "Workflows",
	"commandBar.sections.credentials": "Credentials",
	"commandBar.sections.dataTables": "Data Tables",
	"commandBar.sections.execution": "Execution",
	"commandBar.sections.executions": "Executions",
	"commandBar.sections.evaluation": "Evaluation",
	"commandBar.sections.demo": "Demo",
	"commandBar.sections.chat": "Chat",
	"commandBar.sections.general": "Navigation",
	"commandBar.templates.import": "Import template",
	"commandBar.templates.importWithPrefix": "Import template {templateName}",
	"commandBar.nodes.addNode": "Add node",
	"commandBar.nodes.addStickyNote": "Add sticky note",
	"commandBar.nodes.openNode": "Open node",
	"commandBar.nodes.openNodeWithPrefix": "Open node > {nodeName}",
	"commandBar.nodes.addNodeWithPrefix": "Add node > {nodeName}",
	"commandBar.nodes.searchPlaceholder": "Search by node name, type, etc.",
	"commandBar.nodes.keywords.insert": "insert",
	"commandBar.nodes.keywords.add": "add",
	"commandBar.nodes.keywords.create": "create",
	"commandBar.nodes.keywords.node": "node",
	"commandBar.workflow.test": "Execute workflow",
	"commandBar.workflow.activate": "Activate workflow",
	"commandBar.workflow.deactivate": "Deactivate workflow",
	"commandBar.workflow.selectAll": "Select all",
	"commandBar.workflow.tidyUp": "Tidy up workflow",
	"commandBar.workflow.rename": "Rename workflow",
	"commandBar.workflow.duplicate": "Duplicate workflow",
	"commandBar.workflow.openSettings": "Open workflow settings",
	"commandBar.workflow.download": "Download workflow",
	"commandBar.workflow.importFromURL": "Import workflow from URL",
	"commandBar.workflow.importFromFile": "Import workflow from file",
	"commandBar.workflow.openCredential": "Open credential",
	"commandBar.workflow.openSubworkflow": "Open sub-workflow",
	"commandBar.workflow.archive": "Archive workflow",
	"commandBar.workflow.unarchive": "Unarchive workflow",
	"commandBar.workflow.delete": "Delete workflow",
	"commandBar.workflow.publish": "Publish workflow",
	"commandBar.workflow.unpublish": "Unpublish workflow",
	"commandBar.workflow.keywords.test": "test",
	"commandBar.workflow.keywords.execute": "execute",
	"commandBar.workflow.keywords.run": "run",
	"commandBar.workflow.keywords.workflow": "workflow",
	"commandBar.workflow.keywords.download": "download",
	"commandBar.workflow.keywords.export": "export",
	"commandBar.workflow.keywords.archive": "archive",
	"commandBar.workflow.keywords.delete": "delete",
	"commandBar.workflow.keywords.unarchive": "unarchive",
	"commandBar.workflow.keywords.restore": "restore",
	"commandBar.workflows.create": "Create workflow in {projectName}",
	"commandBar.workflows.open": "Open workflow",
	"commandBar.workflows.searchPlaceholder": "Search by workflow name or node type...",
	"commandBar.workflows.unnamed": "(unnamed workflow)",
	"commandBar.credentials.create": "Create credential in {projectName}",
	"commandBar.credentials.open": "Open credential",
	"commandBar.credentials.searchPlaceholder": "Search by credential name...",
	"commandBar.dataTables.create": "Create data table in {projectName}",
	"commandBar.dataTables.open": "Open data table",
	"commandBar.dataTables.searchPlaceholder": "Search by data table name...",
	"commandBar.executions.open": "Open executions",
	"commandBar.demo.availableEverywhere": "This is available everywhere",
	"commandBar.sections.projects": "Projects",
	"commandBar.projects.create": "Create project",
	"commandBar.projects.open": "Open project",
	"commandBar.projects.searchPlaceholder": "Search by project name...",
	"commandBar.projects.unnamed": "(unnamed project)",
	"commandBar.chat.new": "New chat",
	"commandBar.chat.newWithModel": "New chat with...",
	"commandBar.chat.open": "Open chat",
	"commandBar.chat.delete": "Delete chat",
	"commandBar.chat.deleteCurrent": "Delete current chat",
	"commandBar.chat.deleteSession": "Delete \"{title}\"",
	"commandBar.chat.open.searchPlaceholder": "Search by f title...",
	"commandBar.chat.stop": "Stop message generation",
	"commandBar.sections.instanceAi": "AI Assistant",
	"commandBar.instanceAi.open": "Open AI Assistant",
	"commandBar.instanceAi.newThread": "New conversation",
	"commandBar.instanceAi.openThread": "Open conversation",
	"commandBar.instanceAi.openThread.searchPlaceholder": "Search by title...",
	"browserNotifications.permission.request.title": "Enable desktop notifications",
	"browserNotifications.permission.request.message": "Get notified when your workflows complete or need attention.",
	"browserNotifications.permission.request.allow": "Allow notifications",
	"browserNotifications.permission.request.dismiss": "Not now",
	"browserNotifications.permission.denied.title": "Notifications blocked",
	"browserNotifications.permission.denied.message": "Desktop notifications are blocked. To enable them, click the lock icon in your browser's address bar and allow notifications.",
	"browserNotifications.permission.denied.checkAgain": "Check again",
	"browserNotifications.permission.granted.message": "Desktop notifications are enabled",
	"focusedNodes.nodesLabel": "nodes",
	"focusedNodes.nodesCount": "{count} nodes",
	"focusedNodes.noMatches": "No nodes matching \"{query}\"",
	"focusedNodes.mentionPlaceholder": "Search nodes...",
	"focusedNodes.mentionTooltip": "Mention a node",
	"focusedNodes.allNodes": "All nodes",
	"focusedNodes.unconfirmedTooltip": "Add as context for the assistant",
	"instanceAi.view.title": "AI Assistant",
	"instanceAi.view.subtitle": "Chat with your n8n instance",
	"instanceAi.askAiAssistant": "Ask AI Assistant",
	"instanceAi.canvasActionPopover.title": "Try new AI Assistant",
	"instanceAi.canvasActionPopover.body": "Building, questions, and debugging with AI now happen in the AI Assistant.",
	"instanceAi.canvasActionPopover.action": "Open AI Assistant",
	"instanceAi.input.disclaimer": "Preview version. AI can make mistakes; always verify responses.",
	"instanceAi.input.placeholder": "Ask anything...",
	"instanceAi.input.suspendedPlaceholder": "Complete or skip the setup above to continue",
	"instanceAi.input.workflowBuilderUnavailablePlaceholder": "Workflow builder unavailable",
	"instanceAi.input.send": "Send",
	"instanceAi.input.stop": "Stop",
	"instanceAi.launch.template.message": "I want to start from the workflow template '{name}' (template id: {id}). Load it and give me a short, plain summary: what triggers it, what it does, and which apps it uses. Keep it to a few sentences. Then ask me a few questions specific to this template's steps and apps so I can adapt it, like which of its apps to swap, what to connect, or what behavior to change. Make each question quick to answer: give me numbered choices or ask for a short reply. Don't build anything until I answer.",
	"instanceAi.launch.templateById.message": "I want to start from the workflow template with id {id}. Load it and give me a short, plain summary: what triggers it, what it does, and which apps it uses. Keep it to a few sentences. Then ask me a few questions specific to this template's steps and apps so I can adapt it, like which of its apps to swap, what to connect, or what behavior to change. Make each question quick to answer: give me numbered choices or ask for a short reply. Don't build anything until I answer.",
	"instanceAi.toolCall.input": "Input",
	"instanceAi.toolCall.output": "Output",
	"instanceAi.toolCall.running": "Running...",
	"instanceAi.toolCall.error": "Error",
	"instanceAi.toolResult.moreRows": "and {count} more rows...",
	"instanceAi.toolResult.dataTruncated": "Data truncated for display.",
	"instanceAi.thread.new": "New chat",
	"instanceAi.sidebar.back": "Back",
	"instanceAi.sidebar.threads": "Threads",
	"instanceAi.sidebar.chatHistory": "Chat history",
	"instanceAi.sidebar.collapse": "Collapse sidebar",
	"instanceAi.message.reasoning": "Reasoning",
	"instanceAi.sidebar.noThreads": "No conversations yet",
	"instanceAi.sidebar.group.thisWeek": "This week",
	"instanceAi.sidebar.group.older": "Older",
	"instanceAi.sidebar.renameThread": "Rename",
	"instanceAi.sidebar.deleteThread": "Delete",
	"instanceAi.connections.title": "Connections",
	"instanceAi.connections.empty.title": "No connections yet",
	"instanceAi.connections.empty.cta": "Add a connection",
	"instanceAi.connections.add.label": "Add connection",
	"instanceAi.connections.add.computerUse": "Computer Use",
	"instanceAi.connections.add.browserUse": "Browser Use",
	"instanceAi.connections.add.nothingAvailableTooltip": "All connections are already added",
	"instanceAi.connections.row.connect": "Connect",
	"instanceAi.connections.row.disconnect": "Disconnect",
	"instanceAi.connections.disconnectError.title": "Gateway disconnect failed",
	"instanceAi.connections.disconnectError.message": "Failed to disconnect gateway",
	"instanceAi.connections.row.remove": "Remove",
	"instanceAi.connections.row.settings": "Setup",
	"instanceAi.connections.row.status.connected": "Connected",
	"instanceAi.connections.row.status.waiting": "Waiting…",
	"instanceAi.connections.row.status.disconnected": "Disconnected",
	"instanceAi.connections.types.computerUse.subtitle": "Computer use",
	"instanceAi.connections.types.computerUse.description": "Work with local files, terminal commands, and your browser",
	"instanceAi.connections.types.browserUse.subtitle": "Browser use",
	"instanceAi.connections.types.browserUse.description": "Let the agent automate tasks in your browser",
	"instanceAi.mcp.success.connect": "Connected successfully",
	"instanceAi.mcp.success.changeCredential": "Credential changed successfully",
	"instanceAi.mcp.error.fetchConnections": "Failed to load MCP connections",
	"instanceAi.mcp.error.fetchCatalog": "Failed to load MCP server catalog",
	"instanceAi.mcp.error.fetchTools": "Failed to load MCP server tools",
	"instanceAi.mcp.error.connect": "Failed to connect MCP server",
	"instanceAi.mcp.error.updateSettings": "Failed to update MCP server settings",
	"instanceAi.mcp.error.disconnect": "Failed to disconnect MCP server",
	"instanceAi.mcp.settings.saved": "MCP server settings saved",
	"instanceAi.mcp.error.autoConnectAmbiguous.title": "Credential created",
	"instanceAi.mcp.error.autoConnectAmbiguous.message": "Multiple new credentials appeared. Please pick the one you just created from the credential picker.",
	"instanceAi.browserUse.modal.title": "Connect Browser Use",
	"instanceAi.browserUse.modal.description": "Let the agent automate tasks in your browser. Install the n8n Browser Use extension and connect it - no other software needed.",
	"instanceAi.browserUse.step.extension.title": "1. Install the Chrome extension",
	"instanceAi.browserUse.step.extension.description": "Install the n8n Browser Use extension for Google Chrome so the agent can control your browser.",
	"instanceAi.browserUse.step.extension.cta": "Install Chrome extension",
	"instanceAi.browserUse.step.extension.waiting": "Waiting for extension to connect…",
	"instanceAi.browserUse.step.connect.title": "2. Connect the extension",
	"instanceAi.browserUse.step.connect.description": "Open the extension's connect page, choose which tabs to share, and click Connect.",
	"instanceAi.browserUse.step.connect.cta": "Open Browser Use extension",
	"instanceAi.browserUse.connected": "Browser Use is connected",
	"instanceAi.browserUse.connected.description": "The agent can now use your browser. You can disconnect anytime from the extension or from the Connections list.",
	"instanceAi.browserUse.connectLinkError.title": "Browser Use setup failed",
	"instanceAi.browserUse.connectLinkError.message": "Could not create a connection link. Please try again.",
	"instanceAi.browserUse.disconnectError.title": "Browser Use disconnect failed",
	"instanceAi.browserUse.disconnectError.message": "Failed to disconnect Browser Use",
	"instanceAi.error.sendFailed": "Failed to send message",
	"instanceAi.view.reconnecting": "Reconnecting...",
	"instanceAi.agentTree.subAgent": "Sub-agent",
	"instanceAi.agentTree.tools": "Tools",
	"instanceAi.agentTree.completed": "Completed",
	"instanceAi.agentTree.cancelled": "Cancelled",
	"instanceAi.agentTree.stoppedByUser": "You stopped this run",
	"instanceAi.agentTree.timedOut": "Run timed out",
	"instanceAi.agentTree.error": "Error",
	"instanceAi.error.title": "Something went wrong",
	"instanceAi.error.technicalDetails": "Technical details",
	"instanceAi.error.outOfCredits.title": "You've run out of AI credits",
	"instanceAi.error.outOfCredits.upgrade": "Upgrade plan",
	"instanceAi.artifactsPanel.title": "Artifacts",
	"instanceAi.artifactsPanel.showPreview": "Show artifacts preview",
	"instanceAi.artifactsPanel.hidePreview": "Hide artifacts preview",
	"instanceAi.artifactsPanel.showPanel": "Show lists panel",
	"instanceAi.artifactsPanel.hidePanel": "Hide lists panel",
	"instanceAi.artifactsPanel.noArtifacts": "No artifacts yet",
	"instanceAi.artifactsPanel.openArtifact": "Open {name}",
	"instanceAi.artifactsPanel.tasks": "To-do list",
	"instanceAi.artifactsPanel.openWorkflow": "Open",
	"instanceAi.artifactsPanel.archived": "Archived",
	"instanceAi.artifactsPanel.project": "Project",
	"instanceAi.artifactsPanel.unknownProject": "Unknown project",
	"instanceAi.artifactsPanel.personalSpace": "Personal space",
	"instanceAi.artifactsPanel.context.title": "Context",
	"instanceAi.artifactsPanel.context.dismiss": "Dismiss",
	"instanceAi.artifactsPanel.context.addedToContext": "Preview session",
	"instanceAi.artifactsPanel.context.credentialModal": "Credential setup",
	"instanceAi.artifactsPanel.context.agentPreview": "Preview session",
	"instanceAi.artifactsPanel.context.agentPreviewNamed": "{name} session",
	"instanceAi.artifactsPanel.context.agentPreviewTitled": "{agentName} — {sessionTitle}",
	"instanceAi.artifactsPanel.context.agentPreviewSessionTitled": "{sessionTitle}",
	"instanceAi.projectSelect.tooltip": "Where AI assistant creates automations",
	"instanceAi.projectSelect.placeholder": "Select a project",
	"instanceAi.projectSelect.search": "Search projects",
	"instanceAi.projectSelect.noResults": "No results",
	"instanceAi.projectSelect.personalSpace": "Personal space",
	"instanceAi.previewTabBar.expand": "Expand panel",
	"instanceAi.previewTabBar.collapse": "Collapse panel",
	"instanceAi.previewTabBar.openInEditor": "Open in editor",
	"instanceAi.previewTabBar.openWorkflowInEditor": "Open workflow in editor",
	"instanceAi.previewTabBar.copyLink": "Copy link",
	"instanceAi.confirmation.approve": "Allow once",
	"instanceAi.confirmation.alwaysAllow": "Always allow",
	"instanceAi.confirmation.alwaysAllowSuffix": "during this session",
	"instanceAi.confirmation.allowPrompt": "Allow AI Assistant to {action}?",
	"instanceAi.confirmation.deny": "Deny",
	"instanceAi.confirmation.approved": "Allowed",
	"instanceAi.confirmation.denied": "Denied",
	"instanceAi.confirmation.deferred": "Skipped",
	"instanceAi.confirmation.pendingInline": "Waiting for approval",
	"instanceAi.confirmation.agentContext": "{agent} needs approval",
	"instanceAi.confirmation.approveAll": "Approve all",
	"instanceAi.confirmation.continue": "Continue",
	"instanceAi.gatewayConfirmation.allowForSession": "Allow for session",
	"instanceAi.gatewayConfirmation.allowOnce": "Allow once",
	"instanceAi.gatewayConfirmation.denyOnce": "Deny",
	"instanceAi.gatewayConfirmation.prompt": "Allow AI Assistant to access '{resources}' on Computer Use?",
	"instanceAi.askUser.placeholder": "Type your answer...",
	"instanceAi.askUser.submit": "Submit",
	"instanceAi.askUser.skip": "Skip",
	"instanceAi.domainAccess.prompt": "Allow AI Assistant to access {domain}?",
	"instanceAi.domainAccess.allowOnce": "Allow once",
	"instanceAi.domainAccess.allowDomain": "Always allow {domain}",
	"instanceAi.domainAccess.allowAll": "Allow all domains",
	"instanceAi.domainAccess.deny": "Deny",
	"instanceAi.webSearch.prompt": "AI Assistant wants to search the web",
	"instanceAi.webSearch.allowThread": "Always allow",
	"instanceAi.settings.permissions.fetchUrl.label": "Fetch URLs without approval",
	"instanceAi.credential.selected": "Credential selected",
	"instanceAi.credential.required": "This action requires a credential",
	"instanceAi.credential.allSelected": "All credentials configured",
	"instanceAi.credential.useSelected": "Use selected",
	"instanceAi.credential.deny": "Later",
	"instanceAi.credential.confirmAll": "Confirm all credentials",
	"instanceAi.credential.autoSetup": "Set up automatically",
	"instanceAi.credential.autoSetup.description": "Allow AI to control my browser",
	"instanceAi.credential.autoSetupStarted": "Automatic credential setup started",
	"instanceAi.credential.manualSetup": "Set up manually",
	"instanceAi.credential.manualSetup.description": "We can provide instructions",
	"instanceAi.credential.setupCredentialButton": "Set up credential",
	"instanceAi.credential.finalize.applyCredentials": "Apply credentials",
	"instanceAi.credential.finalize.later": "Later",
	"instanceAi.credential.finalize.applied": "Credentials applied",
	"instanceAi.credential.finalize.deferred": "Skipped — add credentials later",
	"instanceAi.credential.setupButton": "Set up credentials",
	"instanceAi.credential.setupTitle": "Set up {name}",
	"instanceAi.credential.continueButton": "Continue",
	"instanceAi.credential.modal.title": "Set up credentials",
	"instanceAi.workflowSetup.usedByNodes": "Used by {count} node | Used by {count} nodes",
	"instanceAi.workflowSetup.nodesUsing": "Nodes using this credential:",
	"instanceAi.workflowSetup.parameterIssues": "Parameters need attention:",
	"instanceAi.workflowSetup.testTrigger": "Test step",
	"instanceAi.workflowSetup.triggerSuccess": "Trigger test passed",
	"instanceAi.workflowSetup.triggerError": "Trigger test failed",
	"instanceAi.workflowSetup.triggerListening": "Listening for events…",
	"instanceAi.workflowSetup.apply": "Apply",
	"instanceAi.workflowSetup.configureNode": "Configure '{name}'",
	"instanceAi.workflowSetup.credentialTestFailedTooltip": "Credential test failed. Update the credential and try again.",
	"instanceAi.workflowSetup.stepIncompleteTooltip": "To continue, complete the required fields above or skip setup for now",
	"instanceAi.workflowSetup.applyCompleted": "Apply completed",
	"instanceAi.workflowSetup.later": "Skip setup for now",
	"instanceAi.workflowSetup.loading": "Loading setup…",
	"instanceAi.workflowSetup.applying": "Applying changes…",
	"instanceAi.workflowSetup.applied": "Workflow configured",
	"instanceAi.workflowSetup.partiallyApplied": "Partially configured — some nodes skipped",
	"instanceAi.workflowSetup.deferred": "Skipped — configure later",
	"instanceAi.workflowSetup.cardSkipped": "Skipped",
	"instanceAi.workflowSetup.selectOption": "Select an option",
	"instanceAi.workflowSetup.confirmTitle": "Ready to apply",
	"instanceAi.workflowSetup.confirmDescription": "{count} item configured | {count} items configured",
	"instanceAi.workflowSetup.reviewDetails": "Review details",
	"instanceAi.workflowSetup.stepCounter": "{current} of {total}",
	"instanceAi.workflowSetup.prevStep": "Previous step",
	"instanceAi.workflowSetup.nextStep": "Next step",
	"instanceAi.debug.title": "Debug",
	"instanceAi.debug.copyTrace": "Copy trace",
	"instanceAi.debug.timing": "Timing",
	"instanceAi.debug.events": "Events",
	"instanceAi.debug.messageInspector": "Message Inspector",
	"instanceAi.debug.connectionStatus": "Connection",
	"instanceAi.debug.tab.events": "Events",
	"instanceAi.debug.tab.threads": "Threads",
	"instanceAi.debug.tab.llmSteps": "LLM Steps",
	"instanceAi.debug.tab.workflowCode": "Workflow Code",
	"instanceAi.debug.runDebug.refresh": "Refresh",
	"instanceAi.debug.runDebug.noRuns": "No captured runs for this thread",
	"instanceAi.debug.runDebug.noSteps": "No LLM steps captured for this run",
	"instanceAi.debug.runDebug.noWorkflowCode": "No workflow code snapshots for this run",
	"instanceAi.debug.runDebug.selectRun": "Run",
	"instanceAi.debug.runDebug.runs": "Runs",
	"instanceAi.debug.runDebug.step": "Step {number}",
	"instanceAi.debug.runDebug.fetchError": "Failed to load run debug data",
	"instanceAi.debug.runDebug.success": "success",
	"instanceAi.debug.runDebug.failed": "failed",
	"instanceAi.debug.runDebug.openStepsModal": "Expand all steps",
	"instanceAi.debug.runDebug.stepsModalTitle": "LLM Steps",
	"instanceAi.debug.runDebug.input": "Input",
	"instanceAi.debug.runDebug.output": "Output",
	"instanceAi.debug.runDebug.system": "System",
	"instanceAi.debug.runDebug.messages": "Messages",
	"instanceAi.debug.runDebug.activeTools": "Active tools",
	"instanceAi.debug.runDebug.toolChoice": "Tool choice",
	"instanceAi.debug.runDebug.text": "Text",
	"instanceAi.debug.runDebug.toolCalls": "Tool calls",
	"instanceAi.debug.runDebug.usage": "Usage",
	"instanceAi.debug.runDebug.responseMessages": "Response",
	"instanceAi.debug.runDebug.noStepDetail": "No step details captured",
	"instanceAi.debug.runDebug.metadata": "Metadata",
	"instanceAi.debug.runDebug.inputSettings": "Step settings",
	"instanceAi.debug.runDebug.inputExtras": "Tools and step config",
	"instanceAi.debug.runDebug.outputMetadata": "Output metadata",
	"instanceAi.debug.runDebug.toolResults": "Tool results",
	"instanceAi.debug.runDebug.content": "Content",
	"instanceAi.debug.runDebug.systemPrompt": "System prompt",
	"instanceAi.debug.runDebug.charCount": "{count} chars",
	"instanceAi.debug.runDebug.tools": "Tools",
	"instanceAi.debug.runDebug.toolInput": "input",
	"instanceAi.debug.runDebug.toolOutput": "output",
	"instanceAi.debug.runDebug.stepCount": "{count} steps",
	"instanceAi.debug.runDebug.json": "JSON",
	"instanceAi.debug.runDebug.toolCall": "tool-call",
	"instanceAi.debug.runDebug.toolResult": "tool-result",
	"instanceAi.debug.runDebug.reasoning": "reasoning",
	"instanceAi.debug.threads.title": "Thread Inspector",
	"instanceAi.debug.threads.current": "Current",
	"instanceAi.debug.threads.messages": "Messages",
	"instanceAi.debug.threads.noThreads": "No threads found in storage",
	"instanceAi.debug.threads.noMessages": "No messages stored",
	"instanceAi.debug.threads.refresh": "Refresh",
	"instanceAi.debug.threads.fetchError": "Failed to load thread data",
	"instanceAi.debug.threads.messageCount": "{count} messages",
	"instanceAi.settings.title": "Settings",
	"instanceAi.settings.save": "Save",
	"instanceAi.settings.reset": "Reset",
	"instanceAi.settings.section.model": "Model",
	"instanceAi.settings.section.sandbox": "Sandbox",
	"instanceAi.settings.section.search": "Search",
	"instanceAi.settings.section.advanced": "Advanced",
	"instanceAi.settings.credential.label": "Credential",
	"instanceAi.settings.credential.placeholder": "Select a credential...",
	"instanceAi.settings.credential.none": "None (use environment variables)",
	"instanceAi.settings.credential.createNew": "+ Create new credential",
	"instanceAi.settings.credential.createBrave": "+ Create Brave Search credential",
	"instanceAi.settings.credential.createSearxng": "+ Create SearXNG credential",
	"instanceAi.settings.modelName.label": "Model name",
	"instanceAi.settings.modelName.placeholder": "e.g. claude-sonnet-4-5, gpt-4o",
	"instanceAi.settings.apiKey.set": "Set",
	"instanceAi.settings.apiKey.notSet": "Not set",
	"instanceAi.settings.sandboxEnabled.label": "Enable sandbox",
	"instanceAi.settings.sandboxProvider.label": "Sandbox provider",
	"instanceAi.settings.daytonaCredential.label": "Daytona credential",
	"instanceAi.settings.n8nSandboxCredential.label": "n8n sandbox API key credential",
	"instanceAi.settings.n8nSandbox.serviceUrlHint": "Set N8N_SANDBOX_SERVICE_URL in your environment to use the n8n Sandbox Service.",
	"instanceAi.settings.sandboxImage.label": "Sandbox Docker image",
	"instanceAi.settings.sandboxTimeout.label": "Sandbox timeout (ms)",
	"instanceAi.settings.searchCredential.label": "Search credential",
	"instanceAi.settings.browserMcp.label": "Chrome DevTools MCP",
	"instanceAi.settings.mcpServers.label": "MCP servers",
	"instanceAi.settings.mcpServers.placeholder": "name=url, comma-separated",
	"instanceAi.settings.section.permissions": "Permissions",
	"instanceAi.settings.permissions.description": "Toggle which actions require your approval before the agent executes them.",
	"instanceAi.settings.permissions.createWorkflow.label": "Create workflow without approval",
	"instanceAi.settings.permissions.updateWorkflow.label": "Update workflow without approval",
	"instanceAi.settings.permissions.runWorkflow.label": "Run workflow without approval",
	"instanceAi.settings.permissions.publishWorkflow.label": "Publish/unpublish workflow without approval",
	"instanceAi.settings.permissions.deleteWorkflow.label": "Delete workflow without approval",
	"instanceAi.settings.permissions.deleteCredential.label": "Delete credential without approval",
	"instanceAi.settings.permissions.deleteDataTable.label": "Delete data table without approval",
	"instanceAi.builderCard.title": "Building workflow",
	"instanceAi.builderCard.phase.researching": "Researching nodes",
	"instanceAi.builderCard.phase.schemas": "Loading schemas",
	"instanceAi.builderCard.phase.building": "Generating workflow",
	"instanceAi.builderCard.details": "Details",
	"instanceAi.builderCard.success": "Workflow created successfully",
	"instanceAi.builderCard.openWorkflow": "Open workflow",
	"instanceAi.builderCard.failed": "Build failed",
	"instanceAi.workflowPreview.title": "Workflow preview",
	"instanceAi.workflowPreview.openInEditor": "Open in editor",
	"instanceAi.workflowPreview.fetchError": "Could not load workflow",
	"instanceAi.dataTablePreview.title": "Data table preview",
	"instanceAi.dataTablePreview.open": "Open",
	"instanceAi.dataTablePreview.fetchError": "Could not load data table",
	"instanceAi.dataTableCard.title": "Managing data table",
	"instanceAi.dataTableCard.phase.checking": "Checking tables",
	"instanceAi.dataTableCard.phase.schema": "Modifying schema",
	"instanceAi.dataTableCard.phase.rows": "Managing rows",
	"instanceAi.dataTableCard.details": "Details",
	"instanceAi.dataTableCard.success": "Data table operations completed",
	"instanceAi.dataTableCard.failed": "Data table operation failed",
	"instanceAi.artifactCard.updatedJustNow": "Last updated just now",
	"instanceAi.artifactCard.updatedAgo": "Last updated {time} ago",
	"instanceAi.artifactCard.minute": "{count} minute",
	"instanceAi.artifactCard.minutes": "{count} minutes",
	"instanceAi.artifactCard.hour": "{count} hour",
	"instanceAi.artifactCard.hours": "{count} hours",
	"instanceAi.artifactCard.createdAt": "Created {date}",
	"instanceAi.artifactCard.columns": "{count} columns",
	"instanceAi.researchCard.title": "Researching",
	"instanceAi.researchCard.title.analyzing": "Analyzing results",
	"instanceAi.researchCard.phase.searching": "Searching",
	"instanceAi.researchCard.phase.searched": "Searched",
	"instanceAi.researchCard.phase.reading": "Reading",
	"instanceAi.researchCard.phase.read": "Read",
	"instanceAi.researchCard.phase.analyzing": "Analyzing results",
	"instanceAi.researchCard.details": "Details",
	"instanceAi.researchCard.complete": "Research complete",
	"instanceAi.researchCard.failed": "Research failed",
	"instanceAi.agent.stop": "Stop",
	"instanceAi.backgroundTask.running": "Working in the background...",
	"instanceAi.backgroundTask.completed": "Background task finished",
	"instanceAi.backgroundTask.failed": "Background task failed",
	"instanceAi.planReview.title": "Review plan",
	"instanceAi.planReview.titleResolved": "Plan",
	"instanceAi.planReview.titleExpired": "Plan (expired)",
	"instanceAi.planReview.expiredHint": "This plan can no longer be approved. Send a new message to continue.",
	"instanceAi.planReview.building": "Building plan...",
	"instanceAi.planReview.awaitingApproval": "Awaiting approval",
	"instanceAi.planReview.description": "Review the plan, then approve it to start building or request changes to revise it.",
	"instanceAi.planReview.askForEdits": "Ask for edits",
	"instanceAi.planReview.approve": "Approve",
	"instanceAi.planReview.deny": "Deny",
	"instanceAi.planReview.approved": "Plan approved",
	"instanceAi.planReview.denied": "Plan denied",
	"instanceAi.planReview.changesRequested": "Changes requested",
	"instanceAi.planReview.updating": "Updating plan...",
	"instanceAi.message.retry": "Retry",
	"instanceAi.input.amendPlaceholder": "Amend the {role} agent...",
	"instanceAi.fixWithAi.button": "Fix with AI",
	"instanceAi.fixWithAi.notice.title.single": "Execution failed in ‘{nodeName}’ node",
	"instanceAi.fixWithAi.notice.title.multiple": "{count} nodes failed",
	"instanceAi.fixWithAi.notice.dismiss": "Dismiss",
	"instanceAi.fixWithAi.errorDetails": "Error details",
	"instanceAi.fixWithAi.prompt.single": "The \"{nodeName}\" node failed with: \"{errorMessage}\". Help me debug and fix it",
	"instanceAi.fixWithAi.prompt.singleInWorkflow": "The \"{nodeName}\" node in workflow \"{workflowName}\" failed with: \"{errorMessage}\". Help me debug and fix it",
	"instanceAi.fixWithAi.prompt.multiple": "These nodes failed:\n{errorList}\n\nHelp me debug and fix them",
	"instanceAi.fixWithAi.prompt.multipleInWorkflow": "These nodes in workflow \"{workflowName}\" failed:\n{errorList}\n\nHelp me debug and fix them",
	"instanceAi.fixWithAi.prompt.errorLine": "- \"{nodeName}\": {errorMessage}",
	"instanceAi.input.planEditPlaceholder": "What should we change?",
	"instanceAi.input.planEditContext": "Plan edits",
	"instanceAi.feedback.success": "Thanks for your feedback!",
	"instanceAi.emptyState.title": "AI Assistant",
	"experiments.instanceAiTemplateExamples.empty": "No examples found",
	"experiments.instanceAiTemplateExamples.emptyState.title": "What can I help you automate?",
	"experiments.instanceAiTemplateExamples.description": "Or start with an automation from the community",
	"experiments.instanceAiTemplateExamples.card.editHint": "Use with my apps",
	"experiments.instanceAiTemplateExamples.card.ariaLabel": "Use example: {name}",
	"experiments.instanceAiTemplateExamples.nav.previous": "Previous examples",
	"experiments.instanceAiTemplateExamples.nav.next": "Next examples",
	"experiments.instanceAiTemplateExamples.input.placeholder": "Tell me what to build or ask me a question",
	"experiments.instanceAiTemplateExamples.subcategories.all": "All",
	"instanceAi.workflowBuilderUnavailable.title": "Workflow builder unavailable",
	"instanceAi.workflowBuilderUnavailable.enableSandboxDescription": "Ask an admin to enable Instance AI sandboxing.",
	"instanceAi.workflowBuilderUnavailable.serviceUrlDescription": "Ask an admin to set N8N_SANDBOX_SERVICE_URL for the n8n Sandbox Service.",
	"instanceAi.emptyState.suggestions.buildWorkflow.label": "Build a workflow",
	"instanceAi.emptyState.suggestions.buildWorkflow.prompt": "I want to build a new workflow. Help me figure out what to build. Ask me what's the end goal, what should trigger it, and what apps or services are involved.",
	"instanceAi.emptyState.suggestions.buildAgent.label": "Build an agent",
	"instanceAi.emptyState.suggestions.buildAgent.prompt": "I want to build a new agent. Help me figure out what to build. Ask me what the main purpose of the agent is, what should trigger it into action, what apps, tools, or knowledge it should have access to, and whether I have a preference for the AI model used.",
	"instanceAi.emptyState.suggestions.findAutomationIdeas.label": "Find inspiration",
	"instanceAi.emptyState.suggestions.findAutomationIdeas.prompt": "I want to use AI to automate more work. Give me suggestions. Ask me what I do for work, which apps I use, and what I wish I could get done.",
	"instanceAi.emptyState.suggestions.quickExamples.label": "Quick examples",
	"instanceAi.emptyState.quickExamples.monitorCompetitors.label": "Track competitor news",
	"instanceAi.emptyState.quickExamples.monitorCompetitors.prompt": "Once per week, search Google News for mentions of all the competitors listed in a Google Sheet, use Claude to summarize any articles published in the last week, and post the summary to #competitive-intel in Slack.",
	"instanceAi.emptyState.quickExamples.automateInbox.label": "Automate my inbox",
	"instanceAi.emptyState.quickExamples.automateInbox.prompt": "Every morning, read all emails received in the last 24 hours from Gmail, use OpenAI to extract action items and prioritize them, then send me a structured daily digest email summarizing what needs my attention.",
	"instanceAi.emptyState.quickExamples.answerSupportRequests.label": "Summarize and route requests",
	"instanceAi.emptyState.quickExamples.answerSupportRequests.prompt": "When a new email arrives in our Outlook inbox, use Claude to summarize what the prospect is looking for, rate its urgency and potential value, then notify the right person in Slack based on the product and region of the prospect.",
	"instanceAi.emptyState.quickExamples.analyseAdSpend.label": "Answer questions with an agent",
	"instanceAi.emptyState.quickExamples.analyseAdSpend.prompt": "Create an agent that is triggered by a WhatsApp message, gets the relevant information from our Google Doc knowledge base, uses Claude to generate an answer, and replies directly in the same WhatsApp conversation.",
	"instanceAi.emptyState.quickExamples.getNewsSummary.label": "Monitor inventory levels",
	"instanceAi.emptyState.quickExamples.getNewsSummary.prompt": "Twice a day, read inventory levels from a Google Sheet, flag items with fewer than 10 units as critical out-of-stock and fewer than 30 units as low stock, then have Claude draft a summary email for Gmail as well as personalized reorder emails.",
	"instanceAi.emptyState.quickExamples.close": "Close quick examples",
	"instanceAi.statusBar.thinking": "Thinking",
	"instanceAi.tools.workflows": "Workflows",
	"instanceAi.tools.workflows.list": "Listing workflows",
	"instanceAi.tools.workflows.get": "Reading workflow",
	"instanceAi.tools.workflows.get-as-code": "Reading workflow code",
	"instanceAi.tools.workflows.delete": "Archiving workflow",
	"instanceAi.tools.workflows.delete.imperative": "archive workflow",
	"instanceAi.tools.workflows.unarchive.imperative": "restore archived workflow",
	"instanceAi.tools.workflows.setup": "Setting up workflow",
	"instanceAi.tools.workflows.validate": "Validating workflow",
	"instanceAi.tools.workflows.publish": "Publishing workflow",
	"instanceAi.tools.workflows.publish.imperative": "publish workflow",
	"instanceAi.tools.workflows.unpublish": "Unpublishing workflow",
	"instanceAi.tools.workflows.unpublish.imperative": "unpublish workflow",
	"instanceAi.tools.workflows.list-versions": "Listing workflow versions",
	"instanceAi.tools.workflows.get-version": "Reading workflow version",
	"instanceAi.tools.workflows.update-version": "Updating workflow version",
	"instanceAi.tools.workflows.update-version.imperative": "update workflow version",
	"instanceAi.tools.workflows.restore-version": "Restoring workflow version",
	"instanceAi.tools.workflows.restore-version.imperative": "restore workflow version",
	"instanceAi.tools.executions": "Executions",
	"instanceAi.tools.executions.list": "Checking executions",
	"instanceAi.tools.executions.get": "Getting execution result",
	"instanceAi.tools.executions.run": "Running workflow",
	"instanceAi.tools.executions.run.imperative": "execute workflow",
	"instanceAi.tools.executions.debug": "Debugging execution",
	"instanceAi.tools.executions.get-node-output": "Reading node output",
	"instanceAi.tools.executions.get-resolved-node-parameters": "Inspecting node parameters",
	"instanceAi.tools.executions.stop": "Stopping execution",
	"instanceAi.tools.credentials": "Credentials",
	"instanceAi.tools.credentials.list": "Checking credentials",
	"instanceAi.tools.credentials.get": "Reading credential",
	"instanceAi.tools.credentials.delete": "Deleting credential",
	"instanceAi.tools.credentials.delete.imperative": "delete credential",
	"instanceAi.tools.credentials.search-types": "Searching credential types",
	"instanceAi.tools.credentials.setup": "Setting up credentials",
	"instanceAi.tools.credentials.test": "Testing credential",
	"instanceAi.tools.data-tables": "Data tables",
	"instanceAi.tools.data-tables.list": "Listing data tables",
	"instanceAi.tools.data-tables.schema": "Reading table schema",
	"instanceAi.tools.data-tables.query": "Querying data",
	"instanceAi.tools.data-tables.create": "Creating data table",
	"instanceAi.tools.data-tables.create.imperative": "create data table",
	"instanceAi.tools.data-tables.delete": "Deleting data table",
	"instanceAi.tools.data-tables.delete.imperative": "delete data table",
	"instanceAi.tools.data-tables.add-column": "Adding table column",
	"instanceAi.tools.data-tables.add-column.imperative": "add column",
	"instanceAi.tools.data-tables.delete-column": "Removing table column",
	"instanceAi.tools.data-tables.delete-column.imperative": "delete column",
	"instanceAi.tools.data-tables.rename-column": "Renaming table column",
	"instanceAi.tools.data-tables.rename-column.imperative": "rename column",
	"instanceAi.tools.data-tables.insert-rows": "Inserting rows",
	"instanceAi.tools.data-tables.insert-rows.imperative": "insert rows",
	"instanceAi.tools.data-tables.update-rows": "Updating rows",
	"instanceAi.tools.data-tables.update-rows.imperative": "update rows",
	"instanceAi.tools.data-tables.delete-rows": "Deleting rows",
	"instanceAi.tools.data-tables.delete-rows.imperative": "delete rows",
	"instanceAi.tools.workspace": "Workspace",
	"instanceAi.tools.workspace.list-projects": "Listing projects",
	"instanceAi.tools.workspace.list-tags": "Listing tags",
	"instanceAi.tools.workspace.tag-workflow": "Tagging workflow",
	"instanceAi.tools.workspace.tag-workflow.imperative": "tag workflow",
	"instanceAi.tools.workspace.cleanup-test-executions": "Cleaning up test executions",
	"instanceAi.tools.workspace.cleanup-test-executions.imperative": "delete test executions",
	"instanceAi.tools.workspace.list-folders": "Listing folders",
	"instanceAi.tools.workspace.create-folder": "Creating folder",
	"instanceAi.tools.workspace.create-folder.imperative": "create folder",
	"instanceAi.tools.workspace.delete-folder": "Deleting folder",
	"instanceAi.tools.workspace.delete-folder.imperative": "delete folder",
	"instanceAi.tools.workspace.move-workflow-to-folder": "Moving workflow to folder",
	"instanceAi.tools.workspace.move-workflow-to-folder.imperative": "move workflow",
	"instanceAi.tools.research": "Research",
	"instanceAi.tools.research.web-search": "Searching the web",
	"instanceAi.tools.research.fetch-url": "Fetching page",
	"instanceAi.tools.n8n-docs": "Reading n8n docs",
	"instanceAi.tools.n8n-docs.lookup": "Reading n8n docs",
	"instanceAi.tools.n8n-docs.search": "Searching n8n docs",
	"instanceAi.tools.n8n-docs.read": "Opening n8n docs",
	"instanceAi.tools.filesystem": "Filesystem",
	"instanceAi.tools.filesystem.list": "Listing files",
	"instanceAi.tools.filesystem.read": "Reading file",
	"instanceAi.tools.filesystem.search": "Searching files",
	"instanceAi.tools.filesystem.tree": "Reading file tree",
	"instanceAi.tools.nodes": "Nodes",
	"instanceAi.tools.nodes.list": "Listing available nodes",
	"instanceAi.tools.nodes.search": "Searching nodes",
	"instanceAi.tools.nodes.describe": "Reading node details",
	"instanceAi.tools.nodes.type-definition": "Loading node schema",
	"instanceAi.tools.nodes.suggested": "Getting suggested nodes",
	"instanceAi.tools.nodes.explore-resources": "Exploring node resources",
	"instanceAi.tools.task-control": "Task control",
	"instanceAi.tools.task-control.update-checklist": "Updating tasks",
	"instanceAi.tools.task-control.cancel-task": "Cancelling task",
	"instanceAi.tools.task-control.correct-task": "Correcting task",
	"instanceAi.tools.search-nodes": "Searching nodes",
	"instanceAi.tools.get-node-type-definition": "Loading node schema",
	"instanceAi.tools.get-node-description": "Reading node details",
	"instanceAi.tools.explore-node-resources": "Exploring node resources",
	"instanceAi.tools.get-suggested-nodes": "Getting suggested nodes",
	"instanceAi.tools.list-nodes": "Listing available nodes",
	"instanceAi.tools.get-workflow-as-code": "Reading workflow code",
	"instanceAi.tools.build-workflow": "Generating workflow",
	"instanceAi.tools.submit-workflow": "Submitting workflow",
	"instanceAi.tools.list-workflows": "Listing workflows",
	"instanceAi.tools.get-workflow": "Reading workflow",
	"instanceAi.tools.delete-workflow": "Archiving workflow",
	"instanceAi.tools.activate-workflow": "Activating workflow",
	"instanceAi.tools.materialize-node-type": "Installing node type",
	"instanceAi.tools.write-file": "Writing file",
	"instanceAi.tools.list-executions": "Checking executions",
	"instanceAi.tools.run-workflow": "Running workflow",
	"instanceAi.tools.get-execution": "Getting execution result",
	"instanceAi.tools.debug-execution": "Debugging execution",
	"instanceAi.tools.stop-execution": "Stopping execution",
	"instanceAi.tools.list-data-tables": "Listing data tables",
	"instanceAi.tools.get-data-table-schema": "Reading table schema",
	"instanceAi.tools.create-data-table": "Creating data table",
	"instanceAi.tools.delete-data-table": "Deleting data table",
	"instanceAi.tools.add-data-table-column": "Adding table column",
	"instanceAi.tools.delete-data-table-column": "Removing table column",
	"instanceAi.tools.rename-data-table-column": "Renaming table column",
	"instanceAi.tools.query-data-table-rows": "Querying data",
	"instanceAi.tools.insert-data-table-rows": "Inserting rows",
	"instanceAi.tools.update-data-table-rows": "Updating rows",
	"instanceAi.tools.delete-data-table-rows": "Deleting rows",
	"instanceAi.tools.list-credentials": "Checking credentials",
	"instanceAi.tools.get-credential": "Reading credential",
	"instanceAi.tools.test-credential": "Testing credential",
	"instanceAi.tools.setup-credentials": "Setting up credentials",
	"instanceAi.tools.delete-credential": "Deleting credential",
	"instanceAi.tools.plan": "Planning",
	"instanceAi.tools.list_skills": "Checking available skills",
	"instanceAi.tools.load_skill": "Opening skill",
	"instanceAi.tools.load_skill.asset": "Opening",
	"instanceAi.tools.load_skill.assetFallback": "asset",
	"instanceAi.tools.load_skill.example": "Reading",
	"instanceAi.tools.load_skill.exampleFallback": "example",
	"instanceAi.tools.load_skill.file": "Reading",
	"instanceAi.tools.load_skill.reference": "Reading",
	"instanceAi.tools.load_skill.referenceFallback": "reference",
	"instanceAi.tools.load_skill.script": "Inspecting",
	"instanceAi.tools.load_skill.scriptFallback": "script",
	"instanceAi.tools.load_skill.template": "Reading",
	"instanceAi.tools.load_skill.templateFallback": "template",
	"instanceAi.tools.web-search": "Searching the web",
	"instanceAi.tools.fetch-url": "Fetching page",
	"instanceAi.tools.build-workflow-with-agent": "Building workflow",
	"instanceAi.tools.build-workflow-with-agent.imperative": "edit workflow",
	"instanceAi.tools.ask-user": "Asking user",
	"instanceAi.tools.cancel-background-task": "Cancelling task",
	"instanceAi.tools.correct-background-task": "Correcting task",
	"instanceAi.tools.pause-for-user": "Waiting for input",
	"instanceAi.tools.update-tasks": "Updating tasks",
	"instanceAi.tools.report-verification-verdict": "Verifying workflow",
	"instanceAi.tools.verify-built-workflow": "Verifying workflow",
	"instanceAi.tools.complete-checkpoint": "Completing checkpoint",
	"instanceAi.tools.updateWorkingMemory": "Updating memory",
	"instanceAi.tools.apply-workflow-credentials": "Applying credentials",
	"instanceAi.tools.setup-workflow": "Setting up workflow",
	"instanceAi.tools.publish-workflow": "Publishing workflow",
	"instanceAi.tools.unpublish-workflow": "Unpublishing workflow",
	"instanceAi.tools.tag-workflow": "Tagging workflow",
	"instanceAi.tools.move-workflow-to-folder": "Moving workflow to folder",
	"instanceAi.tools.get-workflow-version": "Reading workflow version",
	"instanceAi.tools.list-workflow-versions": "Listing workflow versions",
	"instanceAi.tools.update-workflow-version": "Updating workflow version",
	"instanceAi.tools.restore-workflow-version": "Restoring workflow version",
	"instanceAi.tools.get-node-output": "Reading node output",
	"instanceAi.tools.cleanup-test-executions": "Cleaning up test executions",
	"instanceAi.tools.create-folder": "Creating folder",
	"instanceAi.tools.delete-folder": "Deleting folder",
	"instanceAi.tools.list-folders": "Listing folders",
	"instanceAi.tools.list-projects": "Listing projects",
	"instanceAi.tools.list-tags": "Listing tags",
	"instanceAi.tools.get-file-tree": "Reading file tree",
	"instanceAi.tools.list-files": "Listing files",
	"instanceAi.tools.read-file": "Reading file",
	"instanceAi.tools.search-files": "Searching files",
	"instanceAi.tools.parse-file": "Parsing file",
	"instanceAi.tools.workspace_read_file": "Reading file",
	"instanceAi.tools.workspace_write_file": "Writing file",
	"instanceAi.tools.workspace_edit_file": "Editing file",
	"instanceAi.tools.workspace_str_replace_file": "Editing file",
	"instanceAi.tools.workspace_batch_str_replace_file": "Editing files",
	"instanceAi.tools.workspace_append_file": "Appending file",
	"instanceAi.tools.workspace_list_files": "Listing files",
	"instanceAi.tools.workspace_delete": "Deleting file",
	"instanceAi.tools.workspace_delete_file": "Deleting file",
	"instanceAi.tools.workspace_file_stat": "Checking file info",
	"instanceAi.tools.workspace_mkdir": "Creating directory",
	"instanceAi.tools.workspace_rmdir": "Removing directory",
	"instanceAi.tools.workspace_copy_file": "Copying file",
	"instanceAi.tools.workspace_move_file": "Moving file",
	"instanceAi.tools.workspace_grep": "Searching files",
	"instanceAi.tools.workspace_ast_edit": "Editing code",
	"instanceAi.tools.workspace_execute_command": "Running command",
	"instanceAi.tools.workspace_execute_command.skill": "Running skill script",
	"instanceAi.tools.workspace_execute_command.skillScript": "Running",
	"instanceAi.tools.workspace_get_process_output": "Reading process output",
	"instanceAi.tools.workspace_list_processes": "Listing processes",
	"instanceAi.tools.workspace_kill_process": "Stopping process",
	"instanceAi.tools.workspace_search": "Searching workspace",
	"instanceAi.tools.workspace_index": "Indexing workspace",
	"instanceAi.stepTimeline.showData": "Show data",
	"instanceAi.stepTimeline.hideData": "Hide data",
	"instanceAi.stepTimeline.showBrief": "Show brief",
	"instanceAi.stepTimeline.hideBrief": "Hide brief",
	"instanceAi.stepTimeline.done": "Done",
	"instanceAi.stepTimeline.craftingWorkflow": "Crafting workflow",
	"instanceAi.activitySummary.toolCalls": "{count} tool calls",
	"instanceAi.thinking.active": "Thinking",
	"instanceAi.thinking.done": "Thought for {duration}",
	"instanceAi.thinking.doneFallback": "Finished thinking",
	"instanceAi.thinking.waitingForInput": "Waiting for your input",
	"projects.menu.instanceAi": "AI Assistant",
	"chatInputBase.button.attach": "Attach files",
	"chatInputBase.button.dictate": "Dictate",
	"instanceAi.filesystem.access.read": "Read only",
	"instanceAi.filesystem.access.readWrite": "Read & Write",
	"instanceAi.filesystem.category.browser": "Browser",
	"instanceAi.filesystem.category.computerUse": "Computer",
	"instanceAi.filesystem.category.filesystem": "Files",
	"instanceAi.filesystem.category.shell": "Shell",
	"instanceAi.settings.permissions.activateWorkflow.label": "Activate workflow without approval",
	"instanceAi.tools.patch-workflow": "Updating workflow",
	"agents.home.untitledAgent": "Untitled Agent",
	"agents.relativeTime.justNow": "just now",
	"agents.relativeTime.secondsAgo": "{count}s ago",
	"agents.relativeTime.minutesAgo": "{count}m ago",
	"agents.relativeTime.hoursAgo": "{count}h ago",
	"agents.relativeTime.yesterday": "Yesterday",
	"agents.sort.lastUpdated": "Sort by last updated",
	"agents.sort.lastCreated": "Sort by last created",
	"agents.sort.nameAsc": "Sort by name (A-Z)",
	"agents.sort.nameDesc": "Sort by name (Z-A)",
	"agents.noResults": "No agents found",
	"agents.builder.save": "Save",
	"agents.builder.deleteAgent": "Delete agent",
	"agents.builder.exportJson": "Export JSON",
	"agents.builder.importJson": "Import JSON",
	"agents.builder.importJsonModal.title": "Import agent JSON",
	"agents.builder.importJsonModal.description": "Choose a JSON file exported from an agent. Importing replaces the current configuration.",
	"agents.builder.importJsonModal.fileLabel": "Agent JSON file",
	"agents.builder.importJsonModal.invalidJson": "Agent JSON couldn't be read. Choose a valid agent JSON file.",
	"agents.builder.importJsonModal.import": "Import JSON",
	"agents.delete.modal.title": "Delete \"{name}\"?",
	"agents.delete.modal.description": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
	"agents.delete.modal.button.delete": "Delete",
	"agents.builder.loadError": "Could not load agent",
	"agents.builder.saveError": "Could not save agent settings",
	"agents.builder.chat.sessionPicker.ariaLabel": "Session history",
	"agents.builder.chat.sessionPicker.empty": "No previous chats",
	"agents.builder.chat.newChat.ariaLabel": "Start a new chat",
	"agents.builder.chat.newChat.label": "New chat",
	"agents.chat.loadHistory.error": "Could not load chat history",
	"agents.chat.clearHistory.error": "Could not clear chat history",
	"agents.chat.clearHistory": "Clear chat history",
	"agents.chat.input.placeholder": "Type a message...",
	"agents.preview.episodicMemoryCallout.text": "Access memories from previous conversations.",
	"agents.preview.episodicMemoryCallout.action": "Enable",
	"agents.chat.answerQuestionPlaceholder": "Answer the question above to continue",
	"agents.chat.misconfigured.title": "This agent isn't ready to run yet",
	"agents.chat.misconfigured.issuesPrefix": "Check:",
	"agents.chat.misconfigured.missing.instructions": "Instructions",
	"agents.chat.misconfigured.missing.model": "Model",
	"agents.chat.misconfigured.missing.credential": "Credential",
	"agents.chat.misconfigured.missing.agent": "Agent",
	"agents.chat.misconfigured.missing.skill": "Skill ({id})",
	"agents.chat.misconfigured.missing.tools": "Tool configuration",
	"agents.chat.misconfigured.missing.mcpServers": "MCP server",
	"agents.chat.misconfigured.missing.subAgents.agents": "Sub-agent",
	"agents.chat.misconfigured.dismiss": "Dismiss",
	"agents.chat.emptyState.title": "Chat with your agent",
	"agents.chat.emptyState.description": "Send a message to start a conversation",
	"agents.chat.toolNames.webSearch": "Web search",
	"agents.chat.toolNames.findFile": "Find file",
	"agents.chat.toolNames.searchText": "Search text",
	"agents.chat.toolNames.readFile": "Read file",
	"agents.chat.approval.title": "Approval required",
	"agents.chat.approval.description": "The agent wants to run the {toolName} tool.",
	"agents.chat.approval.approve": "Approve",
	"agents.chat.approval.reject": "Reject",
	"agents.chat.approval.approved": "Approved",
	"agents.chat.approval.rejected": "Rejected",
	"agents.chat.approval.inputPlaceholder": "Approve or reject to continue",
	"agents.chat.delegate.label": "Sub-agent · {name}",
	"agents.chat.delegate.labelFallback": "Sub-agent",
	"agents.chat.delegate.childSuspendUnsupported": "Sub-agent requested user input, which is not supported for delegated runs yet.",
	"agents.chat.difficulty.low": "Low",
	"agents.chat.difficulty.medium": "Medium",
	"agents.chat.difficulty.high": "High",
	"agents.chat.writeTodos.label": "Task list",
	"agents.chat.writeTodos.summary.one": "{count} task",
	"agents.chat.writeTodos.summary.other": "{count} tasks",
	"agents.chat.writeTodos.summary.done": "Done",
	"agents.chat.writeTodos.status.inProgress": "In progress",
	"agents.chat.writeTodos.status.pending": "Pending",
	"agents.chat.writeTodos.status.completed": "Completed",
	"agents.chat.writeTodos.status.blocked": "Blocked",
	"agents.chat.writeTodos.status.cancelled": "Cancelled",
	"agents.chat.writeTodos.hint.difficulty": "Difficulty",
	"agents.chat.writeTodos.hint.subAgent": "Sub-agent",
	"agents.chat.writeTodos.hint.expectedOutput": "Expected output",
	"agents.chat.toolStep.waitingForInput": "Waiting for your input",
	"agents.chat.waitingExternal": "Waiting for a response in {platform}…",
	"agents.backToWorkflow": "Back to workflow",
	"agents.heading": "Agents",
	"agents.list.published": "Published",
	"agents.list.noDescription": "No description",
	"agents.list.updatedAt": "Updated {date}",
	"agents.list.updated": "Last updated",
	"agents.list.created": "Created",
	"agents.list.empty.heading": "Create your first agent",
	"agents.list.empty.description": "Agents automate tasks and answer questions using your connected tools and data",
	"agents.list.empty.button.disabled.tooltip": "Your current role in the project does not allow you to create agents",
	"agents.list.actions.publish": "Publish",
	"agents.list.actions.unpublish": "Unpublish",
	"agents.list.actions.delete": "Delete",
	"agents.list.readonly": "Read only",
	"agents.publish.button.publish": "Publish",
	"agents.publish.button.published": "Published",
	"agents.publish.button.invalidConfigTooltip": "This agent's configuration has errors. Resolve them before publishing.",
	"agents.publish.dropdown.publish": "Publish",
	"agents.publish.dropdown.revertToPublished": "Revert changes",
	"agents.publish.dropdown.unpublish": "Unpublish",
	"agents.publish.dropdown.ariaLabel": "More publish actions",
	"agents.publish.toast.published": "Agent published",
	"agents.publish.toast.reverted": "Reverted to published version",
	"agents.publish.toast.unpublished": "Agent unpublished",
	"agents.publish.error.publish": "Failed to publish agent",
	"agents.publish.error.revert": "Failed to revert agent to published version",
	"agents.publish.error.unpublish": "Failed to unpublish agent",
	"agents.unpublish.modal.title": "Unpublish {name}",
	"agents.unpublish.modal.description": "This will prevent all production executions from using this agent until you publish again.",
	"agents.unpublish.modal.button.unpublish": "Unpublish",
	"agents.revertToPublished.modal.title": "Revert changes?",
	"agents.revertToPublished.modal.description": "This will permanently remove all changes made since the latest published version.",
	"agents.revertToPublished.modal.button.revert": "Revert changes",
	"agents.versionHistory.title": "Publish history",
	"agents.versionHistory.button.tooltip.empty": "This agent currently has no history to view. Once you've published it for the first time, you'll be able to view previous versions",
	"agents.versionHistory.button.ariaLabel": "Open version history",
	"agents.versionHistory.close": "Close",
	"agents.versionHistory.empty": "No versions yet. Publish your agent to start a history.",
	"agents.versionHistory.error.load": "Could not load version history",
	"agents.versionHistory.item.createdAt": "{date} at {time}",
	"agents.versionHistory.item.publishedBadge": "Currently published",
	"agents.versionHistory.item.actions.revert": "Revert to this version",
	"agents.versionHistory.item.actions.publish": "Publish this version",
	"agents.versionHistory.item.actions.unpublish": "Unpublish",
	"agents.versionHistory.revert.modal.title": "Revert to this version?",
	"agents.versionHistory.revert.modal.description": "This will replace your current draft with the contents of this version. Unsaved changes will be lost.",
	"agents.versionHistory.revert.modal.button.revert": "Revert draft",
	"agents.versionHistory.revert.toast.title": "Reverted to version",
	"agents.versionHistory.revert.error": "Could not revert to the selected version",
	"agents.versionHistory.publish.toast.title": "Version published",
	"agents.versionHistory.publish.error": "Could not publish the selected version",
	"agents.search.placeholder": "Search agents...",
	"agents.tools.title": "Tools",
	"agents.tools.add": "Add tool",
	"agents.tools.search.placeholder": "Search tools",
	"agents.tools.availableTools": "Available tools ({count})",
	"agents.tools.availableWorkflows": "Workflows ({count})",
	"agents.tools.availableAiTools": "AI tools ({count})",
	"agents.tools.availableN8nTools": "n8n tools ({count})",
	"agents.tools.availableExternalTools": "External tools ({count})",
	"agents.tools.noResults": "No tools available",
	"agents.tools.noResults.withQuery": "No tools match “{query}”. Try a different keyword.",
	"agents.tools.configure": "Configure",
	"agents.tools.connect": "Connect",
	"agents.tools.added": "Tool added",
	"agents.tools.connected": "Connected",
	"agents.tools.addCredentials": "Add credentials",
	"agents.tools.needsApproval": "Needs approval",
	"agents.tools.noCredentials": "No credentials",
	"agents.tools.workflow.incompatible.title": "Workflow is not compatible",
	"agents.tools.workflow.incompatible.message": "Workflow \"{name}\" contains nodes that can't be used as an agent tool: {nodes}.",
	"agents.tools.workflow.fetchFailed.title": "Couldn't check workflow compatibility",
	"agents.tools.workflow.fetchFailed.message": "Try connecting the workflow again.",
	"agents.tools.availableMcpServers": "MCP servers ({count})",
	"agents.tools.mcp.added": "MCP server added",
	"agents.toolConfig.workflow.description": "Description",
	"agents.toolConfig.workflow.description.placeholder": "Explain to the agent when to use this workflow and what it does",
	"agents.toolConfig.workflow.description.hint": "The LLM reads this to decide when to call the workflow.",
	"agents.toolConfig.workflow.allOutputs": "Return all node outputs",
	"agents.toolConfig.workflow.allOutputs.hint": "When off, only the last node's output is returned.",
	"agents.toolConfig.save": "Save",
	"agents.toolConfig.cancel": "Cancel",
	"agents.toolConfig.approval.label": "Require approval",
	"agents.toolConfig.approval.hint": "Pause before this tool runs until a human approves it.",
	"agents.toolConfig.mcpApproval.label": "Require approval",
	"agents.toolConfig.mcpApproval.hint": "Choose which tools from this MCP server need human approval before they run.",
	"agents.toolConfig.mcpApproval.disabled": "Disabled",
	"agents.toolConfig.mcpApproval.askAll": "Ask all",
	"agents.toolConfig.mcpApproval.askSelected": "Ask selected",
	"agents.toolConfig.mcpApproval.refresh": "Refresh MCP tools",
	"agents.toolConfig.mcpApproval.refresh.hint": "Refresh the list of tools from this MCP server.",
	"agents.toolConfig.mcpApproval.tools.placeholder": "Select tools",
	"agents.toolConfig.mcpApproval.loadError": "Could not load MCP tools. Check the server settings and try again.",
	"agents.new.defaultName": "New Agent",
	"agents.builder.sections.agent": "Agent",
	"agents.builder.sections.advanced": "Advanced",
	"agents.builder.sections.configJson": "Raw",
	"agents.builder.sections.evaluations": "Evaluations",
	"agents.builder.sections.evaluations.comingSoon": "Coming soon",
	"agents.builder.sections.executions": "Sessions",
	"agents.builder.sections.guardrails": "Guardrails",
	"agents.builder.sections.instructions": "Instructions",
	"agents.builder.sections.memory": "Session Memory",
	"agents.builder.sections.model": "Model",
	"agents.builder.sections.skills": "Skills",
	"agents.builder.sections.tools": "Tools",
	"agents.builder.sections.triggers": "Triggers",
	"agents.builder.agent.title": "Agent",
	"agents.builder.agent.description": "Core setup that defines how this agent behaves",
	"agents.builder.agent.name.label": "Name",
	"agents.builder.agent.name.placeholder": "My agent",
	"agents.builder.agent.personalisation.change": "Change agent icon",
	"agents.builder.agent.model.label": "Model",
	"agents.builder.agent.instructions.label": "Instructions",
	"agents.builder.agent.instructions.placeholder": "Enter instructions here",
	"agents.builder.agent.instructions.characterCount": "{count} characters",
	"agents.builder.advanced.title": "Advanced",
	"agents.builder.advanced.description": "Execution tuning — reasoning depth and tool parallelism.",
	"agents.builder.advanced.webSearch.label": "Web search",
	"agents.builder.advanced.webSearch.hint": "Let the model search the web when it needs up-to-date information.",
	"agents.builder.advanced.webSearch.maxUses.label": "Maximum searches",
	"agents.builder.advanced.webSearch.maxUses.hint": "How many web searches the model can run in one response",
	"agents.builder.advanced.webSearch.externalAccess.label": "Live page access",
	"agents.builder.advanced.webSearch.externalAccess.hint": "Allow OpenAI to fetch live page content",
	"agents.builder.advanced.webSearch.contextSize.label": "Search context",
	"agents.builder.advanced.webSearch.method.label": "Search method",
	"agents.builder.advanced.webSearch.method.off": "Off",
	"agents.builder.advanced.webSearch.method.native": "Native",
	"agents.builder.advanced.webSearch.fallbackProvider.brave": "Brave Search",
	"agents.builder.advanced.webSearch.fallbackProvider.searxng": "SearXNG",
	"agents.builder.advanced.webSearch.credential.label": "Credential",
	"agents.builder.advanced.webSearch.credential.hint": "Used by the selected search provider",
	"agents.builder.advanced.thinking.label": "Thinking",
	"agents.builder.advanced.thinking.hint": "Let the model reason before responding.",
	"agents.builder.advanced.thinking.unsupportedTooltip": "{provider} does not support thinking",
	"agents.builder.advanced.thinking.unsupportedProviderFallback": "This provider",
	"agents.builder.advanced.budgetTokens.label": "Budget tokens",
	"agents.builder.advanced.budgetTokens.hint": "How many tokens the model can use for reasoning before answering",
	"agents.builder.advanced.reasoningEffort.label": "Reasoning effort",
	"agents.builder.advanced.promptCaching.hint": "Cache repeated parts of the prompt to reduce latency and cost.",
	"agents.builder.advanced.promptCachingTtl.label": "Cache duration",
	"agents.builder.advanced.concurrency.label": "Tool call concurrency",
	"agents.builder.advanced.concurrency.hint": "How many tool calls the agent can run in parallel.",
	"agents.builder.advanced.recentMessages.label": "Session memory window",
	"agents.builder.advanced.recentMessages.hint": "How many recent messages from this thread the agent sees on each turn.",
	"agents.builder.advanced.recentMessages.memoryDisabledTooltip": "Enable Session Memory in the Memory section to configure the window.",
	"agents.builder.advanced.maxIterations.label": "Max iterations",
	"agents.builder.advanced.maxIterations.hint": "Maximum number of agent loop iterations per run (1–200).",
	"agents.builder.memory.title": "Memory",
	"agents.builder.memory.description": "Session memory is on by default",
	"agents.builder.memory.settings.title": "Memory settings",
	"agents.builder.memory.episodicMemory.label": "Episodic Memory",
	"agents.builder.memory.episodicMemory.hint": "Stores source-backed memories from previous conversations. Requires OpenAI credential.",
	"agents.builder.memory.episodicMemory.credential.label": "OpenAI credential",
	"agents.builder.memory.episodicMemory.credential.hint": "Used to create embeddings for episodic memory.",
	"agents.builder.files.title": "Knowledge base",
	"agents.builder.files.titleTooltip": "Files uploaded to this agent. n8n stores them so the agent can search their contents and read them when answering.",
	"agents.builder.files.description": "Add CSV, PDF, Markdown, or TXT files this agent can search and read. Upload up to {maxFiles} files at a time, {maxSizeMb} MB each. Knowledge base size is limited to {maxTotalGb} GB.",
	"agents.builder.files.count": "{count} file uploaded | {count} files uploaded",
	"agents.builder.files.upload": "Upload file",
	"agents.builder.files.publishRequired": "Publish this agent to upload knowledge files",
	"agents.builder.files.uploadFileTooLarge.title": "File too large",
	"agents.builder.files.uploadFileTooLarge.message": "{name} is larger than {size} MB.",
	"agents.builder.files.uploadTotalTooLarge.title": "Knowledge base limit reached",
	"agents.builder.files.uploadTotalTooLarge.message": "These files would make the knowledge base larger than {size} GB. Delete files or upload a smaller selection.",
	"agents.builder.files.uploadTooManyFiles.title": "Too many files",
	"agents.builder.files.uploadTooManyFiles.message": "You can upload up to {max} files at a time. Select fewer files and try again.",
	"agents.builder.files.empty": "No files uploaded yet.",
	"agents.builder.files.addFile": "Add file",
	"agents.builder.files.loading": "Loading files...",
	"agents.builder.files.origin.user": "User",
	"agents.builder.files.uploaded": "File uploaded",
	"agents.builder.files.deleted": "File deleted",
	"agents.builder.files.delete": "Delete file",
	"agents.builder.files.type.csv": "CSV",
	"agents.builder.files.type.pdf": "PDF",
	"agents.builder.files.type.markdown": "Markdown",
	"agents.builder.files.type.txt": "TXT",
	"agents.builder.files.type.file": "File",
	"agents.builder.files.deleteModal.title": "Delete {name}?",
	"agents.builder.files.deleteModal.description": "This removes {name} from the agent's knowledge files.",
	"agents.builder.files.deleteModal.button.delete": "Delete file",
	"agents.builder.files.loadError": "Could not load files",
	"agents.builder.files.uploadError": "Could not upload file",
	"agents.builder.files.deleteError": "Could not delete file",
	"agents.builder.files.size.bytes": "{bytes} B",
	"agents.builder.files.size.kilobytes": "{kilobytes} KB",
	"agents.builder.files.size.megabytes": "{megabytes} MB",
	"agents.builder.vectorStores.panel.title": "Vector stores",
	"agents.builder.vectorStores.panel.titleTooltip": "External vector databases this agent can search. Unlike knowledge base files, the data lives outside n8n and you manage its indexing yourself.",
	"agents.builder.vectorStores.panel.connectButton": "Connect vector store",
	"agents.builder.vectorStores.panel.empty.title": "No vector stores connected",
	"agents.builder.vectorStores.panel.empty.description": "Connect a vector store so this agent can search data you've already indexed.",
	"agents.builder.vectorStores.panel.edit": "Edit",
	"agents.builder.vectorStores.panel.remove": "Remove connection",
	"agents.builder.vectorStores.panel.removeModal.title": "Remove {name}?",
	"agents.builder.vectorStores.panel.removeModal.description": "This removes {name} from the agent's connected vector stores.",
	"agents.builder.vectorStores.panel.removeModal.button.remove": "Remove connection",
	"agents.builder.vectorStores.modal.title": "Connect vector store",
	"agents.builder.vectorStores.modal.description": "Choose a vector database to search for relevant context during this agent's runs.",
	"agents.builder.vectorStores.modal.connect": "Connect",
	"agents.builder.vectorStores.modal.remove": "Remove connection",
	"agents.builder.vectorStores.modal.back": "Back",
	"agents.builder.vectorStores.modal.name.label": "Name",
	"agents.builder.vectorStores.modal.name.placeholder": "product-docs",
	"agents.builder.vectorStores.modal.name.validation.pattern": "Use only letters, numbers, underscores, and hyphens.",
	"agents.builder.vectorStores.modal.name.validation.duplicate": "A vector store with this name is already connected.",
	"agents.builder.vectorStores.modal.credential.label": "Credential",
	"agents.builder.vectorStores.modal.credential.placeholder": "Select credential",
	"agents.builder.vectorStores.modal.indexName.label": "Index name",
	"agents.builder.vectorStores.modal.indexName.placeholder": "product-docs",
	"agents.builder.vectorStores.modal.namespace.label": "Namespace",
	"agents.builder.vectorStores.modal.namespace.placeholder": "production",
	"agents.builder.vectorStores.modal.collectionName.label": "Collection name",
	"agents.builder.vectorStores.modal.collectionName.placeholder": "product-docs",
	"agents.builder.vectorStores.modal.tableName.label": "Table name",
	"agents.builder.vectorStores.modal.tableName.placeholder": "documents",
	"agents.builder.vectorStores.modal.queryName.label": "Query function name",
	"agents.builder.vectorStores.modal.queryName.placeholder": "match_documents",
	"agents.builder.vectorStores.modal.embeddingModel.label": "Embedding model",
	"agents.builder.vectorStores.modal.embeddingModel.hint": "Must match the model used to index the data in this store. A different model produces meaningless results, even at the same dimension.",
	"agents.builder.vectorStores.modal.embeddingModel.dimensions": "{dimensions} dimensions",
	"agents.builder.vectorStores.modal.test.successTitle": "Connected {name}",
	"agents.builder.vectorStores.modal.test.failedTitle": "Couldn't connect vector store",
	"agents.builder.vectorStores.modal.test.genericError": "Connection failed. Check your credential and connection details, then try again.",
	"agents.builder.vectorStores.useWhen.label": "When should this agent search this store?",
	"agents.builder.vectorStores.useWhen.hint": "Tell the agent when to search this vector store.",
	"agents.builder.vectorStores.useWhen.placeholder": "Search for product documentation when the user asks about features, setup, or troubleshooting.",
	"agents.builder.subAgents.title": "Sub-agents",
	"agents.builder.subAgents.description": "This agent can delegate focused subtasks. Add published agents from this project when you want reusable specialists.",
	"agents.builder.subAgents.settings.title": "Sub-agent settings",
	"agents.builder.subAgents.settings.description": "Configure delegation limits and inline sub-agent model choices.",
	"agents.builder.subAgents.add": "Add sub-agent",
	"agents.builder.subAgents.loadError": "Could not load project agents",
	"agents.builder.subAgents.remove": "Remove {name}",
	"agents.builder.subAgents.useWhen.label": "When should this agent be used?",
	"agents.builder.subAgents.useWhen.hint": "Tell the parent agent when to delegate work to this agent.",
	"agents.builder.subAgents.useWhen.placeholder": "Use for billing questions, invoice investigations, and payment status checks.",
	"agents.builder.subAgents.useWhen.characterCount": "{count}/{max}",
	"agents.builder.subAgents.useWhen.validation.maxLength": "Use when must be {max} characters or less.",
	"agents.builder.subAgents.maxChildren.label": "Max parallel sub-agents",
	"agents.builder.subAgents.maxChildren.hint": "How many sub-agents this agent can run at the same time ({min}-{max}).",
	"agents.builder.subAgents.customModelRouting.label": "Custom model routing",
	"agents.builder.subAgents.customModelRouting.hint": "Use different models for low, medium, or high difficulty tasks.",
	"agents.builder.subAgents.modelsByDifficulty.title": "Models by difficulty",
	"agents.builder.subAgents.modelsByDifficulty.hint": "Optional. Unset difficulties use the parent model.",
	"agents.builder.subAgents.modelsByDifficulty.low.label": "Low",
	"agents.builder.subAgents.modelsByDifficulty.low.description": "Simple tasks that need little context.",
	"agents.builder.subAgents.modelsByDifficulty.medium.label": "Medium",
	"agents.builder.subAgents.modelsByDifficulty.medium.description": "Tasks that need comparison, planning, or light analysis.",
	"agents.builder.subAgents.modelsByDifficulty.high.label": "High",
	"agents.builder.subAgents.modelsByDifficulty.high.description": "Complex tasks that need deeper reasoning or detailed synthesis.",
	"agents.builder.subAgents.modelsByDifficulty.clear": "Use parent model",
	"agents.builder.subAgents.modal.title": "Sub-agents",
	"agents.builder.subAgents.modal.description": "Select published agents from this project to let this agent delegate work to them.",
	"agents.builder.subAgents.modal.selectAgent": "Select {name}",
	"agents.builder.subAgents.modal.empty.title": "No agents to add",
	"agents.builder.subAgents.modal.empty.description": "Published agents from this project show here. Already added agents are hidden.",
	"agents.builder.subAgents.modal.search.placeholder": "Search agents",
	"agents.builder.subAgents.modal.noResults.title": "No matching agents",
	"agents.builder.subAgents.modal.noResults.description": "Try another search term.",
	"agents.builder.subAgents.modal.cancel": "Cancel",
	"agents.builder.subAgents.modal.add": "Add agent",
	"agents.builder.subAgents.modal.remove": "Remove sub agent",
	"agents.builder.memory.recallModel.label": "Memory model",
	"agents.builder.memory.recallModel.hint": "Choose the model that creates, reviews, and retrieves memories. Uses the agent model by default.",
	"agents.builder.editor.copy": "Copy to clipboard",
	"agents.builder.editor.copied": "Copied",
	"agents.builder.tools.title": "Tools",
	"agents.builder.tools.count": "{count} tool configured | {count} tools configured",
	"agents.builder.tools.add": "Add tool",
	"agents.builder.tools.empty": "No tools added yet.",
	"agents.builder.tools.type.workflow": "Workflow",
	"agents.builder.tools.type.custom": "Custom tool",
	"agents.builder.tools.workflows.title": "Workflows",
	"agents.builder.tools.remove": "Remove tool",
	"agents.builder.tools.back": "Back to tools",
	"agents.builder.skills.title": "Skills",
	"agents.builder.skills.count": "{count} skill applied | {count} skills applied",
	"agents.builder.skills.add": "Add skill",
	"agents.builder.skills.empty": "No skills applied yet.",
	"agents.builder.skills.instructions": "Instructions",
	"agents.builder.skills.name.label": "Name",
	"agents.builder.skills.name.placeholder": "Summarize meetings",
	"agents.builder.skills.description.label": "Description",
	"agents.builder.skills.description.placeholder": "Use when summarizing meetings or notes",
	"agents.builder.skills.allowedTools.label": "Allowed tools",
	"agents.builder.skills.allowedTools.placeholder": "load_workflow, search_docs",
	"agents.builder.skills.allowedTools.remove": "Remove {tool}",
	"agents.builder.skills.allowedTools.addModal.title": "Add allowed tool",
	"agents.builder.skills.allowedTools.addModal.empty": "Attach tools to this agent before adding allowed tools.",
	"agents.builder.skills.allowedTools.addModal.allSelected": "All attached tools are already allowed.",
	"agents.builder.skills.instructions.label": "Instructions",
	"agents.builder.skills.instructions.byteCount": "{count} / {max} bytes",
	"agents.builder.skills.filesNav.label": "Skill files",
	"agents.builder.skills.import.skillFile": "Upload SKILL.md",
	"agents.builder.skills.import.folder": "Upload folder",
	"agents.builder.skills.import.noFiles": "Select a SKILL.md file or skill folder.",
	"agents.builder.skills.import.missingSkillFile": "Select a SKILL.md file or a folder that contains one.",
	"agents.builder.skills.import.missingFrontmatter": "SKILL.md must start with YAML frontmatter.",
	"agents.builder.skills.import.invalidFrontmatter": "Check the YAML frontmatter in SKILL.md.",
	"agents.builder.skills.import.missingName": "SKILL.md is missing a name.",
	"agents.builder.skills.import.missingDescription": "SKILL.md is missing a description.",
	"agents.builder.skills.import.scriptsUnsupported": "Scripts aren't supported for skills yet.",
	"agents.builder.skills.import.referenceMarkdownOnly": "References must be markdown files.",
	"agents.builder.skills.import.duplicateReference": "Reference file paths must be unique.",
	"agents.builder.skills.import.tooManyReferences": "The skill folder has too many reference files.",
	"agents.builder.skills.import.referenceTooLarge": "Each reference file must be 65 KB or smaller.",
	"agents.builder.skills.import.referencesTooLarge": "Reference files must be 256 KB or smaller in total.",
	"agents.builder.skills.import.invalidFolder": "Could not import the skill folder.",
	"agents.builder.skills.references.title": "References",
	"agents.builder.skills.references.add": "Add reference",
	"agents.builder.skills.references.remove": "Remove reference",
	"agents.builder.skills.references.empty": "No references yet",
	"agents.builder.skills.references.markdownOnly": "Markdown reference",
	"agents.builder.skills.references.content.label": "Content",
	"agents.builder.skills.references.name.label": "File name",
	"agents.builder.skills.references.name.placeholder": "reference.md",
	"agents.builder.skills.references.name.required": "Enter a file name.",
	"agents.builder.skills.references.name.invalid": "Enter a valid file name.",
	"agents.builder.skills.references.name.noPathSeparators": "Enter the file name only, without folders.",
	"agents.builder.skills.references.name.invalidCharacters": "Use only letters, numbers, spaces, underscores, and hyphens.",
	"agents.builder.skills.references.name.duplicate": "A reference with this file name already exists.",
	"agents.builder.skills.references.contentRequired": "Enter reference content.",
	"agents.builder.skills.references.contentMaxBytes": "Reference content must be {max} bytes or fewer.",
	"agents.builder.skills.references.maxCount": "Skills can have up to {max} reference files.",
	"agents.builder.skills.references.invalidSummary": "Fix reference files before saving.",
	"agents.builder.skills.references.byteCount": "{count} / {max} bytes",
	"agents.builder.skills.create.title": "Add skill",
	"agents.builder.skills.create.cancel": "Cancel",
	"agents.builder.skills.create.save": "Save skill",
	"agents.builder.skills.create.error": "Could not create skill",
	"agents.builder.skills.added": "Skill added",
	"agents.builder.skills.saveError": "Could not save skill",
	"agents.builder.skills.duplicateName.error": "Agent already has a skill named \"{name}\"",
	"agents.builder.skills.validation.nameRequired": "Enter a name.",
	"agents.builder.skills.validation.nameMaxLength": "Name must be 128 characters or fewer.",
	"agents.builder.skills.validation.nameDuplicate": "Agent already has a skill with this name.",
	"agents.builder.skills.validation.descriptionRequired": "Enter a description.",
	"agents.builder.skills.validation.descriptionMaxLength": "Description must be 512 characters or fewer.",
	"agents.builder.skills.validation.instructionsRequired": "Enter instructions.",
	"agents.builder.skills.validation.instructionsMaxLength": "Instructions must be {max} bytes or fewer.",
	"agents.builder.skills.missingContent.callout": "This skill's content is missing. Fill it in and save to recreate it.",
	"agents.builder.skills.remove": "Remove skill",
	"agents.builder.skills.back": "Back to skills",
	"agents.builder.tasks.title": "Schedules",
	"agents.builder.tasks.description": "Objectives the agent runs on a schedule once it's published.",
	"agents.builder.tasks.add": "Add schedule",
	"agents.builder.tasks.empty": "No schedules yet.",
	"agents.builder.tasks.publishHint": "Enabled schedules start running once you publish the agent.",
	"agents.builder.tasks.republishHint": "Changes take effect the next time you publish the agent.",
	"agents.builder.tasks.pendingPublish": "Pending publish",
	"agents.builder.tasks.nextRun": "Next run {time}",
	"agents.builder.tasks.lastRun": "Last run {time}",
	"agents.builder.tasks.neverRun": "Not run yet",
	"agents.builder.tasks.enabled": "Enabled",
	"agents.builder.tasks.status.title": "Schedule status",
	"agents.builder.tasks.status.success": "Success",
	"agents.builder.tasks.status.error": "Failed",
	"agents.builder.tasks.delete": "Delete schedule",
	"agents.builder.tasks.deleteConfirm.title": "Delete schedule?",
	"agents.builder.tasks.deleteConfirm.description": "This schedule will stop running and be removed. This can't be undone.",
	"agents.builder.tasks.deleteConfirm.confirm": "Delete",
	"agents.builder.tasks.loadError": "Could not load schedules",
	"agents.builder.tasks.deleteError": "Could not delete schedule",
	"agents.builder.tasks.create.title": "Add schedule",
	"agents.builder.tasks.edit.title": "Edit schedule",
	"agents.builder.tasks.name.label": "Name",
	"agents.builder.tasks.name.placeholder": "Daily Slack summary",
	"agents.builder.tasks.objective.label": "Objective",
	"agents.builder.tasks.objective.placeholder": "Summarize today's #general messages and post the summary.",
	"agents.builder.tasks.schedule.label": "Schedule",
	"agents.builder.tasks.schedule.frequency.hourly": "Hourly",
	"agents.builder.tasks.schedule.frequency.daily": "Daily",
	"agents.builder.tasks.schedule.frequency.weekly": "Weekly",
	"agents.builder.tasks.schedule.frequency.monthly": "Monthly",
	"agents.builder.tasks.schedule.frequency.custom": "Custom (cron)",
	"agents.builder.tasks.schedule.at": "at",
	"agents.builder.tasks.schedule.on": "on",
	"agents.builder.tasks.schedule.onDay": "on day",
	"agents.builder.tasks.schedule.minuteLabel": "at minute",
	"agents.builder.tasks.schedule.cron.placeholder": "0 9 * * *",
	"agents.builder.tasks.schedule.nextOccurrence": "Next run {occurrence}",
	"agents.builder.tasks.cancel": "Cancel",
	"agents.builder.tasks.save": "Save schedule",
	"agents.builder.tasks.saveError": "Could not save schedule",
	"agents.builder.tasks.execute": "Run schedule",
	"agents.builder.tasks.executeStarted": "Schedule started",
	"agents.builder.tasks.executeError": "Could not start the schedule",
	"agents.builder.tasks.validation.nameRequired": "Enter a name.",
	"agents.builder.tasks.validation.nameMaxLength": "Name must be {max} characters or fewer.",
	"agents.builder.tasks.validation.objectiveRequired": "Enter an objective.",
	"agents.builder.tasks.validation.objectiveMaxLength": "Objective must be {max} characters or fewer.",
	"agents.builder.tasks.validation.cronRequired": "Enter a schedule.",
	"agents.builder.tasks.validation.cronInvalid": "This isn't a valid cron expression",
	"agents.builder.editor.invalidJson": "Invalid JSON",
	"agents.builder.editorColumn.ariaLabel": "Configuration editor",
	"agents.builder.tree.ariaLabel": "Config sections",
	"agents.builder.tree.empty": "No sections yet",
	"agents.builder.tree.toolFallback": "Tool {index}",
	"agents.builder.tree.customBadge": "Custom",
	"agents.builder.tree.foldersEmpty": "No items yet",
	"agents.builder.header.executions": "Executions",
	"agents.builder.header.tab.agent": "Agent",
	"agents.builder.header.tab.knowledge": "Knowledge",
	"agents.builder.header.tab.executions": "Sessions",
	"agents.builder.header.tab.settings": "Settings",
	"agents.builder.header.tab.memory": "Memory",
	"agents.builder.header.tab.evaluations": "Evaluations",
	"agents.builder.header.tab.raw": "Raw",
	"agents.builder.header.workspaceCrumb": "Workspace",
	"agents.builder.header.projectFallback": "Project",
	"agents.builder.header.switcher.empty": "No other agents",
	"agents.builder.header.switcher.newAgent": "New agent",
	"agents.builder.header.switcher.ariaLabel": "Switch agent",
	"agents.builder.header.saving": "Saving…",
	"agents.builder.header.saved": "Saved",
	"agents.builder.preview.button": "Preview",
	"agents.builder.preview.disabledTooltip": "This agent's configuration has errors. Resolve them before previewing.",
	"agents.builder.validation.issue.missingRequired": "A required field is missing",
	"agents.builder.validation.issue.invalidValue": "A field has an invalid value",
	"agents.builder.validation.issue.missingCredential": "Credential is missing",
	"agents.builder.validation.issue.invalidCredential": "Credential isn't valid or isn't accessible",
	"agents.builder.validation.issue.incompatibleCredential": "Credential type doesn't match",
	"agents.builder.validation.issue.missingReference": "A referenced item can't be found",
	"agents.builder.validation.issue.incompatibleReference": "A referenced item isn't compatible",
	"agents.builder.validation.issue.subAgent.missingReference": "This agent no longer exists in this project",
	"agents.builder.validation.issue.subAgent.incompatibleReference": "This agent isn't published yet. Publish it before using it as a sub-agent.",
	"agents.builder.validation.issue.skill.missingReference": "This skill's content is missing. Open it to recreate it.",
	"agents.builder.validation.issue.task.invalidValue": "The schedule isn't a valid cron expression",
	"agents.builder.validation.issue.tool.workflow.missingReference": "Workflow \"{id}\" can't be found in this project",
	"agents.builder.validation.issue.tool.workflow.incompatibleReference": "Workflow \"{id}\" can't be used as an agent tool",
	"agents.builder.validation.issue.tool.custom.missingReference": "This tool's code is missing",
	"agents.builder.validation.issue.tool.node.missingReference": "This node type isn't available on this instance",
	"agents.builder.validation.issue.mcpServer.incompatibleCredential": "The credential type doesn't match the server's authentication method",
	"agents.builder.preview.viewSession": "View session",
	"agents.builder.preview.close.ariaLabel": "Close preview",
	"agents.builder.executions.count": "{count} session | {count} sessions",
	"agents.builder.settings.description": "Configure memory, sub-agent routing, and advanced runtime settings.",
	"agents.builder.raw.description": "Agent JSON configuration",
	"agents.builder.evaluations.comingSoon": "Evaluations functionality is coming soon.",
	"agents.builder.evaluations.configuredInCode": "{count} evaluation configured in code | {count} evaluations configured in code",
	"agents.builder.evaluations.type.check": "Check",
	"agents.builder.evaluations.type.judge": "Judge",
	"agents.builder.evaluations.credentialConfigured": "Credential configured",
	"agents.builder.evaluations.emptyPrefix": "No evaluations configured.",
	"agents.builder.quickActions.memoriesUsed.count": "{count} memory | {count} memories",
	"agents.builder.quickActions.memoriesUsed.keyMemory": "Memory",
	"agents.builder.capabilities.title": "Capabilities",
	"agents.builder.triggers.title": "Channels",
	"agents.builder.triggers.description": "Channels that can invoke this agent",
	"agents.builder.triggers.count": "{count} channel connected | {count} channels connected",
	"agents.builder.triggers.empty": "No channels connected yet.",
	"agents.builder.triggers.add": "Add channel",
	"agents.builder.triggers.empty.title": "No triggers configured",
	"agents.builder.triggers.empty.description": "Add a channel to let this agent respond to events from a chat platform.",
	"agents.builder.addTrigger.modal.title": "Add trigger",
	"agents.builder.addTrigger.modal.description": "Add a trigger to let people message the agent from a chat platform.",
	"agents.builder.addTrigger.picker.label": "Trigger",
	"agents.builder.addTrigger.picker.placeholder": "Select a trigger...",
	"agents.builder.addTrigger.picker.empty": "Pick a trigger above to configure it.",
	"agents.builder.addTrigger.status.connected": "Connected",
	"agents.builder.addTrigger.status.disconnected": "Disconnected",
	"agents.builder.addTrigger.credential": "Credential",
	"agents.builder.addTrigger.selectCredential": "Select a credential...",
	"agents.builder.addTrigger.editCredential": "Edit credential",
	"agents.builder.addTrigger.noCredentials": "No {label} credentials found.",
	"agents.builder.addTrigger.addCredential": "Add {label} credential",
	"agents.builder.addTrigger.newCredential": "New credential",
	"agents.builder.addTrigger.connect": "Connect",
	"agents.builder.addTrigger.disconnect": "Disconnect",
	"agents.builder.addTrigger.copy": "Copy",
	"agents.builder.addTrigger.copied": "Copied",
	"agents.builder.addTrigger.noIntegrations": "No integrations available.",
	"agents.builder.addTrigger.slack.setup.title": "Create Slack app",
	"agents.builder.addTrigger.slack.setup.hint": "Enter a temporary Slack app configuration token. n8n creates the app, installs it, and connects this agent.",
	"agents.builder.addTrigger.slack.setup.tokenPlaceholder": "App configuration token",
	"agents.builder.addTrigger.slack.setup.tokenLink": "Create one in Slack.",
	"agents.builder.addTrigger.slack.setup.button": "Create and install",
	"agents.builder.addTrigger.slack.setup.error": "Could not create and install the Slack app.",
	"agents.channels.setup.publishNotice": "This will publish your agent",
	"agents.channels.slack.setup.createToken.title": "Create token",
	"agents.channels.slack.setup.createToken.description": "Open the Slack dashboard and create an app configuration token.",
	"agents.channels.slack.setup.createToken.link": "Open Slack dashboard",
	"agents.channels.slack.setup.copyAccessToken.title": "Add token",
	"agents.channels.slack.setup.copyAccessToken.description": "Paste the app configuration token from Slack.",
	"agents.channels.slack.setup.copyAccessToken.label": "Token",
	"agents.channels.slack.setup.copyAccessToken.placeholder": "Token",
	"agents.channels.slack.setup.copyAccessToken.showToken": "Show token",
	"agents.channels.slack.setup.copyAccessToken.hideToken": "Hide token",
	"agents.channels.slack.setup.copyAccessToken.hint": "This is unique to you and your workspace. Starts with xoxe.xoxp-",
	"agents.channels.slack.setup.copyAccessToken.invalidToken": "This Slack app configuration token is invalid. Check the token and try again.",
	"agents.channels.slack.setup.installApp.title": "Install app",
	"agents.channels.slack.setup.installApp.description": "Install the Slack app and connect it to this agent.",
	"agents.channels.slack.setup.installApp.button": "Install app",
	"agents.channels.slack.setup.installApp.error": "Could not install the Slack app.",
	"agents.channels.slack.manualSetup.title": "Configure manually",
	"agents.channels.linear.setup.createOAuthApplication.title": "Create OAuth application",
	"agents.channels.linear.setup.createOAuthApplication.description": "Go to Linear and create a new OAuth application. You will need admin permissions.",
	"agents.channels.linear.setup.createOAuthApplication.button": "Open Linear",
	"agents.channels.linear.setup.configureApplication.title": "Configure application",
	"agents.channels.linear.setup.configureApplication.description": "Add name, description, and url. Copy the redirect URI and webhook URL.",
	"agents.channels.linear.setup.configureApplication.webhookHint": "Remember to check ‘Agent session events’ for webhooks.",
	"agents.channels.linear.setup.createCredential.title": "Create credential",
	"agents.channels.linear.setup.createCredential.description": "Copy your Client ID, Client secret, and Signing secret to create a new credential.",
	"agents.channels.linear.setup.createCredential.installButton": "Install app",
	"agents.channels.telegram.setup.credential.title": "Add credential",
	"agents.channels.telegram.setup.access.title": "Set access and restrictions",
	"agents.channels.telegram.setup.connect.title": "Connect Telegram",
	"agents.builder.addTrigger.slack.manual.title": "Manual configuration",
	"agents.builder.addTrigger.slack.manual.description": "If you want to create the Slack app manually, use this app manifest to create it, install it, then create a Slack credential with the Slack bot token and signing secret.",
	"agents.builder.addTrigger.slack.manifestHint": "Copy the app manifest and paste it into your Slack app's settings to configure events, scopes, and interactivity.",
	"agents.builder.addTrigger.slack.viewJson": "View JSON",
	"agents.builder.addTrigger.slack.hideJson": "Hide JSON",
	"agents.builder.addTrigger.slack.copyManifest": "Copy manifest",
	"agents.builder.addTrigger.slack.manifestTitle": "Slack app manifest",
	"agents.builder.addTrigger.slack.manifestLoading": "Loading Slack app manifest...",
	"agents.builder.addTrigger.slack.manifestError": "Couldn't load Slack app manifest. Try again.",
	"agents.builder.addTrigger.slack.docsCalloutLink": "See docs",
	"agents.builder.addTrigger.telegram.accessMode.label": "Access mode",
	"agents.builder.addTrigger.telegram.accessMode.private": "Private",
	"agents.builder.addTrigger.telegram.accessMode.public": "Public",
	"agents.builder.addTrigger.telegram.public.warning": "Any Telegram user will be able to chat with this agent.",
	"agents.builder.addTrigger.telegram.users.label": "Restrict to users",
	"agents.builder.addTrigger.telegram.users.placeholder": "Type a user ID or username and press Space",
	"agents.builder.addTrigger.telegram.validation.invalid": "Enter valid Telegram user IDs or usernames.",
	"agents.builder.addTrigger.telegram.validation.required": "Add at least one Telegram user ID or username.",
	"agents.builder.addTrigger.linear.setup.title": "Set up a Linear app",
	"agents.builder.addTrigger.linear.setup.description": "Create a Linear app to get the credential values, then add these URLs in Linear.",
	"agents.builder.addTrigger.linear.setup.link": "Create a Linear app",
	"agents.builder.addTrigger.linear.oauthCallbackUrl.label": "OAuth callback URL",
	"agents.builder.addTrigger.linear.webhookUrl.label": "Webhook URL",
	"agents.builder.addTrigger.helpText.slack": "Connect a Slack bot credential to allow this agent to receive and respond to Slack messages.",
	"agents.builder.addTrigger.helpText.telegram": "Connect a Telegram bot credential to allow this agent to receive and respond to Telegram messages.",
	"agents.builder.addTrigger.helpText.linear": "Connect a Linear OAuth credential to let this agent respond in Linear. For agent sessions, choose Application as the actor, point a Linear webhook at the URL below, and paste its signing secret into the credential.",
	"agents.builder.addTrigger.connectedText.slack": "Your agent is connected to Slack and ready to send and receive messages.",
	"agents.builder.addTrigger.connectedText.telegram": "Your agent is connected to Telegram and can receive messages.",
	"agents.builder.addTrigger.connectedText.linear": "Your agent is connected to Linear and can reply to {'@'}-mentions.",
	"instanceAi.welcomeModal.gateway.title": "Connect AI Assistant to your computer",
	"instanceAi.welcomeModal.gateway.description": "Allow AI Assistant to work with local files, run terminal commands, and control your browser so it can help build automations on your machine. It connects through n8n Computer Use, a lightweight local process you can disconnect anytime.",
	"instanceAi.welcomeModal.gateway.warning": "AI Assistant is a preview and can be unpredictable. Be aware of allowing access to sensitive data. Permissions can be adjusted during setup.",
	"instanceAi.welcomeModal.gateway.os.mac": "Mac",
	"instanceAi.welcomeModal.gateway.os.windows": "Windows",
	"instanceAi.welcomeModal.gateway.os.linux": "Linux",
	"instanceAi.welcomeModal.gateway.waiting": "Waiting for connection...",
	"instanceAi.welcomeModal.gateway.alreadyRunning": "Already running <code>npx {'@'}n8n/computer-use</code>?",
	"instanceAi.welcomeModal.gateway.connect": "Connect",
	"instanceAi.welcomeModal.gateway.instructions.mac": "Open Terminal (Cmd + Space, type \"Terminal\") and paste the command below.",
	"instanceAi.welcomeModal.gateway.instructions.windows": "Open Terminal (Windows key, type \"Terminal\") and paste the command below.",
	"instanceAi.welcomeModal.gateway.instructions.linux": "Open your terminal and paste the command below.",
	"instanceAi.welcomeModal.gateway.tokenExpiresIn": "Token expires in {minutes} min",
	"instanceAi.welcomeModal.gateway.tokenExpired": "Token has expired. Copy the command again.",
	"tools.connection.title": "Tools",
	"tools.connection.search.placeholder": "Search all tools...",
	"tools.connection.sections.builtInServices": "Connect built-in services",
	"tools.connection.sections.availableNodes": "Connect to a service",
	"tools.connection.sections.availableAgents": "Hand off to an agent",
	"tools.connection.sections.availableData": "Read or write data",
	"tools.connection.sections.availableWorkflows": "Trigger a workflow",
	"tools.connection.action.connect": "Connect",
	"tools.connection.action.connected": "Connected",
	"tools.connection.action.configure": "Configure",
	"tools.connection.action.close": "Close",
	"tools.connection.credentialPicker.search": "Search credentials...",
	"tools.connection.credentialPicker.create": "Create credential",
	"tools.connection.credentialPicker.noResults": "No credentials found",
	"tools.connection.tabs.services": "Services",
	"tools.connection.tabs.agents": "Agents",
	"tools.connection.tabs.data": "Data",
	"tools.connection.tabs.workflows": "Workflows",
	"tools.connection.tabs.settings": "Settings",
	"tools.connection.tabs.details": "Details",
	"tools.connection.settings.toolInclusion": "Tool Inclusion",
	"tools.connection.settings.inclusion.all": "All",
	"tools.connection.settings.inclusion.selected": "Only Selected",
	"tools.connection.settings.inclusion.except": "All Except",
	"tools.connection.settings.toolsToInclude": "Tools to Include",
	"tools.connection.settings.toolsToExclude": "Tools to Exclude",
	"tools.connection.settings.toolsPlaceholder": "Select tools...",
	"tools.connection.settings.remove": "Remove",
	"tools.connection.settings.save": "Save settings",
	"tools.connection.empty.title": "No tools available",
	"tools.connection.empty.noResults": "No results for \"{query}\"",
	"tools.connection.detail.back": "Back",
	"tools.connection.detail.publisher": "Publisher",
	"tools.connection.detail.version": "Version",
	"tools.connection.detail.moreInfo": "More info",
	"tools.connection.detail.docs": "Docs",
	"tools.connection.detail.readTools": "Read tools",
	"tools.connection.detail.writeTools": "Write tools",
	"tools.connection.detail.otherTools": "Tools",
	"tools.connection.detail.noAdditionalDetails": "No additional details available",
	"generic.disconnect": "Disconnect",
	"agents.channels.modal.title": "Channels",
	"agents.channels.modal.connectTitle": "Connect {channel}",
	"agents.channels.modal.editTitle": "Edit {channel}",
	"agents.channels.modal.backToChannels": "Back to channels",
	"agents.channels.modal.description": "Choose a channel to connect to your agent. Channels allow your agent to receive messages and respond to events.",
	"agents.channels.modal.connectDescription": "Connect your {channel} account",
	"agents.channels.modal.setupPlaceholder": "Setup view for {channel} will go here.",
	"agents.channels.modal.editPlaceholder": "Edit view for {channel} will go here.",
	"agents.channels.modal.connected": "Connected"
}
